/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.3.0.0 (NJsonSchema v10.1.11.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import { __extends, __values } from "tslib";
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import * as moment from 'moment';
export var API_BASE_URL = new InjectionToken('API_BASE_URL');
var AdminServiceProxy = /** @class */ (function () {
    function AdminServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    AdminServiceProxy.prototype.getEnvironment = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Admin/GetEnvironment";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetEnvironment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetEnvironment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdminServiceProxy.prototype.processGetEnvironment = function (response) {
        var e_1, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AdminServiceProxy.prototype.getConnectionString = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Admin/GetConnectionString";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetConnectionString(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetConnectionString(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdminServiceProxy.prototype.processGetConnectionString = function (response) {
        var e_2, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AdminServiceProxy.prototype.runDbMigrations = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Admin/RunDbMigrations";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRunDbMigrations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRunDbMigrations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdminServiceProxy.prototype.processRunDbMigrations = function (response) {
        var e_3, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    AdminServiceProxy.prototype.getPolicies = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Admin/GetPolicies";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPolicies(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPolicies(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    AdminServiceProxy.prototype.processGetPolicies = function (response) {
        var e_4, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_4) throw e_4.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (resultData200) {
                    result200 = {};
                    for (var key in resultData200) {
                        if (resultData200.hasOwnProperty(key))
                            result200[key] = resultData200[key];
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return AdminServiceProxy;
}());
export { AdminServiceProxy };
var BinCodeServiceProxy = /** @class */ (function () {
    function BinCodeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    BinCodeServiceProxy.prototype.uploadBins = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BinCode/UploadBins";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadBins(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadBins(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BinCodeServiceProxy.prototype.processUploadBins = function (response) {
        var e_5, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BinCodeServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BinCode/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BinCodeServiceProxy.prototype.processCreate = function (response) {
        var e_6, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_6_1) { e_6 = { error: e_6_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_6) throw e_6.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BinDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    BinCodeServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BinCode/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BinCodeServiceProxy.prototype.processUpdate = function (response) {
        var e_7, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BinDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BinCodeServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BinCode/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BinCodeServiceProxy.prototype.processDelete = function (response) {
        var e_8, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_8) throw e_8.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    BinCodeServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BinCode/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BinCodeServiceProxy.prototype.processGet = function (response) {
        var e_9, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_9_1) { e_9 = { error: e_9_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_9) throw e_9.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BinDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    BinCodeServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/BinCode/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    BinCodeServiceProxy.prototype.processGetAll = function (response) {
        var e_10, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = BinDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return BinCodeServiceProxy;
}());
export { BinCodeServiceProxy };
var CarrierServiceProxy = /** @class */ (function () {
    function CarrierServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    CarrierServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carrier/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierServiceProxy.prototype.processCreate = function (response) {
        var e_11, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_11_1) { e_11 = { error: e_11_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_11) throw e_11.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CarrierDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CarrierServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carrier/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierServiceProxy.prototype.processUpdate = function (response) {
        var e_12, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_12_1) { e_12 = { error: e_12_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_12) throw e_12.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CarrierDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CarrierServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carrier/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierServiceProxy.prototype.processDelete = function (response) {
        var e_13, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_13) throw e_13.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CarrierServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carrier/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierServiceProxy.prototype.processGet = function (response) {
        var e_14, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_14_1) { e_14 = { error: e_14_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_14) throw e_14.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CarrierDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param shippingTypeGroupId (optional)
     * @param storeCode (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CarrierServiceProxy.prototype.getAll = function (filters, shippingTypeGroupId, storeCode, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Carrier/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierServiceProxy.prototype.processGetAll = function (response) {
        var e_15, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_15_1) { e_15 = { error: e_15_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_15) throw e_15.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CarrierDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CarrierServiceProxy;
}());
export { CarrierServiceProxy };
var CarrierDriverServiceProxy = /** @class */ (function () {
    function CarrierDriverServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    CarrierDriverServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CarrierDriver/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierDriverServiceProxy.prototype.processCreate = function (response) {
        var e_16, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_16_1) { e_16 = { error: e_16_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_16) throw e_16.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CarrierDriverDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CarrierDriverServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CarrierDriver/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierDriverServiceProxy.prototype.processUpdate = function (response) {
        var e_17, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_17) throw e_17.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CarrierDriverDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CarrierDriverServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CarrierDriver/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierDriverServiceProxy.prototype.processDelete = function (response) {
        var e_18, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_18_1) { e_18 = { error: e_18_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_18) throw e_18.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CarrierDriverServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CarrierDriver/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierDriverServiceProxy.prototype.processGet = function (response) {
        var e_19, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_19_1) { e_19 = { error: e_19_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_19) throw e_19.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CarrierDriverDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CarrierDriverServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CarrierDriver/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CarrierDriverServiceProxy.prototype.processGetAll = function (response) {
        var e_20, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_20_1) { e_20 = { error: e_20_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_20) throw e_20.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CarrierDriverDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CarrierDriverServiceProxy;
}());
export { CarrierDriverServiceProxy };
var CityServiceProxy = /** @class */ (function () {
    function CityServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    CityServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/City/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CityServiceProxy.prototype.processGet = function (response) {
        var e_21, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_21_1) { e_21 = { error: e_21_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_21) throw e_21.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CityDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CityServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/City/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CityServiceProxy.prototype.processGetAll = function (response) {
        var e_22, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_22_1) { e_22 = { error: e_22_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_22) throw e_22.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CityDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CityServiceProxy;
}());
export { CityServiceProxy };
var ClaimServiceProxy = /** @class */ (function () {
    function ClaimServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.totalReturnOrder = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/TotalReturnOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processTotalReturnOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processTotalReturnOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processTotalReturnOrder = function (response) {
        var e_23, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_23_1) { e_23 = { error: e_23_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_23) throw e_23.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.partialReturnOrder = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/PartialReturnOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPartialReturnOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPartialReturnOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processPartialReturnOrder = function (response) {
        var e_24, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_24_1) { e_24 = { error: e_24_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_24) throw e_24.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.totalDeliveryFailOrder = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/TotalDeliveryFailOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processTotalDeliveryFailOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processTotalDeliveryFailOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processTotalDeliveryFailOrder = function (response) {
        var e_25, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_25_1) { e_25 = { error: e_25_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_25) throw e_25.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.partialDeliveryFailOrder = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/PartialDeliveryFailOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPartialDeliveryFailOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPartialDeliveryFailOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processPartialDeliveryFailOrder = function (response) {
        var e_26, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_26_1) { e_26 = { error: e_26_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_26) throw e_26.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.orderNotDelivered = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/OrderNotDelivered";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOrderNotDelivered(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOrderNotDelivered(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processOrderNotDelivered = function (response) {
        var e_27, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_27_1) { e_27 = { error: e_27_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_27) throw e_27.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.orderItemReplacement = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/OrderItemReplacement";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOrderItemReplacement(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOrderItemReplacement(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processOrderItemReplacement = function (response) {
        var e_28, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_28_1) { e_28 = { error: e_28_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_28) throw e_28.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.getCsv = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/GetCsv?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processGetCsv = function (response) {
        var e_29, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_29_1) { e_29 = { error: e_29_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_29) throw e_29.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processCreate = function (response) {
        var e_30, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_30_1) { e_30 = { error: e_30_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_30) throw e_30.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ClaimDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processUpdate = function (response) {
        var e_31, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_31_1) { e_31 = { error: e_31_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_31) throw e_31.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ClaimDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processDelete = function (response) {
        var e_32, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_32_1) { e_32 = { error: e_32_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_32) throw e_32.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processGet = function (response) {
        var e_33, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_33_1) { e_33 = { error: e_33_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_33) throw e_33.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ClaimDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ClaimServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Claim/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimServiceProxy.prototype.processGetAll = function (response) {
        var e_34, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_34_1) { e_34 = { error: e_34_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_34) throw e_34.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ClaimDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ClaimServiceProxy;
}());
export { ClaimServiceProxy };
var ClaimTypeServiceProxy = /** @class */ (function () {
    function ClaimTypeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ClaimTypeServiceProxy.prototype.getAll = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ClaimType/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ClaimTypeServiceProxy.prototype.processGetAll = function (response) {
        var e_35, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_35_1) { e_35 = { error: e_35_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_35) throw e_35.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_36, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_1 = __values(resultData200), resultData200_1_1 = resultData200_1.next(); !resultData200_1_1.done; resultData200_1_1 = resultData200_1.next()) {
                            var item = resultData200_1_1.value;
                            result200.push(ClaimTypeDto.fromJS(item));
                        }
                    }
                    catch (e_36_1) { e_36 = { error: e_36_1 }; }
                    finally {
                        try {
                            if (resultData200_1_1 && !resultData200_1_1.done && (_a = resultData200_1.return)) _a.call(resultData200_1);
                        }
                        finally { if (e_36) throw e_36.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ClaimTypeServiceProxy;
}());
export { ClaimTypeServiceProxy };
var CommersiaServiceProxy = /** @class */ (function () {
    function CommersiaServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param nroFactura (optional)
     * @param codigoCaja (optional)
     * @return Success
     */
    CommersiaServiceProxy.prototype.getOrder = function (nroFactura, codigoCaja) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Commersia/GetOrder?";
        if (nroFactura !== undefined)
            url_ += "nroFactura=" + encodeURIComponent("" + nroFactura) + "&";
        if (codigoCaja !== undefined)
            url_ += "codigoCaja=" + encodeURIComponent("" + codigoCaja) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommersiaServiceProxy.prototype.processGetOrder = function (response) {
        var e_37, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_37_1) { e_37 = { error: e_37_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_37) throw e_37.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param isVtex (optional)
     * @return Success
     */
    CommersiaServiceProxy.prototype.checkStatus = function (orderId, isVtex) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Commersia/CheckStatus?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (isVtex === null)
            throw new Error("The parameter 'isVtex' cannot be null.");
        else if (isVtex !== undefined)
            url_ += "isVtex=" + encodeURIComponent("" + isVtex) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommersiaServiceProxy.prototype.processCheckStatus = function (response) {
        var e_38, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_38_1) { e_38 = { error: e_38_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_38) throw e_38.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ComerssiaOrderStatus.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param isVtex (optional)
     * @return Success
     */
    CommersiaServiceProxy.prototype.updateOrder = function (orderId, isVtex) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Commersia/UpdateOrder?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (isVtex === null)
            throw new Error("The parameter 'isVtex' cannot be null.");
        else if (isVtex !== undefined)
            url_ += "isVtex=" + encodeURIComponent("" + isVtex) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommersiaServiceProxy.prototype.processUpdateOrder = function (response) {
        var e_39, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_39_1) { e_39 = { error: e_39_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_39) throw e_39.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ComerssiaOrderStatus.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param storeCode (optional)
     * @param isVtex (optional)
     * @return Success
     */
    CommersiaServiceProxy.prototype.relocateOrder = function (orderId, storeCode, isVtex) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Commersia/RelocateOrder?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        if (isVtex === null)
            throw new Error("The parameter 'isVtex' cannot be null.");
        else if (isVtex !== undefined)
            url_ += "isVtex=" + encodeURIComponent("" + isVtex) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRelocateOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRelocateOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommersiaServiceProxy.prototype.processRelocateOrder = function (response) {
        var e_40, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_40_1) { e_40 = { error: e_40_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_40) throw e_40.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param orderSourceCode (optional)
     * @param storeCode (optional)
     * @param sourceCode (optional)
     * @return Success
     */
    CommersiaServiceProxy.prototype.sendTransaction = function (orderId, orderSourceCode, storeCode, sourceCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Commersia/SendTransaction?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (orderSourceCode !== undefined)
            url_ += "orderSourceCode=" + encodeURIComponent("" + orderSourceCode) + "&";
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        if (sourceCode !== undefined)
            url_ += "sourceCode=" + encodeURIComponent("" + sourceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendTransaction(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendTransaction(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommersiaServiceProxy.prototype.processSendTransaction = function (response) {
        var e_41, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_41_1) { e_41 = { error: e_41_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_41) throw e_41.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ComerssiaOrderStatus.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    CommersiaServiceProxy.prototype.isInvoiced = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Commersia/IsInvoiced?";
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processIsInvoiced(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processIsInvoiced(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommersiaServiceProxy.prototype.processIsInvoiced = function (response) {
        var e_42, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_42_1) { e_42 = { error: e_42_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_42) throw e_42.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    CommersiaServiceProxy.prototype.allowedToReasignOrders = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Commersia/AllowedToReasignOrders?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAllowedToReasignOrders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAllowedToReasignOrders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommersiaServiceProxy.prototype.processAllowedToReasignOrders = function (response) {
        var e_43, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_43_1) { e_43 = { error: e_43_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_43) throw e_43.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CommersiaServiceProxy.prototype.sendInvoice = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Commersia/SendInvoice";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendInvoice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendInvoice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CommersiaServiceProxy.prototype.processSendInvoice = function (response) {
        var e_44, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_44_1) { e_44 = { error: e_44_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_44) throw e_44.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = InvoiceResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CommersiaServiceProxy;
}());
export { CommersiaServiceProxy };
var CustomValueServiceProxy = /** @class */ (function () {
    function CustomValueServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param countryCode (optional)
     * @param filters (optional)
     * @param reference (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    CustomValueServiceProxy.prototype.getAll = function (countryCode, filters, reference, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomValue/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (reference !== undefined)
            url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomValueServiceProxy.prototype.processGetAll = function (response) {
        var e_45, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_45_1) { e_45 = { error: e_45_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_45) throw e_45.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CustomValueDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CustomValueServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomValue/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomValueServiceProxy.prototype.processCreate = function (response) {
        var e_46, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_46_1) { e_46 = { error: e_46_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_46) throw e_46.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CustomValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    CustomValueServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomValue/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomValueServiceProxy.prototype.processUpdate = function (response) {
        var e_47, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_47_1) { e_47 = { error: e_47_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_47) throw e_47.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CustomValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CustomValueServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomValue/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomValueServiceProxy.prototype.processDelete = function (response) {
        var e_48, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_48_1) { e_48 = { error: e_48_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_48) throw e_48.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    CustomValueServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/CustomValue/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    CustomValueServiceProxy.prototype.processGet = function (response) {
        var e_49, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_49_1) { e_49 = { error: e_49_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_49) throw e_49.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = CustomValueDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return CustomValueServiceProxy;
}());
export { CustomValueServiceProxy };
var DeliveryScheduleServiceProxy = /** @class */ (function () {
    function DeliveryScheduleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    DeliveryScheduleServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliverySchedule/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryScheduleServiceProxy.prototype.processCreate = function (response) {
        var e_50, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_50_1) { e_50 = { error: e_50_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_50) throw e_50.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DeliveryScheduleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DeliveryScheduleServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliverySchedule/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryScheduleServiceProxy.prototype.processGet = function (response) {
        var e_51, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_51_1) { e_51 = { error: e_51_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_51) throw e_51.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DeliveryScheduleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param countryCode (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DeliveryScheduleServiceProxy.prototype.getAll = function (filters, countryCode, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliverySchedule/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryScheduleServiceProxy.prototype.processGetAll = function (response) {
        var e_52, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_52_1) { e_52 = { error: e_52_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_52) throw e_52.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DeliveryScheduleDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DeliveryScheduleServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliverySchedule/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryScheduleServiceProxy.prototype.processUpdate = function (response) {
        var e_53, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_53_1) { e_53 = { error: e_53_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_53) throw e_53.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DeliveryScheduleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DeliveryScheduleServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DeliverySchedule/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DeliveryScheduleServiceProxy.prototype.processDelete = function (response) {
        var e_54, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_54_1) { e_54 = { error: e_54_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_54) throw e_54.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DeliveryScheduleServiceProxy;
}());
export { DeliveryScheduleServiceProxy };
var DispatchOrderServiceProxy = /** @class */ (function () {
    function DispatchOrderServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param storeCode (optional)
     * @param readyToShip (optional)
     * @param shippingTypeGroupId (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DispatchOrderServiceProxy.prototype.getCountByShippingTypeGroup = function (storeCode, readyToShip, shippingTypeGroupId, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DispatchOrder/GetCountByShippingTypeGroup?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCountByShippingTypeGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCountByShippingTypeGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DispatchOrderServiceProxy.prototype.processGetCountByShippingTypeGroup = function (response) {
        var e_55, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_55_1) { e_55 = { error: e_55_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_55) throw e_55.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DispatchOrderServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DispatchOrder/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DispatchOrderServiceProxy.prototype.processCreate = function (response) {
        var e_56, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_56_1) { e_56 = { error: e_56_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_56) throw e_56.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DispatchOrderServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DispatchOrder/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DispatchOrderServiceProxy.prototype.processUpdate = function (response) {
        var e_57, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_57_1) { e_57 = { error: e_57_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_57) throw e_57.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DispatchOrderServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DispatchOrder/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DispatchOrderServiceProxy.prototype.processDelete = function (response) {
        var e_58, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_58_1) { e_58 = { error: e_58_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_58) throw e_58.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DispatchOrderServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DispatchOrder/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DispatchOrderServiceProxy.prototype.processGet = function (response) {
        var e_59, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_59_1) { e_59 = { error: e_59_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_59) throw e_59.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param readyToShip (optional)
     * @param shippingTypeGroupId (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DispatchOrderServiceProxy.prototype.getAll = function (storeCode, readyToShip, shippingTypeGroupId, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DispatchOrder/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DispatchOrderServiceProxy.prototype.processGetAll = function (response) {
        var e_60, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_60_1) { e_60 = { error: e_60_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_60) throw e_60.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DispatchOrderServiceProxy;
}());
export { DispatchOrderServiceProxy };
var DistrictServiceProxy = /** @class */ (function () {
    function DistrictServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    DistrictServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/District/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DistrictServiceProxy.prototype.processGet = function (response) {
        var e_61, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_61_1) { e_61 = { error: e_61_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_61) throw e_61.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DistrictDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DistrictServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/District/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DistrictServiceProxy.prototype.processGetAll = function (response) {
        var e_62, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_62_1) { e_62 = { error: e_62_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_62) throw e_62.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DistrictDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DistrictServiceProxy;
}());
export { DistrictServiceProxy };
var DocumentsServiceProxy = /** @class */ (function () {
    function DocumentsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param orderId (optional)
     * @param documentId (optional)
     * @param draftNumber (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.setDraftNumber = function (orderId, documentId, draftNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/SetDraftNumber?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        if (draftNumber !== undefined)
            url_ += "draftNumber=" + encodeURIComponent("" + draftNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetDraftNumber(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetDraftNumber(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processSetDraftNumber = function (response) {
        var e_63, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_63_1) { e_63 = { error: e_63_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_63) throw e_63.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.sendDraft = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/SendDraft";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendDraft(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendDraft(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processSendDraft = function (response) {
        var e_64, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_64_1) { e_64 = { error: e_64_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_64) throw e_64.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DocumentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.sendDraftsInvoicesToSap = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/SendDraftsInvoicesToSap";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendDraftsInvoicesToSap(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendDraftsInvoicesToSap(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processSendDraftsInvoicesToSap = function (response) {
        var e_65, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_65_1) { e_65 = { error: e_65_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_65) throw e_65.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_66, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_2 = __values(resultData200), resultData200_2_1 = resultData200_2.next(); !resultData200_2_1.done; resultData200_2_1 = resultData200_2.next()) {
                            var item = resultData200_2_1.value;
                            result200.push(item);
                        }
                    }
                    catch (e_66_1) { e_66 = { error: e_66_1 }; }
                    finally {
                        try {
                            if (resultData200_2_1 && !resultData200_2_1.done && (_a = resultData200_2.return)) _a.call(resultData200_2);
                        }
                        finally { if (e_66) throw e_66.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.sendDraftsInvoicesToSapProcess = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/SendDraftsInvoicesToSapProcess";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendDraftsInvoicesToSapProcess(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendDraftsInvoicesToSapProcess(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processSendDraftsInvoicesToSapProcess = function (response) {
        var e_67, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_67_1) { e_67 = { error: e_67_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_67) throw e_67.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param documentId (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.retry = function (documentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/Retry?";
        if (documentId === null)
            throw new Error("The parameter 'documentId' cannot be null.");
        else if (documentId !== undefined)
            url_ += "documentId=" + encodeURIComponent("" + documentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRetry(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRetry(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processRetry = function (response) {
        var e_68, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_68_1) { e_68 = { error: e_68_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_68) throw e_68.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DocumentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processCreate = function (response) {
        var e_69, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_69_1) { e_69 = { error: e_69_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_69) throw e_69.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DocumentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processUpdate = function (response) {
        var e_70, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_70_1) { e_70 = { error: e_70_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_70) throw e_70.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DocumentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processDelete = function (response) {
        var e_71, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_71_1) { e_71 = { error: e_71_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_71) throw e_71.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processGet = function (response) {
        var e_72, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_72_1) { e_72 = { error: e_72_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_72) throw e_72.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DocumentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    DocumentsServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Documents/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentsServiceProxy.prototype.processGetAll = function (response) {
        var e_73, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_73_1) { e_73 = { error: e_73_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_73) throw e_73.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = DocumentDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DocumentsServiceProxy;
}());
export { DocumentsServiceProxy };
var DocumentTypeServiceProxy = /** @class */ (function () {
    function DocumentTypeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    DocumentTypeServiceProxy.prototype.getAll = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/DocumentType/GetAll";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    DocumentTypeServiceProxy.prototype.processGetAll = function (response) {
        var e_74, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_74_1) { e_74 = { error: e_74_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_74) throw e_74.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_75, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_3 = __values(resultData200), resultData200_3_1 = resultData200_3.next(); !resultData200_3_1.done; resultData200_3_1 = resultData200_3.next()) {
                            var item = resultData200_3_1.value;
                            result200.push(DocumentTypeDto.fromJS(item));
                        }
                    }
                    catch (e_75_1) { e_75 = { error: e_75_1 }; }
                    finally {
                        try {
                            if (resultData200_3_1 && !resultData200_3_1.done && (_a = resultData200_3.return)) _a.call(resultData200_3);
                        }
                        finally { if (e_75) throw e_75.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return DocumentTypeServiceProxy;
}());
export { DocumentTypeServiceProxy };
var ExampleServiceProxy = /** @class */ (function () {
    function ExampleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param message (optional)
     * @return Success
     */
    ExampleServiceProxy.prototype.helloWorld = function (message) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Example/HelloWorld?";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processHelloWorld(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processHelloWorld(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExampleServiceProxy.prototype.processHelloWorld = function (response) {
        var e_76, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_76_1) { e_76 = { error: e_76_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_76) throw e_76.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ExampleServiceProxy.prototype.creatProcess = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Example/CreatProcess";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreatProcess(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreatProcess(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExampleServiceProxy.prototype.processCreatProcess = function (response) {
        var e_77, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_77_1) { e_77 = { error: e_77_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_77) throw e_77.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ExampleServiceProxy.prototype.runProcess = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Example/RunProcess?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRunProcess(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRunProcess(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExampleServiceProxy.prototype.processRunProcess = function (response) {
        var e_78, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_78_1) { e_78 = { error: e_78_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_78) throw e_78.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param code (optional)
     * @param message (optional)
     * @param body (optional)
     * @return Success
     */
    ExampleServiceProxy.prototype.sendNotification = function (code, message, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Example/SendNotification?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (message !== undefined)
            url_ += "message=" + encodeURIComponent("" + message) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ExampleServiceProxy.prototype.processSendNotification = function (response) {
        var e_79, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_79_1) { e_79 = { error: e_79_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_79) throw e_79.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ExampleServiceProxy;
}());
export { ExampleServiceProxy };
var FailedDeliveryServiceProxy = /** @class */ (function () {
    function FailedDeliveryServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param orderId (optional)
     * @return Success
     */
    FailedDeliveryServiceProxy.prototype.getItems = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FailedDelivery/GetItems?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FailedDeliveryServiceProxy.prototype.processGetItems = function (response) {
        var e_80, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_80_1) { e_80 = { error: e_80_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_80) throw e_80.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_81, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_4 = __values(resultData200), resultData200_4_1 = resultData200_4.next(); !resultData200_4_1.done; resultData200_4_1 = resultData200_4.next()) {
                            var item = resultData200_4_1.value;
                            result200.push(FailedDeliveryItemDto.fromJS(item));
                        }
                    }
                    catch (e_81_1) { e_81 = { error: e_81_1 }; }
                    finally {
                        try {
                            if (resultData200_4_1 && !resultData200_4_1.done && (_a = resultData200_4.return)) _a.call(resultData200_4);
                        }
                        finally { if (e_81) throw e_81.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    FailedDeliveryServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FailedDelivery/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FailedDeliveryServiceProxy.prototype.processGet = function (response) {
        var e_82, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_82_1) { e_82 = { error: e_82_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_82) throw e_82.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FailedDeliveryDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param orderId (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    FailedDeliveryServiceProxy.prototype.getAll = function (filters, orderId, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FailedDelivery/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FailedDeliveryServiceProxy.prototype.processGetAll = function (response) {
        var e_83, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_83_1) { e_83 = { error: e_83_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_83) throw e_83.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FailedDeliveryDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return FailedDeliveryServiceProxy;
}());
export { FailedDeliveryServiceProxy };
var FlyerServiceProxy = /** @class */ (function () {
    function FlyerServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    FlyerServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Flyer/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerServiceProxy.prototype.processCreate = function (response) {
        var e_84, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_84_1) { e_84 = { error: e_84_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_84) throw e_84.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FlyerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FlyerServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Flyer/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerServiceProxy.prototype.processUpdate = function (response) {
        var e_85, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_85_1) { e_85 = { error: e_85_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_85) throw e_85.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FlyerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    FlyerServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Flyer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerServiceProxy.prototype.processDelete = function (response) {
        var e_86, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_86_1) { e_86 = { error: e_86_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_86) throw e_86.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    FlyerServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Flyer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerServiceProxy.prototype.processGet = function (response) {
        var e_87, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_87_1) { e_87 = { error: e_87_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_87) throw e_87.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FlyerDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    FlyerServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Flyer/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerServiceProxy.prototype.processGetAll = function (response) {
        var e_88, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_88_1) { e_88 = { error: e_88_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_88) throw e_88.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FlyerDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return FlyerServiceProxy;
}());
export { FlyerServiceProxy };
var FlyerDistributionServiceProxy = /** @class */ (function () {
    function FlyerDistributionServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param source (optional)
     * @param postalCode (optional)
     * @return Success
     */
    FlyerDistributionServiceProxy.prototype.getFlyers = function (source, postalCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FlyerDistribution/GetFlyers?";
        if (source === null)
            throw new Error("The parameter 'source' cannot be null.");
        else if (source !== undefined)
            url_ += "source=" + encodeURIComponent("" + source) + "&";
        if (postalCode === null)
            throw new Error("The parameter 'postalCode' cannot be null.");
        else if (postalCode !== undefined)
            url_ += "postalCode=" + encodeURIComponent("" + postalCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetFlyers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetFlyers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerDistributionServiceProxy.prototype.processGetFlyers = function (response) {
        var e_89, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_89_1) { e_89 = { error: e_89_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_89) throw e_89.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_90, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_5 = __values(resultData200), resultData200_5_1 = resultData200_5.next(); !resultData200_5_1.done; resultData200_5_1 = resultData200_5.next()) {
                            var item = resultData200_5_1.value;
                            result200.push(FlyerDistributionDto.fromJS(item));
                        }
                    }
                    catch (e_90_1) { e_90 = { error: e_90_1 }; }
                    finally {
                        try {
                            if (resultData200_5_1 && !resultData200_5_1.done && (_a = resultData200_5.return)) _a.call(resultData200_5);
                        }
                        finally { if (e_90) throw e_90.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FlyerDistributionServiceProxy.prototype.uploadFlyers = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FlyerDistribution/UploadFlyers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadFlyers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadFlyers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerDistributionServiceProxy.prototype.processUploadFlyers = function (response) {
        var e_91, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_91_1) { e_91 = { error: e_91_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_91) throw e_91.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param countryCode (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    FlyerDistributionServiceProxy.prototype.getCsv = function (filters, countryCode, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FlyerDistribution/GetCsv?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerDistributionServiceProxy.prototype.processGetCsv = function (response) {
        var e_92, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_92_1) { e_92 = { error: e_92_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_92) throw e_92.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FlyerDistributionServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FlyerDistribution/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerDistributionServiceProxy.prototype.processCreate = function (response) {
        var e_93, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_93_1) { e_93 = { error: e_93_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_93) throw e_93.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FlyerDistributionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    FlyerDistributionServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FlyerDistribution/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerDistributionServiceProxy.prototype.processUpdate = function (response) {
        var e_94, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_94_1) { e_94 = { error: e_94_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_94) throw e_94.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FlyerDistributionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    FlyerDistributionServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FlyerDistribution/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerDistributionServiceProxy.prototype.processDelete = function (response) {
        var e_95, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_95_1) { e_95 = { error: e_95_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_95) throw e_95.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    FlyerDistributionServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FlyerDistribution/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerDistributionServiceProxy.prototype.processGet = function (response) {
        var e_96, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_96_1) { e_96 = { error: e_96_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_96) throw e_96.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FlyerDistributionDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param countryCode (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    FlyerDistributionServiceProxy.prototype.getAll = function (filters, countryCode, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/FlyerDistribution/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    FlyerDistributionServiceProxy.prototype.processGetAll = function (response) {
        var e_97, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_97_1) { e_97 = { error: e_97_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_97) throw e_97.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = FlyerDistributionDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return FlyerDistributionServiceProxy;
}());
export { FlyerDistributionServiceProxy };
var GeneralAuditServiceProxy = /** @class */ (function () {
    function GeneralAuditServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param orderId (optional)
     * @return Success
     */
    GeneralAuditServiceProxy.prototype.getGeneralAuditDetail = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/GeneralAudit/GetGeneralAuditDetail?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGeneralAuditDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGeneralAuditDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralAuditServiceProxy.prototype.processGetGeneralAuditDetail = function (response) {
        var e_98, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_98_1) { e_98 = { error: e_98_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_98) throw e_98.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_99, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_6 = __values(resultData200), resultData200_6_1 = resultData200_6.next(); !resultData200_6_1.done; resultData200_6_1 = resultData200_6.next()) {
                            var item = resultData200_6_1.value;
                            result200.push(GeneralAuditOrderDetail.fromJS(item));
                        }
                    }
                    catch (e_99_1) { e_99 = { error: e_99_1 }; }
                    finally {
                        try {
                            if (resultData200_6_1 && !resultData200_6_1.done && (_a = resultData200_6.return)) _a.call(resultData200_6);
                        }
                        finally { if (e_99) throw e_99.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    GeneralAuditServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/GeneralAudit/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralAuditServiceProxy.prototype.processGet = function (response) {
        var e_100, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_100_1) { e_100 = { error: e_100_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_100) throw e_100.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GeneralAuditDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param countryCode (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    GeneralAuditServiceProxy.prototype.getAll = function (filters, countryCode, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/GeneralAudit/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    GeneralAuditServiceProxy.prototype.processGetAll = function (response) {
        var e_101, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_101_1) { e_101 = { error: e_101_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_101) throw e_101.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = GeneralAuditDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return GeneralAuditServiceProxy;
}());
export { GeneralAuditServiceProxy };
var HubDeliveryMappingServiceProxy = /** @class */ (function () {
    function HubDeliveryMappingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    HubDeliveryMappingServiceProxy.prototype.upload = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Upload";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpload(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpload(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HubDeliveryMappingServiceProxy.prototype.processUpload = function (response) {
        var e_102, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_102_1) { e_102 = { error: e_102_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_102) throw e_102.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param countryCode (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    HubDeliveryMappingServiceProxy.prototype.getCsv = function (countryCode, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/GetCsv?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HubDeliveryMappingServiceProxy.prototype.processGetCsv = function (response) {
        var e_103, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_103_1) { e_103 = { error: e_103_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_103) throw e_103.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    HubDeliveryMappingServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HubDeliveryMappingServiceProxy.prototype.processCreate = function (response) {
        var e_104, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_104_1) { e_104 = { error: e_104_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_104) throw e_104.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = HubDeliveryMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    HubDeliveryMappingServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HubDeliveryMappingServiceProxy.prototype.processUpdate = function (response) {
        var e_105, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_105_1) { e_105 = { error: e_105_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_105) throw e_105.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = HubDeliveryMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    HubDeliveryMappingServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HubDeliveryMappingServiceProxy.prototype.processDelete = function (response) {
        var e_106, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_106_1) { e_106 = { error: e_106_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_106) throw e_106.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    HubDeliveryMappingServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HubDeliveryMappingServiceProxy.prototype.processGet = function (response) {
        var e_107, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_107_1) { e_107 = { error: e_107_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_107) throw e_107.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = HubDeliveryMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param countryCode (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    HubDeliveryMappingServiceProxy.prototype.getAll = function (countryCode, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/HubDeliveryMapping/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    HubDeliveryMappingServiceProxy.prototype.processGetAll = function (response) {
        var e_108, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_108_1) { e_108 = { error: e_108_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_108) throw e_108.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = HubDeliveryMappingDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return HubDeliveryMappingServiceProxy;
}());
export { HubDeliveryMappingServiceProxy };
var ICGServiceProxy = /** @class */ (function () {
    function ICGServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param invoiceNumber (optional)
     * @return Success
     */
    ICGServiceProxy.prototype.getOrder = function (invoiceNumber) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ICG/GetOrder?";
        if (invoiceNumber !== undefined)
            url_ += "invoiceNumber=" + encodeURIComponent("" + invoiceNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ICGServiceProxy.prototype.processGetOrder = function (response) {
        var e_109, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_109_1) { e_109 = { error: e_109_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_109) throw e_109.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ICGServiceProxy;
}());
export { ICGServiceProxy };
var LandingInfoServiceProxy = /** @class */ (function () {
    function LandingInfoServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param countryCode (optional)
     * @return Success
     */
    LandingInfoServiceProxy.prototype.getByCountryCode = function (countryCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/LandingInfo/GetByCountryCode?";
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetByCountryCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetByCountryCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    LandingInfoServiceProxy.prototype.processGetByCountryCode = function (response) {
        var e_110, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_110_1) { e_110 = { error: e_110_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_110) throw e_110.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_111, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_7 = __values(resultData200), resultData200_7_1 = resultData200_7.next(); !resultData200_7_1.done; resultData200_7_1 = resultData200_7.next()) {
                            var item = resultData200_7_1.value;
                            result200.push(LandingInfoDto.fromJS(item));
                        }
                    }
                    catch (e_111_1) { e_111 = { error: e_111_1 }; }
                    finally {
                        try {
                            if (resultData200_7_1 && !resultData200_7_1.done && (_a = resultData200_7.return)) _a.call(resultData200_7);
                        }
                        finally { if (e_111) throw e_111.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return LandingInfoServiceProxy;
}());
export { LandingInfoServiceProxy };
var MeliServiceProxy = /** @class */ (function () {
    function MeliServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param input (optional)
     * @return Success
     */
    MeliServiceProxy.prototype.getResourceAr = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Meli/GetResourceAr?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetResourceAr(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetResourceAr(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MeliServiceProxy.prototype.processGetResourceAr = function (response) {
        var e_112, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_112_1) { e_112 = { error: e_112_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_112) throw e_112.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    MeliServiceProxy.prototype.getResourceCo = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Meli/GetResourceCo?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetResourceCo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetResourceCo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MeliServiceProxy.prototype.processGetResourceCo = function (response) {
        var e_113, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_113_1) { e_113 = { error: e_113_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_113) throw e_113.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param shipmentIds (optional)
     * @param orderId (optional)
     * @return Success
     */
    MeliServiceProxy.prototype.getShipmenLabelsZebra = function (shipmentIds, orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Meli/GetShipmenLabelsZebra?";
        if (shipmentIds !== undefined)
            shipmentIds && shipmentIds.forEach(function (item) { url_ += "shipmentIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetShipmenLabelsZebra(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetShipmenLabelsZebra(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MeliServiceProxy.prototype.processGetShipmenLabelsZebra = function (response) {
        var e_114, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_114_1) { e_114 = { error: e_114_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_114) throw e_114.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param shipmentIds (optional)
     * @param orderIds (optional)
     * @return Success
     */
    MeliServiceProxy.prototype.getShipmenLabelsZebraMulti = function (shipmentIds, orderIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Meli/GetShipmenLabelsZebraMulti?";
        if (shipmentIds !== undefined)
            shipmentIds && shipmentIds.forEach(function (item) { url_ += "shipmentIds=" + encodeURIComponent("" + item) + "&"; });
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetShipmenLabelsZebraMulti(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetShipmenLabelsZebraMulti(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MeliServiceProxy.prototype.processGetShipmenLabelsZebraMulti = function (response) {
        var e_115, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_115_1) { e_115 = { error: e_115_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_115) throw e_115.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param shipmentIds (optional)
     * @return Success
     */
    MeliServiceProxy.prototype.getShipmentLabels = function (shipmentIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Meli/GetShipmentLabels?";
        if (shipmentIds !== undefined)
            shipmentIds && shipmentIds.forEach(function (item) { url_ += "shipmentIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetShipmentLabels(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetShipmentLabels(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MeliServiceProxy.prototype.processGetShipmentLabels = function (response) {
        var e_116, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_116_1) { e_116 = { error: e_116_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_116) throw e_116.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    MeliServiceProxy.prototype.uploadInvoice = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Meli/UploadInvoice?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadInvoice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadInvoice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MeliServiceProxy.prototype.processUploadInvoice = function (response) {
        var e_117, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_117_1) { e_117 = { error: e_117_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_117) throw e_117.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return MeliServiceProxy;
}());
export { MeliServiceProxy };
var MeliNotificationServiceProxy = /** @class */ (function () {
    function MeliNotificationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    MeliNotificationServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/MeliNotification/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    MeliNotificationServiceProxy.prototype.processCreate = function (response) {
        var e_118, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_118_1) { e_118 = { error: e_118_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_118) throw e_118.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = AddMeliNotificationResponse.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return MeliNotificationServiceProxy;
}());
export { MeliNotificationServiceProxy };
var OrderServiceProxy = /** @class */ (function () {
    function OrderServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param readyToShip (optional)
     * @param readyToHandle (optional)
     * @param orderIds (optional)
     * @param includeSupplyingOrders (optional)
     * @param excludeGiftCardsOrders (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getAll = function (storeCode, countryCode, readyToShip, readyToHandle, orderIds, includeSupplyingOrders, excludeGiftCardsOrders, filters, search, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&";
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetAll = function (response) {
        var e_119, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_119_1) { e_119 = { error: e_119_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_119) throw e_119.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param customerDocumentNumber (optional)
     * @param customerEmail (optional)
     * @param fromDate (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getAllWithItems = function (customerDocumentNumber, customerEmail, fromDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetAllWithItems?";
        if (customerDocumentNumber !== undefined)
            url_ += "CustomerDocumentNumber=" + encodeURIComponent("" + customerDocumentNumber) + "&";
        if (customerEmail !== undefined)
            url_ += "CustomerEmail=" + encodeURIComponent("" + customerEmail) + "&";
        if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent(fromDate ? "" + fromDate.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllWithItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllWithItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetAllWithItems = function (response) {
        var e_120, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_120_1) { e_120 = { error: e_120_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_120) throw e_120.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDtoListResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getShippedOrder = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetShippedOrder?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetShippedOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetShippedOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetShippedOrder = function (response) {
        var e_121, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_121_1) { e_121 = { error: e_121_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_121) throw e_121.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getNotDeliveredOrders = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetNotDeliveredOrders?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetNotDeliveredOrders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetNotDeliveredOrders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetNotDeliveredOrders = function (response) {
        var e_122, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_122_1) { e_122 = { error: e_122_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_122) throw e_122.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processCreate = function (response) {
        var e_123, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_123_1) { e_123 = { error: e_123_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_123) throw e_123.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.dispatchOrder = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/DispatchOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDispatchOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDispatchOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processDispatchOrder = function (response) {
        var e_124, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_124_1) { e_124 = { error: e_124_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_124) throw e_124.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param readyToShip (optional)
     * @param readyToHandle (optional)
     * @param orderIds (optional)
     * @param includeSupplyingOrders (optional)
     * @param excludeGiftCardsOrders (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getCsv = function (storeCode, countryCode, readyToShip, readyToHandle, orderIds, includeSupplyingOrders, excludeGiftCardsOrders, filters, search, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetCsv?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&";
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetCsv = function (response) {
        var e_125, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_125_1) { e_125 = { error: e_125_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_125) throw e_125.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param readyToShip (optional)
     * @param readyToHandle (optional)
     * @param orderIds (optional)
     * @param includeSupplyingOrders (optional)
     * @param excludeGiftCardsOrders (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getAllDashboard = function (storeCode, countryCode, readyToShip, readyToHandle, orderIds, includeSupplyingOrders, excludeGiftCardsOrders, filters, search, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetAllDashboard?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&";
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetAllDashboard = function (response) {
        var e_126, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_126_1) { e_126 = { error: e_126_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_126) throw e_126.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_127, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_8 = __values(resultData200), resultData200_8_1 = resultData200_8.next(); !resultData200_8_1.done; resultData200_8_1 = resultData200_8.next()) {
                            var item = resultData200_8_1.value;
                            result200.push(OrderCsvDashboardDto.fromJS(item));
                        }
                    }
                    catch (e_127_1) { e_127 = { error: e_127_1 }; }
                    finally {
                        try {
                            if (resultData200_8_1 && !resultData200_8_1.done && (_a = resultData200_8.return)) _a.call(resultData200_8);
                        }
                        finally { if (e_127) throw e_127.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param readyToShip (optional)
     * @param readyToHandle (optional)
     * @param orderIds (optional)
     * @param includeSupplyingOrders (optional)
     * @param excludeGiftCardsOrders (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getCsvOL = function (storeCode, countryCode, readyToShip, readyToHandle, orderIds, includeSupplyingOrders, excludeGiftCardsOrders, filters, search, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetCsvOL?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&";
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsvOL(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsvOL(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetCsvOL = function (response) {
        var e_128, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_128_1) { e_128 = { error: e_128_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_128) throw e_128.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param readyToShip (optional)
     * @param readyToHandle (optional)
     * @param orderIds (optional)
     * @param includeSupplyingOrders (optional)
     * @param excludeGiftCardsOrders (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getCsvQuadmin = function (storeCode, countryCode, readyToShip, readyToHandle, orderIds, includeSupplyingOrders, excludeGiftCardsOrders, filters, search, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetCsvQuadmin?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&";
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsvQuadmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsvQuadmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetCsvQuadmin = function (response) {
        var e_129, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_129_1) { e_129 = { error: e_129_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_129) throw e_129.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param readyToShip (optional)
     * @param readyToHandle (optional)
     * @param orderIds (optional)
     * @param includeSupplyingOrders (optional)
     * @param excludeGiftCardsOrders (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getAllOL = function (storeCode, countryCode, readyToShip, readyToHandle, orderIds, includeSupplyingOrders, excludeGiftCardsOrders, filters, search, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetAllOL?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&";
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllOL(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllOL(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetAllOL = function (response) {
        var e_130, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_130_1) { e_130 = { error: e_130_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_130) throw e_130.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_131, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_9 = __values(resultData200), resultData200_9_1 = resultData200_9.next(); !resultData200_9_1.done; resultData200_9_1 = resultData200_9.next()) {
                            var item = resultData200_9_1.value;
                            result200.push(OrderCsvOLDto.fromJS(item));
                        }
                    }
                    catch (e_131_1) { e_131 = { error: e_131_1 }; }
                    finally {
                        try {
                            if (resultData200_9_1 && !resultData200_9_1.done && (_a = resultData200_9.return)) _a.call(resultData200_9);
                        }
                        finally { if (e_131) throw e_131.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param readyToShip (optional)
     * @param readyToHandle (optional)
     * @param orderIds (optional)
     * @param includeSupplyingOrders (optional)
     * @param excludeGiftCardsOrders (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getAllQuadmin = function (storeCode, countryCode, readyToShip, readyToHandle, orderIds, includeSupplyingOrders, excludeGiftCardsOrders, filters, search, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetAllQuadmin?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (readyToShip !== undefined)
            url_ += "ReadyToShip=" + encodeURIComponent("" + readyToShip) + "&";
        if (readyToHandle !== undefined)
            url_ += "ReadyToHandle=" + encodeURIComponent("" + readyToHandle) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (includeSupplyingOrders === null)
            throw new Error("The parameter 'includeSupplyingOrders' cannot be null.");
        else if (includeSupplyingOrders !== undefined)
            url_ += "IncludeSupplyingOrders=" + encodeURIComponent("" + includeSupplyingOrders) + "&";
        if (excludeGiftCardsOrders === null)
            throw new Error("The parameter 'excludeGiftCardsOrders' cannot be null.");
        else if (excludeGiftCardsOrders !== undefined)
            url_ += "ExcludeGiftCardsOrders=" + encodeURIComponent("" + excludeGiftCardsOrders) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllQuadmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllQuadmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetAllQuadmin = function (response) {
        var e_132, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_132_1) { e_132 = { error: e_132_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_132) throw e_132.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_133, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_10 = __values(resultData200), resultData200_10_1 = resultData200_10.next(); !resultData200_10_1.done; resultData200_10_1 = resultData200_10.next()) {
                            var item = resultData200_10_1.value;
                            result200.push(OrderCsvQuadminDto.fromJS(item));
                        }
                    }
                    catch (e_133_1) { e_133 = { error: e_133_1 }; }
                    finally {
                        try {
                            if (resultData200_10_1 && !resultData200_10_1.done && (_a = resultData200_10.return)) _a.call(resultData200_10);
                        }
                        finally { if (e_133) throw e_133.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.sendToQuadmind = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/SendToQuadmind";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSendToQuadmind(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSendToQuadmind(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processSendToQuadmind = function (response) {
        var e_134, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_134_1) { e_134 = { error: e_134_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_134) throw e_134.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getStatusCount = function (storeCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetStatusCount?";
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetStatusCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetStatusCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetStatusCount = function (response) {
        var e_135, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_135_1) { e_135 = { error: e_135_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_135) throw e_135.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_136, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_11 = __values(resultData200), resultData200_11_1 = resultData200_11.next(); !resultData200_11_1.done; resultData200_11_1 = resultData200_11.next()) {
                            var item = resultData200_11_1.value;
                            result200.push(OrderStatusCountDto.fromJS(item));
                        }
                    }
                    catch (e_136_1) { e_136 = { error: e_136_1 }; }
                    finally {
                        try {
                            if (resultData200_11_1 && !resultData200_11_1.done && (_a = resultData200_11.return)) _a.call(resultData200_11);
                        }
                        finally { if (e_136) throw e_136.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.returnAssignedOrder = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/ReturnAssignedOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processReturnAssignedOrder(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processReturnAssignedOrder(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processReturnAssignedOrder = function (response) {
        var e_137, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_137_1) { e_137 = { error: e_137_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_137) throw e_137.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param highlighted (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.setHighlighted = function (orderId, highlighted) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/SetHighlighted?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (highlighted === null)
            throw new Error("The parameter 'highlighted' cannot be null.");
        else if (highlighted !== undefined)
            url_ += "highlighted=" + encodeURIComponent("" + highlighted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSetHighlighted(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSetHighlighted(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processSetHighlighted = function (response) {
        var e_138, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_138_1) { e_138 = { error: e_138_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_138) throw e_138.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.updateAssignedStore = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/UpdateAssignedStore";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateAssignedStore(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateAssignedStore(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processUpdateAssignedStore = function (response) {
        var e_139, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_139_1) { e_139 = { error: e_139_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_139) throw e_139.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.updateCarrier = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/UpdateCarrier";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateCarrier(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateCarrier(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processUpdateCarrier = function (response) {
        var e_140, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_140_1) { e_140 = { error: e_140_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_140) throw e_140.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.updateStatus = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processUpdateStatus = function (response) {
        var e_141, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_141_1) { e_141 = { error: e_141_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_141) throw e_141.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.updateLogisticStatusProcess = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/UpdateLogisticStatusProcess";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateLogisticStatusProcess(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateLogisticStatusProcess(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processUpdateLogisticStatusProcess = function (response) {
        var e_142, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_142_1) { e_142 = { error: e_142_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_142) throw e_142.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.updateLogisticStatus = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/UpdateLogisticStatus";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateLogisticStatus(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateLogisticStatus(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processUpdateLogisticStatus = function (response) {
        var e_143, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_143_1) { e_143 = { error: e_143_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_143) throw e_143.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.updateHeader = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/UpdateHeader";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateHeader(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateHeader(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processUpdateHeader = function (response) {
        var e_144, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_144_1) { e_144 = { error: e_144_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_144) throw e_144.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.updateItems = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/UpdateItems";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateItems(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateItems(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processUpdateItems = function (response) {
        var e_145, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_145_1) { e_145 = { error: e_145_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_145) throw e_145.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderIds (optional)
     * @param sourceIds (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getPrintableOrderNote = function (orderIds, sourceIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetPrintableOrderNote?";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceIds !== undefined)
            sourceIds && sourceIds.forEach(function (item) { url_ += "sourceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPrintableOrderNote(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPrintableOrderNote(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetPrintableOrderNote = function (response) {
        var e_146, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_146_1) { e_146 = { error: e_146_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_146) throw e_146.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderIds (optional)
     * @param sourceIds (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getInternalPrintableOrderNote = function (orderIds, sourceIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetInternalPrintableOrderNote?";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceIds !== undefined)
            sourceIds && sourceIds.forEach(function (item) { url_ += "sourceIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetInternalPrintableOrderNote(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetInternalPrintableOrderNote(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetInternalPrintableOrderNote = function (response) {
        var e_147, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_147_1) { e_147 = { error: e_147_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_147) throw e_147.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderIds (optional)
     * @param sourceIds (optional)
     * @param countryCode (optional)
     * @param isInternal (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.getPrintableOrderNoteInner = function (orderIds, sourceIds, countryCode, isInternal) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetPrintableOrderNoteInner?";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "orderIds=" + encodeURIComponent("" + item) + "&"; });
        if (sourceIds !== undefined)
            sourceIds && sourceIds.forEach(function (item) { url_ += "sourceIds=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (isInternal === null)
            throw new Error("The parameter 'isInternal' cannot be null.");
        else if (isInternal !== undefined)
            url_ += "isInternal=" + encodeURIComponent("" + isInternal) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPrintableOrderNoteInner(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPrintableOrderNoteInner(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetPrintableOrderNoteInner = function (response) {
        var e_148, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_148_1) { e_148 = { error: e_148_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_148) throw e_148.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.saveGridConfig = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/SaveGridConfig";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveGridConfig(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveGridConfig(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processSaveGridConfig = function (response) {
        var e_149, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_149_1) { e_149 = { error: e_149_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_149) throw e_149.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    OrderServiceProxy.prototype.getGridConfig = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/GetGridConfig";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetGridConfig(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetGridConfig(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGetGridConfig = function (response) {
        var e_150, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_150_1) { e_150 = { error: e_150_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_150) throw e_150.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processUpdate = function (response) {
        var e_151, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_151_1) { e_151 = { error: e_151_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_151) throw e_151.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processDelete = function (response) {
        var e_152, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_152_1) { e_152 = { error: e_152_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_152) throw e_152.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Order/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderServiceProxy.prototype.processGet = function (response) {
        var e_153, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_153_1) { e_153 = { error: e_153_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_153) throw e_153.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderServiceProxy;
}());
export { OrderServiceProxy };
var OrderDetailServiceProxy = /** @class */ (function () {
    function OrderDetailServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetail = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetail?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetail(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetail(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetail = function (response) {
        var e_154, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_154_1) { e_154 = { error: e_154_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_154) throw e_154.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDetailDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailClaims = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailClaims?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailClaims(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailClaims(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailClaims = function (response) {
        var e_155, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_155_1) { e_155 = { error: e_155_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_155) throw e_155.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_156, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_12 = __values(resultData200), resultData200_12_1 = resultData200_12.next(); !resultData200_12_1.done; resultData200_12_1 = resultData200_12.next()) {
                            var item = resultData200_12_1.value;
                            result200.push(OrderDetailClaimDto.fromJS(item));
                        }
                    }
                    catch (e_156_1) { e_156 = { error: e_156_1 }; }
                    finally {
                        try {
                            if (resultData200_12_1 && !resultData200_12_1.done && (_a = resultData200_12.return)) _a.call(resultData200_12);
                        }
                        finally { if (e_156) throw e_156.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailEventLog = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailEventLog?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailEventLog(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailEventLog(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailEventLog = function (response) {
        var e_157, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_157_1) { e_157 = { error: e_157_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_157) throw e_157.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_158, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_13 = __values(resultData200), resultData200_13_1 = resultData200_13.next(); !resultData200_13_1.done; resultData200_13_1 = resultData200_13.next()) {
                            var item = resultData200_13_1.value;
                            result200.push(OrderDetailEventLogDto.fromJS(item));
                        }
                    }
                    catch (e_158_1) { e_158 = { error: e_158_1 }; }
                    finally {
                        try {
                            if (resultData200_13_1 && !resultData200_13_1.done && (_a = resultData200_13.return)) _a.call(resultData200_13);
                        }
                        finally { if (e_158) throw e_158.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailHeader = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailHeader?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailHeader(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailHeader(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailHeader = function (response) {
        var e_159, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_159_1) { e_159 = { error: e_159_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_159) throw e_159.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDetailHeaderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailInvoice = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailInvoice?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailInvoice(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailInvoice(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailInvoice = function (response) {
        var e_160, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_160_1) { e_160 = { error: e_160_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_160) throw e_160.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDetailInvoiceDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailBalance = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailBalance?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailBalance(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailBalance(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailBalance = function (response) {
        var e_161, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_161_1) { e_161 = { error: e_161_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_161) throw e_161.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_162, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_14 = __values(resultData200), resultData200_14_1 = resultData200_14.next(); !resultData200_14_1.done; resultData200_14_1 = resultData200_14.next()) {
                            var item = resultData200_14_1.value;
                            result200.push(OrderDetailOrderBalanceDto.fromJS(item));
                        }
                    }
                    catch (e_162_1) { e_162 = { error: e_162_1 }; }
                    finally {
                        try {
                            if (resultData200_14_1 && !resultData200_14_1.done && (_a = resultData200_14.return)) _a.call(resultData200_14);
                        }
                        finally { if (e_162) throw e_162.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailDocuments = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailDocuments?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailDocuments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailDocuments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailDocuments = function (response) {
        var e_163, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_163_1) { e_163 = { error: e_163_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_163) throw e_163.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_164, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_15 = __values(resultData200), resultData200_15_1 = resultData200_15.next(); !resultData200_15_1.done; resultData200_15_1 = resultData200_15.next()) {
                            var item = resultData200_15_1.value;
                            result200.push(OrderDetailDocumentDto.fromJS(item));
                        }
                    }
                    catch (e_164_1) { e_164 = { error: e_164_1 }; }
                    finally {
                        try {
                            if (resultData200_15_1 && !resultData200_15_1.done && (_a = resultData200_15.return)) _a.call(resultData200_15);
                        }
                        finally { if (e_164) throw e_164.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailItem = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailItem?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailItem(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailItem(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailItem = function (response) {
        var e_165, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_165_1) { e_165 = { error: e_165_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_165) throw e_165.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDetailItemDetailDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailPickingGroups = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailPickingGroups?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailPickingGroups(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailPickingGroups(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailPickingGroups = function (response) {
        var e_166, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_166_1) { e_166 = { error: e_166_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_166) throw e_166.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_167, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_16 = __values(resultData200), resultData200_16_1 = resultData200_16.next(); !resultData200_16_1.done; resultData200_16_1 = resultData200_16.next()) {
                            var item = resultData200_16_1.value;
                            result200.push(OrderDetailPickingGroupDto.fromJS(item));
                        }
                    }
                    catch (e_167_1) { e_167 = { error: e_167_1 }; }
                    finally {
                        try {
                            if (resultData200_16_1 && !resultData200_16_1.done && (_a = resultData200_16.return)) _a.call(resultData200_16);
                        }
                        finally { if (e_167) throw e_167.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailPreparations = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailPreparations?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailPreparations(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailPreparations(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailPreparations = function (response) {
        var e_168, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_168_1) { e_168 = { error: e_168_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_168) throw e_168.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_169, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_17 = __values(resultData200), resultData200_17_1 = resultData200_17.next(); !resultData200_17_1.done; resultData200_17_1 = resultData200_17.next()) {
                            var item = resultData200_17_1.value;
                            result200.push(OrderDetailPreparationDto.fromJS(item));
                        }
                    }
                    catch (e_169_1) { e_169 = { error: e_169_1 }; }
                    finally {
                        try {
                            if (resultData200_17_1 && !resultData200_17_1.done && (_a = resultData200_17.return)) _a.call(resultData200_17);
                        }
                        finally { if (e_169) throw e_169.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailReturnings = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailReturnings?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailReturnings(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailReturnings(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailReturnings = function (response) {
        var e_170, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_170_1) { e_170 = { error: e_170_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_170) throw e_170.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_171, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_18 = __values(resultData200), resultData200_18_1 = resultData200_18.next(); !resultData200_18_1.done; resultData200_18_1 = resultData200_18.next()) {
                            var item = resultData200_18_1.value;
                            result200.push(OrderDetailReturnDto.fromJS(item));
                        }
                    }
                    catch (e_171_1) { e_171 = { error: e_171_1 }; }
                    finally {
                        try {
                            if (resultData200_18_1 && !resultData200_18_1.done && (_a = resultData200_18.return)) _a.call(resultData200_18);
                        }
                        finally { if (e_171) throw e_171.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailShipments = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailShipments?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailShipments(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailShipments(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailShipments = function (response) {
        var e_172, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_172_1) { e_172 = { error: e_172_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_172) throw e_172.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_173, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_19 = __values(resultData200), resultData200_19_1 = resultData200_19.next(); !resultData200_19_1.done; resultData200_19_1 = resultData200_19.next()) {
                            var item = resultData200_19_1.value;
                            result200.push(OrderDetailShipmentDto.fromJS(item));
                        }
                    }
                    catch (e_173_1) { e_173 = { error: e_173_1 }; }
                    finally {
                        try {
                            if (resultData200_19_1 && !resultData200_19_1.done && (_a = resultData200_19.return)) _a.call(resultData200_19);
                        }
                        finally { if (e_173) throw e_173.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailQuadmindsOrderDto = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailQuadmindsOrderDto?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailQuadmindsOrderDto(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailQuadmindsOrderDto(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailQuadmindsOrderDto = function (response) {
        var e_174, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_174_1) { e_174 = { error: e_174_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_174) throw e_174.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDetailQuadmindsDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.getOrderDetailTransfers = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/GetOrderDetailTransfers?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrderDetailTransfers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrderDetailTransfers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processGetOrderDetailTransfers = function (response) {
        var e_175, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_175_1) { e_175 = { error: e_175_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_175) throw e_175.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_176, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_20 = __values(resultData200), resultData200_20_1 = resultData200_20.next(); !resultData200_20_1.done; resultData200_20_1 = resultData200_20.next()) {
                            var item = resultData200_20_1.value;
                            result200.push(OrderDetailTransferDto.fromJS(item));
                        }
                    }
                    catch (e_176_1) { e_176 = { error: e_176_1 }; }
                    finally {
                        try {
                            if (resultData200_20_1 && !resultData200_20_1.done && (_a = resultData200_20.return)) _a.call(resultData200_20);
                        }
                        finally { if (e_176) throw e_176.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderDetailServiceProxy.prototype.updatePickupStore = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderDetail/UpdatePickupStore";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdatePickupStore(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdatePickupStore(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderDetailServiceProxy.prototype.processUpdatePickupStore = function (response) {
        var e_177, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_177_1) { e_177 = { error: e_177_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_177) throw e_177.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderDetailServiceProxy;
}());
export { OrderDetailServiceProxy };
var OrderLogisticStatusServiceProxy = /** @class */ (function () {
    function OrderLogisticStatusServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderLogisticStatusServiceProxy.prototype.getAll = function (storeCode, countryCode, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderLogisticStatusServiceProxy.prototype.processGetAll = function (response) {
        var e_178, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_178_1) { e_178 = { error: e_178_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_178) throw e_178.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderLogisticAuditDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderLogisticStatusServiceProxy.prototype.markAsCancelled = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/MarkAsCancelled?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsCancelled(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsCancelled(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderLogisticStatusServiceProxy.prototype.processMarkAsCancelled = function (response) {
        var e_179, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_179_1) { e_179 = { error: e_179_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_179) throw e_179.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderLogisticStatusServiceProxy.prototype.markAsReadyToHandle = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/MarkAsReadyToHandle?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsReadyToHandle(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsReadyToHandle(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderLogisticStatusServiceProxy.prototype.processMarkAsReadyToHandle = function (response) {
        var e_180, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_180_1) { e_180 = { error: e_180_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_180) throw e_180.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderLogisticStatusServiceProxy.prototype.getCsv = function (storeCode, countryCode, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/GetCsv?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderLogisticStatusServiceProxy.prototype.processGetCsv = function (response) {
        var e_181, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_181_1) { e_181 = { error: e_181_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_181) throw e_181.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderLogisticStatusServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderLogisticStatus/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderLogisticStatusServiceProxy.prototype.processGet = function (response) {
        var e_182, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_182_1) { e_182 = { error: e_182_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_182) throw e_182.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderLogisticAuditDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderLogisticStatusServiceProxy;
}());
export { OrderLogisticStatusServiceProxy };
var OrderNoteServiceProxy = /** @class */ (function () {
    function OrderNoteServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param orderId (optional)
     * @param description (optional)
     * @param notify (optional)
     * @return Success
     */
    OrderNoteServiceProxy.prototype.create = function (orderId, description, notify) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderNote/Create?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (description !== undefined)
            url_ += "description=" + encodeURIComponent("" + description) + "&";
        if (notify === null)
            throw new Error("The parameter 'notify' cannot be null.");
        else if (notify !== undefined)
            url_ += "notify=" + encodeURIComponent("" + notify) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderNoteServiceProxy.prototype.processCreate = function (response) {
        var e_183, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_183_1) { e_183 = { error: e_183_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_183) throw e_183.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @return Success
     */
    OrderNoteServiceProxy.prototype.getCount = function (storeCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderNote/GetCount?";
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderNoteServiceProxy.prototype.processGetCount = function (response) {
        var e_184, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_184_1) { e_184 = { error: e_184_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_184) throw e_184.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderNoteServiceProxy.prototype.markAsReaded = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderNote/MarkAsReaded";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsReaded(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsReaded(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderNoteServiceProxy.prototype.processMarkAsReaded = function (response) {
        var e_185, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_185_1) { e_185 = { error: e_185_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_185) throw e_185.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderNoteServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderNote/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderNoteServiceProxy.prototype.processGet = function (response) {
        var e_186, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_186_1) { e_186 = { error: e_186_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_186) throw e_186.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderNoteDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param storeCode (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderNoteServiceProxy.prototype.getAll = function (orderId, storeCode, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderNote/GetAll?";
        if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderNoteServiceProxy.prototype.processGetAll = function (response) {
        var e_187, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_187_1) { e_187 = { error: e_187_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_187) throw e_187.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderNoteDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderNoteServiceProxy;
}());
export { OrderNoteServiceProxy };
var OrderReadyToHandleServiceProxy = /** @class */ (function () {
    function OrderReadyToHandleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param orderIds (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param dateFrom (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReadyToHandleServiceProxy.prototype.getAll = function (storeCode, countryCode, orderIds, filters, search, dateFrom, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToHandleServiceProxy.prototype.processGetAll = function (response) {
        var e_188, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_188_1) { e_188 = { error: e_188_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_188) throw e_188.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderReadyToHandleDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param orderIds (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param dateFrom (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReadyToHandleServiceProxy.prototype.getCsvOL = function (storeCode, countryCode, orderIds, filters, search, dateFrom, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetCsvOL?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsvOL(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsvOL(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToHandleServiceProxy.prototype.processGetCsvOL = function (response) {
        var e_189, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_189_1) { e_189 = { error: e_189_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_189) throw e_189.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param orderIds (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param dateFrom (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReadyToHandleServiceProxy.prototype.getCsvQuadmin = function (storeCode, countryCode, orderIds, filters, search, dateFrom, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetCsvQuadmin?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsvQuadmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsvQuadmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToHandleServiceProxy.prototype.processGetCsvQuadmin = function (response) {
        var e_190, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_190_1) { e_190 = { error: e_190_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_190) throw e_190.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param orderIds (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param dateFrom (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReadyToHandleServiceProxy.prototype.getAllOL = function (storeCode, countryCode, orderIds, filters, search, dateFrom, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetAllOL?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllOL(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllOL(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToHandleServiceProxy.prototype.processGetAllOL = function (response) {
        var e_191, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_191_1) { e_191 = { error: e_191_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_191) throw e_191.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_192, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_21 = __values(resultData200), resultData200_21_1 = resultData200_21.next(); !resultData200_21_1.done; resultData200_21_1 = resultData200_21.next()) {
                            var item = resultData200_21_1.value;
                            result200.push(OrderCsvOLDto.fromJS(item));
                        }
                    }
                    catch (e_192_1) { e_192 = { error: e_192_1 }; }
                    finally {
                        try {
                            if (resultData200_21_1 && !resultData200_21_1.done && (_a = resultData200_21.return)) _a.call(resultData200_21);
                        }
                        finally { if (e_192) throw e_192.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param countryCode (optional)
     * @param orderIds (optional)
     * @param filters (optional)
     * @param search (optional)
     * @param dateFrom (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReadyToHandleServiceProxy.prototype.getAllQuadmin = function (storeCode, countryCode, orderIds, filters, search, dateFrom, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetAllQuadmin?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllQuadmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllQuadmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToHandleServiceProxy.prototype.processGetAllQuadmin = function (response) {
        var e_193, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_193_1) { e_193 = { error: e_193_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_193) throw e_193.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_194, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_22 = __values(resultData200), resultData200_22_1 = resultData200_22.next(); !resultData200_22_1.done; resultData200_22_1 = resultData200_22.next()) {
                            var item = resultData200_22_1.value;
                            result200.push(OrderReadyToHandleCsvQuadminDto.fromJS(item));
                        }
                    }
                    catch (e_194_1) { e_194 = { error: e_194_1 }; }
                    finally {
                        try {
                            if (resultData200_22_1 && !resultData200_22_1.done && (_a = resultData200_22.return)) _a.call(resultData200_22);
                        }
                        finally { if (e_194) throw e_194.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param pickingGroupId (optional)
     * @param orderId (optional)
     * @return Success
     */
    OrderReadyToHandleServiceProxy.prototype.getOrdersToPrepare = function (pickingGroupId, orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/GetOrdersToPrepare?";
        if (pickingGroupId !== undefined)
            url_ += "PickingGroupId=" + encodeURIComponent("" + pickingGroupId) + "&";
        if (orderId !== undefined)
            url_ += "OrderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrdersToPrepare(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrdersToPrepare(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToHandleServiceProxy.prototype.processGetOrdersToPrepare = function (response) {
        var e_195, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_195_1) { e_195 = { error: e_195_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_195) throw e_195.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_196, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_23 = __values(resultData200), resultData200_23_1 = resultData200_23.next(); !resultData200_23_1.done; resultData200_23_1 = resultData200_23.next()) {
                            var item = resultData200_23_1.value;
                            result200.push(OrderReadyToHandleDto.fromJS(item));
                        }
                    }
                    catch (e_196_1) { e_196 = { error: e_196_1 }; }
                    finally {
                        try {
                            if (resultData200_23_1 && !resultData200_23_1.done && (_a = resultData200_23.return)) _a.call(resultData200_23);
                        }
                        finally { if (e_196) throw e_196.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderReadyToHandleServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToHandle/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToHandleServiceProxy.prototype.processGet = function (response) {
        var e_197, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_197_1) { e_197 = { error: e_197_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_197) throw e_197.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderReadyToHandleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderReadyToHandleServiceProxy;
}());
export { OrderReadyToHandleServiceProxy };
var OrderReadyToShipServiceProxy = /** @class */ (function () {
    function OrderReadyToShipServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param storeCode (optional)
     * @param shippingTypeGroupId (optional)
     * @param filters (optional)
     * @param dateFrom (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReadyToShipServiceProxy.prototype.getAll = function (storeCode, shippingTypeGroupId, filters, dateFrom, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToShipServiceProxy.prototype.processGetAll = function (response) {
        var e_198, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_198_1) { e_198 = { error: e_198_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_198) throw e_198.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderReadyToShipDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param shippingTypeGroupId (optional)
     * @param filters (optional)
     * @param dateFrom (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReadyToShipServiceProxy.prototype.getCountByShippingTypeGroup = function (storeCode, shippingTypeGroupId, filters, dateFrom, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/GetCountByShippingTypeGroup?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (shippingTypeGroupId !== undefined)
            url_ += "ShippingTypeGroupId=" + encodeURIComponent("" + shippingTypeGroupId) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCountByShippingTypeGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCountByShippingTypeGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToShipServiceProxy.prototype.processGetCountByShippingTypeGroup = function (response) {
        var e_199, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_199_1) { e_199 = { error: e_199_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_199) throw e_199.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderReadyToShipServiceProxy.prototype.uploadCsv = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/UploadCsv";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToShipServiceProxy.prototype.processUploadCsv = function (response) {
        var e_200, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_200_1) { e_200 = { error: e_200_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_200) throw e_200.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderReadyToShipServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToShipServiceProxy.prototype.processCreate = function (response) {
        var e_201, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_201_1) { e_201 = { error: e_201_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_201) throw e_201.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderReadyToShipDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderReadyToShipServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToShipServiceProxy.prototype.processUpdate = function (response) {
        var e_202, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_202_1) { e_202 = { error: e_202_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_202) throw e_202.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderReadyToShipDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderReadyToShipServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToShipServiceProxy.prototype.processDelete = function (response) {
        var e_203, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_203_1) { e_203 = { error: e_203_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_203) throw e_203.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderReadyToShipServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReadyToShip/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReadyToShipServiceProxy.prototype.processGet = function (response) {
        var e_204, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_204_1) { e_204 = { error: e_204_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_204) throw e_204.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderReadyToShipDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderReadyToShipServiceProxy;
}());
export { OrderReadyToShipServiceProxy };
var OrderReturnedServiceProxy = /** @class */ (function () {
    function OrderReturnedServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param carrierId (optional)
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReturnedServiceProxy.prototype.getCsv = function (carrierId, dateFrom, dateTo, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReturned/GetCsv?";
        if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReturnedServiceProxy.prototype.processGetCsv = function (response) {
        var e_205, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_205_1) { e_205 = { error: e_205_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_205) throw e_205.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param carrierId (optional)
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderReturnedServiceProxy.prototype.getAll = function (carrierId, dateFrom, dateTo, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReturned/GetAll?";
        if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReturnedServiceProxy.prototype.processGetAll = function (response) {
        var e_206, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_206_1) { e_206 = { error: e_206_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_206) throw e_206.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderReturnedDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderReturnedServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderReturned/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderReturnedServiceProxy.prototype.processGet = function (response) {
        var e_207, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_207_1) { e_207 = { error: e_207_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_207) throw e_207.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderReturnedDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderReturnedServiceProxy;
}());
export { OrderReturnedServiceProxy };
var OrderStatusServiceProxy = /** @class */ (function () {
    function OrderStatusServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param countryCode (optional)
     * @param storeCode (optional)
     * @return Success
     */
    OrderStatusServiceProxy.prototype.getAll = function (countryCode, storeCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStatus/GetAll?";
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStatusServiceProxy.prototype.processGetAll = function (response) {
        var e_208, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_208_1) { e_208 = { error: e_208_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_208) throw e_208.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderWorkflowDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderStatusServiceProxy;
}());
export { OrderStatusServiceProxy };
var OrderStorePickupServiceProxy = /** @class */ (function () {
    function OrderStorePickupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filters (optional)
     * @param countryCode (optional)
     * @param search (optional)
     * @param dateFrom (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.getAll = function (filters, countryCode, search, dateFrom, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (search !== undefined)
            url_ += "Search=" + encodeURIComponent("" + search) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processGetAll = function (response) {
        var e_209, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_209_1) { e_209 = { error: e_209_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_209) throw e_209.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderStorePickupDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param key (optional)
     * @param dateFrom (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.getTotals = function (storeCode, key, dateFrom) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/GetTotals?";
        if (storeCode !== undefined)
            url_ += "storeCode=" + encodeURIComponent("" + storeCode) + "&";
        if (key === null)
            throw new Error("The parameter 'key' cannot be null.");
        else if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTotals(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTotals(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processGetTotals = function (response) {
        var e_210, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_210_1) { e_210 = { error: e_210_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_210) throw e_210.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param sourceCode (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.markAsReceivedBySourceCode = function (sourceCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsReceivedBySourceCode?";
        if (sourceCode !== undefined)
            url_ += "sourceCode=" + encodeURIComponent("" + sourceCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsReceivedBySourceCode(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsReceivedBySourceCode(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processMarkAsReceivedBySourceCode = function (response) {
        var e_211, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_211_1) { e_211 = { error: e_211_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_211) throw e_211.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.markAsReceived = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsReceived?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsReceived(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsReceived(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processMarkAsReceived = function (response) {
        var e_212, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_212_1) { e_212 = { error: e_212_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_212) throw e_212.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.markAsDelivered = function (orderId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsDelivered?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsDelivered(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsDelivered(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processMarkAsDelivered = function (response) {
        var e_213, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_213_1) { e_213 = { error: e_213_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_213) throw e_213.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param note (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.markAsReceivedWithFailure = function (orderId, note) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsReceivedWithFailure?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsReceivedWithFailure(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsReceivedWithFailure(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processMarkAsReceivedWithFailure = function (response) {
        var e_214, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_214_1) { e_214 = { error: e_214_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_214) throw e_214.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param note (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.markAsNotReceived = function (orderId, note) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsNotReceived?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsNotReceived(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsNotReceived(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processMarkAsNotReceived = function (response) {
        var e_215, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_215_1) { e_215 = { error: e_215_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_215) throw e_215.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param note (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.markAsNotDelivered = function (orderId, note) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/MarkAsNotDelivered?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (note !== undefined)
            url_ += "note=" + encodeURIComponent("" + note) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsNotDelivered(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsNotDelivered(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processMarkAsNotDelivered = function (response) {
        var e_216, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_216_1) { e_216 = { error: e_216_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_216) throw e_216.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processCreate = function (response) {
        var e_217, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_217_1) { e_217 = { error: e_217_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_217) throw e_217.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderStorePickupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processUpdate = function (response) {
        var e_218, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_218_1) { e_218 = { error: e_218_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_218) throw e_218.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderStorePickupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processDelete = function (response) {
        var e_219, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_219_1) { e_219 = { error: e_219_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_219) throw e_219.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    OrderStorePickupServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderStorePickup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderStorePickupServiceProxy.prototype.processGet = function (response) {
        var e_220, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_220_1) { e_220 = { error: e_220_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_220) throw e_220.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderStorePickupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderStorePickupServiceProxy;
}());
export { OrderStorePickupServiceProxy };
var OrderTrackingServiceProxy = /** @class */ (function () {
    function OrderTrackingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param nro (optional)
     * @return Success
     */
    OrderTrackingServiceProxy.prototype.get = function (nro) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderTracking/Get?";
        if (nro !== undefined)
            url_ += "nro=" + encodeURIComponent("" + nro) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderTrackingServiceProxy.prototype.processGet = function (response) {
        var e_221, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_221_1) { e_221 = { error: e_221_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_221) throw e_221.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderTrackingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param secureid (optional)
     * @return Success
     */
    OrderTrackingServiceProxy.prototype.validateOrderBySecureId = function (secureid) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderTracking/ValidateOrderBySecureId?";
        if (secureid !== undefined)
            url_ += "secureid=" + encodeURIComponent("" + secureid) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processValidateOrderBySecureId(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processValidateOrderBySecureId(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderTrackingServiceProxy.prototype.processValidateOrderBySecureId = function (response) {
        var e_222, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_222_1) { e_222 = { error: e_222_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_222) throw e_222.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    OrderTrackingServiceProxy.prototype.updateDeliveryData = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/OrderTracking/UpdateDeliveryData";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateDeliveryData(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateDeliveryData(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    OrderTrackingServiceProxy.prototype.processUpdateDeliveryData = function (response) {
        var e_223, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_223_1) { e_223 = { error: e_223_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_223) throw e_223.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return OrderTrackingServiceProxy;
}());
export { OrderTrackingServiceProxy };
var PendingManagementServiceProxy = /** @class */ (function () {
    function PendingManagementServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param orderId (optional)
     * @param documentNumber (optional)
     * @param amount (optional)
     * @return Success
     */
    PendingManagementServiceProxy.prototype.changeToCreditNoteIssue = function (orderId, documentNumber, amount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingManagement/ChangeToCreditNoteIssue?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (documentNumber !== undefined)
            url_ += "documentNumber=" + encodeURIComponent("" + documentNumber) + "&";
        if (amount === null)
            throw new Error("The parameter 'amount' cannot be null.");
        else if (amount !== undefined)
            url_ += "amount=" + encodeURIComponent("" + amount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeToCreditNoteIssue(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeToCreditNoteIssue(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingManagementServiceProxy.prototype.processChangeToCreditNoteIssue = function (response) {
        var e_224, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_224_1) { e_224 = { error: e_224_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_224) throw e_224.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param body (optional)
     * @return Success
     */
    PendingManagementServiceProxy.prototype.changeToPaid = function (orderId, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingManagement/ChangeToPaid?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processChangeToPaid(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processChangeToPaid(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingManagementServiceProxy.prototype.processChangeToPaid = function (response) {
        var e_225, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_225_1) { e_225 = { error: e_225_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_225) throw e_225.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param countryCode (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PendingManagementServiceProxy.prototype.getAll = function (countryCode, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingManagement/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingManagementServiceProxy.prototype.processGetAll = function (response) {
        var e_226, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_226_1) { e_226 = { error: e_226_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_226) throw e_226.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PendingManagementServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingManagement/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingManagementServiceProxy.prototype.processGet = function (response) {
        var e_227, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_227_1) { e_227 = { error: e_227_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_227) throw e_227.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = OrderDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PendingManagementServiceProxy;
}());
export { PendingManagementServiceProxy };
var PendingReturnServiceProxy = /** @class */ (function () {
    function PendingReturnServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    PendingReturnServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingReturn/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingReturnServiceProxy.prototype.processGet = function (response) {
        var e_228, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_228_1) { e_228 = { error: e_228_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_228) throw e_228.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PendingReturnDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param pendingReturnId (optional)
     * @param body (optional)
     * @return Success
     */
    PendingReturnServiceProxy.prototype.markAsReturned = function (pendingReturnId, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingReturn/MarkAsReturned?";
        if (pendingReturnId === null)
            throw new Error("The parameter 'pendingReturnId' cannot be null.");
        else if (pendingReturnId !== undefined)
            url_ += "pendingReturnId=" + encodeURIComponent("" + pendingReturnId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processMarkAsReturned(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processMarkAsReturned(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingReturnServiceProxy.prototype.processMarkAsReturned = function (response) {
        var e_229, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_229_1) { e_229 = { error: e_229_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_229) throw e_229.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PendingReturnServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingReturn/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingReturnServiceProxy.prototype.processCreate = function (response) {
        var e_230, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_230_1) { e_230 = { error: e_230_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_230) throw e_230.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PendingReturnDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PendingReturnServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingReturn/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingReturnServiceProxy.prototype.processUpdate = function (response) {
        var e_231, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_231_1) { e_231 = { error: e_231_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_231) throw e_231.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PendingReturnDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PendingReturnServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingReturn/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingReturnServiceProxy.prototype.processDelete = function (response) {
        var e_232, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_232_1) { e_232 = { error: e_232_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_232) throw e_232.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PendingReturnServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PendingReturn/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PendingReturnServiceProxy.prototype.processGetAll = function (response) {
        var e_233, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_233_1) { e_233 = { error: e_233_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_233) throw e_233.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PendingReturnDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PendingReturnServiceProxy;
}());
export { PendingReturnServiceProxy };
var PicapServiceProxy = /** @class */ (function () {
    function PicapServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    PicapServiceProxy.prototype.hookBooking = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Picap/HookBooking";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processHookBooking(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processHookBooking(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PicapServiceProxy.prototype.processHookBooking = function (response) {
        var e_234, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_234_1) { e_234 = { error: e_234_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_234) throw e_234.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PicapServiceProxy.prototype.hookPackage = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Picap/HookPackage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processHookPackage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processHookPackage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PicapServiceProxy.prototype.processHookPackage = function (response) {
        var e_235, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_235_1) { e_235 = { error: e_235_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_235) throw e_235.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PicapServiceProxy;
}());
export { PicapServiceProxy };
var PickingGroupServiceProxy = /** @class */ (function () {
    function PickingGroupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param storeCode (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.getAll = function (storeCode, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processGetAll = function (response) {
        var e_236, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_236_1) { e_236 = { error: e_236_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_236) throw e_236.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.getWithOrders = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/GetWithOrders?";
        if (input === null)
            throw new Error("The parameter 'input' cannot be null.");
        else if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetWithOrders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetWithOrders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processGetWithOrders = function (response) {
        var e_237, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_237_1) { e_237 = { error: e_237_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_237) throw e_237.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.addOrdersFromPickingGroup = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/AddOrdersFromPickingGroup";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddOrdersFromPickingGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddOrdersFromPickingGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processAddOrdersFromPickingGroup = function (response) {
        var e_238, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_238_1) { e_238 = { error: e_238_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_238) throw e_238.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param pickingGroupId (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.closePickingGroup = function (pickingGroupId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/ClosePickingGroup?";
        if (pickingGroupId === null)
            throw new Error("The parameter 'pickingGroupId' cannot be null.");
        else if (pickingGroupId !== undefined)
            url_ += "pickingGroupId=" + encodeURIComponent("" + pickingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processClosePickingGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processClosePickingGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processClosePickingGroup = function (response) {
        var e_239, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_239_1) { e_239 = { error: e_239_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_239) throw e_239.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.createPicking = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/CreatePicking";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreatePicking(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreatePicking(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processCreatePicking = function (response) {
        var e_240, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_240_1) { e_240 = { error: e_240_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_240) throw e_240.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processDelete = function (response) {
        var e_241, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_241_1) { e_241 = { error: e_241_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_241) throw e_241.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.cancel = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/Cancel";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCancel(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCancel(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processCancel = function (response) {
        var e_242, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_242_1) { e_242 = { error: e_242_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_242) throw e_242.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.getCsv = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/GetCsv?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processGetCsv = function (response) {
        var e_243, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_243_1) { e_243 = { error: e_243_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_243) throw e_243.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderIds (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.removeOrdersFromPickingGroup = function (pickingGroupId, orderIds) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/RemoveOrdersFromPickingGroup?";
        if (pickingGroupId === undefined || pickingGroupId === null)
            throw new Error("The parameter 'pickingGroupId' must be defined and cannot be null.");
        else
            url_ += "PickingGroupId=" + encodeURIComponent("" + pickingGroupId) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processRemoveOrdersFromPickingGroup(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processRemoveOrdersFromPickingGroup(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processRemoveOrdersFromPickingGroup = function (response) {
        var e_244, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_244_1) { e_244 = { error: e_244_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_244) throw e_244.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.solvePickingGroupConflicts = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/SolvePickingGroupConflicts";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSolvePickingGroupConflicts(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSolvePickingGroupConflicts(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processSolvePickingGroupConflicts = function (response) {
        var e_245, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_245_1) { e_245 = { error: e_245_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_245) throw e_245.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.updatePickedQuantity = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/UpdatePickedQuantity";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdatePickedQuantity(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdatePickedQuantity(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processUpdatePickedQuantity = function (response) {
        var e_246, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_246_1) { e_246 = { error: e_246_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_246) throw e_246.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param pickingGroupId (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.getPrintablePickingNote = function (pickingGroupId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/GetPrintablePickingNote?";
        if (pickingGroupId === null)
            throw new Error("The parameter 'pickingGroupId' cannot be null.");
        else if (pickingGroupId !== undefined)
            url_ += "pickingGroupId=" + encodeURIComponent("" + pickingGroupId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetPrintablePickingNote(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetPrintablePickingNote(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processGetPrintablePickingNote = function (response) {
        var e_247, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_247_1) { e_247 = { error: e_247_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_247) throw e_247.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processCreate = function (response) {
        var e_248, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_248_1) { e_248 = { error: e_248_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_248) throw e_248.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processUpdate = function (response) {
        var e_249, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_249_1) { e_249 = { error: e_249_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_249) throw e_249.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PickingGroupServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupServiceProxy.prototype.processGet = function (response) {
        var e_250, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_250_1) { e_250 = { error: e_250_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_250) throw e_250.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PickingGroupServiceProxy;
}());
export { PickingGroupServiceProxy };
var PickingGroupItemServiceProxy = /** @class */ (function () {
    function PickingGroupItemServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupItemServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupItem/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupItemServiceProxy.prototype.processUpdate = function (response) {
        var e_251, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_251_1) { e_251 = { error: e_251_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_251) throw e_251.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupItemServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupItem/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupItemServiceProxy.prototype.processCreate = function (response) {
        var e_252, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_252_1) { e_252 = { error: e_252_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_252) throw e_252.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PickingGroupItemServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupItem/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupItemServiceProxy.prototype.processDelete = function (response) {
        var e_253, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_253_1) { e_253 = { error: e_253_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_253) throw e_253.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PickingGroupItemServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupItem/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupItemServiceProxy.prototype.processGet = function (response) {
        var e_254, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_254_1) { e_254 = { error: e_254_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_254) throw e_254.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param storeCode (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PickingGroupItemServiceProxy.prototype.getAll = function (storeCode, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupItem/GetAll?";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupItemServiceProxy.prototype.processGetAll = function (response) {
        var e_255, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_255_1) { e_255 = { error: e_255_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_255) throw e_255.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PickingGroupItemServiceProxy;
}());
export { PickingGroupItemServiceProxy };
var PickingGroupRuleServiceProxy = /** @class */ (function () {
    function PickingGroupRuleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupRuleServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupRule/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupRuleServiceProxy.prototype.processCreate = function (response) {
        var e_256, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_256_1) { e_256 = { error: e_256_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_256) throw e_256.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupRuleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PickingGroupRuleServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupRule/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupRuleServiceProxy.prototype.processUpdate = function (response) {
        var e_257, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_257_1) { e_257 = { error: e_257_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_257) throw e_257.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupRuleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PickingGroupRuleServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupRule/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupRuleServiceProxy.prototype.processDelete = function (response) {
        var e_258, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_258_1) { e_258 = { error: e_258_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_258) throw e_258.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PickingGroupRuleServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupRule/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupRuleServiceProxy.prototype.processGet = function (response) {
        var e_259, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_259_1) { e_259 = { error: e_259_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_259) throw e_259.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupRuleDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PickingGroupRuleServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PickingGroupRule/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PickingGroupRuleServiceProxy.prototype.processGetAll = function (response) {
        var e_260, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_260_1) { e_260 = { error: e_260_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_260) throw e_260.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PickingGroupRuleDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PickingGroupRuleServiceProxy;
}());
export { PickingGroupRuleServiceProxy };
var PreparationServiceProxy = /** @class */ (function () {
    function PreparationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    PreparationServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Preparation/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PreparationServiceProxy.prototype.processCreate = function (response) {
        var e_261, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_261_1) { e_261 = { error: e_261_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_261) throw e_261.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PreparationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PreparationServiceProxy.prototype.getOrCreate = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Preparation/GetOrCreate";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetOrCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetOrCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PreparationServiceProxy.prototype.processGetOrCreate = function (response) {
        var e_262, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_262_1) { e_262 = { error: e_262_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_262) throw e_262.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PreparationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PreparationServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Preparation/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PreparationServiceProxy.prototype.processUpdate = function (response) {
        var e_263, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_263_1) { e_263 = { error: e_263_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_263) throw e_263.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PreparationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PreparationServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Preparation/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PreparationServiceProxy.prototype.processDelete = function (response) {
        var e_264, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_264_1) { e_264 = { error: e_264_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_264) throw e_264.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PreparationServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Preparation/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PreparationServiceProxy.prototype.processGet = function (response) {
        var e_265, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_265_1) { e_265 = { error: e_265_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_265) throw e_265.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PreparationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PreparationServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Preparation/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PreparationServiceProxy.prototype.processGetAll = function (response) {
        var e_266, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_266_1) { e_266 = { error: e_266_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_266) throw e_266.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PreparationDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PreparationServiceProxy;
}());
export { PreparationServiceProxy };
var ProcessServiceProxy = /** @class */ (function () {
    function ProcessServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    ProcessServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Process/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ProcessServiceProxy.prototype.processGet = function (response) {
        var e_267, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_267_1) { e_267 = { error: e_267_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_267) throw e_267.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ProcessDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ProcessServiceProxy;
}());
export { ProcessServiceProxy };
var PromotionMappingServiceProxy = /** @class */ (function () {
    function PromotionMappingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    PromotionMappingServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PromotionMapping/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PromotionMappingServiceProxy.prototype.processGetAll = function (response) {
        var e_268, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_268_1) { e_268 = { error: e_268_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_268) throw e_268.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PromotionMappingDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PromotionMappingServiceProxy.prototype.uploadPromotions = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PromotionMapping/UploadPromotions";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadPromotions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadPromotions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PromotionMappingServiceProxy.prototype.processUploadPromotions = function (response) {
        var e_269, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_269_1) { e_269 = { error: e_269_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_269) throw e_269.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    PromotionMappingServiceProxy.prototype.deleteAllPromotions = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PromotionMapping/DeleteAllPromotions";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteAllPromotions(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteAllPromotions(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PromotionMappingServiceProxy.prototype.processDeleteAllPromotions = function (response) {
        var e_270, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_270_1) { e_270 = { error: e_270_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_270) throw e_270.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PromotionMappingServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PromotionMapping/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PromotionMappingServiceProxy.prototype.processCreate = function (response) {
        var e_271, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_271_1) { e_271 = { error: e_271_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_271) throw e_271.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PromotionMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    PromotionMappingServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PromotionMapping/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PromotionMappingServiceProxy.prototype.processUpdate = function (response) {
        var e_272, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_272_1) { e_272 = { error: e_272_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_272) throw e_272.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PromotionMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PromotionMappingServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PromotionMapping/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PromotionMappingServiceProxy.prototype.processDelete = function (response) {
        var e_273, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_273_1) { e_273 = { error: e_273_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_273) throw e_273.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    PromotionMappingServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/PromotionMapping/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    PromotionMappingServiceProxy.prototype.processGet = function (response) {
        var e_274, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_274_1) { e_274 = { error: e_274_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_274) throw e_274.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = PromotionMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return PromotionMappingServiceProxy;
}());
export { PromotionMappingServiceProxy };
var QuadmindsOrderServiceProxy = /** @class */ (function () {
    function QuadmindsOrderServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    QuadmindsOrderServiceProxy.prototype.getTest = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuadmindsOrder/GetTest";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuadmindsOrderServiceProxy.prototype.processGetTest = function (response) {
        var e_275, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_275_1) { e_275 = { error: e_275_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_275) throw e_275.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    QuadmindsOrderServiceProxy.prototype.saveDataRequestDto = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuadmindsOrder/SaveDataRequestDto";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveDataRequestDto(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveDataRequestDto(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuadmindsOrderServiceProxy.prototype.processSaveDataRequestDto = function (response) {
        var e_276, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_276_1) { e_276 = { error: e_276_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_276) throw e_276.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param responseData (optional)
     * @return Success
     */
    QuadmindsOrderServiceProxy.prototype.saveDataRequestStr = function (responseData) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/QuadmindsOrder/SaveDataRequestStr?";
        if (responseData !== undefined)
            url_ += "responseData=" + encodeURIComponent("" + responseData) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSaveDataRequestStr(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSaveDataRequestStr(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    QuadmindsOrderServiceProxy.prototype.processSaveDataRequestStr = function (response) {
        var e_277, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_277_1) { e_277 = { error: e_277_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_277) throw e_277.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return QuadmindsOrderServiceProxy;
}());
export { QuadmindsOrderServiceProxy };
var ApiServiceProxy = /** @class */ (function () {
    function ApiServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @return Success
     */
    ApiServiceProxy.prototype.quadMindsOrderGet = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/QuadMindsOrder";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processQuadMindsOrderGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processQuadMindsOrderGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ApiServiceProxy.prototype.processQuadMindsOrderGet = function (response) {
        var e_278, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_278_1) { e_278 = { error: e_278_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_278) throw e_278.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    ApiServiceProxy.prototype.quadMindsOrderPost = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/QuadMindsOrder";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processQuadMindsOrderPost(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processQuadMindsOrderPost(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ApiServiceProxy.prototype.processQuadMindsOrderPost = function (response) {
        var e_279, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_279_1) { e_279 = { error: e_279_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_279) throw e_279.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ApiServiceProxy.prototype.quadMindsOrderPut = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/QuadMindsOrder";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processQuadMindsOrderPut(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processQuadMindsOrderPut(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ApiServiceProxy.prototype.processQuadMindsOrderPut = function (response) {
        var e_280, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_280_1) { e_280 = { error: e_280_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_280) throw e_280.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ApiServiceProxy;
}());
export { ApiServiceProxy };
var RapiboyWebhookServiceProxy = /** @class */ (function () {
    function RapiboyWebhookServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    RapiboyWebhookServiceProxy.prototype.onChangeState = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RapiboyWebhook/OnChangeState";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processOnChangeState(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processOnChangeState(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RapiboyWebhookServiceProxy.prototype.processOnChangeState = function (response) {
        var e_281, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_281_1) { e_281 = { error: e_281_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_281) throw e_281.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return RapiboyWebhookServiceProxy;
}());
export { RapiboyWebhookServiceProxy };
var RappiServiceProxy = /** @class */ (function () {
    function RappiServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processCreate = function (response) {
        var e_282, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_282_1) { e_282 = { error: e_282_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_282) throw e_282.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RappiItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processDelete = function (response) {
        var e_283, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_283_1) { e_283 = { error: e_283_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_283) throw e_283.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processUpdate = function (response) {
        var e_284, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_284_1) { e_284 = { error: e_284_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_284) throw e_284.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RappiItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    RappiServiceProxy.prototype.getCatalog = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/GetCatalog";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCatalog(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCatalog(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processGetCatalog = function (response) {
        var e_285, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_285_1) { e_285 = { error: e_285_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_285) throw e_285.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.getCsv = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/GetCsv?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processGetCsv = function (response) {
        var e_286, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_286_1) { e_286 = { error: e_286_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_286) throw e_286.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.getAllDashboard = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/GetAllDashboard?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllDashboard(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllDashboard(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processGetAllDashboard = function (response) {
        var e_287, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_287_1) { e_287 = { error: e_287_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_287) throw e_287.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_288, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_24 = __values(resultData200), resultData200_24_1 = resultData200_24.next(); !resultData200_24_1.done; resultData200_24_1 = resultData200_24.next()) {
                            var item = resultData200_24_1.value;
                            result200.push(RappiItemCsvDashboardDto.fromJS(item));
                        }
                    }
                    catch (e_288_1) { e_288 = { error: e_288_1 }; }
                    finally {
                        try {
                            if (resultData200_24_1 && !resultData200_24_1.done && (_a = resultData200_24.return)) _a.call(resultData200_24);
                        }
                        finally { if (e_288) throw e_288.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.syncCatalog = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/SyncCatalog";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSyncCatalog(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSyncCatalog(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processSyncCatalog = function (response) {
        var e_289, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_289_1) { e_289 = { error: e_289_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_289) throw e_289.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    RappiServiceProxy.prototype.syncFromComerssia = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/SyncFromComerssia";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processSyncFromComerssia(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processSyncFromComerssia(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processSyncFromComerssia = function (response) {
        var e_290, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_290_1) { e_290 = { error: e_290_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_290) throw e_290.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.updateConfig = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/UpdateConfig";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdateConfig(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdateConfig(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processUpdateConfig = function (response) {
        var e_291, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_291_1) { e_291 = { error: e_291_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_291) throw e_291.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.uploadCsv = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/UploadCsv";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processUploadCsv = function (response) {
        var e_292, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_292_1) { e_292 = { error: e_292_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_292) throw e_292.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.uploadProductsCsv = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/UploadProductsCsv";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadProductsCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadProductsCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processUploadProductsCsv = function (response) {
        var e_293, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_293_1) { e_293 = { error: e_293_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_293) throw e_293.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processGet = function (response) {
        var e_294, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_294_1) { e_294 = { error: e_294_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_294) throw e_294.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RappiItemDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    RappiServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Rappi/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiServiceProxy.prototype.processGetAll = function (response) {
        var e_295, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_295_1) { e_295 = { error: e_295_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_295) throw e_295.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RappiItemDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return RappiServiceProxy;
}());
export { RappiServiceProxy };
var RappiConfigServiceProxy = /** @class */ (function () {
    function RappiConfigServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    RappiConfigServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RappiConfig/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiConfigServiceProxy.prototype.processCreate = function (response) {
        var e_296, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_296_1) { e_296 = { error: e_296_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_296) throw e_296.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RappiStoreConfigDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    RappiConfigServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RappiConfig/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiConfigServiceProxy.prototype.processUpdate = function (response) {
        var e_297, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_297_1) { e_297 = { error: e_297_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_297) throw e_297.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RappiStoreConfigDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    RappiConfigServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RappiConfig/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiConfigServiceProxy.prototype.processDelete = function (response) {
        var e_298, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_298_1) { e_298 = { error: e_298_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_298) throw e_298.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    RappiConfigServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RappiConfig/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiConfigServiceProxy.prototype.processGet = function (response) {
        var e_299, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_299_1) { e_299 = { error: e_299_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_299) throw e_299.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RappiStoreConfigDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    RappiConfigServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/RappiConfig/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    RappiConfigServiceProxy.prototype.processGetAll = function (response) {
        var e_300, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_300_1) { e_300 = { error: e_300_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_300) throw e_300.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = RappiStoreConfigDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return RappiConfigServiceProxy;
}());
export { RappiConfigServiceProxy };
var ReturnServiceProxy = /** @class */ (function () {
    function ReturnServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param returningId (optional)
     * @return Success
     */
    ReturnServiceProxy.prototype.finalize = function (returningId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Return/Finalize?";
        if (returningId === null)
            throw new Error("The parameter 'returningId' cannot be null.");
        else if (returningId !== undefined)
            url_ += "returningId=" + encodeURIComponent("" + returningId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFinalize(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFinalize(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnServiceProxy.prototype.processFinalize = function (response) {
        var e_301, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_301_1) { e_301 = { error: e_301_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_301) throw e_301.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param countryCode (optional)
     * @param storeCode (optional)
     * @param orderIds (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ReturnServiceProxy.prototype.getAll = function (countryCode, storeCode, orderIds, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Return/GetAll?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnServiceProxy.prototype.processGetAll = function (response) {
        var e_302, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_302_1) { e_302 = { error: e_302_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_302) throw e_302.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ReturnDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param countryCode (optional)
     * @param storeCode (optional)
     * @param orderIds (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ReturnServiceProxy.prototype.getCsvQuadmin = function (countryCode, storeCode, orderIds, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Return/GetCsvQuadmin?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsvQuadmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsvQuadmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnServiceProxy.prototype.processGetCsvQuadmin = function (response) {
        var e_303, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_303_1) { e_303 = { error: e_303_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_303) throw e_303.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param countryCode (optional)
     * @param storeCode (optional)
     * @param orderIds (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ReturnServiceProxy.prototype.getAllQuadmin = function (countryCode, storeCode, orderIds, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Return/GetAllQuadmin?";
        if (countryCode !== undefined)
            url_ += "CountryCode=" + encodeURIComponent("" + countryCode) + "&";
        if (storeCode !== undefined)
            url_ += "StoreCode=" + encodeURIComponent("" + storeCode) + "&";
        if (orderIds !== undefined)
            orderIds && orderIds.forEach(function (item) { url_ += "OrderIds=" + encodeURIComponent("" + item) + "&"; });
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAllQuadmin(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAllQuadmin(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnServiceProxy.prototype.processGetAllQuadmin = function (response) {
        var e_304, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_304_1) { e_304 = { error: e_304_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_304) throw e_304.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_305, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_25 = __values(resultData200), resultData200_25_1 = resultData200_25.next(); !resultData200_25_1.done; resultData200_25_1 = resultData200_25.next()) {
                            var item = resultData200_25_1.value;
                            result200.push(ReturnCsvQuadminDto.fromJS(item));
                        }
                    }
                    catch (e_305_1) { e_305 = { error: e_305_1 }; }
                    finally {
                        try {
                            if (resultData200_25_1 && !resultData200_25_1.done && (_a = resultData200_25.return)) _a.call(resultData200_25);
                        }
                        finally { if (e_305) throw e_305.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ReturnServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Return/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnServiceProxy.prototype.processCreate = function (response) {
        var e_306, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_306_1) { e_306 = { error: e_306_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_306) throw e_306.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ReturnDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ReturnServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Return/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnServiceProxy.prototype.processUpdate = function (response) {
        var e_307, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_307_1) { e_307 = { error: e_307_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_307) throw e_307.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ReturnDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ReturnServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Return/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnServiceProxy.prototype.processDelete = function (response) {
        var e_308, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_308_1) { e_308 = { error: e_308_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_308) throw e_308.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ReturnServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Return/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ReturnServiceProxy.prototype.processGet = function (response) {
        var e_309, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_309_1) { e_309 = { error: e_309_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_309) throw e_309.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ReturnDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ReturnServiceProxy;
}());
export { ReturnServiceProxy };
var S3ServiceProxy = /** @class */ (function () {
    function S3ServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param key (optional)
     * @param bucket (optional)
     * @param body (optional)
     * @return Success
     */
    S3ServiceProxy.prototype.uploadFile = function (key, bucket, body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/S3/UploadFile?";
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        if (bucket !== undefined)
            url_ += "bucket=" + encodeURIComponent("" + bucket) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = body;
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "multipart/form-data",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadFile(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadFile(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    S3ServiceProxy.prototype.processUploadFile = function (response) {
        var e_310, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_310_1) { e_310 = { error: e_310_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_310) throw e_310.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    S3ServiceProxy.prototype.uploadImage = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/S3/UploadImage";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadImage(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadImage(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    S3ServiceProxy.prototype.processUploadImage = function (response) {
        var e_311, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_311_1) { e_311 = { error: e_311_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_311) throw e_311.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return S3ServiceProxy;
}());
export { S3ServiceProxy };
var SalesOrderNotificationsServiceProxy = /** @class */ (function () {
    function SalesOrderNotificationsServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    SalesOrderNotificationsServiceProxy.prototype.notify = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SalesOrderNotifications/Notify";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processNotify(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processNotify(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SalesOrderNotificationsServiceProxy.prototype.processNotify = function (response) {
        var e_312, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_312_1) { e_312 = { error: e_312_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_312) throw e_312.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @return Success
     */
    SalesOrderNotificationsServiceProxy.prototype.test = function () {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SalesOrderNotifications/Test";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processTest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processTest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SalesOrderNotificationsServiceProxy.prototype.processTest = function (response) {
        var e_313, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_313_1) { e_313 = { error: e_313_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_313) throw e_313.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return SalesOrderNotificationsServiceProxy;
}());
export { SalesOrderNotificationsServiceProxy };
var ShipmentServiceProxy = /** @class */ (function () {
    function ShipmentServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processCreate = function (response) {
        var e_314, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_314_1) { e_314 = { error: e_314_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_314) throw e_314.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShipmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.createShipmentProcess = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/CreateShipmentProcess";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateShipmentProcess(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateShipmentProcess(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processCreateShipmentProcess = function (response) {
        var e_315, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_315_1) { e_315 = { error: e_315_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_315) throw e_315.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.checkOrdersAvailableToShip = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/CheckOrdersAvailableToShip";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCheckOrdersAvailableToShip(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCheckOrdersAvailableToShip(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processCheckOrdersAvailableToShip = function (response) {
        var e_316, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_316_1) { e_316 = { error: e_316_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_316) throw e_316.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.finalize = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/Finalize";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processFinalize(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processFinalize(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processFinalize = function (response) {
        var e_317, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_317_1) { e_317 = { error: e_317_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_317) throw e_317.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShipmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.partialSave = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/PartialSave";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processPartialSave(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processPartialSave(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processPartialSave = function (response) {
        var e_318, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_318_1) { e_318 = { error: e_318_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_318) throw e_318.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processGet = function (response) {
        var e_319, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_319_1) { e_319 = { error: e_319_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_319) throw e_319.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShipmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.getCsv = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/GetCsv?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processGetCsv = function (response) {
        var e_320, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_320_1) { e_320 = { error: e_320_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_320) throw e_320.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param carrierId (optional)
     * @param dateFrom (optional)
     * @param dateTo (optional)
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.getCsvShipmentsCount = function (carrierId, dateFrom, dateTo, filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/GetCsvShipmentsCount?";
        if (carrierId !== undefined)
            url_ += "CarrierId=" + encodeURIComponent("" + carrierId) + "&";
        if (dateFrom !== undefined)
            url_ += "DateFrom=" + encodeURIComponent(dateFrom ? "" + dateFrom.toJSON() : "") + "&";
        if (dateTo !== undefined)
            url_ += "DateTo=" + encodeURIComponent(dateTo ? "" + dateTo.toJSON() : "") + "&";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsvShipmentsCount(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsvShipmentsCount(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processGetCsvShipmentsCount = function (response) {
        var e_321, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_321_1) { e_321 = { error: e_321_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_321) throw e_321.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.getCsvCompleteShipmentOrderSku = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/GetCsvCompleteShipmentOrderSku?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetCsvCompleteShipmentOrderSku(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetCsvCompleteShipmentOrderSku(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processGetCsvCompleteShipmentOrderSku = function (response) {
        var e_322, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_322_1) { e_322 = { error: e_322_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_322) throw e_322.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param shipmentId (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.getShipmentResume = function (shipmentId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/GetShipmentResume?";
        if (shipmentId === null)
            throw new Error("The parameter 'shipmentId' cannot be null.");
        else if (shipmentId !== undefined)
            url_ += "shipmentId=" + encodeURIComponent("" + shipmentId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetShipmentResume(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetShipmentResume(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processGetShipmentResume = function (response) {
        var e_323, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_323_1) { e_323 = { error: e_323_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_323) throw e_323.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param shipmentId (optional)
     * @param countryCode (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.getShipmentResumeInner = function (shipmentId, countryCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/GetShipmentResumeInner?";
        if (shipmentId === null)
            throw new Error("The parameter 'shipmentId' cannot be null.");
        else if (shipmentId !== undefined)
            url_ += "shipmentId=" + encodeURIComponent("" + shipmentId) + "&";
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetShipmentResumeInner(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetShipmentResumeInner(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processGetShipmentResumeInner = function (response) {
        var e_324, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_324_1) { e_324 = { error: e_324_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_324) throw e_324.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processUpdate = function (response) {
        var e_325, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_325_1) { e_325 = { error: e_325_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_325) throw e_325.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShipmentDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processDelete = function (response) {
        var e_326, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_326_1) { e_326 = { error: e_326_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_326) throw e_326.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ShipmentServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Shipment/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShipmentServiceProxy.prototype.processGetAll = function (response) {
        var e_327, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_327_1) { e_327 = { error: e_327_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_327) throw e_327.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShipmentDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ShipmentServiceProxy;
}());
export { ShipmentServiceProxy };
var ShippingTypeServiceProxy = /** @class */ (function () {
    function ShippingTypeServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param shippingTypeId (optional)
     * @param deliveryScheduleId (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.addDeliverySchedule = function (shippingTypeId, deliveryScheduleId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/AddDeliverySchedule?";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (deliveryScheduleId === null)
            throw new Error("The parameter 'deliveryScheduleId' cannot be null.");
        else if (deliveryScheduleId !== undefined)
            url_ += "deliveryScheduleId=" + encodeURIComponent("" + deliveryScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAddDeliverySchedule(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAddDeliverySchedule(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processAddDeliverySchedule = function (response) {
        var e_328, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_328_1) { e_328 = { error: e_328_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_328) throw e_328.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param shippingTypeId (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.getDeliverySchedules = function (shippingTypeId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/GetDeliverySchedules?";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetDeliverySchedules(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetDeliverySchedules(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processGetDeliverySchedules = function (response) {
        var e_329, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_329_1) { e_329 = { error: e_329_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_329) throw e_329.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_330, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_26 = __values(resultData200), resultData200_26_1 = resultData200_26.next(); !resultData200_26_1.done; resultData200_26_1 = resultData200_26.next()) {
                            var item = resultData200_26_1.value;
                            result200.push(DeliveryScheduleDto.fromJS(item));
                        }
                    }
                    catch (e_330_1) { e_330 = { error: e_330_1 }; }
                    finally {
                        try {
                            if (resultData200_26_1 && !resultData200_26_1.done && (_a = resultData200_26.return)) _a.call(resultData200_26);
                        }
                        finally { if (e_330) throw e_330.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param shippingTypeId (optional)
     * @param deliveryScheduleId (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.deleteDeliverySchedule = function (shippingTypeId, deliveryScheduleId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/DeleteDeliverySchedule?";
        if (shippingTypeId === null)
            throw new Error("The parameter 'shippingTypeId' cannot be null.");
        else if (shippingTypeId !== undefined)
            url_ += "shippingTypeId=" + encodeURIComponent("" + shippingTypeId) + "&";
        if (deliveryScheduleId === null)
            throw new Error("The parameter 'deliveryScheduleId' cannot be null.");
        else if (deliveryScheduleId !== undefined)
            url_ += "deliveryScheduleId=" + encodeURIComponent("" + deliveryScheduleId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDeleteDeliverySchedule(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDeleteDeliverySchedule(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processDeleteDeliverySchedule = function (response) {
        var e_331, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_331_1) { e_331 = { error: e_331_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_331) throw e_331.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param countryCode (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.getShippingTypeForCountry = function (countryCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/GetShippingTypeForCountry?";
        if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetShippingTypeForCountry(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetShippingTypeForCountry(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processGetShippingTypeForCountry = function (response) {
        var e_332, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_332_1) { e_332 = { error: e_332_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_332) throw e_332.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_333, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_27 = __values(resultData200), resultData200_27_1 = resultData200_27.next(); !resultData200_27_1.done; resultData200_27_1 = resultData200_27.next()) {
                            var item = resultData200_27_1.value;
                            result200.push(ShippingTypeDto.fromJS(item));
                        }
                    }
                    catch (e_333_1) { e_333 = { error: e_333_1 }; }
                    finally {
                        try {
                            if (resultData200_27_1 && !resultData200_27_1.done && (_a = resultData200_27.return)) _a.call(resultData200_27);
                        }
                        finally { if (e_333) throw e_333.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processCreate = function (response) {
        var e_334, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_334_1) { e_334 = { error: e_334_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_334) throw e_334.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processUpdate = function (response) {
        var e_335, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_335_1) { e_335 = { error: e_335_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_335) throw e_335.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processDelete = function (response) {
        var e_336, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_336_1) { e_336 = { error: e_336_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_336) throw e_336.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processGet = function (response) {
        var e_337, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_337_1) { e_337 = { error: e_337_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_337) throw e_337.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ShippingTypeServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingType/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeServiceProxy.prototype.processGetAll = function (response) {
        var e_338, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_338_1) { e_338 = { error: e_338_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_338) throw e_338.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ShippingTypeServiceProxy;
}());
export { ShippingTypeServiceProxy };
var ShippingTypeGroupServiceProxy = /** @class */ (function () {
    function ShippingTypeGroupServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ShippingTypeGroupServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeGroupServiceProxy.prototype.processCreate = function (response) {
        var e_339, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_339_1) { e_339 = { error: e_339_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_339) throw e_339.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeGroupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShippingTypeGroupServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeGroupServiceProxy.prototype.processUpdate = function (response) {
        var e_340, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_340_1) { e_340 = { error: e_340_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_340) throw e_340.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeGroupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ShippingTypeGroupServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeGroupServiceProxy.prototype.processDelete = function (response) {
        var e_341, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_341_1) { e_341 = { error: e_341_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_341) throw e_341.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ShippingTypeGroupServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeGroupServiceProxy.prototype.processGet = function (response) {
        var e_342, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_342_1) { e_342 = { error: e_342_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_342) throw e_342.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeGroupDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ShippingTypeGroupServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeGroup/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeGroupServiceProxy.prototype.processGetAll = function (response) {
        var e_343, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_343_1) { e_343 = { error: e_343_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_343) throw e_343.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeGroupDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ShippingTypeGroupServiceProxy;
}());
export { ShippingTypeGroupServiceProxy };
var ShippingTypeMappingServiceProxy = /** @class */ (function () {
    function ShippingTypeMappingServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ShippingTypeMappingServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeMappingServiceProxy.prototype.processCreate = function (response) {
        var e_344, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_344_1) { e_344 = { error: e_344_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_344) throw e_344.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ShippingTypeMappingServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeMappingServiceProxy.prototype.processUpdate = function (response) {
        var e_345, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_345_1) { e_345 = { error: e_345_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_345) throw e_345.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ShippingTypeMappingServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeMappingServiceProxy.prototype.processDelete = function (response) {
        var e_346, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_346_1) { e_346 = { error: e_346_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_346) throw e_346.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ShippingTypeMappingServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeMappingServiceProxy.prototype.processGet = function (response) {
        var e_347, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_347_1) { e_347 = { error: e_347_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_347) throw e_347.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeMappingDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ShippingTypeMappingServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ShippingTypeMapping/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ShippingTypeMappingServiceProxy.prototype.processGetAll = function (response) {
        var e_348, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_348_1) { e_348 = { error: e_348_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_348) throw e_348.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ShippingTypeMappingDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ShippingTypeMappingServiceProxy;
}());
export { ShippingTypeMappingServiceProxy };
var SmartQuickServiceProxy = /** @class */ (function () {
    function SmartQuickServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    SmartQuickServiceProxy.prototype.createServicee = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SmartQuick/CreateServicee";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateServicee(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateServicee(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SmartQuickServiceProxy.prototype.processCreateServicee = function (response) {
        var e_349, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_349_1) { e_349 = { error: e_349_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_349) throw e_349.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    SmartQuickServiceProxy.prototype.createServicesFromShipment = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/SmartQuick/CreateServicesFromShipment";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateServicesFromShipment(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateServicesFromShipment(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    SmartQuickServiceProxy.prototype.processCreateServicesFromShipment = function (response) {
        var e_350, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_350_1) { e_350 = { error: e_350_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_350) throw e_350.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return SmartQuickServiceProxy;
}());
export { SmartQuickServiceProxy };
var StateServiceProxy = /** @class */ (function () {
    function StateServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    StateServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/State/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StateServiceProxy.prototype.processGet = function (response) {
        var e_351, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_351_1) { e_351 = { error: e_351_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_351) throw e_351.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StateDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    StateServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/State/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StateServiceProxy.prototype.processGetAll = function (response) {
        var e_352, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_352_1) { e_352 = { error: e_352_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_352) throw e_352.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StateDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return StateServiceProxy;
}());
export { StateServiceProxy };
var StoreAssignationServiceProxy = /** @class */ (function () {
    function StoreAssignationServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param orderId (optional)
     * @param skus (optional)
     * @param assignationDate (optional)
     * @return Success
     */
    StoreAssignationServiceProxy.prototype.get = function (orderId, skus, assignationDate) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StoreAssignation/Get?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (skus !== undefined)
            skus && skus.forEach(function (item) { url_ += "skus=" + encodeURIComponent("" + item) + "&"; });
        if (assignationDate !== undefined)
            url_ += "assignationDate=" + encodeURIComponent("" + assignationDate) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoreAssignationServiceProxy.prototype.processGet = function (response) {
        var e_353, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_353_1) { e_353 = { error: e_353_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_353) throw e_353.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_354, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_28 = __values(resultData200), resultData200_28_1 = resultData200_28.next(); !resultData200_28_1.done; resultData200_28_1 = resultData200_28.next()) {
                            var item = resultData200_28_1.value;
                            result200.push(StoreDistanceAndStockDto.fromJS(item));
                        }
                    }
                    catch (e_354_1) { e_354 = { error: e_354_1 }; }
                    finally {
                        try {
                            if (resultData200_28_1 && !resultData200_28_1.done && (_a = resultData200_28.return)) _a.call(resultData200_28);
                        }
                        finally { if (e_354) throw e_354.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    StoreAssignationServiceProxy.prototype.normalizarSku = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StoreAssignation/NormalizarSku?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processNormalizarSku(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processNormalizarSku(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoreAssignationServiceProxy.prototype.processNormalizarSku = function (response) {
        var e_355, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_355_1) { e_355 = { error: e_355_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_355) throw e_355.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param destinationStoreCode (optional)
     * @param skus (optional)
     * @return Success
     */
    StoreAssignationServiceProxy.prototype.getByStore = function (destinationStoreCode, skus) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StoreAssignation/GetByStore?";
        if (destinationStoreCode !== undefined)
            url_ += "destinationStoreCode=" + encodeURIComponent("" + destinationStoreCode) + "&";
        if (skus !== undefined)
            skus && skus.forEach(function (item) { url_ += "skus=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetByStore(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetByStore(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StoreAssignationServiceProxy.prototype.processGetByStore = function (response) {
        var e_356, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_356_1) { e_356 = { error: e_356_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_356) throw e_356.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_357, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_29 = __values(resultData200), resultData200_29_1 = resultData200_29.next(); !resultData200_29_1.done; resultData200_29_1 = resultData200_29.next()) {
                            var item = resultData200_29_1.value;
                            result200.push(StoreDistanceAndStockDto.fromJS(item));
                        }
                    }
                    catch (e_357_1) { e_357 = { error: e_357_1 }; }
                    finally {
                        try {
                            if (resultData200_29_1 && !resultData200_29_1.done && (_a = resultData200_29.return)) _a.call(resultData200_29);
                        }
                        finally { if (e_357) throw e_357.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return StoreAssignationServiceProxy;
}());
export { StoreAssignationServiceProxy };
var StorePostalCodesServiceProxy = /** @class */ (function () {
    function StorePostalCodesServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    StorePostalCodesServiceProxy.prototype.uploadCsv = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StorePostalCodes/UploadCsv";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUploadCsv(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUploadCsv(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StorePostalCodesServiceProxy.prototype.processUploadCsv = function (response) {
        var e_358, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_358_1) { e_358 = { error: e_358_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_358) throw e_358.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    StorePostalCodesServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StorePostalCodes/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StorePostalCodesServiceProxy.prototype.processCreate = function (response) {
        var e_359, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_359_1) { e_359 = { error: e_359_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_359) throw e_359.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StorePostalCodeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    StorePostalCodesServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StorePostalCodes/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StorePostalCodesServiceProxy.prototype.processUpdate = function (response) {
        var e_360, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_360_1) { e_360 = { error: e_360_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_360) throw e_360.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StorePostalCodeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    StorePostalCodesServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StorePostalCodes/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StorePostalCodesServiceProxy.prototype.processDelete = function (response) {
        var e_361, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_361_1) { e_361 = { error: e_361_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_361) throw e_361.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    StorePostalCodesServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StorePostalCodes/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StorePostalCodesServiceProxy.prototype.processGet = function (response) {
        var e_362, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_362_1) { e_362 = { error: e_362_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_362) throw e_362.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StorePostalCodeDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    StorePostalCodesServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/StorePostalCodes/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    StorePostalCodesServiceProxy.prototype.processGetAll = function (response) {
        var e_363, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_363_1) { e_363 = { error: e_363_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_363) throw e_363.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = StorePostalCodeDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return StorePostalCodesServiceProxy;
}());
export { StorePostalCodesServiceProxy };
var TransferServiceProxy = /** @class */ (function () {
    function TransferServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.acceptSapTransfers = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/AcceptSapTransfers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processAcceptSapTransfers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processAcceptSapTransfers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processAcceptSapTransfers = function (response) {
        var e_364, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_364_1) { e_364 = { error: e_364_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_364) throw e_364.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param orderId (optional)
     * @param trxSrcCode (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.createTransferRequest = function (orderId, trxSrcCode) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/CreateTransferRequest?";
        if (orderId === null)
            throw new Error("The parameter 'orderId' cannot be null.");
        else if (orderId !== undefined)
            url_ += "orderId=" + encodeURIComponent("" + orderId) + "&";
        if (trxSrcCode !== undefined)
            url_ += "trxSrcCode=" + encodeURIComponent("" + trxSrcCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateTransferRequest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateTransferRequest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processCreateTransferRequest = function (response) {
        var e_365, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_365_1) { e_365 = { error: e_365_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_365) throw e_365.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.completeTransferRequests = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/CompleteTransferRequests";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCompleteTransferRequests(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCompleteTransferRequests(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processCompleteTransferRequests = function (response) {
        var e_366, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_366_1) { e_366 = { error: e_366_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_366) throw e_366.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.createSupplyingRequest = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/CreateSupplyingRequest";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateSupplyingRequest(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateSupplyingRequest(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processCreateSupplyingRequest = function (response) {
        var e_367, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_367_1) { e_367 = { error: e_367_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_367) throw e_367.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.createTransfers = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/CreateTransfers";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateTransfers(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateTransfers(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processCreateTransfers = function (response) {
        var e_368, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_368_1) { e_368 = { error: e_368_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_368) throw e_368.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : null;
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.getTransferOrderInfo = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/GetTransferOrderInfo?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetTransferOrderInfo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetTransferOrderInfo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processGetTransferOrderInfo = function (response) {
        var e_369, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_369_1) { e_369 = { error: e_369_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_369) throw e_369.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TransferOrderInfoDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processCreate = function (response) {
        var e_370, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_370_1) { e_370 = { error: e_370_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_370) throw e_370.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TransferRequestDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processUpdate = function (response) {
        var e_371, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_371_1) { e_371 = { error: e_371_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_371) throw e_371.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TransferRequestDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processDelete = function (response) {
        var e_372, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_372_1) { e_372 = { error: e_372_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_372) throw e_372.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processGet = function (response) {
        var e_373, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_373_1) { e_373 = { error: e_373_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_373) throw e_373.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TransferRequestDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    TransferServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Transfer/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    TransferServiceProxy.prototype.processGetAll = function (response) {
        var e_374, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_374_1) { e_374 = { error: e_374_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_374) throw e_374.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = TransferRequestDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return TransferServiceProxy;
}());
export { TransferServiceProxy };
var VtexServiceProxy = /** @class */ (function () {
    function VtexServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param vtexAccountId (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.disableListening = function (vtexAccountId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/DisableListening?";
        if (vtexAccountId === null)
            throw new Error("The parameter 'vtexAccountId' cannot be null.");
        else if (vtexAccountId !== undefined)
            url_ += "vtexAccountId=" + encodeURIComponent("" + vtexAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDisableListening(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDisableListening(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processDisableListening = function (response) {
        var e_375, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_375_1) { e_375 = { error: e_375_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_375) throw e_375.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param vtexAccountId (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.enableListening = function (vtexAccountId) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/EnableListening?";
        if (vtexAccountId === null)
            throw new Error("The parameter 'vtexAccountId' cannot be null.");
        else if (vtexAccountId !== undefined)
            url_ += "vtexAccountId=" + encodeURIComponent("" + vtexAccountId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processEnableListening(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processEnableListening(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processEnableListening = function (response) {
        var e_376, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_376_1) { e_376 = { error: e_376_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_376) throw e_376.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.getResourceAr = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/GetResourceAr?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetResourceAr(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetResourceAr(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processGetResourceAr = function (response) {
        var e_377, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_377_1) { e_377 = { error: e_377_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_377) throw e_377.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param input (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.getResourceCo = function (input) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/GetResourceCo?";
        if (input !== undefined)
            url_ += "input=" + encodeURIComponent("" + input) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetResourceCo(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetResourceCo(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processGetResourceCo = function (response) {
        var e_378, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_378_1) { e_378 = { error: e_378_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_378) throw e_378.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processCreate = function (response) {
        var e_379, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_379_1) { e_379 = { error: e_379_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_379) throw e_379.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VtexAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processUpdate = function (response) {
        var e_380, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_380_1) { e_380 = { error: e_380_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_380) throw e_380.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VtexAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processDelete = function (response) {
        var e_381, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_381_1) { e_381 = { error: e_381_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_381) throw e_381.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processGet = function (response) {
        var e_382, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_382_1) { e_382 = { error: e_382_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_382) throw e_382.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VtexAccountDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    VtexServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Vtex/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    VtexServiceProxy.prototype.processGetAll = function (response) {
        var e_383, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_383_1) { e_383 = { error: e_383_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_383) throw e_383.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = VtexAccountDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return VtexServiceProxy;
}());
export { VtexServiceProxy };
var ZohoStadisticUrlServiceProxy = /** @class */ (function () {
    function ZohoStadisticUrlServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param id (optional)
     * @return Success
     */
    ZohoStadisticUrlServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZohoStadisticUrlServiceProxy.prototype.processGet = function (response) {
        var e_384, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_384_1) { e_384 = { error: e_384_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_384) throw e_384.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ZohoStadisticUrlDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ZohoStadisticUrlServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZohoStadisticUrlServiceProxy.prototype.processGetAll = function (response) {
        var e_385, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_385_1) { e_385 = { error: e_385_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_385) throw e_385.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ZohoStadisticUrlDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ZohoStadisticUrlServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZohoStadisticUrlServiceProxy.prototype.processCreate = function (response) {
        var e_386, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_386_1) { e_386 = { error: e_386_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_386) throw e_386.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ZohoStadisticUrlDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ZohoStadisticUrlServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZohoStadisticUrlServiceProxy.prototype.processUpdate = function (response) {
        var e_387, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_387_1) { e_387 = { error: e_387_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_387) throw e_387.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ZohoStadisticUrlDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ZohoStadisticUrlServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/ZohoStadisticUrl/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZohoStadisticUrlServiceProxy.prototype.processDelete = function (response) {
        var e_388, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_388_1) { e_388 = { error: e_388_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_388) throw e_388.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ZohoStadisticUrlServiceProxy;
}());
export { ZohoStadisticUrlServiceProxy };
var WebhookServiceProxy = /** @class */ (function () {
    function WebhookServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    WebhookServiceProxy.prototype.zubale = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/webhook/Zubale";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processZubale(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processZubale(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    WebhookServiceProxy.prototype.processZubale = function (response) {
        var e_389, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_389_1) { e_389 = { error: e_389_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_389) throw e_389.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return WebhookServiceProxy;
}());
export { WebhookServiceProxy };
var ZubaleServiceProxy = /** @class */ (function () {
    function ZubaleServiceProxy(http, baseUrl) {
        this.jsonParseReviver = undefined;
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }
    /**
     * @param body (optional)
     * @return Success
     */
    ZubaleServiceProxy.prototype.createDeliveryOrders = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Zubale/CreateDeliveryOrders";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreateDeliveryOrders(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreateDeliveryOrders(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZubaleServiceProxy.prototype.processCreateDeliveryOrders = function (response) {
        var e_390, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_390_1) { e_390 = { error: e_390_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_390) throw e_390.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var e_391, _a;
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                if (Array.isArray(resultData200)) {
                    result200 = [];
                    try {
                        for (var resultData200_30 = __values(resultData200), resultData200_30_1 = resultData200_30.next(); !resultData200_30_1.done; resultData200_30_1 = resultData200_30.next()) {
                            var item = resultData200_30_1.value;
                            result200.push(CreateDeliveryOrderResponseModel.fromJS(item));
                        }
                    }
                    catch (e_391_1) { e_391 = { error: e_391_1 }; }
                    finally {
                        try {
                            if (resultData200_30_1 && !resultData200_30_1.done && (_a = resultData200_30.return)) _a.call(resultData200_30);
                        }
                        finally { if (e_391) throw e_391.error; }
                    }
                }
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ZubaleServiceProxy.prototype.notification = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Zubale/Notification";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processNotification(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processNotification(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZubaleServiceProxy.prototype.processNotification = function (response) {
        var e_392, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_392_1) { e_392 = { error: e_392_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_392) throw e_392.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ZubaleServiceProxy.prototype.create = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Zubale/Create";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("post", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processCreate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processCreate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZubaleServiceProxy.prototype.processCreate = function (response) {
        var e_393, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_393_1) { e_393 = { error: e_393_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_393) throw e_393.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ZubaleNotificationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param body (optional)
     * @return Success
     */
    ZubaleServiceProxy.prototype.update = function (body) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Zubale/Update";
        url_ = url_.replace(/[?&]$/, "");
        var content_ = JSON.stringify(body);
        var options_ = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            })
        };
        return this.http.request("put", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processUpdate(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processUpdate(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZubaleServiceProxy.prototype.processUpdate = function (response) {
        var e_394, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_394_1) { e_394 = { error: e_394_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_394) throw e_394.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ZubaleNotificationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ZubaleServiceProxy.prototype.delete = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Zubale/Delete?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({})
        };
        return this.http.request("delete", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processDelete(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processDelete(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZubaleServiceProxy.prototype.processDelete = function (response) {
        var e_395, _a;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_395_1) { e_395 = { error: e_395_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_395) throw e_395.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return _observableOf(null);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param id (optional)
     * @return Success
     */
    ZubaleServiceProxy.prototype.get = function (id) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Zubale/Get?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGet(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGet(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZubaleServiceProxy.prototype.processGet = function (response) {
        var e_396, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_396_1) { e_396 = { error: e_396_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_396) throw e_396.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ZubaleNotificationDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    /**
     * @param filters (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    ZubaleServiceProxy.prototype.getAll = function (filters, sorting, skipCount, maxResultCount) {
        var _this = this;
        var url_ = this.baseUrl + "/api/services/app/Zubale/GetAll?";
        if (filters !== undefined)
            filters && filters.forEach(function (item) { url_ += "Filters=" + encodeURIComponent("" + item) + "&"; });
        if (sorting !== undefined)
            url_ += "Sorting=" + encodeURIComponent("" + sorting) + "&";
        if (skipCount === null)
            throw new Error("The parameter 'skipCount' cannot be null.");
        else if (skipCount !== undefined)
            url_ += "SkipCount=" + encodeURIComponent("" + skipCount) + "&";
        if (maxResultCount === null)
            throw new Error("The parameter 'maxResultCount' cannot be null.");
        else if (maxResultCount !== undefined)
            url_ += "MaxResultCount=" + encodeURIComponent("" + maxResultCount) + "&";
        url_ = url_.replace(/[?&]$/, "");
        var options_ = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };
        return this.http.request("get", url_, options_).pipe(_observableMergeMap(function (response_) {
            return _this.processGetAll(response_);
        })).pipe(_observableCatch(function (response_) {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return _this.processGetAll(response_);
                }
                catch (e) {
                    return _observableThrow(e);
                }
            }
            else
                return _observableThrow(response_);
        }));
    };
    ZubaleServiceProxy.prototype.processGetAll = function (response) {
        var e_397, _a;
        var _this = this;
        var status = response.status;
        var responseBlob = response instanceof HttpResponse ? response.body :
            response.error instanceof Blob ? response.error : undefined;
        var _headers = {};
        if (response.headers) {
            try {
                for (var _b = __values(response.headers.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    _headers[key] = response.headers.get(key);
                }
            }
            catch (e_397_1) { e_397 = { error: e_397_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_397) throw e_397.error; }
            }
        }
        ;
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                var result200 = null;
                var resultData200 = _responseText === "" ? null : JSON.parse(_responseText, _this.jsonParseReviver);
                result200 = ZubaleNotificationDtoPagedResultDto.fromJS(resultData200);
                return _observableOf(result200);
            }));
        }
        else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(function (_responseText) {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null);
    };
    return ZubaleServiceProxy;
}());
export { ZubaleServiceProxy };
var UploadBinDto = /** @class */ (function () {
    function UploadBinDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadBinDto.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    };
    UploadBinDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadBinDto();
        result.init(data);
        return result;
    };
    UploadBinDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data;
    };
    UploadBinDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UploadBinDto();
        result.init(json);
        return result;
    };
    return UploadBinDto;
}());
export { UploadBinDto };
var BinDto = /** @class */ (function () {
    function BinDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BinDto.prototype.init = function (_data) {
        if (_data) {
            this.binCode = _data["binCode"];
            this.creditCardCompany = _data["creditCardCompany"];
            this.bank = _data["bank"];
            this.id = _data["id"];
        }
    };
    BinDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BinDto();
        result.init(data);
        return result;
    };
    BinDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["binCode"] = this.binCode;
        data["creditCardCompany"] = this.creditCardCompany;
        data["bank"] = this.bank;
        data["id"] = this.id;
        return data;
    };
    BinDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new BinDto();
        result.init(json);
        return result;
    };
    return BinDto;
}());
export { BinDto };
var BinDtoPagedResultDto = /** @class */ (function () {
    function BinDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    BinDtoPagedResultDto.prototype.init = function (_data) {
        var e_398, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(BinDto.fromJS(item));
                    }
                }
                catch (e_398_1) { e_398 = { error: e_398_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_398) throw e_398.error; }
                }
            }
        }
    };
    BinDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new BinDtoPagedResultDto();
        result.init(data);
        return result;
    };
    BinDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_399, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_399_1) { e_399 = { error: e_399_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_399) throw e_399.error; }
            }
        }
        return data;
    };
    BinDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new BinDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return BinDtoPagedResultDto;
}());
export { BinDtoPagedResultDto };
var StoreCarrierDto = /** @class */ (function () {
    function StoreCarrierDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StoreCarrierDto.prototype.init = function (_data) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.storeCode = _data["storeCode"];
            this.id = _data["id"];
        }
    };
    StoreCarrierDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StoreCarrierDto();
        result.init(data);
        return result;
    };
    StoreCarrierDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        return data;
    };
    StoreCarrierDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StoreCarrierDto();
        result.init(json);
        return result;
    };
    return StoreCarrierDto;
}());
export { StoreCarrierDto };
var CarrierDto = /** @class */ (function () {
    function CarrierDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CarrierDto.prototype.init = function (_data) {
        var e_400, _a;
        if (_data) {
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroupName = _data["shippingTypeGroupName"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [];
                try {
                    for (var _b = __values(_data["stores"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.stores.push(StoreCarrierDto.fromJS(item));
                    }
                }
                catch (e_400_1) { e_400 = { error: e_400_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_400) throw e_400.error; }
                }
            }
            this.apiToken = _data["apiToken"];
            this.carrierGroup = _data["carrierGroup"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    CarrierDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CarrierDto();
        result.init(data);
        return result;
    };
    CarrierDto.prototype.toJSON = function (data) {
        var e_401, _a;
        data = typeof data === 'object' ? data : {};
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroupName"] = this.shippingTypeGroupName;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            try {
                for (var _b = __values(this.stores), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["stores"].push(item.toJSON());
                }
            }
            catch (e_401_1) { e_401 = { error: e_401_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_401) throw e_401.error; }
            }
        }
        data["apiToken"] = this.apiToken;
        data["carrierGroup"] = this.carrierGroup;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    CarrierDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CarrierDto();
        result.init(json);
        return result;
    };
    return CarrierDto;
}());
export { CarrierDto };
var CarrierDtoPagedResultDto = /** @class */ (function () {
    function CarrierDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CarrierDtoPagedResultDto.prototype.init = function (_data) {
        var e_402, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(CarrierDto.fromJS(item));
                    }
                }
                catch (e_402_1) { e_402 = { error: e_402_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_402) throw e_402.error; }
                }
            }
        }
    };
    CarrierDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CarrierDtoPagedResultDto();
        result.init(data);
        return result;
    };
    CarrierDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_403, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_403_1) { e_403 = { error: e_403_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_403) throw e_403.error; }
            }
        }
        return data;
    };
    CarrierDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CarrierDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return CarrierDtoPagedResultDto;
}());
export { CarrierDtoPagedResultDto };
var CarrierDriverDto = /** @class */ (function () {
    function CarrierDriverDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CarrierDriverDto.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : undefined;
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    };
    CarrierDriverDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CarrierDriverDto();
        result.init(data);
        return result;
    };
    CarrierDriverDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    };
    CarrierDriverDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CarrierDriverDto();
        result.init(json);
        return result;
    };
    return CarrierDriverDto;
}());
export { CarrierDriverDto };
var CarrierDriverDtoPagedResultDto = /** @class */ (function () {
    function CarrierDriverDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CarrierDriverDtoPagedResultDto.prototype.init = function (_data) {
        var e_404, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(CarrierDriverDto.fromJS(item));
                    }
                }
                catch (e_404_1) { e_404 = { error: e_404_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_404) throw e_404.error; }
                }
            }
        }
    };
    CarrierDriverDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CarrierDriverDtoPagedResultDto();
        result.init(data);
        return result;
    };
    CarrierDriverDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_405, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_405_1) { e_405 = { error: e_405_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_405) throw e_405.error; }
            }
        }
        return data;
    };
    CarrierDriverDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CarrierDriverDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return CarrierDriverDtoPagedResultDto;
}());
export { CarrierDriverDtoPagedResultDto };
var DistrictDto = /** @class */ (function () {
    function DistrictDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DistrictDto.prototype.init = function (_data) {
        var e_406, _a;
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["flashPostalCodes"])) {
                this.flashPostalCodes = [];
                try {
                    for (var _b = __values(_data["flashPostalCodes"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.flashPostalCodes.push(item);
                    }
                }
                catch (e_406_1) { e_406 = { error: e_406_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_406) throw e_406.error; }
                }
            }
            this.cityId = _data["cityId"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    };
    DistrictDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DistrictDto();
        result.init(data);
        return result;
    };
    DistrictDto.prototype.toJSON = function (data) {
        var e_407, _a;
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.flashPostalCodes)) {
            data["flashPostalCodes"] = [];
            try {
                for (var _b = __values(this.flashPostalCodes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["flashPostalCodes"].push(item);
                }
            }
            catch (e_407_1) { e_407 = { error: e_407_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_407) throw e_407.error; }
            }
        }
        data["cityId"] = this.cityId;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    };
    DistrictDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DistrictDto();
        result.init(json);
        return result;
    };
    return DistrictDto;
}());
export { DistrictDto };
var CityDto = /** @class */ (function () {
    function CityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CityDto.prototype.init = function (_data) {
        var e_408, _a;
        if (_data) {
            this.name = _data["name"];
            this.postalCode = _data["postalCode"];
            this.stateId = _data["stateId"];
            if (Array.isArray(_data["districts"])) {
                this.districts = [];
                try {
                    for (var _b = __values(_data["districts"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.districts.push(DistrictDto.fromJS(item));
                    }
                }
                catch (e_408_1) { e_408 = { error: e_408_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_408) throw e_408.error; }
                }
            }
            this.acceptsFlashShipments = _data["acceptsFlashShipments"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    };
    CityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CityDto();
        result.init(data);
        return result;
    };
    CityDto.prototype.toJSON = function (data) {
        var e_409, _a;
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["postalCode"] = this.postalCode;
        data["stateId"] = this.stateId;
        if (Array.isArray(this.districts)) {
            data["districts"] = [];
            try {
                for (var _b = __values(this.districts), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["districts"].push(item.toJSON());
                }
            }
            catch (e_409_1) { e_409 = { error: e_409_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_409) throw e_409.error; }
            }
        }
        data["acceptsFlashShipments"] = this.acceptsFlashShipments;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    };
    CityDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CityDto();
        result.init(json);
        return result;
    };
    return CityDto;
}());
export { CityDto };
var CityDtoPagedResultDto = /** @class */ (function () {
    function CityDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CityDtoPagedResultDto.prototype.init = function (_data) {
        var e_410, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(CityDto.fromJS(item));
                    }
                }
                catch (e_410_1) { e_410 = { error: e_410_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_410) throw e_410.error; }
                }
            }
        }
    };
    CityDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CityDtoPagedResultDto();
        result.init(data);
        return result;
    };
    CityDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_411, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_411_1) { e_411 = { error: e_411_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_411) throw e_411.error; }
            }
        }
        return data;
    };
    CityDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CityDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return CityDtoPagedResultDto;
}());
export { CityDtoPagedResultDto };
var ReturnOrderRequest = /** @class */ (function () {
    function ReturnOrderRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnOrderRequest.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    };
    ReturnOrderRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnOrderRequest();
        result.init(data);
        return result;
    };
    ReturnOrderRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data;
    };
    ReturnOrderRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ReturnOrderRequest();
        result.init(json);
        return result;
    };
    return ReturnOrderRequest;
}());
export { ReturnOrderRequest };
var PartialDeliveryFailOrderItem = /** @class */ (function () {
    function PartialDeliveryFailOrderItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PartialDeliveryFailOrderItem.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.claimedQuantity = _data["claimedQuantity"];
            this.netAmount = _data["netAmount"];
            this.deliveryIssue = _data["deliveryIssue"];
            this.observations = _data["observations"];
            this.skuClaimAction = _data["skuClaimAction"];
            this.isPromotion = _data["isPromotion"];
            this.promotionId = _data["promotionId"];
        }
    };
    PartialDeliveryFailOrderItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PartialDeliveryFailOrderItem();
        result.init(data);
        return result;
    };
    PartialDeliveryFailOrderItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["claimedQuantity"] = this.claimedQuantity;
        data["netAmount"] = this.netAmount;
        data["deliveryIssue"] = this.deliveryIssue;
        data["observations"] = this.observations;
        data["skuClaimAction"] = this.skuClaimAction;
        data["isPromotion"] = this.isPromotion;
        data["promotionId"] = this.promotionId;
        return data;
    };
    PartialDeliveryFailOrderItem.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PartialDeliveryFailOrderItem();
        result.init(json);
        return result;
    };
    return PartialDeliveryFailOrderItem;
}());
export { PartialDeliveryFailOrderItem };
var PartialReturnRequest = /** @class */ (function () {
    function PartialReturnRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PartialReturnRequest.prototype.init = function (_data) {
        var e_412, _a;
        if (_data) {
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _b = __values(_data["orderItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderItems.push(PartialDeliveryFailOrderItem.fromJS(item));
                    }
                }
                catch (e_412_1) { e_412 = { error: e_412_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_412) throw e_412.error; }
                }
            }
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    };
    PartialReturnRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PartialReturnRequest();
        result.init(data);
        return result;
    };
    PartialReturnRequest.prototype.toJSON = function (data) {
        var e_413, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _b = __values(this.orderItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_413_1) { e_413 = { error: e_413_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_413) throw e_413.error; }
            }
        }
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data;
    };
    PartialReturnRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PartialReturnRequest();
        result.init(json);
        return result;
    };
    return PartialReturnRequest;
}());
export { PartialReturnRequest };
var TotalDeliveryFailRequest = /** @class */ (function () {
    function TotalDeliveryFailRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TotalDeliveryFailRequest.prototype.init = function (_data) {
        if (_data) {
            this.orderClaimAction = _data["orderClaimAction"];
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    };
    TotalDeliveryFailRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TotalDeliveryFailRequest();
        result.init(data);
        return result;
    };
    TotalDeliveryFailRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderClaimAction"] = this.orderClaimAction;
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data;
    };
    TotalDeliveryFailRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new TotalDeliveryFailRequest();
        result.init(json);
        return result;
    };
    return TotalDeliveryFailRequest;
}());
export { TotalDeliveryFailRequest };
var PartialDeliveryFailRequest = /** @class */ (function () {
    function PartialDeliveryFailRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PartialDeliveryFailRequest.prototype.init = function (_data) {
        var e_414, _a;
        if (_data) {
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _b = __values(_data["orderItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderItems.push(PartialDeliveryFailOrderItem.fromJS(item));
                    }
                }
                catch (e_414_1) { e_414 = { error: e_414_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_414) throw e_414.error; }
                }
            }
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    };
    PartialDeliveryFailRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PartialDeliveryFailRequest();
        result.init(data);
        return result;
    };
    PartialDeliveryFailRequest.prototype.toJSON = function (data) {
        var e_415, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _b = __values(this.orderItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_415_1) { e_415 = { error: e_415_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_415) throw e_415.error; }
            }
        }
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data;
    };
    PartialDeliveryFailRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PartialDeliveryFailRequest();
        result.init(json);
        return result;
    };
    return PartialDeliveryFailRequest;
}());
export { PartialDeliveryFailRequest };
var OrderNotDeliveredRequest = /** @class */ (function () {
    function OrderNotDeliveredRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderNotDeliveredRequest.prototype.init = function (_data) {
        if (_data) {
            this.orderClaimAction = _data["orderClaimAction"];
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    };
    OrderNotDeliveredRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderNotDeliveredRequest();
        result.init(data);
        return result;
    };
    OrderNotDeliveredRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderClaimAction"] = this.orderClaimAction;
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data;
    };
    OrderNotDeliveredRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderNotDeliveredRequest();
        result.init(json);
        return result;
    };
    return OrderNotDeliveredRequest;
}());
export { OrderNotDeliveredRequest };
var ItemReplacementRequest = /** @class */ (function () {
    function ItemReplacementRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ItemReplacementRequest.prototype.init = function (_data) {
        var e_416, _a;
        if (_data) {
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _b = __values(_data["orderItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderItems.push(PartialDeliveryFailOrderItem.fromJS(item));
                    }
                }
                catch (e_416_1) { e_416 = { error: e_416_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_416) throw e_416.error; }
                }
            }
            this.orderId = _data["orderId"];
            this.description = _data["description"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
        }
    };
    ItemReplacementRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ItemReplacementRequest();
        result.init(data);
        return result;
    };
    ItemReplacementRequest.prototype.toJSON = function (data) {
        var e_417, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _b = __values(this.orderItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_417_1) { e_417 = { error: e_417_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_417) throw e_417.error; }
            }
        }
        data["orderId"] = this.orderId;
        data["description"] = this.description;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        return data;
    };
    ItemReplacementRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ItemReplacementRequest();
        result.init(json);
        return result;
    };
    return ItemReplacementRequest;
}());
export { ItemReplacementRequest };
var ClaimTypeDto = /** @class */ (function () {
    function ClaimTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClaimTypeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    ClaimTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClaimTypeDto();
        result.init(data);
        return result;
    };
    ClaimTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    ClaimTypeDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ClaimTypeDto();
        result.init(json);
        return result;
    };
    return ClaimTypeDto;
}());
export { ClaimTypeDto };
var SourceValueDto = /** @class */ (function () {
    function SourceValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SourceValueDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    SourceValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SourceValueDto();
        result.init(data);
        return result;
    };
    SourceValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    SourceValueDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SourceValueDto();
        result.init(json);
        return result;
    };
    return SourceValueDto;
}());
export { SourceValueDto };
var CustomerDto = /** @class */ (function () {
    function CustomerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomerDto.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberAlternative = _data["phoneNumberAlternative"];
            this.email = _data["email"];
            this.id = _data["id"];
        }
    };
    CustomerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomerDto();
        result.init(data);
        return result;
    };
    CustomerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberAlternative"] = this.phoneNumberAlternative;
        data["email"] = this.email;
        data["id"] = this.id;
        return data;
    };
    CustomerDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CustomerDto();
        result.init(json);
        return result;
    };
    return CustomerDto;
}());
export { CustomerDto };
var MovementTypeDto = /** @class */ (function () {
    function MovementTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    MovementTypeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    MovementTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new MovementTypeDto();
        result.init(data);
        return result;
    };
    MovementTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    MovementTypeDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new MovementTypeDto();
        result.init(json);
        return result;
    };
    return MovementTypeDto;
}());
export { MovementTypeDto };
var OrderBalanceDto = /** @class */ (function () {
    function OrderBalanceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderBalanceDto.prototype.init = function (_data) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.movementType = _data["movementType"] ? MovementTypeDto.fromJS(_data["movementType"]) : undefined;
        }
    };
    OrderBalanceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderBalanceDto();
        result.init(data);
        return result;
    };
    OrderBalanceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType ? this.movementType.toJSON() : undefined;
        return data;
    };
    OrderBalanceDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderBalanceDto();
        result.init(json);
        return result;
    };
    return OrderBalanceDto;
}());
export { OrderBalanceDto };
var OrderNoteDto = /** @class */ (function () {
    function OrderNoteDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderNoteDto.prototype.init = function (_data) {
        if (_data) {
            this.readed = _data["readed"];
            this.notify = _data["notify"];
            this.description = _data["description"];
            this.orderId = _data["orderId"];
            this.creatorName = _data["creatorName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderNoteDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderNoteDto();
        result.init(data);
        return result;
    };
    OrderNoteDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["readed"] = this.readed;
        data["notify"] = this.notify;
        data["description"] = this.description;
        data["orderId"] = this.orderId;
        data["creatorName"] = this.creatorName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderNoteDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderNoteDto();
        result.init(json);
        return result;
    };
    return OrderNoteDto;
}());
export { OrderNoteDto };
var EventLogDto = /** @class */ (function () {
    function EventLogDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventLogDto.prototype.init = function (_data) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.description = _data["description"];
            this.orderId = _data["orderId"];
            this.id = _data["id"];
        }
    };
    EventLogDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EventLogDto();
        result.init(data);
        return result;
    };
    EventLogDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["description"] = this.description;
        data["orderId"] = this.orderId;
        data["id"] = this.id;
        return data;
    };
    EventLogDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new EventLogDto();
        result.init(json);
        return result;
    };
    return EventLogDto;
}());
export { EventLogDto };
export var SourceValue;
(function (SourceValue) {
    SourceValue[SourceValue["_0"] = 0] = "_0";
    SourceValue[SourceValue["_1"] = 1] = "_1";
    SourceValue[SourceValue["_2"] = 2] = "_2";
    SourceValue[SourceValue["_3"] = 3] = "_3";
    SourceValue[SourceValue["_4"] = 4] = "_4";
    SourceValue[SourceValue["_5"] = 5] = "_5";
    SourceValue[SourceValue["_6"] = 6] = "_6";
    SourceValue[SourceValue["_7"] = 7] = "_7";
    SourceValue[SourceValue["_8"] = 8] = "_8";
    SourceValue[SourceValue["_9"] = 9] = "_9";
    SourceValue[SourceValue["_10"] = 10] = "_10";
    SourceValue[SourceValue["_11"] = 11] = "_11";
    SourceValue[SourceValue["_12"] = 12] = "_12";
    SourceValue[SourceValue["_13"] = 13] = "_13";
    SourceValue[SourceValue["_14"] = 14] = "_14";
})(SourceValue || (SourceValue = {}));
var SourceOrderItemDto = /** @class */ (function () {
    function SourceOrderItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SourceOrderItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.barCode = _data["barCode"];
            this.id = _data["id"];
        }
    };
    SourceOrderItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SourceOrderItemDto();
        result.init(data);
        return result;
    };
    SourceOrderItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["barCode"] = this.barCode;
        data["id"] = this.id;
        return data;
    };
    SourceOrderItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SourceOrderItemDto();
        result.init(json);
        return result;
    };
    return SourceOrderItemDto;
}());
export { SourceOrderItemDto };
var OrderItemDto = /** @class */ (function () {
    function OrderItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.quantityDelivered = _data["quantityDelivered"];
            this.quantityInConflict = _data["quantityInConflict"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.cancelled = _data["cancelled"];
            this.isDeleted = _data["isDeleted"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.sourceOrderItemId = _data["sourceOrderItemId"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.isPromotion = _data["isPromotion"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? OrderItemDto.fromJS(_data["promotion"]) : undefined;
            this.barCode = _data["barCode"];
            this.supplierCatalogNumber = _data["supplierCatalogNumber"];
            this.stock = _data["stock"];
            this.notInventory = _data["notInventory"];
            this.id = _data["id"];
        }
    };
    OrderItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderItemDto();
        result.init(data);
        return result;
    };
    OrderItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["quantityDelivered"] = this.quantityDelivered;
        data["quantityInConflict"] = this.quantityInConflict;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["cancelled"] = this.cancelled;
        data["isDeleted"] = this.isDeleted;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["sourceOrderItemId"] = this.sourceOrderItemId;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["isPromotion"] = this.isPromotion;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : undefined;
        data["barCode"] = this.barCode;
        data["supplierCatalogNumber"] = this.supplierCatalogNumber;
        data["stock"] = this.stock;
        data["notInventory"] = this.notInventory;
        data["id"] = this.id;
        return data;
    };
    OrderItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderItemDto();
        result.init(json);
        return result;
    };
    return OrderItemDto;
}());
export { OrderItemDto };
var DocumentTypeDto = /** @class */ (function () {
    function DocumentTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentTypeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    DocumentTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentTypeDto();
        result.init(data);
        return result;
    };
    DocumentTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    DocumentTypeDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DocumentTypeDto();
        result.init(json);
        return result;
    };
    return DocumentTypeDto;
}());
export { DocumentTypeDto };
var OrderDocumentDto = /** @class */ (function () {
    function OrderDocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDocumentDto.prototype.init = function (_data) {
        if (_data) {
            this.number = _data["number"];
            this.documentCreationTime = _data["documentCreationTime"] ? moment(_data["documentCreationTime"].toString()) : undefined;
            this.type = _data["type"] ? DocumentTypeDto.fromJS(_data["type"]) : undefined;
            this.id = _data["id"];
        }
    };
    OrderDocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDocumentDto();
        result.init(data);
        return result;
    };
    OrderDocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["documentCreationTime"] = this.documentCreationTime ? this.documentCreationTime.toISOString() : undefined;
        data["type"] = this.type ? this.type.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    OrderDocumentDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDocumentDto();
        result.init(json);
        return result;
    };
    return OrderDocumentDto;
}());
export { OrderDocumentDto };
var DocumentDto = /** @class */ (function () {
    function DocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentDto.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.sourceCode = _data["sourceCode"];
            this.sourceName = _data["sourceName"];
            this.type = _data["type"];
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.documentUrl = _data["documentUrl"];
            this.customerFirstName = _data["customerFirstName"];
            this.customerLastName = _data["customerLastName"];
            this.customerDocumentNumber = _data["customerDocumentNumber"];
            this.customerPhoneNumber = _data["customerPhoneNumber"];
            this.status = _data["status"];
            this.draftNumber = _data["draftNumber"];
            this.number = _data["number"];
            this.folioNumber = _data["folioNumber"];
            this.amount = _data["amount"];
            this.additionalInfo = _data["additionalInfo"];
            this.documentNotificationId = _data["documentNotificationId"];
            this.storeCode = _data["storeCode"];
            this.id = _data["id"];
        }
    };
    DocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentDto();
        result.init(data);
        return result;
    };
    DocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["sourceCode"] = this.sourceCode;
        data["sourceName"] = this.sourceName;
        data["type"] = this.type;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["documentUrl"] = this.documentUrl;
        data["customerFirstName"] = this.customerFirstName;
        data["customerLastName"] = this.customerLastName;
        data["customerDocumentNumber"] = this.customerDocumentNumber;
        data["customerPhoneNumber"] = this.customerPhoneNumber;
        data["status"] = this.status;
        data["draftNumber"] = this.draftNumber;
        data["number"] = this.number;
        data["folioNumber"] = this.folioNumber;
        data["amount"] = this.amount;
        data["additionalInfo"] = this.additionalInfo;
        data["documentNotificationId"] = this.documentNotificationId;
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        return data;
    };
    DocumentDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DocumentDto();
        result.init(json);
        return result;
    };
    return DocumentDto;
}());
export { DocumentDto };
var PaymentDto = /** @class */ (function () {
    function PaymentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PaymentDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.paymentSystemName = _data["paymentSystemName"];
            this.installments = _data["installments"];
            this.value = _data["value"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    PaymentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PaymentDto();
        result.init(data);
        return result;
    };
    PaymentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["paymentSystemName"] = this.paymentSystemName;
        data["installments"] = this.installments;
        data["value"] = this.value;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    PaymentDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PaymentDto();
        result.init(json);
        return result;
    };
    return PaymentDto;
}());
export { PaymentDto };
var DeliveryTypeDto = /** @class */ (function () {
    function DeliveryTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryTypeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    DeliveryTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryTypeDto();
        result.init(data);
        return result;
    };
    DeliveryTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    DeliveryTypeDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DeliveryTypeDto();
        result.init(json);
        return result;
    };
    return DeliveryTypeDto;
}());
export { DeliveryTypeDto };
var ShippingTypeDto = /** @class */ (function () {
    function ShippingTypeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingTypeDto.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroupName = _data["shippingTypeGroupName"];
            this.id = _data["id"];
        }
    };
    ShippingTypeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingTypeDto();
        result.init(data);
        return result;
    };
    ShippingTypeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroupName"] = this.shippingTypeGroupName;
        data["id"] = this.id;
        return data;
    };
    ShippingTypeDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingTypeDto();
        result.init(json);
        return result;
    };
    return ShippingTypeDto;
}());
export { ShippingTypeDto };
var DeliveryDataDto = /** @class */ (function () {
    function DeliveryDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryDataDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : undefined;
            this.sourceCode = _data["sourceCode"];
            this.sourceStatus = _data["sourceStatus"];
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : undefined;
            this.estimatedDeliveryDateTo = _data["estimatedDeliveryDateTo"] ? moment(_data["estimatedDeliveryDateTo"].toString()) : undefined;
            this.deliveryType = _data["deliveryType"] ? DeliveryTypeDto.fromJS(_data["deliveryType"]) : undefined;
            this.pointOfDelivery = _data["pointOfDelivery"];
            this.addressTypeCode = _data["addressTypeCode"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.complement = _data["complement"];
            this.postalCode = _data["postalCode"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.completeAddress = _data["completeAddress"];
            this.trackingMethod = _data["trackingMethod"];
            this.trackingNumber = _data["trackingNumber"];
            this.shippingCost = _data["shippingCost"];
            this.deliveryCompany = _data["deliveryCompany"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingType = _data["shippingType"] ? ShippingTypeDto.fromJS(_data["shippingType"]) : undefined;
            this.shippingTypeSourceCode = _data["shippingTypeSourceCode"];
            this.receiverName = _data["receiverName"];
            this.carrierEsimatedDeliveryDate = _data["carrierEsimatedDeliveryDate"] ? moment(_data["carrierEsimatedDeliveryDate"].toString()) : undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    DeliveryDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryDataDto();
        result.init(data);
        return result;
    };
    DeliveryDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : undefined;
        data["sourceCode"] = this.sourceCode;
        data["sourceStatus"] = this.sourceStatus;
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : undefined;
        data["estimatedDeliveryDateTo"] = this.estimatedDeliveryDateTo ? this.estimatedDeliveryDateTo.toISOString() : undefined;
        data["deliveryType"] = this.deliveryType ? this.deliveryType.toJSON() : undefined;
        data["pointOfDelivery"] = this.pointOfDelivery;
        data["addressTypeCode"] = this.addressTypeCode;
        data["street"] = this.street;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["postalCode"] = this.postalCode;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["completeAddress"] = this.completeAddress;
        data["trackingMethod"] = this.trackingMethod;
        data["trackingNumber"] = this.trackingNumber;
        data["shippingCost"] = this.shippingCost;
        data["deliveryCompany"] = this.deliveryCompany;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : undefined;
        data["shippingTypeSourceCode"] = this.shippingTypeSourceCode;
        data["receiverName"] = this.receiverName;
        data["carrierEsimatedDeliveryDate"] = this.carrierEsimatedDeliveryDate ? this.carrierEsimatedDeliveryDate.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    DeliveryDataDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DeliveryDataDto();
        result.init(json);
        return result;
    };
    return DeliveryDataDto;
}());
export { DeliveryDataDto };
var AssignedToStoreDto = /** @class */ (function () {
    function AssignedToStoreDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssignedToStoreDto.prototype.init = function (_data) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    AssignedToStoreDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssignedToStoreDto();
        result.init(data);
        return result;
    };
    AssignedToStoreDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    AssignedToStoreDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AssignedToStoreDto();
        result.init(json);
        return result;
    };
    return AssignedToStoreDto;
}());
export { AssignedToStoreDto };
var OverallStatusValueDto = /** @class */ (function () {
    function OverallStatusValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OverallStatusValueDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    OverallStatusValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OverallStatusValueDto();
        result.init(data);
        return result;
    };
    OverallStatusValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    OverallStatusValueDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OverallStatusValueDto();
        result.init(json);
        return result;
    };
    return OverallStatusValueDto;
}());
export { OverallStatusValueDto };
var OverallStatusDto = /** @class */ (function () {
    function OverallStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OverallStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"] ? OverallStatusValueDto.fromJS(_data["value"]) : undefined;
        }
    };
    OverallStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OverallStatusDto();
        result.init(data);
        return result;
    };
    OverallStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    OverallStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OverallStatusDto();
        result.init(json);
        return result;
    };
    return OverallStatusDto;
}());
export { OverallStatusDto };
var CommercialStatusValueDto = /** @class */ (function () {
    function CommercialStatusValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CommercialStatusValueDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    CommercialStatusValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CommercialStatusValueDto();
        result.init(data);
        return result;
    };
    CommercialStatusValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    CommercialStatusValueDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CommercialStatusValueDto();
        result.init(json);
        return result;
    };
    return CommercialStatusValueDto;
}());
export { CommercialStatusValueDto };
var CommercialStatusDto = /** @class */ (function () {
    function CommercialStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CommercialStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"] ? CommercialStatusValueDto.fromJS(_data["value"]) : undefined;
        }
    };
    CommercialStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CommercialStatusDto();
        result.init(data);
        return result;
    };
    CommercialStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    CommercialStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CommercialStatusDto();
        result.init(json);
        return result;
    };
    return CommercialStatusDto;
}());
export { CommercialStatusDto };
var FinancialStatusValueDto = /** @class */ (function () {
    function FinancialStatusValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FinancialStatusValueDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    FinancialStatusValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FinancialStatusValueDto();
        result.init(data);
        return result;
    };
    FinancialStatusValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    FinancialStatusValueDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FinancialStatusValueDto();
        result.init(json);
        return result;
    };
    return FinancialStatusValueDto;
}());
export { FinancialStatusValueDto };
var FinancialStatusDto = /** @class */ (function () {
    function FinancialStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FinancialStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"] ? FinancialStatusValueDto.fromJS(_data["value"]) : undefined;
        }
    };
    FinancialStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FinancialStatusDto();
        result.init(data);
        return result;
    };
    FinancialStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    FinancialStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FinancialStatusDto();
        result.init(json);
        return result;
    };
    return FinancialStatusDto;
}());
export { FinancialStatusDto };
var LogisticStatusValueDto = /** @class */ (function () {
    function LogisticStatusValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogisticStatusValueDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    LogisticStatusValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogisticStatusValueDto();
        result.init(data);
        return result;
    };
    LogisticStatusValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    LogisticStatusValueDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LogisticStatusValueDto();
        result.init(json);
        return result;
    };
    return LogisticStatusValueDto;
}());
export { LogisticStatusValueDto };
var LogisticStatusDto = /** @class */ (function () {
    function LogisticStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogisticStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"] ? LogisticStatusValueDto.fromJS(_data["value"]) : undefined;
        }
    };
    LogisticStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogisticStatusDto();
        result.init(data);
        return result;
    };
    LogisticStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    LogisticStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LogisticStatusDto();
        result.init(json);
        return result;
    };
    return LogisticStatusDto;
}());
export { LogisticStatusDto };
var PreparedItemDto = /** @class */ (function () {
    function PreparedItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PreparedItemDto.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.orderItemId = _data["orderItemId"];
            this.orderItemDescription = _data["orderItemDescription"];
            this.discount = _data["discount"];
            this.grossAmount = _data["grossAmount"];
            this.imageUrl = _data["imageUrl"];
            this.netAmount = _data["netAmount"];
            this.orderQuantity = _data["orderQuantity"];
            this.quantity = _data["quantity"];
            this.sku = _data["sku"];
            this.taxes = _data["taxes"];
            this.totalAmount = _data["totalAmount"];
            this.calculatedAmount = _data["calculatedAmount"];
            this.barCode = _data["barCode"];
            this.supplierCatalogNumber = _data["supplierCatalogNumber"];
            this.stock = _data["stock"];
            this.id = _data["id"];
        }
    };
    PreparedItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PreparedItemDto();
        result.init(data);
        return result;
    };
    PreparedItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["orderItemId"] = this.orderItemId;
        data["orderItemDescription"] = this.orderItemDescription;
        data["discount"] = this.discount;
        data["grossAmount"] = this.grossAmount;
        data["imageUrl"] = this.imageUrl;
        data["netAmount"] = this.netAmount;
        data["orderQuantity"] = this.orderQuantity;
        data["quantity"] = this.quantity;
        data["sku"] = this.sku;
        data["taxes"] = this.taxes;
        data["totalAmount"] = this.totalAmount;
        data["calculatedAmount"] = this.calculatedAmount;
        data["barCode"] = this.barCode;
        data["supplierCatalogNumber"] = this.supplierCatalogNumber;
        data["stock"] = this.stock;
        data["id"] = this.id;
        return data;
    };
    PreparedItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PreparedItemDto();
        result.init(json);
        return result;
    };
    return PreparedItemDto;
}());
export { PreparedItemDto };
var PackageDto = /** @class */ (function () {
    function PackageDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PackageDto.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.id = _data["id"];
        }
    };
    PackageDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PackageDto();
        result.init(data);
        return result;
    };
    PackageDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["id"] = this.id;
        return data;
    };
    PackageDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PackageDto();
        result.init(json);
        return result;
    };
    return PackageDto;
}());
export { PackageDto };
var PreparationDto = /** @class */ (function () {
    function PreparationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PreparationDto.prototype.init = function (_data) {
        var e_418, _a, e_419, _b;
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.status = _data["status"];
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["preparedItems"])) {
                this.preparedItems = [];
                try {
                    for (var _c = __values(_data["preparedItems"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.preparedItems.push(PreparedItemDto.fromJS(item));
                    }
                }
                catch (e_418_1) { e_418 = { error: e_418_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_418) throw e_418.error; }
                }
            }
            if (Array.isArray(_data["packages"])) {
                this.packages = [];
                try {
                    for (var _e = __values(_data["packages"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.packages.push(PackageDto.fromJS(item));
                    }
                }
                catch (e_419_1) { e_419 = { error: e_419_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_419) throw e_419.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    PreparationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PreparationDto();
        result.init(data);
        return result;
    };
    PreparationDto.prototype.toJSON = function (data) {
        var e_420, _a, e_421, _b;
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["status"] = this.status;
        data["orderId"] = this.orderId;
        if (Array.isArray(this.preparedItems)) {
            data["preparedItems"] = [];
            try {
                for (var _c = __values(this.preparedItems), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["preparedItems"].push(item.toJSON());
                }
            }
            catch (e_420_1) { e_420 = { error: e_420_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_420) throw e_420.error; }
            }
        }
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            try {
                for (var _e = __values(this.packages), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["packages"].push(item.toJSON());
                }
            }
            catch (e_421_1) { e_421 = { error: e_421_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_421) throw e_421.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    PreparationDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PreparationDto();
        result.init(json);
        return result;
    };
    return PreparationDto;
}());
export { PreparationDto };
var ShipmentOrderDto = /** @class */ (function () {
    function ShipmentOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShipmentOrderDto.prototype.init = function (_data) {
        var e_422, _a;
        if (_data) {
            this.shipmentId = _data["shipmentId"];
            this.orderId = _data["orderId"];
            this.sourceCode = _data["sourceCode"];
            this.sourceName = _data["sourceName"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.addressComplement = _data["addressComplement"];
            this.phoneNumber = _data["phoneNumber"];
            this.shippingStatus = _data["shippingStatus"];
            this.shipmentIssue = _data["shipmentIssue"];
            this.deliveryType = _data["deliveryType"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.deliveredOn = _data["deliveredOn"] ? moment(_data["deliveredOn"].toString()) : undefined;
            this.notDeliveredOn = _data["notDeliveredOn"] ? moment(_data["notDeliveredOn"].toString()) : undefined;
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [];
                try {
                    for (var _b = __values(_data["proofFiles"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.proofFiles.push(item);
                    }
                }
                catch (e_422_1) { e_422 = { error: e_422_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_422) throw e_422.error; }
                }
            }
            this.proofNote = _data["proofNote"];
        }
    };
    ShipmentOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShipmentOrderDto();
        result.init(data);
        return result;
    };
    ShipmentOrderDto.prototype.toJSON = function (data) {
        var e_423, _a;
        data = typeof data === 'object' ? data : {};
        data["shipmentId"] = this.shipmentId;
        data["orderId"] = this.orderId;
        data["sourceCode"] = this.sourceCode;
        data["sourceName"] = this.sourceName;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["addressComplement"] = this.addressComplement;
        data["phoneNumber"] = this.phoneNumber;
        data["shippingStatus"] = this.shippingStatus;
        data["shipmentIssue"] = this.shipmentIssue;
        data["deliveryType"] = this.deliveryType;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : undefined;
        data["notDeliveredOn"] = this.notDeliveredOn ? this.notDeliveredOn.toISOString() : undefined;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            try {
                for (var _b = __values(this.proofFiles), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["proofFiles"].push(item);
                }
            }
            catch (e_423_1) { e_423 = { error: e_423_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_423) throw e_423.error; }
            }
        }
        data["proofNote"] = this.proofNote;
        return data;
    };
    ShipmentOrderDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShipmentOrderDto();
        result.init(json);
        return result;
    };
    return ShipmentOrderDto;
}());
export { ShipmentOrderDto };
var StockStatusDto = /** @class */ (function () {
    function StockStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StockStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    StockStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StockStatusDto();
        result.init(data);
        return result;
    };
    StockStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    StockStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StockStatusDto();
        result.init(json);
        return result;
    };
    return StockStatusDto;
}());
export { StockStatusDto };
var ReplacementCriteriaDto = /** @class */ (function () {
    function ReplacementCriteriaDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReplacementCriteriaDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    ReplacementCriteriaDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReplacementCriteriaDto();
        result.init(data);
        return result;
    };
    ReplacementCriteriaDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    ReplacementCriteriaDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ReplacementCriteriaDto();
        result.init(json);
        return result;
    };
    return ReplacementCriteriaDto;
}());
export { ReplacementCriteriaDto };
var IncludedGiftCardDto = /** @class */ (function () {
    function IncludedGiftCardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IncludedGiftCardDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    IncludedGiftCardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IncludedGiftCardDto();
        result.init(data);
        return result;
    };
    IncludedGiftCardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    IncludedGiftCardDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new IncludedGiftCardDto();
        result.init(json);
        return result;
    };
    return IncludedGiftCardDto;
}());
export { IncludedGiftCardDto };
var OrderDto = /** @class */ (function () {
    function OrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDto.prototype.init = function (_data) {
        var e_424, _a, e_425, _b, e_426, _c, e_427, _d, e_428, _e, e_429, _f, e_430, _g, e_431, _h, e_432, _j;
        if (_data) {
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : undefined;
            this.sourceCode = _data["sourceCode"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.routeOrder = _data["routeOrder"];
            this.invoiceCreationTime = _data["invoiceCreationTime"] ? moment(_data["invoiceCreationTime"].toString()) : undefined;
            this.invoiceType = _data["invoiceType"];
            this.highlighted = _data["highlighted"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrderId = _data["packOrderId"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [];
                try {
                    for (var _k = __values(_data["orderBalances"]), _l = _k.next(); !_l.done; _l = _k.next()) {
                        var item = _l.value;
                        this.orderBalances.push(OrderBalanceDto.fromJS(item));
                    }
                }
                catch (e_424_1) { e_424 = { error: e_424_1 }; }
                finally {
                    try {
                        if (_l && !_l.done && (_a = _k.return)) _a.call(_k);
                    }
                    finally { if (e_424) throw e_424.error; }
                }
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [];
                try {
                    for (var _m = __values(_data["notes"]), _o = _m.next(); !_o.done; _o = _m.next()) {
                        var item = _o.value;
                        this.notes.push(OrderNoteDto.fromJS(item));
                    }
                }
                catch (e_425_1) { e_425 = { error: e_425_1 }; }
                finally {
                    try {
                        if (_o && !_o.done && (_b = _m.return)) _b.call(_m);
                    }
                    finally { if (e_425) throw e_425.error; }
                }
            }
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [];
                try {
                    for (var _p = __values(_data["eventLogs"]), _q = _p.next(); !_q.done; _q = _p.next()) {
                        var item = _q.value;
                        this.eventLogs.push(EventLogDto.fromJS(item));
                    }
                }
                catch (e_426_1) { e_426 = { error: e_426_1 }; }
                finally {
                    try {
                        if (_q && !_q.done && (_c = _p.return)) _c.call(_p);
                    }
                    finally { if (e_426) throw e_426.error; }
                }
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [];
                try {
                    for (var _r = __values(_data["sourceOrderItems"]), _s = _r.next(); !_s.done; _s = _r.next()) {
                        var item = _s.value;
                        this.sourceOrderItems.push(SourceOrderItemDto.fromJS(item));
                    }
                }
                catch (e_427_1) { e_427 = { error: e_427_1 }; }
                finally {
                    try {
                        if (_s && !_s.done && (_d = _r.return)) _d.call(_r);
                    }
                    finally { if (e_427) throw e_427.error; }
                }
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _t = __values(_data["orderItems"]), _u = _t.next(); !_u.done; _u = _t.next()) {
                        var item = _u.value;
                        this.orderItems.push(OrderItemDto.fromJS(item));
                    }
                }
                catch (e_428_1) { e_428 = { error: e_428_1 }; }
                finally {
                    try {
                        if (_u && !_u.done && (_e = _t.return)) _e.call(_t);
                    }
                    finally { if (e_428) throw e_428.error; }
                }
            }
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [];
                try {
                    for (var _v = __values(_data["relatedDocuments"]), _w = _v.next(); !_w.done; _w = _v.next()) {
                        var item = _w.value;
                        this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
                    }
                }
                catch (e_429_1) { e_429 = { error: e_429_1 }; }
                finally {
                    try {
                        if (_w && !_w.done && (_f = _v.return)) _f.call(_v);
                    }
                    finally { if (e_429) throw e_429.error; }
                }
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [];
                try {
                    for (var _x = __values(_data["documents"]), _y = _x.next(); !_y.done; _y = _x.next()) {
                        var item = _y.value;
                        this.documents.push(DocumentDto.fromJS(item));
                    }
                }
                catch (e_430_1) { e_430 = { error: e_430_1 }; }
                finally {
                    try {
                        if (_y && !_y.done && (_g = _x.return)) _g.call(_x);
                    }
                    finally { if (e_430) throw e_430.error; }
                }
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [];
                try {
                    for (var _z = __values(_data["payments"]), _19 = _z.next(); !_19.done; _19 = _z.next()) {
                        var item = _19.value;
                        this.payments.push(PaymentDto.fromJS(item));
                    }
                }
                catch (e_431_1) { e_431 = { error: e_431_1 }; }
                finally {
                    try {
                        if (_19 && !_19.done && (_h = _z.return)) _h.call(_z);
                    }
                    finally { if (e_431) throw e_431.error; }
                }
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : undefined;
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatusDto.fromJS(_data["currentCommercialStatus"]) : undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : undefined;
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [];
                try {
                    for (var _20 = __values(_data["preparations"]), _21 = _20.next(); !_21.done; _21 = _20.next()) {
                        var item = _21.value;
                        this.preparations.push(PreparationDto.fromJS(item));
                    }
                }
                catch (e_432_1) { e_432 = { error: e_432_1 }; }
                finally {
                    try {
                        if (_21 && !_21.done && (_j = _20.return)) _j.call(_20);
                    }
                    finally { if (e_432) throw e_432.error; }
                }
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrderDto.fromJS(_data["shipmentOrder"]) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.stockStatus = _data["stockStatus"] ? StockStatusDto.fromJS(_data["stockStatus"]) : undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriverDto.fromJS(_data["carrierDriver"]) : undefined;
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"] ? ReplacementCriteriaDto.fromJS(_data["replacementCriteria"]) : undefined;
            this.carrierInfo = _data["carrierInfo"];
            this.giftCard = _data["giftCard"];
            this.includedGiftCard = _data["includedGiftCard"] ? IncludedGiftCardDto.fromJS(_data["includedGiftCard"]) : undefined;
            this.createFromOrderStorePickup = _data["createFromOrderStorePickup"];
            this.invoiceStoreCode = _data["invoiceStoreCode"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.interest = _data["interest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDto();
        result.init(data);
        return result;
    };
    OrderDto.prototype.toJSON = function (data) {
        var e_433, _a, e_434, _b, e_435, _c, e_436, _d, e_437, _e, e_438, _f, e_439, _g, e_440, _h, e_441, _j;
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : undefined;
        data["sourceCode"] = this.sourceCode;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["invoiceNumber"] = this.invoiceNumber;
        data["routeOrder"] = this.routeOrder;
        data["invoiceCreationTime"] = this.invoiceCreationTime ? this.invoiceCreationTime.toISOString() : undefined;
        data["invoiceType"] = this.invoiceType;
        data["highlighted"] = this.highlighted;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrderId"] = this.packOrderId;
        data["balance"] = this.balance;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            try {
                for (var _k = __values(this.orderBalances), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var item = _l.value;
                    data["orderBalances"].push(item.toJSON());
                }
            }
            catch (e_433_1) { e_433 = { error: e_433_1 }; }
            finally {
                try {
                    if (_l && !_l.done && (_a = _k.return)) _a.call(_k);
                }
                finally { if (e_433) throw e_433.error; }
            }
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            try {
                for (var _m = __values(this.notes), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var item = _o.value;
                    data["notes"].push(item.toJSON());
                }
            }
            catch (e_434_1) { e_434 = { error: e_434_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_b = _m.return)) _b.call(_m);
                }
                finally { if (e_434) throw e_434.error; }
            }
        }
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            try {
                for (var _p = __values(this.eventLogs), _q = _p.next(); !_q.done; _q = _p.next()) {
                    var item = _q.value;
                    data["eventLogs"].push(item.toJSON());
                }
            }
            catch (e_435_1) { e_435 = { error: e_435_1 }; }
            finally {
                try {
                    if (_q && !_q.done && (_c = _p.return)) _c.call(_p);
                }
                finally { if (e_435) throw e_435.error; }
            }
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            try {
                for (var _r = __values(this.sourceOrderItems), _s = _r.next(); !_s.done; _s = _r.next()) {
                    var item = _s.value;
                    data["sourceOrderItems"].push(item.toJSON());
                }
            }
            catch (e_436_1) { e_436 = { error: e_436_1 }; }
            finally {
                try {
                    if (_s && !_s.done && (_d = _r.return)) _d.call(_r);
                }
                finally { if (e_436) throw e_436.error; }
            }
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _t = __values(this.orderItems), _u = _t.next(); !_u.done; _u = _t.next()) {
                    var item = _u.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_437_1) { e_437 = { error: e_437_1 }; }
            finally {
                try {
                    if (_u && !_u.done && (_e = _t.return)) _e.call(_t);
                }
                finally { if (e_437) throw e_437.error; }
            }
        }
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            try {
                for (var _v = __values(this.relatedDocuments), _w = _v.next(); !_w.done; _w = _v.next()) {
                    var item = _w.value;
                    data["relatedDocuments"].push(item.toJSON());
                }
            }
            catch (e_438_1) { e_438 = { error: e_438_1 }; }
            finally {
                try {
                    if (_w && !_w.done && (_f = _v.return)) _f.call(_v);
                }
                finally { if (e_438) throw e_438.error; }
            }
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            try {
                for (var _x = __values(this.documents), _y = _x.next(); !_y.done; _y = _x.next()) {
                    var item = _y.value;
                    data["documents"].push(item.toJSON());
                }
            }
            catch (e_439_1) { e_439 = { error: e_439_1 }; }
            finally {
                try {
                    if (_y && !_y.done && (_g = _x.return)) _g.call(_x);
                }
                finally { if (e_439) throw e_439.error; }
            }
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            try {
                for (var _z = __values(this.payments), _19 = _z.next(); !_19.done; _19 = _z.next()) {
                    var item = _19.value;
                    data["payments"].push(item.toJSON());
                }
            }
            catch (e_440_1) { e_440 = { error: e_440_1 }; }
            finally {
                try {
                    if (_19 && !_19.done && (_h = _z.return)) _h.call(_z);
                }
                finally { if (e_440) throw e_440.error; }
            }
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : undefined;
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : undefined;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            try {
                for (var _20 = __values(this.preparations), _21 = _20.next(); !_21.done; _21 = _20.next()) {
                    var item = _21.value;
                    data["preparations"].push(item.toJSON());
                }
            }
            catch (e_441_1) { e_441 = { error: e_441_1 }; }
            finally {
                try {
                    if (_21 && !_21.done && (_j = _20.return)) _j.call(_20);
                }
                finally { if (e_441) throw e_441.error; }
            }
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["stockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : undefined;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria ? this.replacementCriteria.toJSON() : undefined;
        data["carrierInfo"] = this.carrierInfo;
        data["giftCard"] = this.giftCard;
        data["includedGiftCard"] = this.includedGiftCard ? this.includedGiftCard.toJSON() : undefined;
        data["createFromOrderStorePickup"] = this.createFromOrderStorePickup;
        data["invoiceStoreCode"] = this.invoiceStoreCode;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["interest"] = this.interest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDto();
        result.init(json);
        return result;
    };
    return OrderDto;
}());
export { OrderDto };
var ClaimItemDto = /** @class */ (function () {
    function ClaimItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClaimItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.netAmount = _data["netAmount"];
            this.claimedQuantity = _data["claimedQuantity"];
            this.deliveryIssue = _data["deliveryIssue"];
            this.observation = _data["observation"];
            this.action = _data["action"];
            this.id = _data["id"];
        }
    };
    ClaimItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClaimItemDto();
        result.init(data);
        return result;
    };
    ClaimItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["netAmount"] = this.netAmount;
        data["claimedQuantity"] = this.claimedQuantity;
        data["deliveryIssue"] = this.deliveryIssue;
        data["observation"] = this.observation;
        data["action"] = this.action;
        data["id"] = this.id;
        return data;
    };
    ClaimItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ClaimItemDto();
        result.init(json);
        return result;
    };
    return ClaimItemDto;
}());
export { ClaimItemDto };
var ClaimDto = /** @class */ (function () {
    function ClaimDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClaimDto.prototype.init = function (_data) {
        var e_442, _a;
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"] ? ClaimTypeDto.fromJS(_data["type"]) : undefined;
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? OrderDto.fromJS(_data["order"]) : undefined;
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            if (Array.isArray(_data["claimItems"])) {
                this.claimItems = [];
                try {
                    for (var _b = __values(_data["claimItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.claimItems.push(ClaimItemDto.fromJS(item));
                    }
                }
                catch (e_442_1) { e_442 = { error: e_442_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_442) throw e_442.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    ClaimDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClaimDto();
        result.init(data);
        return result;
    };
    ClaimDto.prototype.toJSON = function (data) {
        var e_443, _a;
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type ? this.type.toJSON() : undefined;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        if (Array.isArray(this.claimItems)) {
            data["claimItems"] = [];
            try {
                for (var _b = __values(this.claimItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["claimItems"].push(item.toJSON());
                }
            }
            catch (e_443_1) { e_443 = { error: e_443_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_443) throw e_443.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    ClaimDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ClaimDto();
        result.init(json);
        return result;
    };
    return ClaimDto;
}());
export { ClaimDto };
var ClaimDtoPagedResultDto = /** @class */ (function () {
    function ClaimDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClaimDtoPagedResultDto.prototype.init = function (_data) {
        var e_444, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ClaimDto.fromJS(item));
                    }
                }
                catch (e_444_1) { e_444 = { error: e_444_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_444) throw e_444.error; }
                }
            }
        }
    };
    ClaimDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClaimDtoPagedResultDto();
        result.init(data);
        return result;
    };
    ClaimDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_445, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_445_1) { e_445 = { error: e_445_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_445) throw e_445.error; }
            }
        }
        return data;
    };
    ClaimDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ClaimDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return ClaimDtoPagedResultDto;
}());
export { ClaimDtoPagedResultDto };
var ComerssiaOrderStatus = /** @class */ (function () {
    function ComerssiaOrderStatus(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ComerssiaOrderStatus.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.statusCode = _data["statusCode"];
            this.statusDescription = _data["statusDescription"];
            this.storeCode = _data["storeCode"];
            this.invoiceNumber = _data["invoiceNumber"];
        }
    };
    ComerssiaOrderStatus.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ComerssiaOrderStatus();
        result.init(data);
        return result;
    };
    ComerssiaOrderStatus.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["storeCode"] = this.storeCode;
        data["invoiceNumber"] = this.invoiceNumber;
        return data;
    };
    ComerssiaOrderStatus.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ComerssiaOrderStatus();
        result.init(json);
        return result;
    };
    return ComerssiaOrderStatus;
}());
export { ComerssiaOrderStatus };
var CapturaDto = /** @class */ (function () {
    function CapturaDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CapturaDto.prototype.init = function (_data) {
        if (_data) {
            this.presentacion = _data["presentacion"];
            this.descripcion = _data["descripcion"];
            this.cadena = _data["cadena"];
            this.letra = _data["letra"];
            this.valorNumerico = _data["valorNumerico"];
        }
    };
    CapturaDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CapturaDto();
        result.init(data);
        return result;
    };
    CapturaDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["presentacion"] = this.presentacion;
        data["descripcion"] = this.descripcion;
        data["cadena"] = this.cadena;
        data["letra"] = this.letra;
        data["valorNumerico"] = this.valorNumerico;
        return data;
    };
    CapturaDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CapturaDto();
        result.init(json);
        return result;
    };
    return CapturaDto;
}());
export { CapturaDto };
var InvoiceItemDto = /** @class */ (function () {
    function InvoiceItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvoiceItemDto.prototype.init = function (_data) {
        if (_data) {
            this.nItem = _data["nItem"];
            this.tipo = _data["tipo"];
            this.visible = _data["visible"];
            this.imprime = _data["imprime"];
            this.presentacion = _data["presentacion"];
            this.descripcion = _data["descripcion"];
            this.cadena = _data["cadena"];
            this.letra = _data["letra"];
            this.codigo = _data["codigo"];
            this.tfcCodigo = _data["tfcCodigo"];
            this.tipoRef = _data["tipoRef"];
            this.refCodigo1 = _data["refCodigo1"];
            this.refPrecioLista = _data["refPrecioLista"];
            this.irfBruto = _data["irfBruto"];
            this.irfDescuento = _data["irfDescuento"];
            this.irfPago = _data["irfPago"];
            this.irfCantidad = _data["irfCantidad"];
            this.irfValorImpuesto = _data["irfValorImpuesto"];
            this.irfImpuesto = _data["irfImpuesto"];
            this.refEsCombo = _data["refEsCombo"];
            this.irfVenta = _data["irfVenta"];
            this.irfNeto = _data["irfNeto"];
            this.irfValorImpuestoNeto = _data["irfValorImpuestoNeto"];
            this.captura = _data["captura"] ? CapturaDto.fromJS(_data["captura"]) : undefined;
            this.irfBase = _data["irfBase"];
        }
    };
    InvoiceItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InvoiceItemDto();
        result.init(data);
        return result;
    };
    InvoiceItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["nItem"] = this.nItem;
        data["tipo"] = this.tipo;
        data["visible"] = this.visible;
        data["imprime"] = this.imprime;
        data["presentacion"] = this.presentacion;
        data["descripcion"] = this.descripcion;
        data["cadena"] = this.cadena;
        data["letra"] = this.letra;
        data["codigo"] = this.codigo;
        data["tfcCodigo"] = this.tfcCodigo;
        data["tipoRef"] = this.tipoRef;
        data["refCodigo1"] = this.refCodigo1;
        data["refPrecioLista"] = this.refPrecioLista;
        data["irfBruto"] = this.irfBruto;
        data["irfDescuento"] = this.irfDescuento;
        data["irfPago"] = this.irfPago;
        data["irfCantidad"] = this.irfCantidad;
        data["irfValorImpuesto"] = this.irfValorImpuesto;
        data["irfImpuesto"] = this.irfImpuesto;
        data["refEsCombo"] = this.refEsCombo;
        data["irfVenta"] = this.irfVenta;
        data["irfNeto"] = this.irfNeto;
        data["irfValorImpuestoNeto"] = this.irfValorImpuestoNeto;
        data["captura"] = this.captura ? this.captura.toJSON() : undefined;
        data["irfBase"] = this.irfBase;
        return data;
    };
    InvoiceItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new InvoiceItemDto();
        result.init(json);
        return result;
    };
    return InvoiceItemDto;
}());
export { InvoiceItemDto };
var InvoiceDto = /** @class */ (function () {
    function InvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvoiceDto.prototype.init = function (_data) {
        var e_446, _a;
        if (_data) {
            this.usuCodigo = _data["usuCodigo"];
            this.cajCodigo = _data["cajCodigo"];
            this.almCodigo = _data["almCodigo"];
            this.almNombre = _data["almNombre"];
            this.fecha = _data["fecha"];
            this.hora = _data["hora"];
            this.prcCodigo = _data["prcCodigo"];
            this.encConsTrx = _data["encConsTrx"];
            this.totalReferencias = _data["totalReferencias"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                try {
                    for (var _b = __values(_data["data"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.data.push(InvoiceItemDto.fromJS(item));
                    }
                }
                catch (e_446_1) { e_446 = { error: e_446_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_446) throw e_446.error; }
                }
            }
        }
    };
    InvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InvoiceDto();
        result.init(data);
        return result;
    };
    InvoiceDto.prototype.toJSON = function (data) {
        var e_447, _a;
        data = typeof data === 'object' ? data : {};
        data["usuCodigo"] = this.usuCodigo;
        data["cajCodigo"] = this.cajCodigo;
        data["almCodigo"] = this.almCodigo;
        data["almNombre"] = this.almNombre;
        data["fecha"] = this.fecha;
        data["hora"] = this.hora;
        data["prcCodigo"] = this.prcCodigo;
        data["encConsTrx"] = this.encConsTrx;
        data["totalReferencias"] = this.totalReferencias;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            try {
                for (var _b = __values(this.data), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["data"].push(item.toJSON());
                }
            }
            catch (e_447_1) { e_447 = { error: e_447_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_447) throw e_447.error; }
            }
        }
        return data;
    };
    InvoiceDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new InvoiceDto();
        result.init(json);
        return result;
    };
    return InvoiceDto;
}());
export { InvoiceDto };
var InvoiceResponse = /** @class */ (function () {
    function InvoiceResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    InvoiceResponse.prototype.init = function (_data) {
        if (_data) {
            this.codigo = _data["codigo"];
            this.descripcion = _data["descripcion"];
            this.xmlUrl = _data["xmlUrl"];
            this.prcCodigo = _data["prcCodigo"];
        }
    };
    InvoiceResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new InvoiceResponse();
        result.init(data);
        return result;
    };
    InvoiceResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["codigo"] = this.codigo;
        data["descripcion"] = this.descripcion;
        data["xmlUrl"] = this.xmlUrl;
        data["prcCodigo"] = this.prcCodigo;
        return data;
    };
    InvoiceResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new InvoiceResponse();
        result.init(json);
        return result;
    };
    return InvoiceResponse;
}());
export { InvoiceResponse };
var CustomValueDto = /** @class */ (function () {
    function CustomValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomValueDto.prototype.init = function (_data) {
        if (_data) {
            this.reference = _data["reference"];
            this.value = _data["value"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    };
    CustomValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomValueDto();
        result.init(data);
        return result;
    };
    CustomValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["value"] = this.value;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    };
    CustomValueDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CustomValueDto();
        result.init(json);
        return result;
    };
    return CustomValueDto;
}());
export { CustomValueDto };
var CustomValueDtoPagedResultDto = /** @class */ (function () {
    function CustomValueDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomValueDtoPagedResultDto.prototype.init = function (_data) {
        var e_448, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(CustomValueDto.fromJS(item));
                    }
                }
                catch (e_448_1) { e_448 = { error: e_448_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_448) throw e_448.error; }
                }
            }
        }
    };
    CustomValueDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomValueDtoPagedResultDto();
        result.init(data);
        return result;
    };
    CustomValueDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_449, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_449_1) { e_449 = { error: e_449_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_449) throw e_449.error; }
            }
        }
        return data;
    };
    CustomValueDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CustomValueDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return CustomValueDtoPagedResultDto;
}());
export { CustomValueDtoPagedResultDto };
var DeliveryScheduleDto = /** @class */ (function () {
    function DeliveryScheduleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryScheduleDto.prototype.init = function (_data) {
        if (_data) {
            this.label = _data["label"];
            this.hourFrom = _data["hourFrom"];
            this.offset = _data["offset"];
            this.customValueId = _data["customValueId"];
            this.countryCode = _data["countryCode"];
            this.customValue = _data["customValue"] ? CustomValueDto.fromJS(_data["customValue"]) : undefined;
            this.id = _data["id"];
        }
    };
    DeliveryScheduleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryScheduleDto();
        result.init(data);
        return result;
    };
    DeliveryScheduleDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["hourFrom"] = this.hourFrom;
        data["offset"] = this.offset;
        data["customValueId"] = this.customValueId;
        data["countryCode"] = this.countryCode;
        data["customValue"] = this.customValue ? this.customValue.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    DeliveryScheduleDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DeliveryScheduleDto();
        result.init(json);
        return result;
    };
    return DeliveryScheduleDto;
}());
export { DeliveryScheduleDto };
var DeliveryScheduleDtoPagedResultDto = /** @class */ (function () {
    function DeliveryScheduleDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryScheduleDtoPagedResultDto.prototype.init = function (_data) {
        var e_450, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(DeliveryScheduleDto.fromJS(item));
                    }
                }
                catch (e_450_1) { e_450 = { error: e_450_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_450) throw e_450.error; }
                }
            }
        }
    };
    DeliveryScheduleDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryScheduleDtoPagedResultDto();
        result.init(data);
        return result;
    };
    DeliveryScheduleDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_451, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_451_1) { e_451 = { error: e_451_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_451) throw e_451.error; }
            }
        }
        return data;
    };
    DeliveryScheduleDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DeliveryScheduleDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return DeliveryScheduleDtoPagedResultDto;
}());
export { DeliveryScheduleDtoPagedResultDto };
var OrderDtoPagedResultDto = /** @class */ (function () {
    function OrderDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDtoPagedResultDto.prototype.init = function (_data) {
        var e_452, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrderDto.fromJS(item));
                    }
                }
                catch (e_452_1) { e_452 = { error: e_452_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_452) throw e_452.error; }
                }
            }
        }
    };
    OrderDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDtoPagedResultDto();
        result.init(data);
        return result;
    };
    OrderDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_453, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_453_1) { e_453 = { error: e_453_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_453) throw e_453.error; }
            }
        }
        return data;
    };
    OrderDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return OrderDtoPagedResultDto;
}());
export { OrderDtoPagedResultDto };
var DistrictDtoPagedResultDto = /** @class */ (function () {
    function DistrictDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DistrictDtoPagedResultDto.prototype.init = function (_data) {
        var e_454, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(DistrictDto.fromJS(item));
                    }
                }
                catch (e_454_1) { e_454 = { error: e_454_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_454) throw e_454.error; }
                }
            }
        }
    };
    DistrictDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DistrictDtoPagedResultDto();
        result.init(data);
        return result;
    };
    DistrictDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_455, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_455_1) { e_455 = { error: e_455_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_455) throw e_455.error; }
            }
        }
        return data;
    };
    DistrictDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DistrictDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return DistrictDtoPagedResultDto;
}());
export { DistrictDtoPagedResultDto };
var SendDraftRequest = /** @class */ (function () {
    function SendDraftRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendDraftRequest.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.documentType = _data["documentType"];
            this.documentId = _data["documentId"];
            this.documentNotificationId = _data["documentNotificationId"];
        }
    };
    SendDraftRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendDraftRequest();
        result.init(data);
        return result;
    };
    SendDraftRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["documentType"] = this.documentType;
        data["documentId"] = this.documentId;
        data["documentNotificationId"] = this.documentNotificationId;
        return data;
    };
    SendDraftRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SendDraftRequest();
        result.init(json);
        return result;
    };
    return SendDraftRequest;
}());
export { SendDraftRequest };
var SendDraftRequestList = /** @class */ (function () {
    function SendDraftRequestList(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendDraftRequestList.prototype.init = function (_data) {
        var e_456, _a;
        if (_data) {
            if (Array.isArray(_data["drafts"])) {
                this.drafts = [];
                try {
                    for (var _b = __values(_data["drafts"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.drafts.push(SendDraftRequest.fromJS(item));
                    }
                }
                catch (e_456_1) { e_456 = { error: e_456_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_456) throw e_456.error; }
                }
            }
        }
    };
    SendDraftRequestList.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendDraftRequestList();
        result.init(data);
        return result;
    };
    SendDraftRequestList.prototype.toJSON = function (data) {
        var e_457, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.drafts)) {
            data["drafts"] = [];
            try {
                for (var _b = __values(this.drafts), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["drafts"].push(item.toJSON());
                }
            }
            catch (e_457_1) { e_457 = { error: e_457_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_457) throw e_457.error; }
            }
        }
        return data;
    };
    SendDraftRequestList.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SendDraftRequestList();
        result.init(json);
        return result;
    };
    return SendDraftRequestList;
}());
export { SendDraftRequestList };
var DocumentDtoPagedResultDto = /** @class */ (function () {
    function DocumentDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentDtoPagedResultDto.prototype.init = function (_data) {
        var e_458, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(DocumentDto.fromJS(item));
                    }
                }
                catch (e_458_1) { e_458 = { error: e_458_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_458) throw e_458.error; }
                }
            }
        }
    };
    DocumentDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentDtoPagedResultDto();
        result.init(data);
        return result;
    };
    DocumentDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_459, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_459_1) { e_459 = { error: e_459_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_459) throw e_459.error; }
            }
        }
        return data;
    };
    DocumentDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DocumentDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return DocumentDtoPagedResultDto;
}());
export { DocumentDtoPagedResultDto };
var FailedDeliveryItemDto = /** @class */ (function () {
    function FailedDeliveryItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FailedDeliveryItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.quantityFailed = _data["quantityFailed"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    };
    FailedDeliveryItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FailedDeliveryItemDto();
        result.init(data);
        return result;
    };
    FailedDeliveryItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["quantityFailed"] = this.quantityFailed;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data;
    };
    FailedDeliveryItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FailedDeliveryItemDto();
        result.init(json);
        return result;
    };
    return FailedDeliveryItemDto;
}());
export { FailedDeliveryItemDto };
var FailedDeliveryDto = /** @class */ (function () {
    function FailedDeliveryDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FailedDeliveryDto.prototype.init = function (_data) {
        var e_460, _a;
        if (_data) {
            this.orderId = _data["orderId"];
            this.comments = _data["comments"];
            if (Array.isArray(_data["failedItems"])) {
                this.failedItems = [];
                try {
                    for (var _b = __values(_data["failedItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.failedItems.push(FailedDeliveryItemDto.fromJS(item));
                    }
                }
                catch (e_460_1) { e_460 = { error: e_460_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_460) throw e_460.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    FailedDeliveryDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FailedDeliveryDto();
        result.init(data);
        return result;
    };
    FailedDeliveryDto.prototype.toJSON = function (data) {
        var e_461, _a;
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["comments"] = this.comments;
        if (Array.isArray(this.failedItems)) {
            data["failedItems"] = [];
            try {
                for (var _b = __values(this.failedItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["failedItems"].push(item.toJSON());
                }
            }
            catch (e_461_1) { e_461 = { error: e_461_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_461) throw e_461.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    FailedDeliveryDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FailedDeliveryDto();
        result.init(json);
        return result;
    };
    return FailedDeliveryDto;
}());
export { FailedDeliveryDto };
var FailedDeliveryDtoPagedResultDto = /** @class */ (function () {
    function FailedDeliveryDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FailedDeliveryDtoPagedResultDto.prototype.init = function (_data) {
        var e_462, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(FailedDeliveryDto.fromJS(item));
                    }
                }
                catch (e_462_1) { e_462 = { error: e_462_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_462) throw e_462.error; }
                }
            }
        }
    };
    FailedDeliveryDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FailedDeliveryDtoPagedResultDto();
        result.init(data);
        return result;
    };
    FailedDeliveryDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_463, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_463_1) { e_463 = { error: e_463_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_463) throw e_463.error; }
            }
        }
        return data;
    };
    FailedDeliveryDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FailedDeliveryDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return FailedDeliveryDtoPagedResultDto;
}());
export { FailedDeliveryDtoPagedResultDto };
var FlyerDto = /** @class */ (function () {
    function FlyerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlyerDto.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.color = _data["color"];
            this.isDefault = _data["isDefault"];
            this.id = _data["id"];
        }
    };
    FlyerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlyerDto();
        result.init(data);
        return result;
    };
    FlyerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["color"] = this.color;
        data["isDefault"] = this.isDefault;
        data["id"] = this.id;
        return data;
    };
    FlyerDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FlyerDto();
        result.init(json);
        return result;
    };
    return FlyerDto;
}());
export { FlyerDto };
var FlyerDtoPagedResultDto = /** @class */ (function () {
    function FlyerDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlyerDtoPagedResultDto.prototype.init = function (_data) {
        var e_464, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(FlyerDto.fromJS(item));
                    }
                }
                catch (e_464_1) { e_464 = { error: e_464_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_464) throw e_464.error; }
                }
            }
        }
    };
    FlyerDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlyerDtoPagedResultDto();
        result.init(data);
        return result;
    };
    FlyerDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_465, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_465_1) { e_465 = { error: e_465_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_465) throw e_465.error; }
            }
        }
        return data;
    };
    FlyerDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FlyerDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return FlyerDtoPagedResultDto;
}());
export { FlyerDtoPagedResultDto };
var FlyerDistributionDto = /** @class */ (function () {
    function FlyerDistributionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlyerDistributionDto.prototype.init = function (_data) {
        if (_data) {
            this.flyerId = _data["flyerId"];
            this.flyer = _data["flyer"] ? FlyerDto.fromJS(_data["flyer"]) : undefined;
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : undefined;
            this.city = _data["city"];
            this.postalCodeFrom = _data["postalCodeFrom"];
            this.postalCodeTo = _data["postalCodeTo"];
            this.dateFrom = _data["dateFrom"] ? moment(_data["dateFrom"].toString()) : undefined;
            this.dateTo = _data["dateTo"] ? moment(_data["dateTo"].toString()) : undefined;
            this.name = _data["name"];
            this.id = _data["id"];
        }
    };
    FlyerDistributionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlyerDistributionDto();
        result.init(data);
        return result;
    };
    FlyerDistributionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["flyerId"] = this.flyerId;
        data["flyer"] = this.flyer ? this.flyer.toJSON() : undefined;
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : undefined;
        data["city"] = this.city;
        data["postalCodeFrom"] = this.postalCodeFrom;
        data["postalCodeTo"] = this.postalCodeTo;
        data["dateFrom"] = this.dateFrom ? this.dateFrom.toISOString() : undefined;
        data["dateTo"] = this.dateTo ? this.dateTo.toISOString() : undefined;
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    };
    FlyerDistributionDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FlyerDistributionDto();
        result.init(json);
        return result;
    };
    return FlyerDistributionDto;
}());
export { FlyerDistributionDto };
var FlyerUploadDto = /** @class */ (function () {
    function FlyerUploadDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlyerUploadDto.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    };
    FlyerUploadDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlyerUploadDto();
        result.init(data);
        return result;
    };
    FlyerUploadDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data;
    };
    FlyerUploadDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FlyerUploadDto();
        result.init(json);
        return result;
    };
    return FlyerUploadDto;
}());
export { FlyerUploadDto };
var FlyerDistributionDtoPagedResultDto = /** @class */ (function () {
    function FlyerDistributionDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlyerDistributionDtoPagedResultDto.prototype.init = function (_data) {
        var e_466, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(FlyerDistributionDto.fromJS(item));
                    }
                }
                catch (e_466_1) { e_466 = { error: e_466_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_466) throw e_466.error; }
                }
            }
        }
    };
    FlyerDistributionDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlyerDistributionDtoPagedResultDto();
        result.init(data);
        return result;
    };
    FlyerDistributionDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_467, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_467_1) { e_467 = { error: e_467_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_467) throw e_467.error; }
            }
        }
        return data;
    };
    FlyerDistributionDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FlyerDistributionDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return FlyerDistributionDtoPagedResultDto;
}());
export { FlyerDistributionDtoPagedResultDto };
var GeneralAuditOrderDetail = /** @class */ (function () {
    function GeneralAuditOrderDetail(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GeneralAuditOrderDetail.prototype.init = function (_data) {
        if (_data) {
            this.shipmentId = _data["shipmentId"];
            this.shipmentIssue = _data["shipmentIssue"];
            this.shipmentDate = _data["shipmentDate"] ? moment(_data["shipmentDate"].toString()) : undefined;
            this.carrierName = _data["carrierName"];
        }
    };
    GeneralAuditOrderDetail.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeneralAuditOrderDetail();
        result.init(data);
        return result;
    };
    GeneralAuditOrderDetail.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["shipmentId"] = this.shipmentId;
        data["shipmentIssue"] = this.shipmentIssue;
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["carrierName"] = this.carrierName;
        return data;
    };
    GeneralAuditOrderDetail.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GeneralAuditOrderDetail();
        result.init(json);
        return result;
    };
    return GeneralAuditOrderDetail;
}());
export { GeneralAuditOrderDetail };
var GeneralAuditDto = /** @class */ (function () {
    function GeneralAuditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GeneralAuditDto.prototype.init = function (_data) {
        if (_data) {
            this.shipmentsCount = _data["shipmentsCount"];
            this.orderNumber = _data["orderNumber"];
            this.channel = _data["channel"];
            this.reviewDate = _data["reviewDate"] ? moment(_data["reviewDate"].toString()) : undefined;
            this.shippingType = _data["shippingType"];
            this.logisticStatus = _data["logisticStatus"] ? LogisticStatusValueDto.fromJS(_data["logisticStatus"]) : undefined;
            this.countryCode = _data["countryCode"];
            this.quantityInClonflict = _data["quantityInClonflict"];
            this.id = _data["id"];
        }
    };
    GeneralAuditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeneralAuditDto();
        result.init(data);
        return result;
    };
    GeneralAuditDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["shipmentsCount"] = this.shipmentsCount;
        data["orderNumber"] = this.orderNumber;
        data["channel"] = this.channel;
        data["reviewDate"] = this.reviewDate ? this.reviewDate.toISOString() : undefined;
        data["shippingType"] = this.shippingType;
        data["logisticStatus"] = this.logisticStatus ? this.logisticStatus.toJSON() : undefined;
        data["countryCode"] = this.countryCode;
        data["quantityInClonflict"] = this.quantityInClonflict;
        data["id"] = this.id;
        return data;
    };
    GeneralAuditDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GeneralAuditDto();
        result.init(json);
        return result;
    };
    return GeneralAuditDto;
}());
export { GeneralAuditDto };
var GeneralAuditDtoPagedResultDto = /** @class */ (function () {
    function GeneralAuditDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GeneralAuditDtoPagedResultDto.prototype.init = function (_data) {
        var e_468, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(GeneralAuditDto.fromJS(item));
                    }
                }
                catch (e_468_1) { e_468 = { error: e_468_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_468) throw e_468.error; }
                }
            }
        }
    };
    GeneralAuditDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GeneralAuditDtoPagedResultDto();
        result.init(data);
        return result;
    };
    GeneralAuditDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_469, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_469_1) { e_469 = { error: e_469_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_469) throw e_469.error; }
            }
        }
        return data;
    };
    GeneralAuditDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GeneralAuditDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return GeneralAuditDtoPagedResultDto;
}());
export { GeneralAuditDtoPagedResultDto };
var UploadHubDeliveryMappingDto = /** @class */ (function () {
    function UploadHubDeliveryMappingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadHubDeliveryMappingDto.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    };
    UploadHubDeliveryMappingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadHubDeliveryMappingDto();
        result.init(data);
        return result;
    };
    UploadHubDeliveryMappingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data;
    };
    UploadHubDeliveryMappingDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UploadHubDeliveryMappingDto();
        result.init(json);
        return result;
    };
    return UploadHubDeliveryMappingDto;
}());
export { UploadHubDeliveryMappingDto };
var HubDeliveryMappingDto = /** @class */ (function () {
    function HubDeliveryMappingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HubDeliveryMappingDto.prototype.init = function (_data) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.sourceName = _data["sourceName"];
            this.postalCode = _data["postalCode"];
            this.countryCode = _data["countryCode"];
            this.orderCreationWindow = _data["orderCreationWindow"];
            this.isSunday = _data["isSunday"];
            this.id = _data["id"];
        }
    };
    HubDeliveryMappingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HubDeliveryMappingDto();
        result.init(data);
        return result;
    };
    HubDeliveryMappingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["sourceName"] = this.sourceName;
        data["postalCode"] = this.postalCode;
        data["countryCode"] = this.countryCode;
        data["orderCreationWindow"] = this.orderCreationWindow;
        data["isSunday"] = this.isSunday;
        data["id"] = this.id;
        return data;
    };
    HubDeliveryMappingDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new HubDeliveryMappingDto();
        result.init(json);
        return result;
    };
    return HubDeliveryMappingDto;
}());
export { HubDeliveryMappingDto };
var HubDeliveryMappingDtoPagedResultDto = /** @class */ (function () {
    function HubDeliveryMappingDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    HubDeliveryMappingDtoPagedResultDto.prototype.init = function (_data) {
        var e_470, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(HubDeliveryMappingDto.fromJS(item));
                    }
                }
                catch (e_470_1) { e_470 = { error: e_470_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_470) throw e_470.error; }
                }
            }
        }
    };
    HubDeliveryMappingDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new HubDeliveryMappingDtoPagedResultDto();
        result.init(data);
        return result;
    };
    HubDeliveryMappingDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_471, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_471_1) { e_471 = { error: e_471_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_471) throw e_471.error; }
            }
        }
        return data;
    };
    HubDeliveryMappingDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new HubDeliveryMappingDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return HubDeliveryMappingDtoPagedResultDto;
}());
export { HubDeliveryMappingDtoPagedResultDto };
var LandingInfoDto = /** @class */ (function () {
    function LandingInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LandingInfoDto.prototype.init = function (_data) {
        if (_data) {
            this.group = _data["group"];
            this.value = _data["value"];
            this.extraInfo = _data["extraInfo"];
            this.category = _data["category"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    };
    LandingInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LandingInfoDto();
        result.init(data);
        return result;
    };
    LandingInfoDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["group"] = this.group;
        data["value"] = this.value;
        data["extraInfo"] = this.extraInfo;
        data["category"] = this.category;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    };
    LandingInfoDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LandingInfoDto();
        result.init(json);
        return result;
    };
    return LandingInfoDto;
}());
export { LandingInfoDto };
var AddMeliNotification = /** @class */ (function () {
    function AddMeliNotification(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddMeliNotification.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
        }
    };
    AddMeliNotification.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddMeliNotification();
        result.init(data);
        return result;
    };
    AddMeliNotification.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        return data;
    };
    AddMeliNotification.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddMeliNotification();
        result.init(json);
        return result;
    };
    return AddMeliNotification;
}());
export { AddMeliNotification };
var AddMeliNotificationResponse = /** @class */ (function () {
    function AddMeliNotificationResponse(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AddMeliNotificationResponse.prototype.init = function (_data) {
        if (_data) {
            this.addOk = _data["addOk"];
            this.validationMsj = _data["validationMsj"];
        }
    };
    AddMeliNotificationResponse.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AddMeliNotificationResponse();
        result.init(data);
        return result;
    };
    AddMeliNotificationResponse.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["addOk"] = this.addOk;
        data["validationMsj"] = this.validationMsj;
        return data;
    };
    AddMeliNotificationResponse.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AddMeliNotificationResponse();
        result.init(json);
        return result;
    };
    return AddMeliNotificationResponse;
}());
export { AddMeliNotificationResponse };
var OrderDtoListResultDto = /** @class */ (function () {
    function OrderDtoListResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDtoListResultDto.prototype.init = function (_data) {
        var e_472, _a;
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrderDto.fromJS(item));
                    }
                }
                catch (e_472_1) { e_472 = { error: e_472_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_472) throw e_472.error; }
                }
            }
        }
    };
    OrderDtoListResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDtoListResultDto();
        result.init(data);
        return result;
    };
    OrderDtoListResultDto.prototype.toJSON = function (data) {
        var e_473, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_473_1) { e_473 = { error: e_473_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_473) throw e_473.error; }
            }
        }
        return data;
    };
    OrderDtoListResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDtoListResultDto();
        result.init(json);
        return result;
    };
    return OrderDtoListResultDto;
}());
export { OrderDtoListResultDto };
var DispatchOrderRequest = /** @class */ (function () {
    function DispatchOrderRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DispatchOrderRequest.prototype.init = function (_data) {
        var e_474, _a;
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [];
                try {
                    for (var _b = __values(_data["relatedDocuments"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
                    }
                }
                catch (e_474_1) { e_474 = { error: e_474_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_474) throw e_474.error; }
                }
            }
        }
    };
    DispatchOrderRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DispatchOrderRequest();
        result.init(data);
        return result;
    };
    DispatchOrderRequest.prototype.toJSON = function (data) {
        var e_475, _a;
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            try {
                for (var _b = __values(this.relatedDocuments), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["relatedDocuments"].push(item.toJSON());
                }
            }
            catch (e_475_1) { e_475 = { error: e_475_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_475) throw e_475.error; }
            }
        }
        return data;
    };
    DispatchOrderRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DispatchOrderRequest();
        result.init(json);
        return result;
    };
    return DispatchOrderRequest;
}());
export { DispatchOrderRequest };
var OrderCsvDashboardDto = /** @class */ (function () {
    function OrderCsvDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderCsvDashboardDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.sourceOrderCode = _data["sourceOrderCode"];
            this.salesChannel = _data["salesChannel"];
            this.sourceCreationTime = _data["sourceCreationTime"];
            this.estimatedDeliveryDate = _data["estimatedDeliveryDate"];
            this.timeZone = _data["timeZone"];
            this.shippingType = _data["shippingType"];
            this.currentOverallStatus = _data["currentOverallStatus"];
            this.currentLogisticStatus = _data["currentLogisticStatus"];
            this.customerDocument = _data["customerDocument"];
            this.customer = _data["customer"];
            this.deliveryAddress = _data["deliveryAddress"];
            this.customerPhone = _data["customerPhone"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.netValue = _data["netValue"];
            this.totalValue = _data["totalValue"];
            this.carrier = _data["carrier"];
            this.currentAssignedToStore = _data["currentAssignedToStore"];
            this.distanceTraveled = _data["distanceTraveled"];
            this.orderNotes = _data["orderNotes"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.shipmentDeliveredOn = _data["shipmentDeliveredOn"];
        }
    };
    OrderCsvDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderCsvDashboardDto();
        result.init(data);
        return result;
    };
    OrderCsvDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sourceOrderCode"] = this.sourceOrderCode;
        data["salesChannel"] = this.salesChannel;
        data["sourceCreationTime"] = this.sourceCreationTime;
        data["estimatedDeliveryDate"] = this.estimatedDeliveryDate;
        data["timeZone"] = this.timeZone;
        data["shippingType"] = this.shippingType;
        data["currentOverallStatus"] = this.currentOverallStatus;
        data["currentLogisticStatus"] = this.currentLogisticStatus;
        data["customerDocument"] = this.customerDocument;
        data["customer"] = this.customer;
        data["deliveryAddress"] = this.deliveryAddress;
        data["customerPhone"] = this.customerPhone;
        data["invoiceNumber"] = this.invoiceNumber;
        data["netValue"] = this.netValue;
        data["totalValue"] = this.totalValue;
        data["carrier"] = this.carrier;
        data["currentAssignedToStore"] = this.currentAssignedToStore;
        data["distanceTraveled"] = this.distanceTraveled;
        data["orderNotes"] = this.orderNotes;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["shipmentDeliveredOn"] = this.shipmentDeliveredOn;
        return data;
    };
    OrderCsvDashboardDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderCsvDashboardDto();
        result.init(json);
        return result;
    };
    return OrderCsvDashboardDto;
}());
export { OrderCsvDashboardDto };
var OrderCsvOLDto = /** @class */ (function () {
    function OrderCsvOLDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderCsvOLDto.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.dispatchDate = _data["dispatchDate"];
            this.dispatchTime = _data["dispatchTime"];
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"];
            this.estimatedDeliveryDateFromTime = _data["estimatedDeliveryDateFromTime"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.customerCode = _data["customerCode"];
            this.customer = _data["customer"];
            this.documentNumber = _data["documentNumber"];
            this.email = _data["email"];
            this.shippingType = _data["shippingType"];
            this.address = _data["address"];
            this.postalCode = _data["postalCode"];
            this.complement = _data["complement"];
            this.franjaHoraria = _data["franjaHoraria"];
            this.canalDeEntrega = _data["canalDeEntrega"];
            this.estadoGeneral = _data["estadoGeneral"];
            this.tiendaAsignada = _data["tiendaAsignada"];
        }
    };
    OrderCsvOLDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderCsvOLDto();
        result.init(data);
        return result;
    };
    OrderCsvOLDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["dispatchDate"] = this.dispatchDate;
        data["dispatchTime"] = this.dispatchTime;
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom;
        data["estimatedDeliveryDateFromTime"] = this.estimatedDeliveryDateFromTime;
        data["city"] = this.city;
        data["state"] = this.state;
        data["customerCode"] = this.customerCode;
        data["customer"] = this.customer;
        data["documentNumber"] = this.documentNumber;
        data["email"] = this.email;
        data["shippingType"] = this.shippingType;
        data["address"] = this.address;
        data["postalCode"] = this.postalCode;
        data["complement"] = this.complement;
        data["franjaHoraria"] = this.franjaHoraria;
        data["canalDeEntrega"] = this.canalDeEntrega;
        data["estadoGeneral"] = this.estadoGeneral;
        data["tiendaAsignada"] = this.tiendaAsignada;
        return data;
    };
    OrderCsvOLDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderCsvOLDto();
        result.init(json);
        return result;
    };
    return OrderCsvOLDto;
}());
export { OrderCsvOLDto };
var OrderCsvQuadminDto = /** @class */ (function () {
    function OrderCsvQuadminDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderCsvQuadminDto.prototype.init = function (_data) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.orderId = _data["orderId"];
            this.dispatchTime = _data["dispatchTime"];
            this.operation = _data["operation"];
            this.sku = _data["sku"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.money = _data["money"];
            this.clientDelay = _data["clientDelay"];
            this.deliveryWindow1 = _data["deliveryWindow1"];
            this.deliveryWindow2 = _data["deliveryWindow2"];
            this.deliveryCommentaries = _data["deliveryCommentaries"];
            this.group = _data["group"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
        }
    };
    OrderCsvQuadminDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderCsvQuadminDto();
        result.init(data);
        return result;
    };
    OrderCsvQuadminDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["orderId"] = this.orderId;
        data["dispatchTime"] = this.dispatchTime;
        data["operation"] = this.operation;
        data["sku"] = this.sku;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["money"] = this.money;
        data["clientDelay"] = this.clientDelay;
        data["deliveryWindow1"] = this.deliveryWindow1;
        data["deliveryWindow2"] = this.deliveryWindow2;
        data["deliveryCommentaries"] = this.deliveryCommentaries;
        data["group"] = this.group;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        return data;
    };
    OrderCsvQuadminDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderCsvQuadminDto();
        result.init(json);
        return result;
    };
    return OrderCsvQuadminDto;
}());
export { OrderCsvQuadminDto };
var SendToQuadmindsDto = /** @class */ (function () {
    function SendToQuadmindsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SendToQuadmindsDto.prototype.init = function (_data) {
        var e_476, _a;
        if (_data) {
            if (Array.isArray(_data["orders"])) {
                this.orders = [];
                try {
                    for (var _b = __values(_data["orders"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orders.push(item);
                    }
                }
                catch (e_476_1) { e_476 = { error: e_476_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_476) throw e_476.error; }
                }
            }
            this.countryCode = _data["countryCode"];
            this.type = _data["type"];
        }
    };
    SendToQuadmindsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SendToQuadmindsDto();
        result.init(data);
        return result;
    };
    SendToQuadmindsDto.prototype.toJSON = function (data) {
        var e_477, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            try {
                for (var _b = __values(this.orders), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orders"].push(item);
                }
            }
            catch (e_477_1) { e_477 = { error: e_477_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_477) throw e_477.error; }
            }
        }
        data["countryCode"] = this.countryCode;
        data["type"] = this.type;
        return data;
    };
    SendToQuadmindsDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SendToQuadmindsDto();
        result.init(json);
        return result;
    };
    return SendToQuadmindsDto;
}());
export { SendToQuadmindsDto };
var OrderStatusCountDto = /** @class */ (function () {
    function OrderStatusCountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderStatusCountDto.prototype.init = function (_data) {
        if (_data) {
            this.currentOverallStatus = _data["currentOverallStatus"];
            this.currentLogisticStatus = _data["currentLogisticStatus"];
            this.currentCommercialStatus = _data["currentCommercialStatus"];
            this.quantity = _data["quantity"];
        }
    };
    OrderStatusCountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderStatusCountDto();
        result.init(data);
        return result;
    };
    OrderStatusCountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["currentOverallStatus"] = this.currentOverallStatus;
        data["currentLogisticStatus"] = this.currentLogisticStatus;
        data["currentCommercialStatus"] = this.currentCommercialStatus;
        data["quantity"] = this.quantity;
        return data;
    };
    OrderStatusCountDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderStatusCountDto();
        result.init(json);
        return result;
    };
    return OrderStatusCountDto;
}());
export { OrderStatusCountDto };
var OrderUpdateReturnAssignedRequest = /** @class */ (function () {
    function OrderUpdateReturnAssignedRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }
    OrderUpdateReturnAssignedRequest.prototype.init = function (_data) {
        var e_478, _a;
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [];
                try {
                    for (var _b = __values(_data["orderIds"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderIds.push(item);
                    }
                }
                catch (e_478_1) { e_478 = { error: e_478_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_478) throw e_478.error; }
                }
            }
            this.reason = _data["reason"];
        }
    };
    OrderUpdateReturnAssignedRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderUpdateReturnAssignedRequest();
        result.init(data);
        return result;
    };
    OrderUpdateReturnAssignedRequest.prototype.toJSON = function (data) {
        var e_479, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            try {
                for (var _b = __values(this.orderIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderIds"].push(item);
                }
            }
            catch (e_479_1) { e_479 = { error: e_479_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_479) throw e_479.error; }
            }
        }
        data["reason"] = this.reason;
        return data;
    };
    OrderUpdateReturnAssignedRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderUpdateReturnAssignedRequest();
        result.init(json);
        return result;
    };
    return OrderUpdateReturnAssignedRequest;
}());
export { OrderUpdateReturnAssignedRequest };
var OrderUpdateAssignedStoreRequest = /** @class */ (function () {
    function OrderUpdateAssignedStoreRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }
    OrderUpdateAssignedStoreRequest.prototype.init = function (_data) {
        var e_480, _a;
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [];
                try {
                    for (var _b = __values(_data["orderIds"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderIds.push(item);
                    }
                }
                catch (e_480_1) { e_480 = { error: e_480_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_480) throw e_480.error; }
                }
            }
            this.storeCode = _data["storeCode"];
        }
    };
    OrderUpdateAssignedStoreRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderUpdateAssignedStoreRequest();
        result.init(data);
        return result;
    };
    OrderUpdateAssignedStoreRequest.prototype.toJSON = function (data) {
        var e_481, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            try {
                for (var _b = __values(this.orderIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderIds"].push(item);
                }
            }
            catch (e_481_1) { e_481 = { error: e_481_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_481) throw e_481.error; }
            }
        }
        data["storeCode"] = this.storeCode;
        return data;
    };
    OrderUpdateAssignedStoreRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderUpdateAssignedStoreRequest();
        result.init(json);
        return result;
    };
    return OrderUpdateAssignedStoreRequest;
}());
export { OrderUpdateAssignedStoreRequest };
var OrderUpdateCarrierRequest = /** @class */ (function () {
    function OrderUpdateCarrierRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }
    OrderUpdateCarrierRequest.prototype.init = function (_data) {
        var e_482, _a;
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [];
                try {
                    for (var _b = __values(_data["orderIds"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderIds.push(item);
                    }
                }
                catch (e_482_1) { e_482 = { error: e_482_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_482) throw e_482.error; }
                }
            }
            this.carrierId = _data["carrierId"];
            this.carrierDriverId = _data["carrierDriverId"];
        }
    };
    OrderUpdateCarrierRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderUpdateCarrierRequest();
        result.init(data);
        return result;
    };
    OrderUpdateCarrierRequest.prototype.toJSON = function (data) {
        var e_483, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            try {
                for (var _b = __values(this.orderIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderIds"].push(item);
                }
            }
            catch (e_483_1) { e_483 = { error: e_483_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_483) throw e_483.error; }
            }
        }
        data["carrierId"] = this.carrierId;
        data["carrierDriverId"] = this.carrierDriverId;
        return data;
    };
    OrderUpdateCarrierRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderUpdateCarrierRequest();
        result.init(json);
        return result;
    };
    return OrderUpdateCarrierRequest;
}());
export { OrderUpdateCarrierRequest };
var OrderUpdateStatusRequest = /** @class */ (function () {
    function OrderUpdateStatusRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.orderIds = [];
        }
    }
    OrderUpdateStatusRequest.prototype.init = function (_data) {
        var e_484, _a;
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [];
                try {
                    for (var _b = __values(_data["orderIds"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderIds.push(item);
                    }
                }
                catch (e_484_1) { e_484 = { error: e_484_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_484) throw e_484.error; }
                }
            }
            this.commercialStatusId = _data["commercialStatusId"];
            this.financialStatusId = _data["financialStatusId"];
            this.logisticStatusId = _data["logisticStatusId"];
            this.overallStatusId = _data["overallStatusId"];
            this.logisticAuditStatusId = _data["logisticAuditStatusId"];
        }
    };
    OrderUpdateStatusRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderUpdateStatusRequest();
        result.init(data);
        return result;
    };
    OrderUpdateStatusRequest.prototype.toJSON = function (data) {
        var e_485, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            try {
                for (var _b = __values(this.orderIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderIds"].push(item);
                }
            }
            catch (e_485_1) { e_485 = { error: e_485_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_485) throw e_485.error; }
            }
        }
        data["commercialStatusId"] = this.commercialStatusId;
        data["financialStatusId"] = this.financialStatusId;
        data["logisticStatusId"] = this.logisticStatusId;
        data["overallStatusId"] = this.overallStatusId;
        data["logisticAuditStatusId"] = this.logisticAuditStatusId;
        return data;
    };
    OrderUpdateStatusRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderUpdateStatusRequest();
        result.init(json);
        return result;
    };
    return OrderUpdateStatusRequest;
}());
export { OrderUpdateStatusRequest };
var OrderReturnedStatusRequest = /** @class */ (function () {
    function OrderReturnedStatusRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderReturnedStatusRequest.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.logisticStatus = _data["logisticStatus"];
            this.reason = _data["reason"];
            this.shipmentId = _data["shipmentId"];
            this.failedDelivery = _data["failedDelivery"] ? FailedDeliveryDto.fromJS(_data["failedDelivery"]) : undefined;
        }
    };
    OrderReturnedStatusRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderReturnedStatusRequest();
        result.init(data);
        return result;
    };
    OrderReturnedStatusRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["logisticStatus"] = this.logisticStatus;
        data["reason"] = this.reason;
        data["shipmentId"] = this.shipmentId;
        data["failedDelivery"] = this.failedDelivery ? this.failedDelivery.toJSON() : undefined;
        return data;
    };
    OrderReturnedStatusRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderReturnedStatusRequest();
        result.init(json);
        return result;
    };
    return OrderReturnedStatusRequest;
}());
export { OrderReturnedStatusRequest };
var OrderUpdateHeaderRequest = /** @class */ (function () {
    function OrderUpdateHeaderRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderUpdateHeaderRequest.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.phoneNumber = _data["phoneNumber"];
            this.documentNumber = _data["documentNumber"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.postalCode = _data["postalCode"];
            this.dispatchTag = _data["dispatchTag"];
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.shippingTypeId = _data["shippingTypeId"];
            this.receiverName = _data["receiverName"];
            this.pickupStoreCode = _data["pickupStoreCode"];
        }
    };
    OrderUpdateHeaderRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderUpdateHeaderRequest();
        result.init(data);
        return result;
    };
    OrderUpdateHeaderRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["phoneNumber"] = this.phoneNumber;
        data["documentNumber"] = this.documentNumber;
        data["street"] = this.street;
        data["number"] = this.number;
        data["city"] = this.city;
        data["state"] = this.state;
        data["postalCode"] = this.postalCode;
        data["dispatchTag"] = this.dispatchTag;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["shippingTypeId"] = this.shippingTypeId;
        data["receiverName"] = this.receiverName;
        data["pickupStoreCode"] = this.pickupStoreCode;
        return data;
    };
    OrderUpdateHeaderRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderUpdateHeaderRequest();
        result.init(json);
        return result;
    };
    return OrderUpdateHeaderRequest;
}());
export { OrderUpdateHeaderRequest };
var OrderItemUpdateDto = /** @class */ (function () {
    function OrderItemUpdateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderItemUpdateDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.price = _data["price"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    };
    OrderItemUpdateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderItemUpdateDto();
        result.init(data);
        return result;
    };
    OrderItemUpdateDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["price"] = this.price;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    };
    OrderItemUpdateDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderItemUpdateDto();
        result.init(json);
        return result;
    };
    return OrderItemUpdateDto;
}());
export { OrderItemUpdateDto };
var OrderUpdateItemsRequest = /** @class */ (function () {
    function OrderUpdateItemsRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderUpdateItemsRequest.prototype.init = function (_data) {
        var e_486, _a, e_487, _b, e_488, _c, e_489, _d;
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _e = __values(_data["orderItems"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.orderItems.push(OrderItemUpdateDto.fromJS(item));
                    }
                }
                catch (e_486_1) { e_486 = { error: e_486_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                    }
                    finally { if (e_486) throw e_486.error; }
                }
            }
            if (Array.isArray(_data["addedOrderItems"])) {
                this.addedOrderItems = [];
                try {
                    for (var _g = __values(_data["addedOrderItems"]), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var item = _h.value;
                        this.addedOrderItems.push(OrderItemUpdateDto.fromJS(item));
                    }
                }
                catch (e_487_1) { e_487 = { error: e_487_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                    }
                    finally { if (e_487) throw e_487.error; }
                }
            }
            if (Array.isArray(_data["removedOrderItems"])) {
                this.removedOrderItems = [];
                try {
                    for (var _j = __values(_data["removedOrderItems"]), _k = _j.next(); !_k.done; _k = _j.next()) {
                        var item = _k.value;
                        this.removedOrderItems.push(OrderItemUpdateDto.fromJS(item));
                    }
                }
                catch (e_488_1) { e_488 = { error: e_488_1 }; }
                finally {
                    try {
                        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                    }
                    finally { if (e_488) throw e_488.error; }
                }
            }
            if (Array.isArray(_data["updatedOrderItems"])) {
                this.updatedOrderItems = [];
                try {
                    for (var _l = __values(_data["updatedOrderItems"]), _m = _l.next(); !_m.done; _m = _l.next()) {
                        var item = _m.value;
                        this.updatedOrderItems.push(OrderItemUpdateDto.fromJS(item));
                    }
                }
                catch (e_489_1) { e_489 = { error: e_489_1 }; }
                finally {
                    try {
                        if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                    }
                    finally { if (e_489) throw e_489.error; }
                }
            }
            this.updatePromoItemsPrice = _data["updatePromoItemsPrice"];
        }
    };
    OrderUpdateItemsRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderUpdateItemsRequest();
        result.init(data);
        return result;
    };
    OrderUpdateItemsRequest.prototype.toJSON = function (data) {
        var e_490, _a, e_491, _b, e_492, _c, e_493, _d;
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _e = __values(this.orderItems), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_490_1) { e_490 = { error: e_490_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_490) throw e_490.error; }
            }
        }
        if (Array.isArray(this.addedOrderItems)) {
            data["addedOrderItems"] = [];
            try {
                for (var _g = __values(this.addedOrderItems), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var item = _h.value;
                    data["addedOrderItems"].push(item.toJSON());
                }
            }
            catch (e_491_1) { e_491 = { error: e_491_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                }
                finally { if (e_491) throw e_491.error; }
            }
        }
        if (Array.isArray(this.removedOrderItems)) {
            data["removedOrderItems"] = [];
            try {
                for (var _j = __values(this.removedOrderItems), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var item = _k.value;
                    data["removedOrderItems"].push(item.toJSON());
                }
            }
            catch (e_492_1) { e_492 = { error: e_492_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                }
                finally { if (e_492) throw e_492.error; }
            }
        }
        if (Array.isArray(this.updatedOrderItems)) {
            data["updatedOrderItems"] = [];
            try {
                for (var _l = __values(this.updatedOrderItems), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var item = _m.value;
                    data["updatedOrderItems"].push(item.toJSON());
                }
            }
            catch (e_493_1) { e_493 = { error: e_493_1 }; }
            finally {
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                }
                finally { if (e_493) throw e_493.error; }
            }
        }
        data["updatePromoItemsPrice"] = this.updatePromoItemsPrice;
        return data;
    };
    OrderUpdateItemsRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderUpdateItemsRequest();
        result.init(json);
        return result;
    };
    return OrderUpdateItemsRequest;
}());
export { OrderUpdateItemsRequest };
var GridConfigRequest = /** @class */ (function () {
    function GridConfigRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    GridConfigRequest.prototype.init = function (_data) {
        if (_data) {
            this.excludedColumns = _data["excludedColumns"];
        }
    };
    GridConfigRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new GridConfigRequest();
        result.init(data);
        return result;
    };
    GridConfigRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["excludedColumns"] = this.excludedColumns;
        return data;
    };
    GridConfigRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new GridConfigRequest();
        result.init(json);
        return result;
    };
    return GridConfigRequest;
}());
export { GridConfigRequest };
var OrderDetailDto = /** @class */ (function () {
    function OrderDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"];
            this.currentLogisticStatus = _data["currentLogisticStatus"];
            this.currentOverallStatus = _data["currentOverallStatus"];
            this.currentCommercialStatus = _data["currentCommercialStatus"];
            this.currentFinancialStatus = _data["currentFinancialStatus"];
            this.currentLogisticStatusId = _data["currentLogisticStatusId"];
            this.currentOverallStatusId = _data["currentOverallStatusId"];
            this.currentCommercialStatusId = _data["currentCommercialStatusId"];
            this.currentFinancialStatusId = _data["currentFinancialStatusId"];
            this.sourceCode = _data["sourceCode"];
            this.deliverySourceCode = _data["deliverySourceCode"];
            this.sourceName = _data["sourceName"];
            this.highlighted = _data["highlighted"];
            this.carrierId = _data["carrierId"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.replacementCriteria = _data["replacementCriteria"];
            this.id = _data["id"];
        }
    };
    OrderDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailDto();
        result.init(data);
        return result;
    };
    OrderDetailDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore;
        data["currentLogisticStatus"] = this.currentLogisticStatus;
        data["currentOverallStatus"] = this.currentOverallStatus;
        data["currentCommercialStatus"] = this.currentCommercialStatus;
        data["currentFinancialStatus"] = this.currentFinancialStatus;
        data["currentLogisticStatusId"] = this.currentLogisticStatusId;
        data["currentOverallStatusId"] = this.currentOverallStatusId;
        data["currentCommercialStatusId"] = this.currentCommercialStatusId;
        data["currentFinancialStatusId"] = this.currentFinancialStatusId;
        data["sourceCode"] = this.sourceCode;
        data["deliverySourceCode"] = this.deliverySourceCode;
        data["sourceName"] = this.sourceName;
        data["highlighted"] = this.highlighted;
        data["carrierId"] = this.carrierId;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["replacementCriteria"] = this.replacementCriteria;
        data["id"] = this.id;
        return data;
    };
    OrderDetailDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailDto();
        result.init(json);
        return result;
    };
    return OrderDetailDto;
}());
export { OrderDetailDto };
var OrderDetailClaimDto = /** @class */ (function () {
    function OrderDetailClaimDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailClaimDto.prototype.init = function (_data) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.description = _data["description"];
            this.type = _data["type"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.id = _data["id"];
        }
    };
    OrderDetailClaimDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailClaimDto();
        result.init(data);
        return result;
    };
    OrderDetailClaimDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["description"] = this.description;
        data["type"] = this.type;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    OrderDetailClaimDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailClaimDto();
        result.init(json);
        return result;
    };
    return OrderDetailClaimDto;
}());
export { OrderDetailClaimDto };
var OrderDetailEventLogDto = /** @class */ (function () {
    function OrderDetailEventLogDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailEventLogDto.prototype.init = function (_data) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.creatorName = _data["creatorName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.description = _data["description"];
            this.id = _data["id"];
        }
    };
    OrderDetailEventLogDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailEventLogDto();
        result.init(data);
        return result;
    };
    OrderDetailEventLogDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creatorName"] = this.creatorName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["description"] = this.description;
        data["id"] = this.id;
        return data;
    };
    OrderDetailEventLogDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailEventLogDto();
        result.init(json);
        return result;
    };
    return OrderDetailEventLogDto;
}());
export { OrderDetailEventLogDto };
var OrderHeaderCustomerDto = /** @class */ (function () {
    function OrderHeaderCustomerDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderHeaderCustomerDto.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.documentNumber = _data["documentNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
        }
    };
    OrderHeaderCustomerDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderHeaderCustomerDto();
        result.init(data);
        return result;
    };
    OrderHeaderCustomerDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["documentNumber"] = this.documentNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        return data;
    };
    OrderHeaderCustomerDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderHeaderCustomerDto();
        result.init(json);
        return result;
    };
    return OrderHeaderCustomerDto;
}());
export { OrderHeaderCustomerDto };
var OrderHeaderDeliveryDataDto = /** @class */ (function () {
    function OrderHeaderDeliveryDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderHeaderDeliveryDataDto.prototype.init = function (_data) {
        if (_data) {
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : undefined;
            this.estimatedDeliveryDateTo = _data["estimatedDeliveryDateTo"] ? moment(_data["estimatedDeliveryDateTo"].toString()) : undefined;
            this.deliveryType = _data["deliveryType"];
            this.shippingType = _data["shippingType"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.city = _data["city"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.trackingNumber = _data["trackingNumber"];
            this.completeAddress = _data["completeAddress"];
            this.receiverName = _data["receiverName"];
            this.complement = _data["complement"];
            this.neighborhood = _data["neighborhood"];
        }
    };
    OrderHeaderDeliveryDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderHeaderDeliveryDataDto();
        result.init(data);
        return result;
    };
    OrderHeaderDeliveryDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : undefined;
        data["estimatedDeliveryDateTo"] = this.estimatedDeliveryDateTo ? this.estimatedDeliveryDateTo.toISOString() : undefined;
        data["deliveryType"] = this.deliveryType;
        data["shippingType"] = this.shippingType;
        data["street"] = this.street;
        data["number"] = this.number;
        data["city"] = this.city;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["trackingNumber"] = this.trackingNumber;
        data["completeAddress"] = this.completeAddress;
        data["receiverName"] = this.receiverName;
        data["complement"] = this.complement;
        data["neighborhood"] = this.neighborhood;
        return data;
    };
    OrderHeaderDeliveryDataDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderHeaderDeliveryDataDto();
        result.init(json);
        return result;
    };
    return OrderHeaderDeliveryDataDto;
}());
export { OrderHeaderDeliveryDataDto };
var OrderDetailHeaderDto = /** @class */ (function () {
    function OrderDetailHeaderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailHeaderDto.prototype.init = function (_data) {
        if (_data) {
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.carrierName = _data["carrierName"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.customer = _data["customer"] ? OrderHeaderCustomerDto.fromJS(_data["customer"]) : undefined;
            this.deliveryData = _data["deliveryData"] ? OrderHeaderDeliveryDataDto.fromJS(_data["deliveryData"]) : undefined;
            this.stockStatus = _data["stockStatus"];
            this.currentFinancialStatus = _data["currentFinancialStatus"];
            this.currentFinancialStatusId = _data["currentFinancialStatusId"];
            this.id = _data["id"];
        }
    };
    OrderDetailHeaderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailHeaderDto();
        result.init(data);
        return result;
    };
    OrderDetailHeaderDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["carrierName"] = this.carrierName;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        data["stockStatus"] = this.stockStatus;
        data["currentFinancialStatus"] = this.currentFinancialStatus;
        data["currentFinancialStatusId"] = this.currentFinancialStatusId;
        data["id"] = this.id;
        return data;
    };
    OrderDetailHeaderDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailHeaderDto();
        result.init(json);
        return result;
    };
    return OrderDetailHeaderDto;
}());
export { OrderDetailHeaderDto };
var OrderDetailInvoiceDto = /** @class */ (function () {
    function OrderDetailInvoiceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailInvoiceDto.prototype.init = function (_data) {
        if (_data) {
            this.balance = _data["balance"];
            this.totalAmount = _data["totalAmount"];
            this.currentCommercialStatus = _data["currentCommercialStatus"];
            this.currentFinancialStatus = _data["currentFinancialStatus"];
            this.paymentSystemName = _data["paymentSystemName"];
            this.id = _data["id"];
        }
    };
    OrderDetailInvoiceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailInvoiceDto();
        result.init(data);
        return result;
    };
    OrderDetailInvoiceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["balance"] = this.balance;
        data["totalAmount"] = this.totalAmount;
        data["currentCommercialStatus"] = this.currentCommercialStatus;
        data["currentFinancialStatus"] = this.currentFinancialStatus;
        data["paymentSystemName"] = this.paymentSystemName;
        data["id"] = this.id;
        return data;
    };
    OrderDetailInvoiceDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailInvoiceDto();
        result.init(json);
        return result;
    };
    return OrderDetailInvoiceDto;
}());
export { OrderDetailInvoiceDto };
var OrderDetailOrderBalanceDto = /** @class */ (function () {
    function OrderDetailOrderBalanceDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailOrderBalanceDto.prototype.init = function (_data) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.amount = _data["amount"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.movementType = _data["movementType"];
        }
    };
    OrderDetailOrderBalanceDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailOrderBalanceDto();
        result.init(data);
        return result;
    };
    OrderDetailOrderBalanceDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["amount"] = this.amount;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType;
        return data;
    };
    OrderDetailOrderBalanceDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailOrderBalanceDto();
        result.init(json);
        return result;
    };
    return OrderDetailOrderBalanceDto;
}());
export { OrderDetailOrderBalanceDto };
var OrderDetailDocumentDto = /** @class */ (function () {
    function OrderDetailDocumentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailDocumentDto.prototype.init = function (_data) {
        if (_data) {
            this.draftNumber = _data["draftNumber"];
            this.number = _data["number"];
            this.amount = _data["amount"];
            this.type = _data["type"];
            this.additionalInfo = _data["additionalInfo"];
            this.documentUrl = _data["documentUrl"];
            this.status = _data["status"];
        }
    };
    OrderDetailDocumentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailDocumentDto();
        result.init(data);
        return result;
    };
    OrderDetailDocumentDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["draftNumber"] = this.draftNumber;
        data["number"] = this.number;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["additionalInfo"] = this.additionalInfo;
        data["documentUrl"] = this.documentUrl;
        data["status"] = this.status;
        return data;
    };
    OrderDetailDocumentDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailDocumentDto();
        result.init(json);
        return result;
    };
    return OrderDetailDocumentDto;
}());
export { OrderDetailDocumentDto };
var OrderDetailOrderItemDto = /** @class */ (function () {
    function OrderDetailOrderItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailOrderItemDto.prototype.init = function (_data) {
        var e_494, _a;
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.sourceOrderItemId = _data["sourceOrderItemId"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.quantityInConflict = _data["quantityInConflict"];
            this.barCode = _data["barCode"];
            if (Array.isArray(_data["promotedItems"])) {
                this.promotedItems = [];
                try {
                    for (var _b = __values(_data["promotedItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.promotedItems.push(OrderDetailOrderItemDto.fromJS(item));
                    }
                }
                catch (e_494_1) { e_494 = { error: e_494_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_494) throw e_494.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    OrderDetailOrderItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailOrderItemDto();
        result.init(data);
        return result;
    };
    OrderDetailOrderItemDto.prototype.toJSON = function (data) {
        var e_495, _a;
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["sourceOrderItemId"] = this.sourceOrderItemId;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["quantityInConflict"] = this.quantityInConflict;
        data["barCode"] = this.barCode;
        if (Array.isArray(this.promotedItems)) {
            data["promotedItems"] = [];
            try {
                for (var _b = __values(this.promotedItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["promotedItems"].push(item.toJSON());
                }
            }
            catch (e_495_1) { e_495 = { error: e_495_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_495) throw e_495.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    OrderDetailOrderItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailOrderItemDto();
        result.init(json);
        return result;
    };
    return OrderDetailOrderItemDto;
}());
export { OrderDetailOrderItemDto };
var OrderDetailItemDetailDto = /** @class */ (function () {
    function OrderDetailItemDetailDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailItemDetailDto.prototype.init = function (_data) {
        var e_496, _a, e_497, _b;
        if (_data) {
            this.totalAmount = _data["totalAmount"];
            this.sourceTotalAmount = _data["sourceTotalAmount"];
            this.sourceGrossAmount = _data["sourceGrossAmount"];
            this.sourceNetAmount = _data["sourceNetAmount"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.shippingCost = _data["shippingCost"];
            this.interest = _data["interest"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _c = __values(_data["orderItems"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.orderItems.push(OrderDetailOrderItemDto.fromJS(item));
                    }
                }
                catch (e_496_1) { e_496 = { error: e_496_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_496) throw e_496.error; }
                }
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [];
                try {
                    for (var _e = __values(_data["sourceOrderItems"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.sourceOrderItems.push(OrderDetailOrderItemDto.fromJS(item));
                    }
                }
                catch (e_497_1) { e_497 = { error: e_497_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_497) throw e_497.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    OrderDetailItemDetailDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailItemDetailDto();
        result.init(data);
        return result;
    };
    OrderDetailItemDetailDto.prototype.toJSON = function (data) {
        var e_498, _a, e_499, _b;
        data = typeof data === 'object' ? data : {};
        data["totalAmount"] = this.totalAmount;
        data["sourceTotalAmount"] = this.sourceTotalAmount;
        data["sourceGrossAmount"] = this.sourceGrossAmount;
        data["sourceNetAmount"] = this.sourceNetAmount;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["shippingCost"] = this.shippingCost;
        data["interest"] = this.interest;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _c = __values(this.orderItems), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_498_1) { e_498 = { error: e_498_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_498) throw e_498.error; }
            }
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            try {
                for (var _e = __values(this.sourceOrderItems), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["sourceOrderItems"].push(item.toJSON());
                }
            }
            catch (e_499_1) { e_499 = { error: e_499_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_499) throw e_499.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    OrderDetailItemDetailDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailItemDetailDto();
        result.init(json);
        return result;
    };
    return OrderDetailItemDetailDto;
}());
export { OrderDetailItemDetailDto };
var OrderDetailPickingGroupDto = /** @class */ (function () {
    function OrderDetailPickingGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailPickingGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.alias = _data["alias"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.responsible = _data["responsible"];
            this.status = _data["status"];
            this.id = _data["id"];
        }
    };
    OrderDetailPickingGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailPickingGroupDto();
        result.init(data);
        return result;
    };
    OrderDetailPickingGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["responsible"] = this.responsible;
        data["status"] = this.status;
        data["id"] = this.id;
        return data;
    };
    OrderDetailPickingGroupDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailPickingGroupDto();
        result.init(json);
        return result;
    };
    return OrderDetailPickingGroupDto;
}());
export { OrderDetailPickingGroupDto };
var OrderDetailPreparationDto = /** @class */ (function () {
    function OrderDetailPreparationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailPreparationDto.prototype.init = function (_data) {
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.status = _data["status"];
            this.storeCode = _data["storeCode"];
            this.id = _data["id"];
        }
    };
    OrderDetailPreparationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailPreparationDto();
        result.init(data);
        return result;
    };
    OrderDetailPreparationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["status"] = this.status;
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        return data;
    };
    OrderDetailPreparationDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailPreparationDto();
        result.init(json);
        return result;
    };
    return OrderDetailPreparationDto;
}());
export { OrderDetailPreparationDto };
var OrderDetailReturnDto = /** @class */ (function () {
    function OrderDetailReturnDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailReturnDto.prototype.init = function (_data) {
        if (_data) {
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.status = _data["status"];
            this.returnedItemsQuantity = _data["returnedItemsQuantity"];
            this.completeAddress = _data["completeAddress"];
            this.id = _data["id"];
        }
    };
    OrderDetailReturnDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailReturnDto();
        result.init(data);
        return result;
    };
    OrderDetailReturnDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["status"] = this.status;
        data["returnedItemsQuantity"] = this.returnedItemsQuantity;
        data["completeAddress"] = this.completeAddress;
        data["id"] = this.id;
        return data;
    };
    OrderDetailReturnDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailReturnDto();
        result.init(json);
        return result;
    };
    return OrderDetailReturnDto;
}());
export { OrderDetailReturnDto };
var OrderDetailShipmentDto = /** @class */ (function () {
    function OrderDetailShipmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailShipmentDto.prototype.init = function (_data) {
        var e_500, _a;
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.carrierDriver = _data["carrierDriver"];
            this.carrier = _data["carrier"];
            this.shippingTypeGroup = _data["shippingTypeGroup"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : undefined;
            this.shipmentStatus = _data["shipmentStatus"];
            this.shipmentOrderStatus = _data["shipmentOrderStatus"];
            this.proofNote = _data["proofNote"];
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [];
                try {
                    for (var _b = __values(_data["proofFiles"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.proofFiles.push(item);
                    }
                }
                catch (e_500_1) { e_500 = { error: e_500_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_500) throw e_500.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    OrderDetailShipmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailShipmentDto();
        result.init(data);
        return result;
    };
    OrderDetailShipmentDto.prototype.toJSON = function (data) {
        var e_501, _a;
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["carrierDriver"] = this.carrierDriver;
        data["carrier"] = this.carrier;
        data["shippingTypeGroup"] = this.shippingTypeGroup;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        data["shipmentStatus"] = this.shipmentStatus;
        data["shipmentOrderStatus"] = this.shipmentOrderStatus;
        data["proofNote"] = this.proofNote;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            try {
                for (var _b = __values(this.proofFiles), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["proofFiles"].push(item);
                }
            }
            catch (e_501_1) { e_501 = { error: e_501_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_501) throw e_501.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    OrderDetailShipmentDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailShipmentDto();
        result.init(json);
        return result;
    };
    return OrderDetailShipmentDto;
}());
export { OrderDetailShipmentDto };
var OrderDetailQuadmindsDto = /** @class */ (function () {
    function OrderDetailQuadmindsDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailQuadmindsDto.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.sourceId = _data["sourceId"];
            this.status = _data["status"];
            this.statusRoute = _data["statusRoute"];
            this.visitedStart = _data["visitedStart"] ? moment(_data["visitedStart"].toString()) : undefined;
            this.visitedEnd = _data["visitedEnd"] ? moment(_data["visitedEnd"].toString()) : undefined;
            this.visitedDuration = _data["visitedDuration"];
            this.warehouseDepartureDate = _data["warehouseDepartureDate"] ? moment(_data["warehouseDepartureDate"].toString()) : undefined;
            this.id = _data["id"];
        }
    };
    OrderDetailQuadmindsDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailQuadmindsDto();
        result.init(data);
        return result;
    };
    OrderDetailQuadmindsDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["sourceId"] = this.sourceId;
        data["status"] = this.status;
        data["statusRoute"] = this.statusRoute;
        data["visitedStart"] = this.visitedStart ? this.visitedStart.toISOString() : undefined;
        data["visitedEnd"] = this.visitedEnd ? this.visitedEnd.toISOString() : undefined;
        data["visitedDuration"] = this.visitedDuration;
        data["warehouseDepartureDate"] = this.warehouseDepartureDate ? this.warehouseDepartureDate.toISOString() : undefined;
        data["id"] = this.id;
        return data;
    };
    OrderDetailQuadmindsDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailQuadmindsDto();
        result.init(json);
        return result;
    };
    return OrderDetailQuadmindsDto;
}());
export { OrderDetailQuadmindsDto };
var OrderDetailTransferItemDto = /** @class */ (function () {
    function OrderDetailTransferItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailTransferItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    };
    OrderDetailTransferItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailTransferItemDto();
        result.init(data);
        return result;
    };
    OrderDetailTransferItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    };
    OrderDetailTransferItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailTransferItemDto();
        result.init(json);
        return result;
    };
    return OrderDetailTransferItemDto;
}());
export { OrderDetailTransferItemDto };
var OrderDetailTransferDto = /** @class */ (function () {
    function OrderDetailTransferDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDetailTransferDto.prototype.init = function (_data) {
        var e_502, _a;
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.trxSrcCode = _data["trxSrcCode"];
            this.sourceStoreCode = _data["sourceStoreCode"];
            this.destinationStoreCode = _data["destinationStoreCode"];
            this.status = _data["status"];
            this.type = _data["type"];
            this.shipmentId = _data["shipmentId"];
            this.transferId = _data["transferId"];
            this.sapCode = _data["sapCode"];
            if (Array.isArray(_data["transferItems"])) {
                this.transferItems = [];
                try {
                    for (var _b = __values(_data["transferItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.transferItems.push(OrderDetailTransferItemDto.fromJS(item));
                    }
                }
                catch (e_502_1) { e_502 = { error: e_502_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_502) throw e_502.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    OrderDetailTransferDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDetailTransferDto();
        result.init(data);
        return result;
    };
    OrderDetailTransferDto.prototype.toJSON = function (data) {
        var e_503, _a;
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["trxSrcCode"] = this.trxSrcCode;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["destinationStoreCode"] = this.destinationStoreCode;
        data["status"] = this.status;
        data["type"] = this.type;
        data["shipmentId"] = this.shipmentId;
        data["transferId"] = this.transferId;
        data["sapCode"] = this.sapCode;
        if (Array.isArray(this.transferItems)) {
            data["transferItems"] = [];
            try {
                for (var _b = __values(this.transferItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["transferItems"].push(item.toJSON());
                }
            }
            catch (e_503_1) { e_503 = { error: e_503_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_503) throw e_503.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    OrderDetailTransferDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDetailTransferDto();
        result.init(json);
        return result;
    };
    return OrderDetailTransferDto;
}());
export { OrderDetailTransferDto };
var UpdatePickupStoreRequest = /** @class */ (function () {
    function UpdatePickupStoreRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdatePickupStoreRequest.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.pickupStoreCode = _data["pickupStoreCode"];
        }
    };
    UpdatePickupStoreRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdatePickupStoreRequest();
        result.init(data);
        return result;
    };
    UpdatePickupStoreRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["pickupStoreCode"] = this.pickupStoreCode;
        return data;
    };
    UpdatePickupStoreRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UpdatePickupStoreRequest();
        result.init(json);
        return result;
    };
    return UpdatePickupStoreRequest;
}());
export { UpdatePickupStoreRequest };
var LogisticAuditStatusValueDto = /** @class */ (function () {
    function LogisticAuditStatusValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogisticAuditStatusValueDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    LogisticAuditStatusValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogisticAuditStatusValueDto();
        result.init(data);
        return result;
    };
    LogisticAuditStatusValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    LogisticAuditStatusValueDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LogisticAuditStatusValueDto();
        result.init(json);
        return result;
    };
    return LogisticAuditStatusValueDto;
}());
export { LogisticAuditStatusValueDto };
var LogisticAuditStatusDto = /** @class */ (function () {
    function LogisticAuditStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogisticAuditStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"] ? LogisticAuditStatusValueDto.fromJS(_data["value"]) : undefined;
        }
    };
    LogisticAuditStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogisticAuditStatusDto();
        result.init(data);
        return result;
    };
    LogisticAuditStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value ? this.value.toJSON() : undefined;
        return data;
    };
    LogisticAuditStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LogisticAuditStatusDto();
        result.init(json);
        return result;
    };
    return LogisticAuditStatusDto;
}());
export { LogisticAuditStatusDto };
var OrderLogisticAuditDto = /** @class */ (function () {
    function OrderLogisticAuditDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderLogisticAuditDto.prototype.init = function (_data) {
        var e_504, _a, e_505, _b, e_506, _c, e_507, _d, e_508, _e, e_509, _f, e_510, _g, e_511, _h, e_512, _j;
        if (_data) {
            this.currentLogisticAuditStatus = _data["currentLogisticAuditStatus"] ? LogisticAuditStatusDto.fromJS(_data["currentLogisticAuditStatus"]) : undefined;
            this.itemsInConflict = _data["itemsInConflict"];
            this.lastNote = _data["lastNote"];
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : undefined;
            this.sourceCode = _data["sourceCode"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.routeOrder = _data["routeOrder"];
            this.invoiceCreationTime = _data["invoiceCreationTime"] ? moment(_data["invoiceCreationTime"].toString()) : undefined;
            this.invoiceType = _data["invoiceType"];
            this.highlighted = _data["highlighted"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrderId = _data["packOrderId"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [];
                try {
                    for (var _k = __values(_data["orderBalances"]), _l = _k.next(); !_l.done; _l = _k.next()) {
                        var item = _l.value;
                        this.orderBalances.push(OrderBalanceDto.fromJS(item));
                    }
                }
                catch (e_504_1) { e_504 = { error: e_504_1 }; }
                finally {
                    try {
                        if (_l && !_l.done && (_a = _k.return)) _a.call(_k);
                    }
                    finally { if (e_504) throw e_504.error; }
                }
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [];
                try {
                    for (var _m = __values(_data["notes"]), _o = _m.next(); !_o.done; _o = _m.next()) {
                        var item = _o.value;
                        this.notes.push(OrderNoteDto.fromJS(item));
                    }
                }
                catch (e_505_1) { e_505 = { error: e_505_1 }; }
                finally {
                    try {
                        if (_o && !_o.done && (_b = _m.return)) _b.call(_m);
                    }
                    finally { if (e_505) throw e_505.error; }
                }
            }
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [];
                try {
                    for (var _p = __values(_data["eventLogs"]), _q = _p.next(); !_q.done; _q = _p.next()) {
                        var item = _q.value;
                        this.eventLogs.push(EventLogDto.fromJS(item));
                    }
                }
                catch (e_506_1) { e_506 = { error: e_506_1 }; }
                finally {
                    try {
                        if (_q && !_q.done && (_c = _p.return)) _c.call(_p);
                    }
                    finally { if (e_506) throw e_506.error; }
                }
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [];
                try {
                    for (var _r = __values(_data["sourceOrderItems"]), _s = _r.next(); !_s.done; _s = _r.next()) {
                        var item = _s.value;
                        this.sourceOrderItems.push(SourceOrderItemDto.fromJS(item));
                    }
                }
                catch (e_507_1) { e_507 = { error: e_507_1 }; }
                finally {
                    try {
                        if (_s && !_s.done && (_d = _r.return)) _d.call(_r);
                    }
                    finally { if (e_507) throw e_507.error; }
                }
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _t = __values(_data["orderItems"]), _u = _t.next(); !_u.done; _u = _t.next()) {
                        var item = _u.value;
                        this.orderItems.push(OrderItemDto.fromJS(item));
                    }
                }
                catch (e_508_1) { e_508 = { error: e_508_1 }; }
                finally {
                    try {
                        if (_u && !_u.done && (_e = _t.return)) _e.call(_t);
                    }
                    finally { if (e_508) throw e_508.error; }
                }
            }
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [];
                try {
                    for (var _v = __values(_data["relatedDocuments"]), _w = _v.next(); !_w.done; _w = _v.next()) {
                        var item = _w.value;
                        this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
                    }
                }
                catch (e_509_1) { e_509 = { error: e_509_1 }; }
                finally {
                    try {
                        if (_w && !_w.done && (_f = _v.return)) _f.call(_v);
                    }
                    finally { if (e_509) throw e_509.error; }
                }
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [];
                try {
                    for (var _x = __values(_data["documents"]), _y = _x.next(); !_y.done; _y = _x.next()) {
                        var item = _y.value;
                        this.documents.push(DocumentDto.fromJS(item));
                    }
                }
                catch (e_510_1) { e_510 = { error: e_510_1 }; }
                finally {
                    try {
                        if (_y && !_y.done && (_g = _x.return)) _g.call(_x);
                    }
                    finally { if (e_510) throw e_510.error; }
                }
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [];
                try {
                    for (var _z = __values(_data["payments"]), _19 = _z.next(); !_19.done; _19 = _z.next()) {
                        var item = _19.value;
                        this.payments.push(PaymentDto.fromJS(item));
                    }
                }
                catch (e_511_1) { e_511 = { error: e_511_1 }; }
                finally {
                    try {
                        if (_19 && !_19.done && (_h = _z.return)) _h.call(_z);
                    }
                    finally { if (e_511) throw e_511.error; }
                }
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : undefined;
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatusDto.fromJS(_data["currentCommercialStatus"]) : undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : undefined;
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [];
                try {
                    for (var _20 = __values(_data["preparations"]), _21 = _20.next(); !_21.done; _21 = _20.next()) {
                        var item = _21.value;
                        this.preparations.push(PreparationDto.fromJS(item));
                    }
                }
                catch (e_512_1) { e_512 = { error: e_512_1 }; }
                finally {
                    try {
                        if (_21 && !_21.done && (_j = _20.return)) _j.call(_20);
                    }
                    finally { if (e_512) throw e_512.error; }
                }
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrderDto.fromJS(_data["shipmentOrder"]) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.stockStatus = _data["stockStatus"] ? StockStatusDto.fromJS(_data["stockStatus"]) : undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriverDto.fromJS(_data["carrierDriver"]) : undefined;
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"] ? ReplacementCriteriaDto.fromJS(_data["replacementCriteria"]) : undefined;
            this.carrierInfo = _data["carrierInfo"];
            this.giftCard = _data["giftCard"];
            this.includedGiftCard = _data["includedGiftCard"] ? IncludedGiftCardDto.fromJS(_data["includedGiftCard"]) : undefined;
            this.createFromOrderStorePickup = _data["createFromOrderStorePickup"];
            this.invoiceStoreCode = _data["invoiceStoreCode"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.interest = _data["interest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderLogisticAuditDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderLogisticAuditDto();
        result.init(data);
        return result;
    };
    OrderLogisticAuditDto.prototype.toJSON = function (data) {
        var e_513, _a, e_514, _b, e_515, _c, e_516, _d, e_517, _e, e_518, _f, e_519, _g, e_520, _h, e_521, _j;
        data = typeof data === 'object' ? data : {};
        data["currentLogisticAuditStatus"] = this.currentLogisticAuditStatus ? this.currentLogisticAuditStatus.toJSON() : undefined;
        data["itemsInConflict"] = this.itemsInConflict;
        data["lastNote"] = this.lastNote;
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : undefined;
        data["sourceCode"] = this.sourceCode;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["invoiceNumber"] = this.invoiceNumber;
        data["routeOrder"] = this.routeOrder;
        data["invoiceCreationTime"] = this.invoiceCreationTime ? this.invoiceCreationTime.toISOString() : undefined;
        data["invoiceType"] = this.invoiceType;
        data["highlighted"] = this.highlighted;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrderId"] = this.packOrderId;
        data["balance"] = this.balance;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            try {
                for (var _k = __values(this.orderBalances), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var item = _l.value;
                    data["orderBalances"].push(item.toJSON());
                }
            }
            catch (e_513_1) { e_513 = { error: e_513_1 }; }
            finally {
                try {
                    if (_l && !_l.done && (_a = _k.return)) _a.call(_k);
                }
                finally { if (e_513) throw e_513.error; }
            }
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            try {
                for (var _m = __values(this.notes), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var item = _o.value;
                    data["notes"].push(item.toJSON());
                }
            }
            catch (e_514_1) { e_514 = { error: e_514_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_b = _m.return)) _b.call(_m);
                }
                finally { if (e_514) throw e_514.error; }
            }
        }
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            try {
                for (var _p = __values(this.eventLogs), _q = _p.next(); !_q.done; _q = _p.next()) {
                    var item = _q.value;
                    data["eventLogs"].push(item.toJSON());
                }
            }
            catch (e_515_1) { e_515 = { error: e_515_1 }; }
            finally {
                try {
                    if (_q && !_q.done && (_c = _p.return)) _c.call(_p);
                }
                finally { if (e_515) throw e_515.error; }
            }
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            try {
                for (var _r = __values(this.sourceOrderItems), _s = _r.next(); !_s.done; _s = _r.next()) {
                    var item = _s.value;
                    data["sourceOrderItems"].push(item.toJSON());
                }
            }
            catch (e_516_1) { e_516 = { error: e_516_1 }; }
            finally {
                try {
                    if (_s && !_s.done && (_d = _r.return)) _d.call(_r);
                }
                finally { if (e_516) throw e_516.error; }
            }
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _t = __values(this.orderItems), _u = _t.next(); !_u.done; _u = _t.next()) {
                    var item = _u.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_517_1) { e_517 = { error: e_517_1 }; }
            finally {
                try {
                    if (_u && !_u.done && (_e = _t.return)) _e.call(_t);
                }
                finally { if (e_517) throw e_517.error; }
            }
        }
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            try {
                for (var _v = __values(this.relatedDocuments), _w = _v.next(); !_w.done; _w = _v.next()) {
                    var item = _w.value;
                    data["relatedDocuments"].push(item.toJSON());
                }
            }
            catch (e_518_1) { e_518 = { error: e_518_1 }; }
            finally {
                try {
                    if (_w && !_w.done && (_f = _v.return)) _f.call(_v);
                }
                finally { if (e_518) throw e_518.error; }
            }
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            try {
                for (var _x = __values(this.documents), _y = _x.next(); !_y.done; _y = _x.next()) {
                    var item = _y.value;
                    data["documents"].push(item.toJSON());
                }
            }
            catch (e_519_1) { e_519 = { error: e_519_1 }; }
            finally {
                try {
                    if (_y && !_y.done && (_g = _x.return)) _g.call(_x);
                }
                finally { if (e_519) throw e_519.error; }
            }
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            try {
                for (var _z = __values(this.payments), _19 = _z.next(); !_19.done; _19 = _z.next()) {
                    var item = _19.value;
                    data["payments"].push(item.toJSON());
                }
            }
            catch (e_520_1) { e_520 = { error: e_520_1 }; }
            finally {
                try {
                    if (_19 && !_19.done && (_h = _z.return)) _h.call(_z);
                }
                finally { if (e_520) throw e_520.error; }
            }
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : undefined;
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : undefined;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            try {
                for (var _20 = __values(this.preparations), _21 = _20.next(); !_21.done; _21 = _20.next()) {
                    var item = _21.value;
                    data["preparations"].push(item.toJSON());
                }
            }
            catch (e_521_1) { e_521 = { error: e_521_1 }; }
            finally {
                try {
                    if (_21 && !_21.done && (_j = _20.return)) _j.call(_20);
                }
                finally { if (e_521) throw e_521.error; }
            }
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["stockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : undefined;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria ? this.replacementCriteria.toJSON() : undefined;
        data["carrierInfo"] = this.carrierInfo;
        data["giftCard"] = this.giftCard;
        data["includedGiftCard"] = this.includedGiftCard ? this.includedGiftCard.toJSON() : undefined;
        data["createFromOrderStorePickup"] = this.createFromOrderStorePickup;
        data["invoiceStoreCode"] = this.invoiceStoreCode;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["interest"] = this.interest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderLogisticAuditDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderLogisticAuditDto();
        result.init(json);
        return result;
    };
    return OrderLogisticAuditDto;
}());
export { OrderLogisticAuditDto };
var OrderLogisticAuditDtoPagedResultDto = /** @class */ (function () {
    function OrderLogisticAuditDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderLogisticAuditDtoPagedResultDto.prototype.init = function (_data) {
        var e_522, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrderLogisticAuditDto.fromJS(item));
                    }
                }
                catch (e_522_1) { e_522 = { error: e_522_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_522) throw e_522.error; }
                }
            }
        }
    };
    OrderLogisticAuditDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderLogisticAuditDtoPagedResultDto();
        result.init(data);
        return result;
    };
    OrderLogisticAuditDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_523, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_523_1) { e_523 = { error: e_523_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_523) throw e_523.error; }
            }
        }
        return data;
    };
    OrderLogisticAuditDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderLogisticAuditDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return OrderLogisticAuditDtoPagedResultDto;
}());
export { OrderLogisticAuditDtoPagedResultDto };
var OrderNoteDtoPagedResultDto = /** @class */ (function () {
    function OrderNoteDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderNoteDtoPagedResultDto.prototype.init = function (_data) {
        var e_524, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrderNoteDto.fromJS(item));
                    }
                }
                catch (e_524_1) { e_524 = { error: e_524_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_524) throw e_524.error; }
                }
            }
        }
    };
    OrderNoteDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderNoteDtoPagedResultDto();
        result.init(data);
        return result;
    };
    OrderNoteDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_525, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_525_1) { e_525 = { error: e_525_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_525) throw e_525.error; }
            }
        }
        return data;
    };
    OrderNoteDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderNoteDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return OrderNoteDtoPagedResultDto;
}());
export { OrderNoteDtoPagedResultDto };
var OrderReadyToHandleDto = /** @class */ (function () {
    function OrderReadyToHandleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderReadyToHandleDto.prototype.init = function (_data) {
        var e_526, _a, e_527, _b, e_528, _c, e_529, _d, e_530, _e, e_531, _f, e_532, _g, e_533, _h, e_534, _j, e_535, _k;
        if (_data) {
            this.currentPreparationId = _data["currentPreparationId"];
            this.currentPickingGroupId = _data["currentPickingGroupId"];
            this.currentPickingGroupActive = _data["currentPickingGroupActive"];
            this.currentPreparationActive = _data["currentPreparationActive"];
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            if (Array.isArray(_data["flyers"])) {
                this.flyers = [];
                try {
                    for (var _l = __values(_data["flyers"]), _m = _l.next(); !_m.done; _m = _l.next()) {
                        var item = _m.value;
                        this.flyers.push(FlyerDistributionDto.fromJS(item));
                    }
                }
                catch (e_526_1) { e_526 = { error: e_526_1 }; }
                finally {
                    try {
                        if (_m && !_m.done && (_a = _l.return)) _a.call(_l);
                    }
                    finally { if (e_526) throw e_526.error; }
                }
            }
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : undefined;
            this.sourceCode = _data["sourceCode"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.routeOrder = _data["routeOrder"];
            this.invoiceCreationTime = _data["invoiceCreationTime"] ? moment(_data["invoiceCreationTime"].toString()) : undefined;
            this.invoiceType = _data["invoiceType"];
            this.highlighted = _data["highlighted"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrderId = _data["packOrderId"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [];
                try {
                    for (var _o = __values(_data["orderBalances"]), _p = _o.next(); !_p.done; _p = _o.next()) {
                        var item = _p.value;
                        this.orderBalances.push(OrderBalanceDto.fromJS(item));
                    }
                }
                catch (e_527_1) { e_527 = { error: e_527_1 }; }
                finally {
                    try {
                        if (_p && !_p.done && (_b = _o.return)) _b.call(_o);
                    }
                    finally { if (e_527) throw e_527.error; }
                }
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [];
                try {
                    for (var _q = __values(_data["notes"]), _r = _q.next(); !_r.done; _r = _q.next()) {
                        var item = _r.value;
                        this.notes.push(OrderNoteDto.fromJS(item));
                    }
                }
                catch (e_528_1) { e_528 = { error: e_528_1 }; }
                finally {
                    try {
                        if (_r && !_r.done && (_c = _q.return)) _c.call(_q);
                    }
                    finally { if (e_528) throw e_528.error; }
                }
            }
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [];
                try {
                    for (var _s = __values(_data["eventLogs"]), _t = _s.next(); !_t.done; _t = _s.next()) {
                        var item = _t.value;
                        this.eventLogs.push(EventLogDto.fromJS(item));
                    }
                }
                catch (e_529_1) { e_529 = { error: e_529_1 }; }
                finally {
                    try {
                        if (_t && !_t.done && (_d = _s.return)) _d.call(_s);
                    }
                    finally { if (e_529) throw e_529.error; }
                }
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [];
                try {
                    for (var _u = __values(_data["sourceOrderItems"]), _v = _u.next(); !_v.done; _v = _u.next()) {
                        var item = _v.value;
                        this.sourceOrderItems.push(SourceOrderItemDto.fromJS(item));
                    }
                }
                catch (e_530_1) { e_530 = { error: e_530_1 }; }
                finally {
                    try {
                        if (_v && !_v.done && (_e = _u.return)) _e.call(_u);
                    }
                    finally { if (e_530) throw e_530.error; }
                }
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _w = __values(_data["orderItems"]), _x = _w.next(); !_x.done; _x = _w.next()) {
                        var item = _x.value;
                        this.orderItems.push(OrderItemDto.fromJS(item));
                    }
                }
                catch (e_531_1) { e_531 = { error: e_531_1 }; }
                finally {
                    try {
                        if (_x && !_x.done && (_f = _w.return)) _f.call(_w);
                    }
                    finally { if (e_531) throw e_531.error; }
                }
            }
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [];
                try {
                    for (var _y = __values(_data["relatedDocuments"]), _z = _y.next(); !_z.done; _z = _y.next()) {
                        var item = _z.value;
                        this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
                    }
                }
                catch (e_532_1) { e_532 = { error: e_532_1 }; }
                finally {
                    try {
                        if (_z && !_z.done && (_g = _y.return)) _g.call(_y);
                    }
                    finally { if (e_532) throw e_532.error; }
                }
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [];
                try {
                    for (var _19 = __values(_data["documents"]), _20 = _19.next(); !_20.done; _20 = _19.next()) {
                        var item = _20.value;
                        this.documents.push(DocumentDto.fromJS(item));
                    }
                }
                catch (e_533_1) { e_533 = { error: e_533_1 }; }
                finally {
                    try {
                        if (_20 && !_20.done && (_h = _19.return)) _h.call(_19);
                    }
                    finally { if (e_533) throw e_533.error; }
                }
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [];
                try {
                    for (var _21 = __values(_data["payments"]), _22 = _21.next(); !_22.done; _22 = _21.next()) {
                        var item = _22.value;
                        this.payments.push(PaymentDto.fromJS(item));
                    }
                }
                catch (e_534_1) { e_534 = { error: e_534_1 }; }
                finally {
                    try {
                        if (_22 && !_22.done && (_j = _21.return)) _j.call(_21);
                    }
                    finally { if (e_534) throw e_534.error; }
                }
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : undefined;
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatusDto.fromJS(_data["currentCommercialStatus"]) : undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : undefined;
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [];
                try {
                    for (var _23 = __values(_data["preparations"]), _24 = _23.next(); !_24.done; _24 = _23.next()) {
                        var item = _24.value;
                        this.preparations.push(PreparationDto.fromJS(item));
                    }
                }
                catch (e_535_1) { e_535 = { error: e_535_1 }; }
                finally {
                    try {
                        if (_24 && !_24.done && (_k = _23.return)) _k.call(_23);
                    }
                    finally { if (e_535) throw e_535.error; }
                }
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrderDto.fromJS(_data["shipmentOrder"]) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.stockStatus = _data["stockStatus"] ? StockStatusDto.fromJS(_data["stockStatus"]) : undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriverDto.fromJS(_data["carrierDriver"]) : undefined;
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"] ? ReplacementCriteriaDto.fromJS(_data["replacementCriteria"]) : undefined;
            this.carrierInfo = _data["carrierInfo"];
            this.giftCard = _data["giftCard"];
            this.includedGiftCard = _data["includedGiftCard"] ? IncludedGiftCardDto.fromJS(_data["includedGiftCard"]) : undefined;
            this.createFromOrderStorePickup = _data["createFromOrderStorePickup"];
            this.invoiceStoreCode = _data["invoiceStoreCode"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.interest = _data["interest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderReadyToHandleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderReadyToHandleDto();
        result.init(data);
        return result;
    };
    OrderReadyToHandleDto.prototype.toJSON = function (data) {
        var e_536, _a, e_537, _b, e_538, _c, e_539, _d, e_540, _e, e_541, _f, e_542, _g, e_543, _h, e_544, _j, e_545, _k;
        data = typeof data === 'object' ? data : {};
        data["currentPreparationId"] = this.currentPreparationId;
        data["currentPickingGroupId"] = this.currentPickingGroupId;
        data["currentPickingGroupActive"] = this.currentPickingGroupActive;
        data["currentPreparationActive"] = this.currentPreparationActive;
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        if (Array.isArray(this.flyers)) {
            data["flyers"] = [];
            try {
                for (var _l = __values(this.flyers), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var item = _m.value;
                    data["flyers"].push(item.toJSON());
                }
            }
            catch (e_536_1) { e_536 = { error: e_536_1 }; }
            finally {
                try {
                    if (_m && !_m.done && (_a = _l.return)) _a.call(_l);
                }
                finally { if (e_536) throw e_536.error; }
            }
        }
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : undefined;
        data["sourceCode"] = this.sourceCode;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["invoiceNumber"] = this.invoiceNumber;
        data["routeOrder"] = this.routeOrder;
        data["invoiceCreationTime"] = this.invoiceCreationTime ? this.invoiceCreationTime.toISOString() : undefined;
        data["invoiceType"] = this.invoiceType;
        data["highlighted"] = this.highlighted;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrderId"] = this.packOrderId;
        data["balance"] = this.balance;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            try {
                for (var _o = __values(this.orderBalances), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var item = _p.value;
                    data["orderBalances"].push(item.toJSON());
                }
            }
            catch (e_537_1) { e_537 = { error: e_537_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_b = _o.return)) _b.call(_o);
                }
                finally { if (e_537) throw e_537.error; }
            }
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            try {
                for (var _q = __values(this.notes), _r = _q.next(); !_r.done; _r = _q.next()) {
                    var item = _r.value;
                    data["notes"].push(item.toJSON());
                }
            }
            catch (e_538_1) { e_538 = { error: e_538_1 }; }
            finally {
                try {
                    if (_r && !_r.done && (_c = _q.return)) _c.call(_q);
                }
                finally { if (e_538) throw e_538.error; }
            }
        }
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            try {
                for (var _s = __values(this.eventLogs), _t = _s.next(); !_t.done; _t = _s.next()) {
                    var item = _t.value;
                    data["eventLogs"].push(item.toJSON());
                }
            }
            catch (e_539_1) { e_539 = { error: e_539_1 }; }
            finally {
                try {
                    if (_t && !_t.done && (_d = _s.return)) _d.call(_s);
                }
                finally { if (e_539) throw e_539.error; }
            }
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            try {
                for (var _u = __values(this.sourceOrderItems), _v = _u.next(); !_v.done; _v = _u.next()) {
                    var item = _v.value;
                    data["sourceOrderItems"].push(item.toJSON());
                }
            }
            catch (e_540_1) { e_540 = { error: e_540_1 }; }
            finally {
                try {
                    if (_v && !_v.done && (_e = _u.return)) _e.call(_u);
                }
                finally { if (e_540) throw e_540.error; }
            }
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _w = __values(this.orderItems), _x = _w.next(); !_x.done; _x = _w.next()) {
                    var item = _x.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_541_1) { e_541 = { error: e_541_1 }; }
            finally {
                try {
                    if (_x && !_x.done && (_f = _w.return)) _f.call(_w);
                }
                finally { if (e_541) throw e_541.error; }
            }
        }
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            try {
                for (var _y = __values(this.relatedDocuments), _z = _y.next(); !_z.done; _z = _y.next()) {
                    var item = _z.value;
                    data["relatedDocuments"].push(item.toJSON());
                }
            }
            catch (e_542_1) { e_542 = { error: e_542_1 }; }
            finally {
                try {
                    if (_z && !_z.done && (_g = _y.return)) _g.call(_y);
                }
                finally { if (e_542) throw e_542.error; }
            }
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            try {
                for (var _19 = __values(this.documents), _20 = _19.next(); !_20.done; _20 = _19.next()) {
                    var item = _20.value;
                    data["documents"].push(item.toJSON());
                }
            }
            catch (e_543_1) { e_543 = { error: e_543_1 }; }
            finally {
                try {
                    if (_20 && !_20.done && (_h = _19.return)) _h.call(_19);
                }
                finally { if (e_543) throw e_543.error; }
            }
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            try {
                for (var _21 = __values(this.payments), _22 = _21.next(); !_22.done; _22 = _21.next()) {
                    var item = _22.value;
                    data["payments"].push(item.toJSON());
                }
            }
            catch (e_544_1) { e_544 = { error: e_544_1 }; }
            finally {
                try {
                    if (_22 && !_22.done && (_j = _21.return)) _j.call(_21);
                }
                finally { if (e_544) throw e_544.error; }
            }
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : undefined;
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : undefined;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            try {
                for (var _23 = __values(this.preparations), _24 = _23.next(); !_24.done; _24 = _23.next()) {
                    var item = _24.value;
                    data["preparations"].push(item.toJSON());
                }
            }
            catch (e_545_1) { e_545 = { error: e_545_1 }; }
            finally {
                try {
                    if (_24 && !_24.done && (_k = _23.return)) _k.call(_23);
                }
                finally { if (e_545) throw e_545.error; }
            }
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["stockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : undefined;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria ? this.replacementCriteria.toJSON() : undefined;
        data["carrierInfo"] = this.carrierInfo;
        data["giftCard"] = this.giftCard;
        data["includedGiftCard"] = this.includedGiftCard ? this.includedGiftCard.toJSON() : undefined;
        data["createFromOrderStorePickup"] = this.createFromOrderStorePickup;
        data["invoiceStoreCode"] = this.invoiceStoreCode;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["interest"] = this.interest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderReadyToHandleDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderReadyToHandleDto();
        result.init(json);
        return result;
    };
    return OrderReadyToHandleDto;
}());
export { OrderReadyToHandleDto };
var OrderReadyToHandleDtoPagedResultDto = /** @class */ (function () {
    function OrderReadyToHandleDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderReadyToHandleDtoPagedResultDto.prototype.init = function (_data) {
        var e_546, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrderReadyToHandleDto.fromJS(item));
                    }
                }
                catch (e_546_1) { e_546 = { error: e_546_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_546) throw e_546.error; }
                }
            }
        }
    };
    OrderReadyToHandleDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderReadyToHandleDtoPagedResultDto();
        result.init(data);
        return result;
    };
    OrderReadyToHandleDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_547, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_547_1) { e_547 = { error: e_547_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_547) throw e_547.error; }
            }
        }
        return data;
    };
    OrderReadyToHandleDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderReadyToHandleDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return OrderReadyToHandleDtoPagedResultDto;
}());
export { OrderReadyToHandleDtoPagedResultDto };
var OrderReadyToHandleCsvQuadminDto = /** @class */ (function () {
    function OrderReadyToHandleCsvQuadminDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderReadyToHandleCsvQuadminDto.prototype.init = function (_data) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.orderId = _data["orderId"];
            this.dispatchTime = _data["dispatchTime"];
            this.operation = _data["operation"];
            this.sku = _data["sku"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.money = _data["money"];
            this.clientDelay = _data["clientDelay"];
            this.deliveryWindow1 = _data["deliveryWindow1"];
            this.deliveryWindow2 = _data["deliveryWindow2"];
            this.deliveryCommentaries = _data["deliveryCommentaries"];
            this.group = _data["group"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
        }
    };
    OrderReadyToHandleCsvQuadminDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderReadyToHandleCsvQuadminDto();
        result.init(data);
        return result;
    };
    OrderReadyToHandleCsvQuadminDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["orderId"] = this.orderId;
        data["dispatchTime"] = this.dispatchTime;
        data["operation"] = this.operation;
        data["sku"] = this.sku;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["money"] = this.money;
        data["clientDelay"] = this.clientDelay;
        data["deliveryWindow1"] = this.deliveryWindow1;
        data["deliveryWindow2"] = this.deliveryWindow2;
        data["deliveryCommentaries"] = this.deliveryCommentaries;
        data["group"] = this.group;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        return data;
    };
    OrderReadyToHandleCsvQuadminDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderReadyToHandleCsvQuadminDto();
        result.init(json);
        return result;
    };
    return OrderReadyToHandleCsvQuadminDto;
}());
export { OrderReadyToHandleCsvQuadminDto };
var OrderReadyToShipDto = /** @class */ (function () {
    function OrderReadyToShipDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderReadyToShipDto.prototype.init = function (_data) {
        var e_548, _a, e_549, _b, e_550, _c, e_551, _d, e_552, _e, e_553, _f, e_554, _g, e_555, _h, e_556, _j;
        if (_data) {
            this.currentPreparationId = _data["currentPreparationId"];
            this.currentPickingGroupId = _data["currentPickingGroupId"];
            this.storeCode = _data["storeCode"];
            this.returnedDate = _data["returnedDate"] ? moment(_data["returnedDate"].toString()) : undefined;
            this.pendingReturning = _data["pendingReturning"];
            this.lastPendingReturnId = _data["lastPendingReturnId"];
            this.responsible = _data["responsible"];
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : undefined;
            this.sourceCode = _data["sourceCode"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.routeOrder = _data["routeOrder"];
            this.invoiceCreationTime = _data["invoiceCreationTime"] ? moment(_data["invoiceCreationTime"].toString()) : undefined;
            this.invoiceType = _data["invoiceType"];
            this.highlighted = _data["highlighted"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined;
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? CarrierDto.fromJS(_data["carrier"]) : undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrderId = _data["packOrderId"];
            this.balance = _data["balance"];
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [];
                try {
                    for (var _k = __values(_data["orderBalances"]), _l = _k.next(); !_l.done; _l = _k.next()) {
                        var item = _l.value;
                        this.orderBalances.push(OrderBalanceDto.fromJS(item));
                    }
                }
                catch (e_548_1) { e_548 = { error: e_548_1 }; }
                finally {
                    try {
                        if (_l && !_l.done && (_a = _k.return)) _a.call(_k);
                    }
                    finally { if (e_548) throw e_548.error; }
                }
            }
            if (Array.isArray(_data["notes"])) {
                this.notes = [];
                try {
                    for (var _m = __values(_data["notes"]), _o = _m.next(); !_o.done; _o = _m.next()) {
                        var item = _o.value;
                        this.notes.push(OrderNoteDto.fromJS(item));
                    }
                }
                catch (e_549_1) { e_549 = { error: e_549_1 }; }
                finally {
                    try {
                        if (_o && !_o.done && (_b = _m.return)) _b.call(_m);
                    }
                    finally { if (e_549) throw e_549.error; }
                }
            }
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [];
                try {
                    for (var _p = __values(_data["eventLogs"]), _q = _p.next(); !_q.done; _q = _p.next()) {
                        var item = _q.value;
                        this.eventLogs.push(EventLogDto.fromJS(item));
                    }
                }
                catch (e_550_1) { e_550 = { error: e_550_1 }; }
                finally {
                    try {
                        if (_q && !_q.done && (_c = _p.return)) _c.call(_p);
                    }
                    finally { if (e_550) throw e_550.error; }
                }
            }
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [];
                try {
                    for (var _r = __values(_data["sourceOrderItems"]), _s = _r.next(); !_s.done; _s = _r.next()) {
                        var item = _s.value;
                        this.sourceOrderItems.push(SourceOrderItemDto.fromJS(item));
                    }
                }
                catch (e_551_1) { e_551 = { error: e_551_1 }; }
                finally {
                    try {
                        if (_s && !_s.done && (_d = _r.return)) _d.call(_r);
                    }
                    finally { if (e_551) throw e_551.error; }
                }
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _t = __values(_data["orderItems"]), _u = _t.next(); !_u.done; _u = _t.next()) {
                        var item = _u.value;
                        this.orderItems.push(OrderItemDto.fromJS(item));
                    }
                }
                catch (e_552_1) { e_552 = { error: e_552_1 }; }
                finally {
                    try {
                        if (_u && !_u.done && (_e = _t.return)) _e.call(_t);
                    }
                    finally { if (e_552) throw e_552.error; }
                }
            }
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [];
                try {
                    for (var _v = __values(_data["relatedDocuments"]), _w = _v.next(); !_w.done; _w = _v.next()) {
                        var item = _w.value;
                        this.relatedDocuments.push(OrderDocumentDto.fromJS(item));
                    }
                }
                catch (e_553_1) { e_553 = { error: e_553_1 }; }
                finally {
                    try {
                        if (_w && !_w.done && (_f = _v.return)) _f.call(_v);
                    }
                    finally { if (e_553) throw e_553.error; }
                }
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [];
                try {
                    for (var _x = __values(_data["documents"]), _y = _x.next(); !_y.done; _y = _x.next()) {
                        var item = _y.value;
                        this.documents.push(DocumentDto.fromJS(item));
                    }
                }
                catch (e_554_1) { e_554 = { error: e_554_1 }; }
                finally {
                    try {
                        if (_y && !_y.done && (_g = _x.return)) _g.call(_x);
                    }
                    finally { if (e_554) throw e_554.error; }
                }
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [];
                try {
                    for (var _z = __values(_data["payments"]), _19 = _z.next(); !_19.done; _19 = _z.next()) {
                        var item = _19.value;
                        this.payments.push(PaymentDto.fromJS(item));
                    }
                }
                catch (e_555_1) { e_555 = { error: e_555_1 }; }
                finally {
                    try {
                        if (_19 && !_19.done && (_h = _z.return)) _h.call(_z);
                    }
                    finally { if (e_555) throw e_555.error; }
                }
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : undefined;
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatusDto.fromJS(_data["currentCommercialStatus"]) : undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : undefined;
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [];
                try {
                    for (var _20 = __values(_data["preparations"]), _21 = _20.next(); !_21.done; _21 = _20.next()) {
                        var item = _21.value;
                        this.preparations.push(PreparationDto.fromJS(item));
                    }
                }
                catch (e_556_1) { e_556 = { error: e_556_1 }; }
                finally {
                    try {
                        if (_21 && !_21.done && (_j = _20.return)) _j.call(_20);
                    }
                    finally { if (e_556) throw e_556.error; }
                }
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrderDto.fromJS(_data["shipmentOrder"]) : undefined;
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.stockStatus = _data["stockStatus"] ? StockStatusDto.fromJS(_data["stockStatus"]) : undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriverDto.fromJS(_data["carrierDriver"]) : undefined;
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"] ? ReplacementCriteriaDto.fromJS(_data["replacementCriteria"]) : undefined;
            this.carrierInfo = _data["carrierInfo"];
            this.giftCard = _data["giftCard"];
            this.includedGiftCard = _data["includedGiftCard"] ? IncludedGiftCardDto.fromJS(_data["includedGiftCard"]) : undefined;
            this.createFromOrderStorePickup = _data["createFromOrderStorePickup"];
            this.invoiceStoreCode = _data["invoiceStoreCode"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.interest = _data["interest"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderReadyToShipDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderReadyToShipDto();
        result.init(data);
        return result;
    };
    OrderReadyToShipDto.prototype.toJSON = function (data) {
        var e_557, _a, e_558, _b, e_559, _c, e_560, _d, e_561, _e, e_562, _f, e_563, _g, e_564, _h, e_565, _j;
        data = typeof data === 'object' ? data : {};
        data["currentPreparationId"] = this.currentPreparationId;
        data["currentPickingGroupId"] = this.currentPickingGroupId;
        data["storeCode"] = this.storeCode;
        data["returnedDate"] = this.returnedDate ? this.returnedDate.toISOString() : undefined;
        data["pendingReturning"] = this.pendingReturning;
        data["lastPendingReturnId"] = this.lastPendingReturnId;
        data["responsible"] = this.responsible;
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : undefined;
        data["sourceCode"] = this.sourceCode;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["invoiceNumber"] = this.invoiceNumber;
        data["routeOrder"] = this.routeOrder;
        data["invoiceCreationTime"] = this.invoiceCreationTime ? this.invoiceCreationTime.toISOString() : undefined;
        data["invoiceType"] = this.invoiceType;
        data["highlighted"] = this.highlighted;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrderId"] = this.packOrderId;
        data["balance"] = this.balance;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            try {
                for (var _k = __values(this.orderBalances), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var item = _l.value;
                    data["orderBalances"].push(item.toJSON());
                }
            }
            catch (e_557_1) { e_557 = { error: e_557_1 }; }
            finally {
                try {
                    if (_l && !_l.done && (_a = _k.return)) _a.call(_k);
                }
                finally { if (e_557) throw e_557.error; }
            }
        }
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            try {
                for (var _m = __values(this.notes), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var item = _o.value;
                    data["notes"].push(item.toJSON());
                }
            }
            catch (e_558_1) { e_558 = { error: e_558_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_b = _m.return)) _b.call(_m);
                }
                finally { if (e_558) throw e_558.error; }
            }
        }
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            try {
                for (var _p = __values(this.eventLogs), _q = _p.next(); !_q.done; _q = _p.next()) {
                    var item = _q.value;
                    data["eventLogs"].push(item.toJSON());
                }
            }
            catch (e_559_1) { e_559 = { error: e_559_1 }; }
            finally {
                try {
                    if (_q && !_q.done && (_c = _p.return)) _c.call(_p);
                }
                finally { if (e_559) throw e_559.error; }
            }
        }
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            try {
                for (var _r = __values(this.sourceOrderItems), _s = _r.next(); !_s.done; _s = _r.next()) {
                    var item = _s.value;
                    data["sourceOrderItems"].push(item.toJSON());
                }
            }
            catch (e_560_1) { e_560 = { error: e_560_1 }; }
            finally {
                try {
                    if (_s && !_s.done && (_d = _r.return)) _d.call(_r);
                }
                finally { if (e_560) throw e_560.error; }
            }
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _t = __values(this.orderItems), _u = _t.next(); !_u.done; _u = _t.next()) {
                    var item = _u.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_561_1) { e_561 = { error: e_561_1 }; }
            finally {
                try {
                    if (_u && !_u.done && (_e = _t.return)) _e.call(_t);
                }
                finally { if (e_561) throw e_561.error; }
            }
        }
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            try {
                for (var _v = __values(this.relatedDocuments), _w = _v.next(); !_w.done; _w = _v.next()) {
                    var item = _w.value;
                    data["relatedDocuments"].push(item.toJSON());
                }
            }
            catch (e_562_1) { e_562 = { error: e_562_1 }; }
            finally {
                try {
                    if (_w && !_w.done && (_f = _v.return)) _f.call(_v);
                }
                finally { if (e_562) throw e_562.error; }
            }
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            try {
                for (var _x = __values(this.documents), _y = _x.next(); !_y.done; _y = _x.next()) {
                    var item = _y.value;
                    data["documents"].push(item.toJSON());
                }
            }
            catch (e_563_1) { e_563 = { error: e_563_1 }; }
            finally {
                try {
                    if (_y && !_y.done && (_g = _x.return)) _g.call(_x);
                }
                finally { if (e_563) throw e_563.error; }
            }
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            try {
                for (var _z = __values(this.payments), _19 = _z.next(); !_19.done; _19 = _z.next()) {
                    var item = _19.value;
                    data["payments"].push(item.toJSON());
                }
            }
            catch (e_564_1) { e_564 = { error: e_564_1 }; }
            finally {
                try {
                    if (_19 && !_19.done && (_h = _z.return)) _h.call(_z);
                }
                finally { if (e_564) throw e_564.error; }
            }
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : undefined;
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : undefined;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            try {
                for (var _20 = __values(this.preparations), _21 = _20.next(); !_21.done; _21 = _20.next()) {
                    var item = _21.value;
                    data["preparations"].push(item.toJSON());
                }
            }
            catch (e_565_1) { e_565 = { error: e_565_1 }; }
            finally {
                try {
                    if (_21 && !_21.done && (_j = _20.return)) _j.call(_20);
                }
                finally { if (e_565) throw e_565.error; }
            }
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : undefined;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["stockStatus"] = this.stockStatus ? this.stockStatus.toJSON() : undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : undefined;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria ? this.replacementCriteria.toJSON() : undefined;
        data["carrierInfo"] = this.carrierInfo;
        data["giftCard"] = this.giftCard;
        data["includedGiftCard"] = this.includedGiftCard ? this.includedGiftCard.toJSON() : undefined;
        data["createFromOrderStorePickup"] = this.createFromOrderStorePickup;
        data["invoiceStoreCode"] = this.invoiceStoreCode;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["interest"] = this.interest;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderReadyToShipDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderReadyToShipDto();
        result.init(json);
        return result;
    };
    return OrderReadyToShipDto;
}());
export { OrderReadyToShipDto };
var OrderReadyToShipDtoPagedResultDto = /** @class */ (function () {
    function OrderReadyToShipDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderReadyToShipDtoPagedResultDto.prototype.init = function (_data) {
        var e_566, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrderReadyToShipDto.fromJS(item));
                    }
                }
                catch (e_566_1) { e_566 = { error: e_566_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_566) throw e_566.error; }
                }
            }
        }
    };
    OrderReadyToShipDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderReadyToShipDtoPagedResultDto();
        result.init(data);
        return result;
    };
    OrderReadyToShipDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_567, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_567_1) { e_567 = { error: e_567_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_567) throw e_567.error; }
            }
        }
        return data;
    };
    OrderReadyToShipDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderReadyToShipDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return OrderReadyToShipDtoPagedResultDto;
}());
export { OrderReadyToShipDtoPagedResultDto };
var UploadRouteRequestDto = /** @class */ (function () {
    function UploadRouteRequestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadRouteRequestDto.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    };
    UploadRouteRequestDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadRouteRequestDto();
        result.init(data);
        return result;
    };
    UploadRouteRequestDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data;
    };
    UploadRouteRequestDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UploadRouteRequestDto();
        result.init(json);
        return result;
    };
    return UploadRouteRequestDto;
}());
export { UploadRouteRequestDto };
var OrderReturnedDto = /** @class */ (function () {
    function OrderReturnedDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderReturnedDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.customerName = _data["customerName"];
            this.customerAdress = _data["customerAdress"];
            this.shipmentId = _data["shipmentId"];
            this.shipmentQuantity = _data["shipmentQuantity"];
            this.carrierName = _data["carrierName"];
            this.orderAction = _data["orderAction"];
            this.observation = _data["observation"];
            this.sku = _data["sku"];
            this.name = _data["name"];
            this.quantity = _data["quantity"];
            this.quantityReturned = _data["quantityReturned"];
            this.comentary = _data["comentary"];
            this.id = _data["id"];
        }
    };
    OrderReturnedDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderReturnedDto();
        result.init(data);
        return result;
    };
    OrderReturnedDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["customerName"] = this.customerName;
        data["customerAdress"] = this.customerAdress;
        data["shipmentId"] = this.shipmentId;
        data["shipmentQuantity"] = this.shipmentQuantity;
        data["carrierName"] = this.carrierName;
        data["orderAction"] = this.orderAction;
        data["observation"] = this.observation;
        data["sku"] = this.sku;
        data["name"] = this.name;
        data["quantity"] = this.quantity;
        data["quantityReturned"] = this.quantityReturned;
        data["comentary"] = this.comentary;
        data["id"] = this.id;
        return data;
    };
    OrderReturnedDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderReturnedDto();
        result.init(json);
        return result;
    };
    return OrderReturnedDto;
}());
export { OrderReturnedDto };
var OrderReturnedDtoPagedResultDto = /** @class */ (function () {
    function OrderReturnedDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderReturnedDtoPagedResultDto.prototype.init = function (_data) {
        var e_568, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrderReturnedDto.fromJS(item));
                    }
                }
                catch (e_568_1) { e_568 = { error: e_568_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_568) throw e_568.error; }
                }
            }
        }
    };
    OrderReturnedDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderReturnedDtoPagedResultDto();
        result.init(data);
        return result;
    };
    OrderReturnedDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_569, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_569_1) { e_569 = { error: e_569_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_569) throw e_569.error; }
            }
        }
        return data;
    };
    OrderReturnedDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderReturnedDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return OrderReturnedDtoPagedResultDto;
}());
export { OrderReturnedDtoPagedResultDto };
var OverallFlowStatusDto = /** @class */ (function () {
    function OverallFlowStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OverallFlowStatusDto.prototype.init = function (_data) {
        var e_570, _a;
        if (_data) {
            this.from = _data["from"] ? OverallStatusValueDto.fromJS(_data["from"]) : undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [];
                try {
                    for (var _b = __values(_data["to"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.to.push(OverallStatusValueDto.fromJS(item));
                    }
                }
                catch (e_570_1) { e_570 = { error: e_570_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_570) throw e_570.error; }
                }
            }
        }
    };
    OverallFlowStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OverallFlowStatusDto();
        result.init(data);
        return result;
    };
    OverallFlowStatusDto.prototype.toJSON = function (data) {
        var e_571, _a;
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            try {
                for (var _b = __values(this.to), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["to"].push(item.toJSON());
                }
            }
            catch (e_571_1) { e_571 = { error: e_571_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_571) throw e_571.error; }
            }
        }
        return data;
    };
    OverallFlowStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OverallFlowStatusDto();
        result.init(json);
        return result;
    };
    return OverallFlowStatusDto;
}());
export { OverallFlowStatusDto };
var LogisticFlowStatusDto = /** @class */ (function () {
    function LogisticFlowStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogisticFlowStatusDto.prototype.init = function (_data) {
        var e_572, _a;
        if (_data) {
            this.from = _data["from"] ? LogisticStatusValueDto.fromJS(_data["from"]) : undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [];
                try {
                    for (var _b = __values(_data["to"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.to.push(LogisticStatusValueDto.fromJS(item));
                    }
                }
                catch (e_572_1) { e_572 = { error: e_572_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_572) throw e_572.error; }
                }
            }
        }
    };
    LogisticFlowStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogisticFlowStatusDto();
        result.init(data);
        return result;
    };
    LogisticFlowStatusDto.prototype.toJSON = function (data) {
        var e_573, _a;
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            try {
                for (var _b = __values(this.to), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["to"].push(item.toJSON());
                }
            }
            catch (e_573_1) { e_573 = { error: e_573_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_573) throw e_573.error; }
            }
        }
        return data;
    };
    LogisticFlowStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LogisticFlowStatusDto();
        result.init(json);
        return result;
    };
    return LogisticFlowStatusDto;
}());
export { LogisticFlowStatusDto };
var LogisticAuditFlowStatusDto = /** @class */ (function () {
    function LogisticAuditFlowStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogisticAuditFlowStatusDto.prototype.init = function (_data) {
        var e_574, _a;
        if (_data) {
            this.from = _data["from"] ? LogisticAuditStatusValueDto.fromJS(_data["from"]) : undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [];
                try {
                    for (var _b = __values(_data["to"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.to.push(LogisticAuditStatusValueDto.fromJS(item));
                    }
                }
                catch (e_574_1) { e_574 = { error: e_574_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_574) throw e_574.error; }
                }
            }
        }
    };
    LogisticAuditFlowStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogisticAuditFlowStatusDto();
        result.init(data);
        return result;
    };
    LogisticAuditFlowStatusDto.prototype.toJSON = function (data) {
        var e_575, _a;
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            try {
                for (var _b = __values(this.to), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["to"].push(item.toJSON());
                }
            }
            catch (e_575_1) { e_575 = { error: e_575_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_575) throw e_575.error; }
            }
        }
        return data;
    };
    LogisticAuditFlowStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LogisticAuditFlowStatusDto();
        result.init(json);
        return result;
    };
    return LogisticAuditFlowStatusDto;
}());
export { LogisticAuditFlowStatusDto };
var CommercialFlowStatusDto = /** @class */ (function () {
    function CommercialFlowStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CommercialFlowStatusDto.prototype.init = function (_data) {
        var e_576, _a;
        if (_data) {
            this.from = _data["from"] ? CommercialStatusValueDto.fromJS(_data["from"]) : undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [];
                try {
                    for (var _b = __values(_data["to"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.to.push(CommercialStatusValueDto.fromJS(item));
                    }
                }
                catch (e_576_1) { e_576 = { error: e_576_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_576) throw e_576.error; }
                }
            }
        }
    };
    CommercialFlowStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CommercialFlowStatusDto();
        result.init(data);
        return result;
    };
    CommercialFlowStatusDto.prototype.toJSON = function (data) {
        var e_577, _a;
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            try {
                for (var _b = __values(this.to), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["to"].push(item.toJSON());
                }
            }
            catch (e_577_1) { e_577 = { error: e_577_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_577) throw e_577.error; }
            }
        }
        return data;
    };
    CommercialFlowStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CommercialFlowStatusDto();
        result.init(json);
        return result;
    };
    return CommercialFlowStatusDto;
}());
export { CommercialFlowStatusDto };
var FinancialFlowStatusDto = /** @class */ (function () {
    function FinancialFlowStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FinancialFlowStatusDto.prototype.init = function (_data) {
        var e_578, _a;
        if (_data) {
            this.from = _data["from"] ? FinancialStatusValueDto.fromJS(_data["from"]) : undefined;
            if (Array.isArray(_data["to"])) {
                this.to = [];
                try {
                    for (var _b = __values(_data["to"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.to.push(FinancialStatusValueDto.fromJS(item));
                    }
                }
                catch (e_578_1) { e_578 = { error: e_578_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_578) throw e_578.error; }
                }
            }
        }
    };
    FinancialFlowStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FinancialFlowStatusDto();
        result.init(data);
        return result;
    };
    FinancialFlowStatusDto.prototype.toJSON = function (data) {
        var e_579, _a;
        data = typeof data === 'object' ? data : {};
        data["from"] = this.from ? this.from.toJSON() : undefined;
        if (Array.isArray(this.to)) {
            data["to"] = [];
            try {
                for (var _b = __values(this.to), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["to"].push(item.toJSON());
                }
            }
            catch (e_579_1) { e_579 = { error: e_579_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_579) throw e_579.error; }
            }
        }
        return data;
    };
    FinancialFlowStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FinancialFlowStatusDto();
        result.init(json);
        return result;
    };
    return FinancialFlowStatusDto;
}());
export { FinancialFlowStatusDto };
var OrderWorkflowDto = /** @class */ (function () {
    function OrderWorkflowDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderWorkflowDto.prototype.init = function (_data) {
        var e_580, _a, e_581, _b, e_582, _c, e_583, _d, e_584, _e;
        if (_data) {
            if (Array.isArray(_data["overallStatus"])) {
                this.overallStatus = [];
                try {
                    for (var _f = __values(_data["overallStatus"]), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var item = _g.value;
                        this.overallStatus.push(OverallFlowStatusDto.fromJS(item));
                    }
                }
                catch (e_580_1) { e_580 = { error: e_580_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                    }
                    finally { if (e_580) throw e_580.error; }
                }
            }
            if (Array.isArray(_data["logisticStatus"])) {
                this.logisticStatus = [];
                try {
                    for (var _h = __values(_data["logisticStatus"]), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        this.logisticStatus.push(LogisticFlowStatusDto.fromJS(item));
                    }
                }
                catch (e_581_1) { e_581 = { error: e_581_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                    }
                    finally { if (e_581) throw e_581.error; }
                }
            }
            if (Array.isArray(_data["logisticAuditStatus"])) {
                this.logisticAuditStatus = [];
                try {
                    for (var _k = __values(_data["logisticAuditStatus"]), _l = _k.next(); !_l.done; _l = _k.next()) {
                        var item = _l.value;
                        this.logisticAuditStatus.push(LogisticAuditFlowStatusDto.fromJS(item));
                    }
                }
                catch (e_582_1) { e_582 = { error: e_582_1 }; }
                finally {
                    try {
                        if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                    }
                    finally { if (e_582) throw e_582.error; }
                }
            }
            if (Array.isArray(_data["comerciallStatus"])) {
                this.comerciallStatus = [];
                try {
                    for (var _m = __values(_data["comerciallStatus"]), _o = _m.next(); !_o.done; _o = _m.next()) {
                        var item = _o.value;
                        this.comerciallStatus.push(CommercialFlowStatusDto.fromJS(item));
                    }
                }
                catch (e_583_1) { e_583 = { error: e_583_1 }; }
                finally {
                    try {
                        if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
                    }
                    finally { if (e_583) throw e_583.error; }
                }
            }
            if (Array.isArray(_data["financialStatus"])) {
                this.financialStatus = [];
                try {
                    for (var _p = __values(_data["financialStatus"]), _q = _p.next(); !_q.done; _q = _p.next()) {
                        var item = _q.value;
                        this.financialStatus.push(FinancialFlowStatusDto.fromJS(item));
                    }
                }
                catch (e_584_1) { e_584 = { error: e_584_1 }; }
                finally {
                    try {
                        if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
                    }
                    finally { if (e_584) throw e_584.error; }
                }
            }
        }
    };
    OrderWorkflowDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderWorkflowDto();
        result.init(data);
        return result;
    };
    OrderWorkflowDto.prototype.toJSON = function (data) {
        var e_585, _a, e_586, _b, e_587, _c, e_588, _d, e_589, _e;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.overallStatus)) {
            data["overallStatus"] = [];
            try {
                for (var _f = __values(this.overallStatus), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    data["overallStatus"].push(item.toJSON());
                }
            }
            catch (e_585_1) { e_585 = { error: e_585_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
                }
                finally { if (e_585) throw e_585.error; }
            }
        }
        if (Array.isArray(this.logisticStatus)) {
            data["logisticStatus"] = [];
            try {
                for (var _h = __values(this.logisticStatus), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var item = _j.value;
                    data["logisticStatus"].push(item.toJSON());
                }
            }
            catch (e_586_1) { e_586 = { error: e_586_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
                }
                finally { if (e_586) throw e_586.error; }
            }
        }
        if (Array.isArray(this.logisticAuditStatus)) {
            data["logisticAuditStatus"] = [];
            try {
                for (var _k = __values(this.logisticAuditStatus), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var item = _l.value;
                    data["logisticAuditStatus"].push(item.toJSON());
                }
            }
            catch (e_587_1) { e_587 = { error: e_587_1 }; }
            finally {
                try {
                    if (_l && !_l.done && (_c = _k.return)) _c.call(_k);
                }
                finally { if (e_587) throw e_587.error; }
            }
        }
        if (Array.isArray(this.comerciallStatus)) {
            data["comerciallStatus"] = [];
            try {
                for (var _m = __values(this.comerciallStatus), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var item = _o.value;
                    data["comerciallStatus"].push(item.toJSON());
                }
            }
            catch (e_588_1) { e_588 = { error: e_588_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_d = _m.return)) _d.call(_m);
                }
                finally { if (e_588) throw e_588.error; }
            }
        }
        if (Array.isArray(this.financialStatus)) {
            data["financialStatus"] = [];
            try {
                for (var _p = __values(this.financialStatus), _q = _p.next(); !_q.done; _q = _p.next()) {
                    var item = _q.value;
                    data["financialStatus"].push(item.toJSON());
                }
            }
            catch (e_589_1) { e_589 = { error: e_589_1 }; }
            finally {
                try {
                    if (_q && !_q.done && (_e = _p.return)) _e.call(_p);
                }
                finally { if (e_589) throw e_589.error; }
            }
        }
        return data;
    };
    OrderWorkflowDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderWorkflowDto();
        result.init(json);
        return result;
    };
    return OrderWorkflowDto;
}());
export { OrderWorkflowDto };
var FlashStatusIndicatorDto = /** @class */ (function () {
    function FlashStatusIndicatorDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FlashStatusIndicatorDto.prototype.init = function (_data) {
        if (_data) {
            this.icon = _data["icon"];
            this.severity = _data["severity"];
        }
    };
    FlashStatusIndicatorDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FlashStatusIndicatorDto();
        result.init(data);
        return result;
    };
    FlashStatusIndicatorDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["icon"] = this.icon;
        data["severity"] = this.severity;
        return data;
    };
    FlashStatusIndicatorDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FlashStatusIndicatorDto();
        result.init(json);
        return result;
    };
    return FlashStatusIndicatorDto;
}());
export { FlashStatusIndicatorDto };
var OrderStorePickupDto = /** @class */ (function () {
    function OrderStorePickupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderStorePickupDto.prototype.init = function (_data) {
        var e_590, _a, e_591, _b;
        if (_data) {
            this.sourceName = _data["sourceName"] ? SourceValueDto.fromJS(_data["sourceName"]) : undefined;
            this.sourceCode = _data["sourceCode"];
            this.customer = _data["customer"] ? CustomerDto.fromJS(_data["customer"]) : undefined;
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : undefined;
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : undefined;
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStoreDto.fromJS(_data["currentAssignedToStore"]) : undefined;
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatusDto.fromJS(_data["currentOverallStatus"]) : undefined;
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatusDto.fromJS(_data["currentLogisticStatus"]) : undefined;
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatusDto.fromJS(_data["currentFinancialStatus"]) : undefined;
            this.modified = _data["modified"];
            if (Array.isArray(_data["flashStatusIndicators"])) {
                this.flashStatusIndicators = [];
                try {
                    for (var _c = __values(_data["flashStatusIndicators"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.flashStatusIndicators.push(FlashStatusIndicatorDto.fromJS(item));
                    }
                }
                catch (e_590_1) { e_590 = { error: e_590_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_590) throw e_590.error; }
                }
            }
            this.carrierId = _data["carrierId"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.netAmount = _data["netAmount"];
            if (Array.isArray(_data["notes"])) {
                this.notes = [];
                try {
                    for (var _e = __values(_data["notes"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.notes.push(OrderNoteDto.fromJS(item));
                    }
                }
                catch (e_591_1) { e_591 = { error: e_591_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_591) throw e_591.error; }
                }
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderStorePickupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderStorePickupDto();
        result.init(data);
        return result;
    };
    OrderStorePickupDto.prototype.toJSON = function (data) {
        var e_592, _a, e_593, _b;
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName ? this.sourceName.toJSON() : undefined;
        data["sourceCode"] = this.sourceCode;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : undefined;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : undefined;
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : undefined;
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : undefined;
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : undefined;
        data["modified"] = this.modified;
        if (Array.isArray(this.flashStatusIndicators)) {
            data["flashStatusIndicators"] = [];
            try {
                for (var _c = __values(this.flashStatusIndicators), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["flashStatusIndicators"].push(item.toJSON());
                }
            }
            catch (e_592_1) { e_592 = { error: e_592_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_592) throw e_592.error; }
            }
        }
        data["carrierId"] = this.carrierId;
        data["invoiceNumber"] = this.invoiceNumber;
        data["netAmount"] = this.netAmount;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            try {
                for (var _e = __values(this.notes), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["notes"].push(item.toJSON());
                }
            }
            catch (e_593_1) { e_593 = { error: e_593_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_593) throw e_593.error; }
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderStorePickupDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderStorePickupDto();
        result.init(json);
        return result;
    };
    return OrderStorePickupDto;
}());
export { OrderStorePickupDto };
var OrderStorePickupDtoPagedResultDto = /** @class */ (function () {
    function OrderStorePickupDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderStorePickupDtoPagedResultDto.prototype.init = function (_data) {
        var e_594, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(OrderStorePickupDto.fromJS(item));
                    }
                }
                catch (e_594_1) { e_594 = { error: e_594_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_594) throw e_594.error; }
                }
            }
        }
    };
    OrderStorePickupDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderStorePickupDtoPagedResultDto();
        result.init(data);
        return result;
    };
    OrderStorePickupDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_595, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_595_1) { e_595 = { error: e_595_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_595) throw e_595.error; }
            }
        }
        return data;
    };
    OrderStorePickupDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderStorePickupDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return OrderStorePickupDtoPagedResultDto;
}());
export { OrderStorePickupDtoPagedResultDto };
var OrderTrackingStepDto = /** @class */ (function () {
    function OrderTrackingStepDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderTrackingStepDto.prototype.init = function (_data) {
        if (_data) {
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined;
            this.dateDesc = _data["dateDesc"];
            this.stepDesc = _data["stepDesc"];
            this.stepDescSub = _data["stepDescSub"];
            this.isChecked = _data["isChecked"];
        }
    };
    OrderTrackingStepDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderTrackingStepDto();
        result.init(data);
        return result;
    };
    OrderTrackingStepDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : undefined;
        data["dateDesc"] = this.dateDesc;
        data["stepDesc"] = this.stepDesc;
        data["stepDescSub"] = this.stepDescSub;
        data["isChecked"] = this.isChecked;
        return data;
    };
    OrderTrackingStepDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderTrackingStepDto();
        result.init(json);
        return result;
    };
    return OrderTrackingStepDto;
}());
export { OrderTrackingStepDto };
var OrderTrackingDto = /** @class */ (function () {
    function OrderTrackingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderTrackingDto.prototype.init = function (_data) {
        var e_596, _a, e_597, _b;
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.isShipping = _data["isShipping"];
            this.nombre = _data["nombre"];
            this.estimatedDate = _data["estimatedDate"];
            this.estimatedTime = _data["estimatedTime"];
            this.estimatedTimeEnd = _data["estimatedTimeEnd"];
            this.storeName = _data["storeName"];
            this.storeAdress = _data["storeAdress"];
            this.storeTelefono = _data["storeTelefono"];
            this.storeMail = _data["storeMail"];
            this.adress = _data["adress"];
            this.calle = _data["calle"];
            this.numero = _data["numero"];
            this.pisoDepto = _data["pisoDepto"];
            this.barrioCiudad = _data["barrioCiudad"];
            this.codigoPostal = _data["codigoPostal"];
            this.provincia = _data["provincia"];
            this.telefono = _data["telefono"];
            this.adressLat = _data["adressLat"];
            this.adressLng = _data["adressLng"];
            if (Array.isArray(_data["steps"])) {
                this.steps = [];
                try {
                    for (var _c = __values(_data["steps"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.steps.push(OrderTrackingStepDto.fromJS(item));
                    }
                }
                catch (e_596_1) { e_596 = { error: e_596_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_596) throw e_596.error; }
                }
            }
            this.lastStepDesc = _data["lastStepDesc"];
            this.lastStepDetail = _data["lastStepDetail"];
            this.lastStepDescSub = _data["lastStepDescSub"];
            this.lastStepIsDelivered = _data["lastStepIsDelivered"];
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _e = __values(_data["orderItems"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.orderItems.push(OrderItemDto.fromJS(item));
                    }
                }
                catch (e_597_1) { e_597 = { error: e_597_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_597) throw e_597.error; }
                }
            }
            this.editable = _data["editable"];
            this.dispatchTag = _data["dispatchTag"];
            this.id = _data["id"];
        }
    };
    OrderTrackingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderTrackingDto();
        result.init(data);
        return result;
    };
    OrderTrackingDto.prototype.toJSON = function (data) {
        var e_598, _a, e_599, _b;
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["isShipping"] = this.isShipping;
        data["nombre"] = this.nombre;
        data["estimatedDate"] = this.estimatedDate;
        data["estimatedTime"] = this.estimatedTime;
        data["estimatedTimeEnd"] = this.estimatedTimeEnd;
        data["storeName"] = this.storeName;
        data["storeAdress"] = this.storeAdress;
        data["storeTelefono"] = this.storeTelefono;
        data["storeMail"] = this.storeMail;
        data["adress"] = this.adress;
        data["calle"] = this.calle;
        data["numero"] = this.numero;
        data["pisoDepto"] = this.pisoDepto;
        data["barrioCiudad"] = this.barrioCiudad;
        data["codigoPostal"] = this.codigoPostal;
        data["provincia"] = this.provincia;
        data["telefono"] = this.telefono;
        data["adressLat"] = this.adressLat;
        data["adressLng"] = this.adressLng;
        if (Array.isArray(this.steps)) {
            data["steps"] = [];
            try {
                for (var _c = __values(this.steps), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["steps"].push(item.toJSON());
                }
            }
            catch (e_598_1) { e_598 = { error: e_598_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_598) throw e_598.error; }
            }
        }
        data["lastStepDesc"] = this.lastStepDesc;
        data["lastStepDetail"] = this.lastStepDetail;
        data["lastStepDescSub"] = this.lastStepDescSub;
        data["lastStepIsDelivered"] = this.lastStepIsDelivered;
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _e = __values(this.orderItems), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_599_1) { e_599 = { error: e_599_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_599) throw e_599.error; }
            }
        }
        data["editable"] = this.editable;
        data["dispatchTag"] = this.dispatchTag;
        data["id"] = this.id;
        return data;
    };
    OrderTrackingDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderTrackingDto();
        result.init(json);
        return result;
    };
    return OrderTrackingDto;
}());
export { OrderTrackingDto };
var UpdateDeliveryDataDto = /** @class */ (function () {
    function UpdateDeliveryDataDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateDeliveryDataDto.prototype.init = function (_data) {
        if (_data) {
            this.secureId = _data["secureId"];
            this.country = _data["country"];
            this.state = _data["state"];
            this.city = _data["city"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.postalCode = _data["postalCode"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.depto = _data["depto"];
            this.phoneNumber = _data["phoneNumber"];
        }
    };
    UpdateDeliveryDataDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateDeliveryDataDto();
        result.init(data);
        return result;
    };
    UpdateDeliveryDataDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["secureId"] = this.secureId;
        data["country"] = this.country;
        data["state"] = this.state;
        data["city"] = this.city;
        data["street"] = this.street;
        data["number"] = this.number;
        data["postalCode"] = this.postalCode;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["depto"] = this.depto;
        data["phoneNumber"] = this.phoneNumber;
        return data;
    };
    UpdateDeliveryDataDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UpdateDeliveryDataDto();
        result.init(json);
        return result;
    };
    return UpdateDeliveryDataDto;
}());
export { UpdateDeliveryDataDto };
export var MovementType;
(function (MovementType) {
    MovementType[MovementType["_0"] = 0] = "_0";
    MovementType[MovementType["_1"] = 1] = "_1";
    MovementType[MovementType["_2"] = 2] = "_2";
    MovementType[MovementType["_3"] = 3] = "_3";
    MovementType[MovementType["_4"] = 4] = "_4";
    MovementType[MovementType["_5"] = 5] = "_5";
    MovementType[MovementType["_6"] = 6] = "_6";
})(MovementType || (MovementType = {}));
var PendingReturnStatusDto = /** @class */ (function () {
    function PendingReturnStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PendingReturnStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    PendingReturnStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PendingReturnStatusDto();
        result.init(data);
        return result;
    };
    PendingReturnStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    PendingReturnStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PendingReturnStatusDto();
        result.init(json);
        return result;
    };
    return PendingReturnStatusDto;
}());
export { PendingReturnStatusDto };
var PendingReturnItemDto = /** @class */ (function () {
    function PendingReturnItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PendingReturnItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.quantityReturned = _data["quantityReturned"];
            this.comments = _data["comments"];
            this.id = _data["id"];
        }
    };
    PendingReturnItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PendingReturnItemDto();
        result.init(data);
        return result;
    };
    PendingReturnItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["quantityReturned"] = this.quantityReturned;
        data["comments"] = this.comments;
        data["id"] = this.id;
        return data;
    };
    PendingReturnItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PendingReturnItemDto();
        result.init(json);
        return result;
    };
    return PendingReturnItemDto;
}());
export { PendingReturnItemDto };
var PendingReturnDto = /** @class */ (function () {
    function PendingReturnDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PendingReturnDto.prototype.init = function (_data) {
        var e_600, _a;
        if (_data) {
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.returnDate = _data["returnDate"] ? moment(_data["returnDate"].toString()) : undefined;
            this.order = _data["order"] ? OrderDto.fromJS(_data["order"]) : undefined;
            this.claim = _data["claim"] ? ClaimDto.fromJS(_data["claim"]) : undefined;
            this.status = _data["status"] ? PendingReturnStatusDto.fromJS(_data["status"]) : undefined;
            if (Array.isArray(_data["pendingReturnsItems"])) {
                this.pendingReturnsItems = [];
                try {
                    for (var _b = __values(_data["pendingReturnsItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.pendingReturnsItems.push(PendingReturnItemDto.fromJS(item));
                    }
                }
                catch (e_600_1) { e_600 = { error: e_600_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_600) throw e_600.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    PendingReturnDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PendingReturnDto();
        result.init(data);
        return result;
    };
    PendingReturnDto.prototype.toJSON = function (data) {
        var e_601, _a;
        data = typeof data === 'object' ? data : {};
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["returnDate"] = this.returnDate ? this.returnDate.toISOString() : undefined;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["claim"] = this.claim ? this.claim.toJSON() : undefined;
        data["status"] = this.status ? this.status.toJSON() : undefined;
        if (Array.isArray(this.pendingReturnsItems)) {
            data["pendingReturnsItems"] = [];
            try {
                for (var _b = __values(this.pendingReturnsItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["pendingReturnsItems"].push(item.toJSON());
                }
            }
            catch (e_601_1) { e_601 = { error: e_601_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_601) throw e_601.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    PendingReturnDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PendingReturnDto();
        result.init(json);
        return result;
    };
    return PendingReturnDto;
}());
export { PendingReturnDto };
var PendingReturnDtoPagedResultDto = /** @class */ (function () {
    function PendingReturnDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PendingReturnDtoPagedResultDto.prototype.init = function (_data) {
        var e_602, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(PendingReturnDto.fromJS(item));
                    }
                }
                catch (e_602_1) { e_602 = { error: e_602_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_602) throw e_602.error; }
                }
            }
        }
    };
    PendingReturnDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PendingReturnDtoPagedResultDto();
        result.init(data);
        return result;
    };
    PendingReturnDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_603, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_603_1) { e_603 = { error: e_603_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_603) throw e_603.error; }
            }
        }
        return data;
    };
    PendingReturnDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PendingReturnDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return PendingReturnDtoPagedResultDto;
}());
export { PendingReturnDtoPagedResultDto };
var PicapBookingStatusDto = /** @class */ (function () {
    function PicapBookingStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PicapBookingStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.bookingId = _data["bookingId"];
            this.statusCd = _data["statusCd"];
            this.eventCd = _data["eventCd"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : undefined;
            this.relaunchedToId = _data["relaunchedToId"];
            if (_data["driver"]) {
                this.driver = {};
                for (var key in _data["driver"]) {
                    if (_data["driver"].hasOwnProperty(key))
                        this.driver[key] = _data["driver"][key];
                }
            }
            if (_data["vehicle"]) {
                this.vehicle = {};
                for (var key in _data["vehicle"]) {
                    if (_data["vehicle"].hasOwnProperty(key))
                        this.vehicle[key] = _data["vehicle"][key];
                }
            }
        }
    };
    PicapBookingStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PicapBookingStatusDto();
        result.init(data);
        return result;
    };
    PicapBookingStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["bookingId"] = this.bookingId;
        data["statusCd"] = this.statusCd;
        data["eventCd"] = this.eventCd;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["relaunchedToId"] = this.relaunchedToId;
        if (this.driver) {
            data["driver"] = {};
            for (var key in this.driver) {
                if (this.driver.hasOwnProperty(key))
                    data["driver"][key] = this.driver[key];
            }
        }
        if (this.vehicle) {
            data["vehicle"] = {};
            for (var key in this.vehicle) {
                if (this.vehicle.hasOwnProperty(key))
                    data["vehicle"][key] = this.vehicle[key];
            }
        }
        return data;
    };
    PicapBookingStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PicapBookingStatusDto();
        result.init(json);
        return result;
    };
    return PicapBookingStatusDto;
}());
export { PicapBookingStatusDto };
var PicapPackageStatusDto = /** @class */ (function () {
    function PicapPackageStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PicapPackageStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.packageId = _data["packageId"];
            this.statusCd = _data["statusCd"];
            this.eventCd = _data["eventCd"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : undefined;
        }
    };
    PicapPackageStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PicapPackageStatusDto();
        result.init(data);
        return result;
    };
    PicapPackageStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["packageId"] = this.packageId;
        data["statusCd"] = this.statusCd;
        data["eventCd"] = this.eventCd;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    };
    PicapPackageStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PicapPackageStatusDto();
        result.init(json);
        return result;
    };
    return PicapPackageStatusDto;
}());
export { PicapPackageStatusDto };
var PickingGroupStatusValueDto = /** @class */ (function () {
    function PickingGroupStatusValueDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupStatusValueDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    PickingGroupStatusValueDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupStatusValueDto();
        result.init(data);
        return result;
    };
    PickingGroupStatusValueDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    PickingGroupStatusValueDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupStatusValueDto();
        result.init(json);
        return result;
    };
    return PickingGroupStatusValueDto;
}());
export { PickingGroupStatusValueDto };
var OrderPickingGroupDto = /** @class */ (function () {
    function OrderPickingGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderPickingGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.order = _data["order"] ? OrderDto.fromJS(_data["order"]) : undefined;
            this.orderId = _data["orderId"];
            this.pickingGroupId = _data["pickingGroupId"];
            this.id = _data["id"];
        }
    };
    OrderPickingGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderPickingGroupDto();
        result.init(data);
        return result;
    };
    OrderPickingGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["orderId"] = this.orderId;
        data["pickingGroupId"] = this.pickingGroupId;
        data["id"] = this.id;
        return data;
    };
    OrderPickingGroupDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderPickingGroupDto();
        result.init(json);
        return result;
    };
    return OrderPickingGroupDto;
}());
export { OrderPickingGroupDto };
var PickingGroupItemDto = /** @class */ (function () {
    function PickingGroupItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.quantityPicked = _data["quantityPicked"];
            this.barCode = _data["barCode"];
            this.orderNumber = _data["orderNumber"];
            this.aisle = _data["aisle"];
            this.location = _data["location"];
            this.locationId = _data["locationId"];
            this.weight = _data["weight"];
            this.id = _data["id"];
        }
    };
    PickingGroupItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupItemDto();
        result.init(data);
        return result;
    };
    PickingGroupItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["quantityPicked"] = this.quantityPicked;
        data["barCode"] = this.barCode;
        data["orderNumber"] = this.orderNumber;
        data["aisle"] = this.aisle;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["weight"] = this.weight;
        data["id"] = this.id;
        return data;
    };
    PickingGroupItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupItemDto();
        result.init(json);
        return result;
    };
    return PickingGroupItemDto;
}());
export { PickingGroupItemDto };
var PickingGroupDto = /** @class */ (function () {
    function PickingGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupDto.prototype.init = function (_data) {
        var e_604, _a, e_605, _b, e_606, _c;
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.pickingGroupStatus = _data["pickingGroupStatus"] ? PickingGroupStatusValueDto.fromJS(_data["pickingGroupStatus"]) : undefined;
            this.quantityToPick = _data["quantityToPick"];
            this.quantityPicked = _data["quantityPicked"];
            this.lines = _data["lines"];
            this.orderQuantity = _data["orderQuantity"];
            this.alias = _data["alias"];
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
            this.weight = _data["weight"];
            if (Array.isArray(_data["shippingTypes"])) {
                this.shippingTypes = [];
                try {
                    for (var _d = __values(_data["shippingTypes"]), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var item = _e.value;
                        this.shippingTypes.push(ShippingTypeDto.fromJS(item));
                    }
                }
                catch (e_604_1) { e_604 = { error: e_604_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_604) throw e_604.error; }
                }
            }
            if (Array.isArray(_data["ordersToPick"])) {
                this.ordersToPick = [];
                try {
                    for (var _f = __values(_data["ordersToPick"]), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var item = _g.value;
                        this.ordersToPick.push(OrderPickingGroupDto.fromJS(item));
                    }
                }
                catch (e_605_1) { e_605 = { error: e_605_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_605) throw e_605.error; }
                }
            }
            if (Array.isArray(_data["pickingGroupItems"])) {
                this.pickingGroupItems = [];
                try {
                    for (var _h = __values(_data["pickingGroupItems"]), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        this.pickingGroupItems.push(PickingGroupItemDto.fromJS(item));
                    }
                }
                catch (e_606_1) { e_606 = { error: e_606_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_606) throw e_606.error; }
                }
            }
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    PickingGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupDto();
        result.init(data);
        return result;
    };
    PickingGroupDto.prototype.toJSON = function (data) {
        var e_607, _a, e_608, _b, e_609, _c;
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["pickingGroupStatus"] = this.pickingGroupStatus ? this.pickingGroupStatus.toJSON() : undefined;
        data["quantityToPick"] = this.quantityToPick;
        data["quantityPicked"] = this.quantityPicked;
        data["lines"] = this.lines;
        data["orderQuantity"] = this.orderQuantity;
        data["alias"] = this.alias;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        data["weight"] = this.weight;
        if (Array.isArray(this.shippingTypes)) {
            data["shippingTypes"] = [];
            try {
                for (var _d = __values(this.shippingTypes), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var item = _e.value;
                    data["shippingTypes"].push(item.toJSON());
                }
            }
            catch (e_607_1) { e_607 = { error: e_607_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_607) throw e_607.error; }
            }
        }
        if (Array.isArray(this.ordersToPick)) {
            data["ordersToPick"] = [];
            try {
                for (var _f = __values(this.ordersToPick), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    data["ordersToPick"].push(item.toJSON());
                }
            }
            catch (e_608_1) { e_608 = { error: e_608_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_608) throw e_608.error; }
            }
        }
        if (Array.isArray(this.pickingGroupItems)) {
            data["pickingGroupItems"] = [];
            try {
                for (var _h = __values(this.pickingGroupItems), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var item = _j.value;
                    data["pickingGroupItems"].push(item.toJSON());
                }
            }
            catch (e_609_1) { e_609 = { error: e_609_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_609) throw e_609.error; }
            }
        }
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    PickingGroupDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupDto();
        result.init(json);
        return result;
    };
    return PickingGroupDto;
}());
export { PickingGroupDto };
var PickingGroupDtoPagedResultDto = /** @class */ (function () {
    function PickingGroupDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupDtoPagedResultDto.prototype.init = function (_data) {
        var e_610, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(PickingGroupDto.fromJS(item));
                    }
                }
                catch (e_610_1) { e_610 = { error: e_610_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_610) throw e_610.error; }
                }
            }
        }
    };
    PickingGroupDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupDtoPagedResultDto();
        result.init(data);
        return result;
    };
    PickingGroupDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_611, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_611_1) { e_611 = { error: e_611_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_611) throw e_611.error; }
            }
        }
        return data;
    };
    PickingGroupDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return PickingGroupDtoPagedResultDto;
}());
export { PickingGroupDtoPagedResultDto };
var UpdateOrdersFromPickingGroupRequest = /** @class */ (function () {
    function UpdateOrdersFromPickingGroupRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdateOrdersFromPickingGroupRequest.prototype.init = function (_data) {
        var e_612, _a;
        if (_data) {
            this.pickingGroupId = _data["pickingGroupId"];
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [];
                try {
                    for (var _b = __values(_data["orderIds"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderIds.push(item);
                    }
                }
                catch (e_612_1) { e_612 = { error: e_612_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_612) throw e_612.error; }
                }
            }
        }
    };
    UpdateOrdersFromPickingGroupRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdateOrdersFromPickingGroupRequest();
        result.init(data);
        return result;
    };
    UpdateOrdersFromPickingGroupRequest.prototype.toJSON = function (data) {
        var e_613, _a;
        data = typeof data === 'object' ? data : {};
        data["pickingGroupId"] = this.pickingGroupId;
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            try {
                for (var _b = __values(this.orderIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderIds"].push(item);
                }
            }
            catch (e_613_1) { e_613 = { error: e_613_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_613) throw e_613.error; }
            }
        }
        return data;
    };
    UpdateOrdersFromPickingGroupRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UpdateOrdersFromPickingGroupRequest();
        result.init(json);
        return result;
    };
    return UpdateOrdersFromPickingGroupRequest;
}());
export { UpdateOrdersFromPickingGroupRequest };
var PickingGroupCreateDto = /** @class */ (function () {
    function PickingGroupCreateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupCreateDto.prototype.init = function (_data) {
        var e_614, _a;
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [];
                try {
                    for (var _b = __values(_data["orderIds"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderIds.push(item);
                    }
                }
                catch (e_614_1) { e_614 = { error: e_614_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_614) throw e_614.error; }
                }
            }
            this.assignedTo = _data["assignedTo"];
            this.storeCode = _data["storeCode"];
            this.alias = _data["alias"];
        }
    };
    PickingGroupCreateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupCreateDto();
        result.init(data);
        return result;
    };
    PickingGroupCreateDto.prototype.toJSON = function (data) {
        var e_615, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            try {
                for (var _b = __values(this.orderIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderIds"].push(item);
                }
            }
            catch (e_615_1) { e_615 = { error: e_615_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_615) throw e_615.error; }
            }
        }
        data["assignedTo"] = this.assignedTo;
        data["storeCode"] = this.storeCode;
        data["alias"] = this.alias;
        return data;
    };
    PickingGroupCreateDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupCreateDto();
        result.init(json);
        return result;
    };
    return PickingGroupCreateDto;
}());
export { PickingGroupCreateDto };
var Int32EntityDto = /** @class */ (function () {
    function Int32EntityDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Int32EntityDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
        }
    };
    Int32EntityDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Int32EntityDto();
        result.init(data);
        return result;
    };
    Int32EntityDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    };
    Int32EntityDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Int32EntityDto();
        result.init(json);
        return result;
    };
    return Int32EntityDto;
}());
export { Int32EntityDto };
var PickingGroupCreateWithConflictsRequest = /** @class */ (function () {
    function PickingGroupCreateWithConflictsRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupCreateWithConflictsRequest.prototype.init = function (_data) {
        var e_616, _a;
        if (_data) {
            this.pickingGroupId = _data["pickingGroupId"];
            this.isRequestToStore = _data["isRequestToStore"];
            if (Array.isArray(_data["ordersToRemoveFromPickingGroup"])) {
                this.ordersToRemoveFromPickingGroup = [];
                try {
                    for (var _b = __values(_data["ordersToRemoveFromPickingGroup"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.ordersToRemoveFromPickingGroup.push(item);
                    }
                }
                catch (e_616_1) { e_616 = { error: e_616_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_616) throw e_616.error; }
                }
            }
        }
    };
    PickingGroupCreateWithConflictsRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupCreateWithConflictsRequest();
        result.init(data);
        return result;
    };
    PickingGroupCreateWithConflictsRequest.prototype.toJSON = function (data) {
        var e_617, _a;
        data = typeof data === 'object' ? data : {};
        data["pickingGroupId"] = this.pickingGroupId;
        data["isRequestToStore"] = this.isRequestToStore;
        if (Array.isArray(this.ordersToRemoveFromPickingGroup)) {
            data["ordersToRemoveFromPickingGroup"] = [];
            try {
                for (var _b = __values(this.ordersToRemoveFromPickingGroup), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["ordersToRemoveFromPickingGroup"].push(item);
                }
            }
            catch (e_617_1) { e_617 = { error: e_617_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_617) throw e_617.error; }
            }
        }
        return data;
    };
    PickingGroupCreateWithConflictsRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupCreateWithConflictsRequest();
        result.init(json);
        return result;
    };
    return PickingGroupCreateWithConflictsRequest;
}());
export { PickingGroupCreateWithConflictsRequest };
var UpdatePickedQuantityRequest = /** @class */ (function () {
    function UpdatePickedQuantityRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UpdatePickedQuantityRequest.prototype.init = function (_data) {
        var e_618, _a;
        if (_data) {
            this.pickingGroupId = _data["pickingGroupId"];
            if (Array.isArray(_data["pickingGroupItems"])) {
                this.pickingGroupItems = [];
                try {
                    for (var _b = __values(_data["pickingGroupItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.pickingGroupItems.push(PickingGroupItemDto.fromJS(item));
                    }
                }
                catch (e_618_1) { e_618 = { error: e_618_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_618) throw e_618.error; }
                }
            }
        }
    };
    UpdatePickedQuantityRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UpdatePickedQuantityRequest();
        result.init(data);
        return result;
    };
    UpdatePickedQuantityRequest.prototype.toJSON = function (data) {
        var e_619, _a;
        data = typeof data === 'object' ? data : {};
        data["pickingGroupId"] = this.pickingGroupId;
        if (Array.isArray(this.pickingGroupItems)) {
            data["pickingGroupItems"] = [];
            try {
                for (var _b = __values(this.pickingGroupItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["pickingGroupItems"].push(item.toJSON());
                }
            }
            catch (e_619_1) { e_619 = { error: e_619_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_619) throw e_619.error; }
            }
        }
        return data;
    };
    UpdatePickedQuantityRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UpdatePickedQuantityRequest();
        result.init(json);
        return result;
    };
    return UpdatePickedQuantityRequest;
}());
export { UpdatePickedQuantityRequest };
var PickingGroupItemDtoPagedResultDto = /** @class */ (function () {
    function PickingGroupItemDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupItemDtoPagedResultDto.prototype.init = function (_data) {
        var e_620, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(PickingGroupItemDto.fromJS(item));
                    }
                }
                catch (e_620_1) { e_620 = { error: e_620_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_620) throw e_620.error; }
                }
            }
        }
    };
    PickingGroupItemDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupItemDtoPagedResultDto();
        result.init(data);
        return result;
    };
    PickingGroupItemDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_621, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_621_1) { e_621 = { error: e_621_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_621) throw e_621.error; }
            }
        }
        return data;
    };
    PickingGroupItemDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupItemDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return PickingGroupItemDtoPagedResultDto;
}());
export { PickingGroupItemDtoPagedResultDto };
var PickingGroupRuleDto = /** @class */ (function () {
    function PickingGroupRuleDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupRuleDto.prototype.init = function (_data) {
        var e_622, _a, e_623, _b, e_624, _c, e_625, _d;
        if (_data) {
            this.alias = _data["alias"];
            this.ordersLimit = _data["ordersLimit"];
            if (Array.isArray(_data["fields"])) {
                this.fields = [];
                try {
                    for (var _e = __values(_data["fields"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.fields.push(item);
                    }
                }
                catch (e_622_1) { e_622 = { error: e_622_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                    }
                    finally { if (e_622) throw e_622.error; }
                }
            }
            if (Array.isArray(_data["dispatchTags"])) {
                this.dispatchTags = [];
                try {
                    for (var _g = __values(_data["dispatchTags"]), _h = _g.next(); !_h.done; _h = _g.next()) {
                        var item = _h.value;
                        this.dispatchTags.push(item);
                    }
                }
                catch (e_623_1) { e_623 = { error: e_623_1 }; }
                finally {
                    try {
                        if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                    }
                    finally { if (e_623) throw e_623.error; }
                }
            }
            this.withPostalCode = _data["withPostalCode"];
            if (Array.isArray(_data["postalCode"])) {
                this.postalCode = [];
                try {
                    for (var _j = __values(_data["postalCode"]), _k = _j.next(); !_k.done; _k = _j.next()) {
                        var item = _k.value;
                        this.postalCode.push(item);
                    }
                }
                catch (e_624_1) { e_624 = { error: e_624_1 }; }
                finally {
                    try {
                        if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                    }
                    finally { if (e_624) throw e_624.error; }
                }
            }
            if (Array.isArray(_data["shippingTypeIds"])) {
                this.shippingTypeIds = [];
                try {
                    for (var _l = __values(_data["shippingTypeIds"]), _m = _l.next(); !_m.done; _m = _l.next()) {
                        var item = _m.value;
                        this.shippingTypeIds.push(item);
                    }
                }
                catch (e_625_1) { e_625 = { error: e_625_1 }; }
                finally {
                    try {
                        if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                    }
                    finally { if (e_625) throw e_625.error; }
                }
            }
            this.postalCodesFile = _data["postalCodesFile"];
            this.enabled = _data["enabled"];
            this.id = _data["id"];
        }
    };
    PickingGroupRuleDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupRuleDto();
        result.init(data);
        return result;
    };
    PickingGroupRuleDto.prototype.toJSON = function (data) {
        var e_626, _a, e_627, _b, e_628, _c, e_629, _d;
        data = typeof data === 'object' ? data : {};
        data["alias"] = this.alias;
        data["ordersLimit"] = this.ordersLimit;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            try {
                for (var _e = __values(this.fields), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["fields"].push(item);
                }
            }
            catch (e_626_1) { e_626 = { error: e_626_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
                }
                finally { if (e_626) throw e_626.error; }
            }
        }
        if (Array.isArray(this.dispatchTags)) {
            data["dispatchTags"] = [];
            try {
                for (var _g = __values(this.dispatchTags), _h = _g.next(); !_h.done; _h = _g.next()) {
                    var item = _h.value;
                    data["dispatchTags"].push(item);
                }
            }
            catch (e_627_1) { e_627 = { error: e_627_1 }; }
            finally {
                try {
                    if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
                }
                finally { if (e_627) throw e_627.error; }
            }
        }
        data["withPostalCode"] = this.withPostalCode;
        if (Array.isArray(this.postalCode)) {
            data["postalCode"] = [];
            try {
                for (var _j = __values(this.postalCode), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var item = _k.value;
                    data["postalCode"].push(item);
                }
            }
            catch (e_628_1) { e_628 = { error: e_628_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_c = _j.return)) _c.call(_j);
                }
                finally { if (e_628) throw e_628.error; }
            }
        }
        if (Array.isArray(this.shippingTypeIds)) {
            data["shippingTypeIds"] = [];
            try {
                for (var _l = __values(this.shippingTypeIds), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var item = _m.value;
                    data["shippingTypeIds"].push(item);
                }
            }
            catch (e_629_1) { e_629 = { error: e_629_1 }; }
            finally {
                try {
                    if (_m && !_m.done && (_d = _l.return)) _d.call(_l);
                }
                finally { if (e_629) throw e_629.error; }
            }
        }
        data["postalCodesFile"] = this.postalCodesFile;
        data["enabled"] = this.enabled;
        data["id"] = this.id;
        return data;
    };
    PickingGroupRuleDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupRuleDto();
        result.init(json);
        return result;
    };
    return PickingGroupRuleDto;
}());
export { PickingGroupRuleDto };
var PickingGroupRuleDtoPagedResultDto = /** @class */ (function () {
    function PickingGroupRuleDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupRuleDtoPagedResultDto.prototype.init = function (_data) {
        var e_630, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(PickingGroupRuleDto.fromJS(item));
                    }
                }
                catch (e_630_1) { e_630 = { error: e_630_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_630) throw e_630.error; }
                }
            }
        }
    };
    PickingGroupRuleDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupRuleDtoPagedResultDto();
        result.init(data);
        return result;
    };
    PickingGroupRuleDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_631, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_631_1) { e_631 = { error: e_631_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_631) throw e_631.error; }
            }
        }
        return data;
    };
    PickingGroupRuleDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupRuleDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return PickingGroupRuleDtoPagedResultDto;
}());
export { PickingGroupRuleDtoPagedResultDto };
var PreparationDtoPagedResultDto = /** @class */ (function () {
    function PreparationDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PreparationDtoPagedResultDto.prototype.init = function (_data) {
        var e_632, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(PreparationDto.fromJS(item));
                    }
                }
                catch (e_632_1) { e_632 = { error: e_632_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_632) throw e_632.error; }
                }
            }
        }
    };
    PreparationDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PreparationDtoPagedResultDto();
        result.init(data);
        return result;
    };
    PreparationDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_633, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_633_1) { e_633 = { error: e_633_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_633) throw e_633.error; }
            }
        }
        return data;
    };
    PreparationDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PreparationDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return PreparationDtoPagedResultDto;
}());
export { PreparationDtoPagedResultDto };
var CurrentStatusDto = /** @class */ (function () {
    function CurrentStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CurrentStatusDto.prototype.init = function (_data) {
        var e_634, _a;
        if (_data) {
            this.processId = _data["processId"];
            this.status = _data["status"];
            if (Array.isArray(_data["currentStep"])) {
                this.currentStep = [];
                try {
                    for (var _b = __values(_data["currentStep"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.currentStep.push(item);
                    }
                }
                catch (e_634_1) { e_634 = { error: e_634_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_634) throw e_634.error; }
                }
            }
        }
    };
    CurrentStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CurrentStatusDto();
        result.init(data);
        return result;
    };
    CurrentStatusDto.prototype.toJSON = function (data) {
        var e_635, _a;
        data = typeof data === 'object' ? data : {};
        data["processId"] = this.processId;
        data["status"] = this.status;
        if (Array.isArray(this.currentStep)) {
            data["currentStep"] = [];
            try {
                for (var _b = __values(this.currentStep), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["currentStep"].push(item);
                }
            }
            catch (e_635_1) { e_635 = { error: e_635_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_635) throw e_635.error; }
            }
        }
        return data;
    };
    CurrentStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CurrentStatusDto();
        result.init(json);
        return result;
    };
    return CurrentStatusDto;
}());
export { CurrentStatusDto };
var ProcessDto = /** @class */ (function () {
    function ProcessDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProcessDto.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.status = _data["status"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.currentStatus = _data["currentStatus"] ? CurrentStatusDto.fromJS(_data["currentStatus"]) : undefined;
            this.output = _data["output"];
            this.action = _data["action"];
            this.parameters = _data["parameters"];
        }
    };
    ProcessDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProcessDto();
        result.init(data);
        return result;
    };
    ProcessDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["status"] = this.status;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : undefined;
        data["output"] = this.output;
        data["action"] = this.action;
        data["parameters"] = this.parameters;
        return data;
    };
    ProcessDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ProcessDto();
        result.init(json);
        return result;
    };
    return ProcessDto;
}());
export { ProcessDto };
var PromotionMappingDto = /** @class */ (function () {
    function PromotionMappingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PromotionMappingDto.prototype.init = function (_data) {
        if (_data) {
            this.promotionCode = _data["promotionCode"];
            this.description = _data["description"];
            this.isSkuPromotion = _data["isSkuPromotion"];
            this.sku = _data["sku"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    };
    PromotionMappingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PromotionMappingDto();
        result.init(data);
        return result;
    };
    PromotionMappingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["promotionCode"] = this.promotionCode;
        data["description"] = this.description;
        data["isSkuPromotion"] = this.isSkuPromotion;
        data["sku"] = this.sku;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    };
    PromotionMappingDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PromotionMappingDto();
        result.init(json);
        return result;
    };
    return PromotionMappingDto;
}());
export { PromotionMappingDto };
var PromotionMappingDtoPagedResultDto = /** @class */ (function () {
    function PromotionMappingDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PromotionMappingDtoPagedResultDto.prototype.init = function (_data) {
        var e_636, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(PromotionMappingDto.fromJS(item));
                    }
                }
                catch (e_636_1) { e_636 = { error: e_636_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_636) throw e_636.error; }
                }
            }
        }
    };
    PromotionMappingDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PromotionMappingDtoPagedResultDto();
        result.init(data);
        return result;
    };
    PromotionMappingDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_637, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_637_1) { e_637 = { error: e_637_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_637) throw e_637.error; }
            }
        }
        return data;
    };
    PromotionMappingDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PromotionMappingDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return PromotionMappingDtoPagedResultDto;
}());
export { PromotionMappingDtoPagedResultDto };
var UploadPromotionDto = /** @class */ (function () {
    function UploadPromotionDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadPromotionDto.prototype.init = function (_data) {
        if (_data) {
            this.url = _data["url"];
            this.countryCode = _data["countryCode"];
        }
    };
    UploadPromotionDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadPromotionDto();
        result.init(data);
        return result;
    };
    UploadPromotionDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["countryCode"] = this.countryCode;
        return data;
    };
    UploadPromotionDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UploadPromotionDto();
        result.init(json);
        return result;
    };
    return UploadPromotionDto;
}());
export { UploadPromotionDto };
var DeliveryState = /** @class */ (function () {
    function DeliveryState(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryState.prototype.init = function (_data) {
        if (_data) {
            this.description = _data["description"];
            this.reason = _data["reason"];
        }
    };
    DeliveryState.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryState();
        result.init(data);
        return result;
    };
    DeliveryState.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["reason"] = this.reason;
        return data;
    };
    DeliveryState.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DeliveryState();
        result.init(json);
        return result;
    };
    return DeliveryState;
}());
export { DeliveryState };
var Poi = /** @class */ (function () {
    function Poi(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Poi.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.address = _data["address"];
            this.lat = _data["lat"];
            this.lng = _data["lng"];
            this.email = _data["email"];
            this.phone = _data["phone"];
        }
    };
    Poi.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Poi();
        result.init(data);
        return result;
    };
    Poi.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["address"] = this.address;
        data["lat"] = this.lat;
        data["lng"] = this.lng;
        data["email"] = this.email;
        data["phone"] = this.phone;
        return data;
    };
    Poi.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Poi();
        result.init(json);
        return result;
    };
    return Poi;
}());
export { Poi };
var OrderW = /** @class */ (function () {
    function OrderW(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderW.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
            this.qtn = _data["qtn"];
        }
    };
    OrderW.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderW();
        result.init(data);
        return result;
    };
    OrderW.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        data["qtn"] = this.qtn;
        return data;
    };
    OrderW.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderW();
        result.init(json);
        return result;
    };
    return OrderW;
}());
export { OrderW };
var Route = /** @class */ (function () {
    function Route(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Route.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
        }
    };
    Route.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Route();
        result.init(data);
        return result;
    };
    Route.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    };
    Route.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Route();
        result.init(json);
        return result;
    };
    return Route;
}());
export { Route };
var QuadmindsWebHookDto = /** @class */ (function () {
    function QuadmindsWebHookDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    QuadmindsWebHookDto.prototype.init = function (_data) {
        if (_data) {
            this.event = _data["event"];
            this.deliveryDate = _data["deliveryDate"];
            this.deliveryDateUTC = _data["deliveryDateUTC"];
            this.code = _data["code"];
            this.qtn = _data["qtn"];
            this.eta = _data["eta"];
            this.etaUTC = _data["etaUTC"];
            this.deliveryState = _data["deliveryState"] ? DeliveryState.fromJS(_data["deliveryState"]) : undefined;
            this.poi = _data["poi"] ? Poi.fromJS(_data["poi"]) : undefined;
            this.order = _data["order"] ? OrderW.fromJS(_data["order"]) : undefined;
            this.route = _data["route"] ? Route.fromJS(_data["route"]) : undefined;
        }
    };
    QuadmindsWebHookDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new QuadmindsWebHookDto();
        result.init(data);
        return result;
    };
    QuadmindsWebHookDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["event"] = this.event;
        data["deliveryDate"] = this.deliveryDate;
        data["deliveryDateUTC"] = this.deliveryDateUTC;
        data["code"] = this.code;
        data["qtn"] = this.qtn;
        data["eta"] = this.eta;
        data["etaUTC"] = this.etaUTC;
        data["deliveryState"] = this.deliveryState ? this.deliveryState.toJSON() : undefined;
        data["poi"] = this.poi ? this.poi.toJSON() : undefined;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["route"] = this.route ? this.route.toJSON() : undefined;
        return data;
    };
    QuadmindsWebHookDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new QuadmindsWebHookDto();
        result.init(json);
        return result;
    };
    return QuadmindsWebHookDto;
}());
export { QuadmindsWebHookDto };
var RapiboyRequest = /** @class */ (function () {
    function RapiboyRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RapiboyRequest.prototype.init = function (_data) {
        if (_data) {
            this.idPedido = _data["idPedido"];
            this.trackingId = _data["trackingId"];
            this.referenciaExterna = _data["referenciaExterna"];
            this.estado = _data["estado"];
            this.nombre = _data["nombre"];
            this.telefono = _data["telefono"];
            this.idMotivoCancelacion = _data["idMotivoCancelacion"];
            this.motivoCancelacion = _data["motivoCancelacion"];
            this.idMotivoNoEntregado = _data["idMotivoNoEntregado"];
            this.motivoNoEntregado = _data["motivoNoEntregado"];
            this.fecha = _data["fecha"];
        }
    };
    RapiboyRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RapiboyRequest();
        result.init(data);
        return result;
    };
    RapiboyRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["idPedido"] = this.idPedido;
        data["trackingId"] = this.trackingId;
        data["referenciaExterna"] = this.referenciaExterna;
        data["estado"] = this.estado;
        data["nombre"] = this.nombre;
        data["telefono"] = this.telefono;
        data["idMotivoCancelacion"] = this.idMotivoCancelacion;
        data["motivoCancelacion"] = this.motivoCancelacion;
        data["idMotivoNoEntregado"] = this.idMotivoNoEntregado;
        data["motivoNoEntregado"] = this.motivoNoEntregado;
        data["fecha"] = this.fecha;
        return data;
    };
    RapiboyRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RapiboyRequest();
        result.init(json);
        return result;
    };
    return RapiboyRequest;
}());
export { RapiboyRequest };
var RappiItemDto = /** @class */ (function () {
    function RappiItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RappiItemDto.prototype.init = function (_data) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.codComerssia = _data["codComerssia"];
            this.referenciaAliado = _data["referenciaAliado"];
            this.sku = _data["sku"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
            this.marca = _data["marca"];
            this.stock = _data["stock"];
            this.tienda = _data["tienda"];
            this.precioPorTienda = _data["precioPorTienda"];
            this.precioConDescuento = _data["precioConDescuento"];
            this.descuento = _data["descuento"];
            this.fechaInicioDescuento = _data["fechaInicioDescuento"] ? moment(_data["fechaInicioDescuento"].toString()) : undefined;
            this.fechaFinDescuento = _data["fechaFinDescuento"] ? moment(_data["fechaFinDescuento"].toString()) : undefined;
            this.categoriaProducto1 = _data["categoriaProducto1"];
            this.categoriaProducto2 = _data["categoriaProducto2"];
            this.categoriaProducto3 = _data["categoriaProducto3"];
            this.imagenDeProducto = _data["imagenDeProducto"];
            this.categoriaCombinacion = _data["categoriaCombinacion"];
            this.nombreCombinacion = _data["nombreCombinacion"];
            this.disponible = _data["disponible"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    RappiItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RappiItemDto();
        result.init(data);
        return result;
    };
    RappiItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["codComerssia"] = this.codComerssia;
        data["referenciaAliado"] = this.referenciaAliado;
        data["sku"] = this.sku;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        data["marca"] = this.marca;
        data["stock"] = this.stock;
        data["tienda"] = this.tienda;
        data["precioPorTienda"] = this.precioPorTienda;
        data["precioConDescuento"] = this.precioConDescuento;
        data["descuento"] = this.descuento;
        data["fechaInicioDescuento"] = this.fechaInicioDescuento ? this.fechaInicioDescuento.toISOString() : undefined;
        data["fechaFinDescuento"] = this.fechaFinDescuento ? this.fechaFinDescuento.toISOString() : undefined;
        data["categoriaProducto1"] = this.categoriaProducto1;
        data["categoriaProducto2"] = this.categoriaProducto2;
        data["categoriaProducto3"] = this.categoriaProducto3;
        data["imagenDeProducto"] = this.imagenDeProducto;
        data["categoriaCombinacion"] = this.categoriaCombinacion;
        data["nombreCombinacion"] = this.nombreCombinacion;
        data["disponible"] = this.disponible;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    RappiItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RappiItemDto();
        result.init(json);
        return result;
    };
    return RappiItemDto;
}());
export { RappiItemDto };
var RappiItemCsvDashboardDto = /** @class */ (function () {
    function RappiItemCsvDashboardDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RappiItemCsvDashboardDto.prototype.init = function (_data) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.codComerssia = _data["codComerssia"];
            this.referenciaAliado = _data["referenciaAliado"];
            this.sku = _data["sku"];
            this.nombre = _data["nombre"];
            this.descripcion = _data["descripcion"];
            this.marca = _data["marca"];
            this.stock = _data["stock"];
            this.tienda = _data["tienda"];
            this.precioPorTienda = _data["precioPorTienda"];
            this.precioConDescuento = _data["precioConDescuento"];
            this.descuento = _data["descuento"];
            this.fechaInicioDescuento = _data["fechaInicioDescuento"] ? moment(_data["fechaInicioDescuento"].toString()) : undefined;
            this.fechaFinDescuento = _data["fechaFinDescuento"] ? moment(_data["fechaFinDescuento"].toString()) : undefined;
            this.categoriaProducto1 = _data["categoriaProducto1"];
            this.categoriaProducto2 = _data["categoriaProducto2"];
            this.categoriaProducto3 = _data["categoriaProducto3"];
            this.imagenDeProducto = _data["imagenDeProducto"];
            this.categoriaCombinacion = _data["categoriaCombinacion"];
            this.nombreCombinacion = _data["nombreCombinacion"];
            this.disponible = _data["disponible"];
        }
    };
    RappiItemCsvDashboardDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RappiItemCsvDashboardDto();
        result.init(data);
        return result;
    };
    RappiItemCsvDashboardDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["codComerssia"] = this.codComerssia;
        data["referenciaAliado"] = this.referenciaAliado;
        data["sku"] = this.sku;
        data["nombre"] = this.nombre;
        data["descripcion"] = this.descripcion;
        data["marca"] = this.marca;
        data["stock"] = this.stock;
        data["tienda"] = this.tienda;
        data["precioPorTienda"] = this.precioPorTienda;
        data["precioConDescuento"] = this.precioConDescuento;
        data["descuento"] = this.descuento;
        data["fechaInicioDescuento"] = this.fechaInicioDescuento ? this.fechaInicioDescuento.toISOString() : undefined;
        data["fechaFinDescuento"] = this.fechaFinDescuento ? this.fechaFinDescuento.toISOString() : undefined;
        data["categoriaProducto1"] = this.categoriaProducto1;
        data["categoriaProducto2"] = this.categoriaProducto2;
        data["categoriaProducto3"] = this.categoriaProducto3;
        data["imagenDeProducto"] = this.imagenDeProducto;
        data["categoriaCombinacion"] = this.categoriaCombinacion;
        data["nombreCombinacion"] = this.nombreCombinacion;
        data["disponible"] = this.disponible;
        return data;
    };
    RappiItemCsvDashboardDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RappiItemCsvDashboardDto();
        result.init(json);
        return result;
    };
    return RappiItemCsvDashboardDto;
}());
export { RappiItemCsvDashboardDto };
var SyncRappiCatalogDto = /** @class */ (function () {
    function SyncRappiCatalogDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SyncRappiCatalogDto.prototype.init = function (_data) {
        var e_638, _a;
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.type = _data["type"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [];
                try {
                    for (var _b = __values(_data["stores"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.stores.push(item);
                    }
                }
                catch (e_638_1) { e_638 = { error: e_638_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_638) throw e_638.error; }
                }
            }
        }
    };
    SyncRappiCatalogDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SyncRappiCatalogDto();
        result.init(data);
        return result;
    };
    SyncRappiCatalogDto.prototype.toJSON = function (data) {
        var e_639, _a;
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["type"] = this.type;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            try {
                for (var _b = __values(this.stores), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["stores"].push(item);
                }
            }
            catch (e_639_1) { e_639 = { error: e_639_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_639) throw e_639.error; }
            }
        }
        return data;
    };
    SyncRappiCatalogDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SyncRappiCatalogDto();
        result.init(json);
        return result;
    };
    return SyncRappiCatalogDto;
}());
export { SyncRappiCatalogDto };
var StoreConfig = /** @class */ (function () {
    function StoreConfig(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StoreConfig.prototype.init = function (_data) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
        }
    };
    StoreConfig.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StoreConfig();
        result.init(data);
        return result;
    };
    StoreConfig.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        return data;
    };
    StoreConfig.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StoreConfig();
        result.init(json);
        return result;
    };
    return StoreConfig;
}());
export { StoreConfig };
var RappiConfigDto = /** @class */ (function () {
    function RappiConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RappiConfigDto.prototype.init = function (_data) {
        var e_640, _a;
        if (_data) {
            if (Array.isArray(_data["storeConfigs"])) {
                this.storeConfigs = [];
                try {
                    for (var _b = __values(_data["storeConfigs"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.storeConfigs.push(StoreConfig.fromJS(item));
                    }
                }
                catch (e_640_1) { e_640 = { error: e_640_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_640) throw e_640.error; }
                }
            }
        }
    };
    RappiConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RappiConfigDto();
        result.init(data);
        return result;
    };
    RappiConfigDto.prototype.toJSON = function (data) {
        var e_641, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.storeConfigs)) {
            data["storeConfigs"] = [];
            try {
                for (var _b = __values(this.storeConfigs), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["storeConfigs"].push(item.toJSON());
                }
            }
            catch (e_641_1) { e_641 = { error: e_641_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_641) throw e_641.error; }
            }
        }
        return data;
    };
    RappiConfigDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RappiConfigDto();
        result.init(json);
        return result;
    };
    return RappiConfigDto;
}());
export { RappiConfigDto };
var UploadRappiDiscountsRequestDto = /** @class */ (function () {
    function UploadRappiDiscountsRequestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadRappiDiscountsRequestDto.prototype.init = function (_data) {
        var e_642, _a;
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.url = _data["url"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [];
                try {
                    for (var _b = __values(_data["stores"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.stores.push(item);
                    }
                }
                catch (e_642_1) { e_642 = { error: e_642_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_642) throw e_642.error; }
                }
            }
        }
    };
    UploadRappiDiscountsRequestDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadRappiDiscountsRequestDto();
        result.init(data);
        return result;
    };
    UploadRappiDiscountsRequestDto.prototype.toJSON = function (data) {
        var e_643, _a;
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["url"] = this.url;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            try {
                for (var _b = __values(this.stores), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["stores"].push(item);
                }
            }
            catch (e_643_1) { e_643 = { error: e_643_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_643) throw e_643.error; }
            }
        }
        return data;
    };
    UploadRappiDiscountsRequestDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UploadRappiDiscountsRequestDto();
        result.init(json);
        return result;
    };
    return UploadRappiDiscountsRequestDto;
}());
export { UploadRappiDiscountsRequestDto };
var UploadRappiProductsRequestDto = /** @class */ (function () {
    function UploadRappiProductsRequestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadRappiProductsRequestDto.prototype.init = function (_data) {
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.url = _data["url"];
        }
    };
    UploadRappiProductsRequestDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadRappiProductsRequestDto();
        result.init(data);
        return result;
    };
    UploadRappiProductsRequestDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["url"] = this.url;
        return data;
    };
    UploadRappiProductsRequestDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UploadRappiProductsRequestDto();
        result.init(json);
        return result;
    };
    return UploadRappiProductsRequestDto;
}());
export { UploadRappiProductsRequestDto };
var RappiItemDtoPagedResultDto = /** @class */ (function () {
    function RappiItemDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RappiItemDtoPagedResultDto.prototype.init = function (_data) {
        var e_644, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(RappiItemDto.fromJS(item));
                    }
                }
                catch (e_644_1) { e_644 = { error: e_644_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_644) throw e_644.error; }
                }
            }
        }
    };
    RappiItemDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RappiItemDtoPagedResultDto();
        result.init(data);
        return result;
    };
    RappiItemDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_645, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_645_1) { e_645 = { error: e_645_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_645) throw e_645.error; }
            }
        }
        return data;
    };
    RappiItemDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RappiItemDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return RappiItemDtoPagedResultDto;
}());
export { RappiItemDtoPagedResultDto };
var RappiStoreConfigDto = /** @class */ (function () {
    function RappiStoreConfigDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RappiStoreConfigDto.prototype.init = function (_data) {
        if (_data) {
            this.rappiStoreId = _data["rappiStoreId"];
            this.safetyStockPercentage = _data["safetyStockPercentage"];
            this.safetyStockAmount = _data["safetyStockAmount"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    RappiStoreConfigDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RappiStoreConfigDto();
        result.init(data);
        return result;
    };
    RappiStoreConfigDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["rappiStoreId"] = this.rappiStoreId;
        data["safetyStockPercentage"] = this.safetyStockPercentage;
        data["safetyStockAmount"] = this.safetyStockAmount;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    RappiStoreConfigDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RappiStoreConfigDto();
        result.init(json);
        return result;
    };
    return RappiStoreConfigDto;
}());
export { RappiStoreConfigDto };
var RappiStoreConfigDtoPagedResultDto = /** @class */ (function () {
    function RappiStoreConfigDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    RappiStoreConfigDtoPagedResultDto.prototype.init = function (_data) {
        var e_646, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(RappiStoreConfigDto.fromJS(item));
                    }
                }
                catch (e_646_1) { e_646 = { error: e_646_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_646) throw e_646.error; }
                }
            }
        }
    };
    RappiStoreConfigDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new RappiStoreConfigDtoPagedResultDto();
        result.init(data);
        return result;
    };
    RappiStoreConfigDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_647, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_647_1) { e_647 = { error: e_647_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_647) throw e_647.error; }
            }
        }
        return data;
    };
    RappiStoreConfigDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new RappiStoreConfigDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return RappiStoreConfigDtoPagedResultDto;
}());
export { RappiStoreConfigDtoPagedResultDto };
var ReturnStatusDto = /** @class */ (function () {
    function ReturnStatusDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnStatusDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    ReturnStatusDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnStatusDto();
        result.init(data);
        return result;
    };
    ReturnStatusDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    ReturnStatusDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ReturnStatusDto();
        result.init(json);
        return result;
    };
    return ReturnStatusDto;
}());
export { ReturnStatusDto };
var ReturnItemDto = /** @class */ (function () {
    function ReturnItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.id = _data["id"];
        }
    };
    ReturnItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnItemDto();
        result.init(data);
        return result;
    };
    ReturnItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["id"] = this.id;
        return data;
    };
    ReturnItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ReturnItemDto();
        result.init(json);
        return result;
    };
    return ReturnItemDto;
}());
export { ReturnItemDto };
var ReturnDto = /** @class */ (function () {
    function ReturnDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnDto.prototype.init = function (_data) {
        var e_648, _a;
        if (_data) {
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.deliveryData = _data["deliveryData"] ? DeliveryDataDto.fromJS(_data["deliveryData"]) : undefined;
            this.status = _data["status"] ? ReturnStatusDto.fromJS(_data["status"]) : undefined;
            this.claim = _data["claim"] ? ClaimDto.fromJS(_data["claim"]) : undefined;
            this.itemQuantity = _data["itemQuantity"];
            if (Array.isArray(_data["returnItems"])) {
                this.returnItems = [];
                try {
                    for (var _b = __values(_data["returnItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.returnItems.push(ReturnItemDto.fromJS(item));
                    }
                }
                catch (e_648_1) { e_648 = { error: e_648_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_648) throw e_648.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    ReturnDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnDto();
        result.init(data);
        return result;
    };
    ReturnDto.prototype.toJSON = function (data) {
        var e_649, _a;
        data = typeof data === 'object' ? data : {};
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        data["status"] = this.status ? this.status.toJSON() : undefined;
        data["claim"] = this.claim ? this.claim.toJSON() : undefined;
        data["itemQuantity"] = this.itemQuantity;
        if (Array.isArray(this.returnItems)) {
            data["returnItems"] = [];
            try {
                for (var _b = __values(this.returnItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["returnItems"].push(item.toJSON());
                }
            }
            catch (e_649_1) { e_649 = { error: e_649_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_649) throw e_649.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    ReturnDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ReturnDto();
        result.init(json);
        return result;
    };
    return ReturnDto;
}());
export { ReturnDto };
var ReturnDtoPagedResultDto = /** @class */ (function () {
    function ReturnDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnDtoPagedResultDto.prototype.init = function (_data) {
        var e_650, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ReturnDto.fromJS(item));
                    }
                }
                catch (e_650_1) { e_650 = { error: e_650_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_650) throw e_650.error; }
                }
            }
        }
    };
    ReturnDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnDtoPagedResultDto();
        result.init(data);
        return result;
    };
    ReturnDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_651, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_651_1) { e_651 = { error: e_651_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_651) throw e_651.error; }
            }
        }
        return data;
    };
    ReturnDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ReturnDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return ReturnDtoPagedResultDto;
}());
export { ReturnDtoPagedResultDto };
var ReturnCsvQuadminDto = /** @class */ (function () {
    function ReturnCsvQuadminDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnCsvQuadminDto.prototype.init = function (_data) {
        if (_data) {
            this.customerCode = _data["customerCode"];
            this.customer = _data["customer"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.phoneNumber = _data["phoneNumber"];
            this.email = _data["email"];
            this.orderId = _data["orderId"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.operation = _data["operation"];
            this.sku = _data["sku"];
            this.productDescription = _data["productDescription"];
            this.quantity = _data["quantity"];
            this.weight = _data["weight"];
            this.volume = _data["volume"];
            this.money = _data["money"];
            this.clientDelay = _data["clientDelay"];
            this.deliveryWindow1 = _data["deliveryWindow1"];
            this.deliveryWindow2 = _data["deliveryWindow2"];
            this.deliveryCommentaries = _data["deliveryCommentaries"];
            this.group = _data["group"];
        }
    };
    ReturnCsvQuadminDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnCsvQuadminDto();
        result.init(data);
        return result;
    };
    ReturnCsvQuadminDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["customerCode"] = this.customerCode;
        data["customer"] = this.customer;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["phoneNumber"] = this.phoneNumber;
        data["email"] = this.email;
        data["orderId"] = this.orderId;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["operation"] = this.operation;
        data["sku"] = this.sku;
        data["productDescription"] = this.productDescription;
        data["quantity"] = this.quantity;
        data["weight"] = this.weight;
        data["volume"] = this.volume;
        data["money"] = this.money;
        data["clientDelay"] = this.clientDelay;
        data["deliveryWindow1"] = this.deliveryWindow1;
        data["deliveryWindow2"] = this.deliveryWindow2;
        data["deliveryCommentaries"] = this.deliveryCommentaries;
        data["group"] = this.group;
        return data;
    };
    ReturnCsvQuadminDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ReturnCsvQuadminDto();
        result.init(json);
        return result;
    };
    return ReturnCsvQuadminDto;
}());
export { ReturnCsvQuadminDto };
var UploadImageInputDto = /** @class */ (function () {
    function UploadImageInputDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadImageInputDto.prototype.init = function (_data) {
        if (_data) {
            this.imageBase64 = _data["imageBase64"];
            this.fileName = _data["fileName"];
            this.fileContentType = _data["fileContentType"];
            this.bucket = _data["bucket"];
        }
    };
    UploadImageInputDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadImageInputDto();
        result.init(data);
        return result;
    };
    UploadImageInputDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["imageBase64"] = this.imageBase64;
        data["fileName"] = this.fileName;
        data["fileContentType"] = this.fileContentType;
        data["bucket"] = this.bucket;
        return data;
    };
    UploadImageInputDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UploadImageInputDto();
        result.init(json);
        return result;
    };
    return UploadImageInputDto;
}());
export { UploadImageInputDto };
var SalesOrderNotificationRequest = /** @class */ (function () {
    function SalesOrderNotificationRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SalesOrderNotificationRequest.prototype.init = function (_data) {
        if (_data) {
            this.salesOrderId = _data["salesOrderId"];
        }
    };
    SalesOrderNotificationRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SalesOrderNotificationRequest();
        result.init(data);
        return result;
    };
    SalesOrderNotificationRequest.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["salesOrderId"] = this.salesOrderId;
        return data;
    };
    SalesOrderNotificationRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SalesOrderNotificationRequest();
        result.init(json);
        return result;
    };
    return SalesOrderNotificationRequest;
}());
export { SalesOrderNotificationRequest };
var ShipmentCreateDto = /** @class */ (function () {
    function ShipmentCreateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShipmentCreateDto.prototype.init = function (_data) {
        var e_652, _a;
        if (_data) {
            if (Array.isArray(_data["orderIds"])) {
                this.orderIds = [];
                try {
                    for (var _b = __values(_data["orderIds"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orderIds.push(item);
                    }
                }
                catch (e_652_1) { e_652 = { error: e_652_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_652) throw e_652.error; }
                }
            }
            this.carrierId = _data["carrierId"];
            this.carrierDriverId = _data["carrierDriverId"];
            this.storeCode = _data["storeCode"];
            this.countryCode = _data["countryCode"];
            this.deliveryType = _data["deliveryType"];
            this.id = _data["id"];
        }
    };
    ShipmentCreateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShipmentCreateDto();
        result.init(data);
        return result;
    };
    ShipmentCreateDto.prototype.toJSON = function (data) {
        var e_653, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderIds)) {
            data["orderIds"] = [];
            try {
                for (var _b = __values(this.orderIds), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orderIds"].push(item);
                }
            }
            catch (e_653_1) { e_653 = { error: e_653_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_653) throw e_653.error; }
            }
        }
        data["carrierId"] = this.carrierId;
        data["carrierDriverId"] = this.carrierDriverId;
        data["storeCode"] = this.storeCode;
        data["countryCode"] = this.countryCode;
        data["deliveryType"] = this.deliveryType;
        data["id"] = this.id;
        return data;
    };
    ShipmentCreateDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShipmentCreateDto();
        result.init(json);
        return result;
    };
    return ShipmentCreateDto;
}());
export { ShipmentCreateDto };
var OrderDelivered = /** @class */ (function () {
    function OrderDelivered(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDelivered.prototype.init = function (_data) {
        var e_654, _a;
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [];
                try {
                    for (var _b = __values(_data["proofFiles"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.proofFiles.push(item);
                    }
                }
                catch (e_654_1) { e_654 = { error: e_654_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_654) throw e_654.error; }
                }
            }
            this.proofNote = _data["proofNote"];
        }
    };
    OrderDelivered.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDelivered();
        result.init(data);
        return result;
    };
    OrderDelivered.prototype.toJSON = function (data) {
        var e_655, _a;
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            try {
                for (var _b = __values(this.proofFiles), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["proofFiles"].push(item);
                }
            }
            catch (e_655_1) { e_655 = { error: e_655_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_655) throw e_655.error; }
            }
        }
        data["proofNote"] = this.proofNote;
        return data;
    };
    OrderDelivered.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDelivered();
        result.init(json);
        return result;
    };
    return OrderDelivered;
}());
export { OrderDelivered };
var OrderNotDelivered = /** @class */ (function () {
    function OrderNotDelivered(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderNotDelivered.prototype.init = function (_data) {
        var e_656, _a;
        if (_data) {
            this.orderId = _data["orderId"];
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [];
                try {
                    for (var _b = __values(_data["proofFiles"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.proofFiles.push(item);
                    }
                }
                catch (e_656_1) { e_656 = { error: e_656_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_656) throw e_656.error; }
                }
            }
            this.proofNote = _data["proofNote"];
            this.shipmentIssue = _data["shipmentIssue"];
        }
    };
    OrderNotDelivered.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderNotDelivered();
        result.init(data);
        return result;
    };
    OrderNotDelivered.prototype.toJSON = function (data) {
        var e_657, _a;
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            try {
                for (var _b = __values(this.proofFiles), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["proofFiles"].push(item);
                }
            }
            catch (e_657_1) { e_657 = { error: e_657_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_657) throw e_657.error; }
            }
        }
        data["proofNote"] = this.proofNote;
        data["shipmentIssue"] = this.shipmentIssue;
        return data;
    };
    OrderNotDelivered.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderNotDelivered();
        result.init(json);
        return result;
    };
    return OrderNotDelivered;
}());
export { OrderNotDelivered };
var ShipmentRegisterRequest = /** @class */ (function () {
    function ShipmentRegisterRequest(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShipmentRegisterRequest.prototype.init = function (_data) {
        var e_658, _a, e_659, _b;
        if (_data) {
            this.shipmentId = _data["shipmentId"];
            if (Array.isArray(_data["orderDelivered"])) {
                this.orderDelivered = [];
                try {
                    for (var _c = __values(_data["orderDelivered"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.orderDelivered.push(OrderDelivered.fromJS(item));
                    }
                }
                catch (e_658_1) { e_658 = { error: e_658_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_658) throw e_658.error; }
                }
            }
            if (Array.isArray(_data["ordersNotDelivered"])) {
                this.ordersNotDelivered = [];
                try {
                    for (var _e = __values(_data["ordersNotDelivered"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.ordersNotDelivered.push(OrderNotDelivered.fromJS(item));
                    }
                }
                catch (e_659_1) { e_659 = { error: e_659_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_659) throw e_659.error; }
                }
            }
        }
    };
    ShipmentRegisterRequest.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShipmentRegisterRequest();
        result.init(data);
        return result;
    };
    ShipmentRegisterRequest.prototype.toJSON = function (data) {
        var e_660, _a, e_661, _b;
        data = typeof data === 'object' ? data : {};
        data["shipmentId"] = this.shipmentId;
        if (Array.isArray(this.orderDelivered)) {
            data["orderDelivered"] = [];
            try {
                for (var _c = __values(this.orderDelivered), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["orderDelivered"].push(item.toJSON());
                }
            }
            catch (e_660_1) { e_660 = { error: e_660_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_660) throw e_660.error; }
            }
        }
        if (Array.isArray(this.ordersNotDelivered)) {
            data["ordersNotDelivered"] = [];
            try {
                for (var _e = __values(this.ordersNotDelivered), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["ordersNotDelivered"].push(item.toJSON());
                }
            }
            catch (e_661_1) { e_661 = { error: e_661_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_661) throw e_661.error; }
            }
        }
        return data;
    };
    ShipmentRegisterRequest.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShipmentRegisterRequest();
        result.init(json);
        return result;
    };
    return ShipmentRegisterRequest;
}());
export { ShipmentRegisterRequest };
var ShipmentDto = /** @class */ (function () {
    function ShipmentDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShipmentDto.prototype.init = function (_data) {
        var e_662, _a;
        if (_data) {
            this.shipmentDate = _data["shipmentDate"] ? moment(_data["shipmentDate"].toString()) : undefined;
            this.status = _data["status"];
            this.carrierId = _data["carrierId"];
            this.carrierDriverId = _data["carrierDriverId"];
            this.shipmentTypeGroupName = _data["shipmentTypeGroupName"];
            this.carrierName = _data["carrierName"];
            this.carrierDriverName = _data["carrierDriverName"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [];
                try {
                    for (var _b = __values(_data["orders"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orders.push(ShipmentOrderDto.fromJS(item));
                    }
                }
                catch (e_662_1) { e_662 = { error: e_662_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_662) throw e_662.error; }
                }
            }
            this.ordersQuantity = _data["ordersQuantity"];
            this.storeCode = _data["storeCode"];
            this.shipmentRegisterPartialSavedId = _data["shipmentRegisterPartialSavedId"];
            this.shipmentRegisterRequest = _data["shipmentRegisterRequest"] ? ShipmentRegisterRequest.fromJS(_data["shipmentRegisterRequest"]) : undefined;
            this.id = _data["id"];
        }
    };
    ShipmentDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShipmentDto();
        result.init(data);
        return result;
    };
    ShipmentDto.prototype.toJSON = function (data) {
        var e_663, _a;
        data = typeof data === 'object' ? data : {};
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["status"] = this.status;
        data["carrierId"] = this.carrierId;
        data["carrierDriverId"] = this.carrierDriverId;
        data["shipmentTypeGroupName"] = this.shipmentTypeGroupName;
        data["carrierName"] = this.carrierName;
        data["carrierDriverName"] = this.carrierDriverName;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            try {
                for (var _b = __values(this.orders), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orders"].push(item.toJSON());
                }
            }
            catch (e_663_1) { e_663 = { error: e_663_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_663) throw e_663.error; }
            }
        }
        data["ordersQuantity"] = this.ordersQuantity;
        data["storeCode"] = this.storeCode;
        data["shipmentRegisterPartialSavedId"] = this.shipmentRegisterPartialSavedId;
        data["shipmentRegisterRequest"] = this.shipmentRegisterRequest ? this.shipmentRegisterRequest.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    ShipmentDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShipmentDto();
        result.init(json);
        return result;
    };
    return ShipmentDto;
}());
export { ShipmentDto };
var ShipmentDtoPagedResultDto = /** @class */ (function () {
    function ShipmentDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShipmentDtoPagedResultDto.prototype.init = function (_data) {
        var e_664, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ShipmentDto.fromJS(item));
                    }
                }
                catch (e_664_1) { e_664 = { error: e_664_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_664) throw e_664.error; }
                }
            }
        }
    };
    ShipmentDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShipmentDtoPagedResultDto();
        result.init(data);
        return result;
    };
    ShipmentDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_665, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_665_1) { e_665 = { error: e_665_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_665) throw e_665.error; }
            }
        }
        return data;
    };
    ShipmentDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShipmentDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return ShipmentDtoPagedResultDto;
}());
export { ShipmentDtoPagedResultDto };
var ShippingTypeDtoPagedResultDto = /** @class */ (function () {
    function ShippingTypeDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingTypeDtoPagedResultDto.prototype.init = function (_data) {
        var e_666, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ShippingTypeDto.fromJS(item));
                    }
                }
                catch (e_666_1) { e_666 = { error: e_666_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_666) throw e_666.error; }
                }
            }
        }
    };
    ShippingTypeDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingTypeDtoPagedResultDto();
        result.init(data);
        return result;
    };
    ShippingTypeDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_667, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_667_1) { e_667 = { error: e_667_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_667) throw e_667.error; }
            }
        }
        return data;
    };
    ShippingTypeDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingTypeDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return ShippingTypeDtoPagedResultDto;
}());
export { ShippingTypeDtoPagedResultDto };
var ShippingTypeGroupDto = /** @class */ (function () {
    function ShippingTypeGroupDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingTypeGroupDto.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.icon = _data["icon"];
            this.id = _data["id"];
        }
    };
    ShippingTypeGroupDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingTypeGroupDto();
        result.init(data);
        return result;
    };
    ShippingTypeGroupDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["color"] = this.color;
        data["icon"] = this.icon;
        data["id"] = this.id;
        return data;
    };
    ShippingTypeGroupDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingTypeGroupDto();
        result.init(json);
        return result;
    };
    return ShippingTypeGroupDto;
}());
export { ShippingTypeGroupDto };
var ShippingTypeGroupDtoPagedResultDto = /** @class */ (function () {
    function ShippingTypeGroupDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingTypeGroupDtoPagedResultDto.prototype.init = function (_data) {
        var e_668, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ShippingTypeGroupDto.fromJS(item));
                    }
                }
                catch (e_668_1) { e_668 = { error: e_668_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_668) throw e_668.error; }
                }
            }
        }
    };
    ShippingTypeGroupDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingTypeGroupDtoPagedResultDto();
        result.init(data);
        return result;
    };
    ShippingTypeGroupDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_669, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_669_1) { e_669 = { error: e_669_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_669) throw e_669.error; }
            }
        }
        return data;
    };
    ShippingTypeGroupDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingTypeGroupDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return ShippingTypeGroupDtoPagedResultDto;
}());
export { ShippingTypeGroupDtoPagedResultDto };
var ShippingTypeMappingDto = /** @class */ (function () {
    function ShippingTypeMappingDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingTypeMappingDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.shippingTypeSourceCode = _data["shippingTypeSourceCode"];
            this.shippingTypeCode = _data["shippingTypeCode"];
            this.deliveryTypeId = _data["deliveryTypeId"];
            this.deliveryType = _data["deliveryType"];
            this.id = _data["id"];
        }
    };
    ShippingTypeMappingDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingTypeMappingDto();
        result.init(data);
        return result;
    };
    ShippingTypeMappingDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["shippingTypeSourceCode"] = this.shippingTypeSourceCode;
        data["shippingTypeCode"] = this.shippingTypeCode;
        data["deliveryTypeId"] = this.deliveryTypeId;
        data["deliveryType"] = this.deliveryType;
        data["id"] = this.id;
        return data;
    };
    ShippingTypeMappingDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingTypeMappingDto();
        result.init(json);
        return result;
    };
    return ShippingTypeMappingDto;
}());
export { ShippingTypeMappingDto };
var ShippingTypeMappingDtoPagedResultDto = /** @class */ (function () {
    function ShippingTypeMappingDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingTypeMappingDtoPagedResultDto.prototype.init = function (_data) {
        var e_670, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ShippingTypeMappingDto.fromJS(item));
                    }
                }
                catch (e_670_1) { e_670 = { error: e_670_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_670) throw e_670.error; }
                }
            }
        }
    };
    ShippingTypeMappingDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingTypeMappingDtoPagedResultDto();
        result.init(data);
        return result;
    };
    ShippingTypeMappingDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_671, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_671_1) { e_671 = { error: e_671_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_671) throw e_671.error; }
            }
        }
        return data;
    };
    ShippingTypeMappingDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingTypeMappingDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return ShippingTypeMappingDtoPagedResultDto;
}());
export { ShippingTypeMappingDtoPagedResultDto };
var SourceData = /** @class */ (function () {
    function SourceData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SourceData.prototype.init = function (_data) {
        if (_data) {
            this.code = _data["code"];
            this.source = _data["source"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    SourceData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SourceData();
        result.init(data);
        return result;
    };
    SourceData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["source"] = this.source;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    SourceData.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SourceData();
        result.init(json);
        return result;
    };
    return SourceData;
}());
export { SourceData };
var Customer = /** @class */ (function () {
    function Customer(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Customer.prototype.init = function (_data) {
        var e_672, _a;
        if (_data) {
            if (Array.isArray(_data["sourceCode"])) {
                this.sourceCode = [];
                try {
                    for (var _b = __values(_data["sourceCode"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.sourceCode.push(SourceData.fromJS(item));
                    }
                }
                catch (e_672_1) { e_672 = { error: e_672_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_672) throw e_672.error; }
                }
            }
            this.code = _data["code"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.phoneNumber = _data["phoneNumber"];
            this.phoneNumberAlternative = _data["phoneNumberAlternative"];
            this.email = _data["email"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Customer.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Customer();
        result.init(data);
        return result;
    };
    Customer.prototype.toJSON = function (data) {
        var e_673, _a;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.sourceCode)) {
            data["sourceCode"] = [];
            try {
                for (var _b = __values(this.sourceCode), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["sourceCode"].push(item.toJSON());
                }
            }
            catch (e_673_1) { e_673 = { error: e_673_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_673) throw e_673.error; }
            }
        }
        data["code"] = this.code;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["phoneNumber"] = this.phoneNumber;
        data["phoneNumberAlternative"] = this.phoneNumberAlternative;
        data["email"] = this.email;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Customer.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Customer();
        result.init(json);
        return result;
    };
    return Customer;
}());
export { Customer };
export var DocumentType;
(function (DocumentType) {
    DocumentType[DocumentType["_0"] = 0] = "_0";
    DocumentType[DocumentType["_1"] = 1] = "_1";
    DocumentType[DocumentType["_2"] = 2] = "_2";
    DocumentType[DocumentType["_3"] = 3] = "_3";
    DocumentType[DocumentType["_4"] = 4] = "_4";
    DocumentType[DocumentType["_5"] = 5] = "_5";
})(DocumentType || (DocumentType = {}));
var OrderDocument = /** @class */ (function () {
    function OrderDocument(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderDocument.prototype.init = function (_data) {
        if (_data) {
            this.number = _data["number"];
            this.documentCreationTime = _data["documentCreationTime"] ? moment(_data["documentCreationTime"].toString()) : undefined;
            this.type = _data["type"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderDocument.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderDocument();
        result.init(data);
        return result;
    };
    OrderDocument.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["number"] = this.number;
        data["documentCreationTime"] = this.documentCreationTime ? this.documentCreationTime.toISOString() : undefined;
        data["type"] = this.type;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderDocument.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderDocument();
        result.init(json);
        return result;
    };
    return OrderDocument;
}());
export { OrderDocument };
var IEventData = /** @class */ (function () {
    function IEventData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    IEventData.prototype.init = function (_data) {
        if (_data) {
            this.eventTime = _data["eventTime"] ? moment(_data["eventTime"].toString()) : undefined;
            this.eventSource = _data["eventSource"];
        }
    };
    IEventData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new IEventData();
        result.init(data);
        return result;
    };
    IEventData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : undefined;
        data["eventSource"] = this.eventSource;
        return data;
    };
    IEventData.prototype.clone = function () {
        var json = this.toJSON();
        var result = new IEventData();
        result.init(json);
        return result;
    };
    return IEventData;
}());
export { IEventData };
var CustomValue = /** @class */ (function () {
    function CustomValue(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CustomValue.prototype.init = function (_data) {
        var e_674, _a;
        if (_data) {
            this.reference = _data["reference"];
            this.value = _data["value"];
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["deliverySchedules"])) {
                this.deliverySchedules = [];
                try {
                    for (var _b = __values(_data["deliverySchedules"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.deliverySchedules.push(DeliverySchedule.fromJS(item));
                    }
                }
                catch (e_674_1) { e_674 = { error: e_674_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_674) throw e_674.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    CustomValue.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CustomValue();
        result.init(data);
        return result;
    };
    CustomValue.prototype.toJSON = function (data) {
        var e_675, _a;
        data = typeof data === 'object' ? data : {};
        data["reference"] = this.reference;
        data["value"] = this.value;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.deliverySchedules)) {
            data["deliverySchedules"] = [];
            try {
                for (var _b = __values(this.deliverySchedules), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["deliverySchedules"].push(item.toJSON());
                }
            }
            catch (e_675_1) { e_675 = { error: e_675_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_675) throw e_675.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    CustomValue.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CustomValue();
        result.init(json);
        return result;
    };
    return CustomValue;
}());
export { CustomValue };
var DeliverySchedule = /** @class */ (function () {
    function DeliverySchedule(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliverySchedule.prototype.init = function (_data) {
        var e_676, _a;
        if (_data) {
            this.label = _data["label"];
            this.hourFrom = _data["hourFrom"];
            this.offset = _data["offset"];
            this.customValueId = _data["customValueId"];
            this.customValue = _data["customValue"] ? CustomValue.fromJS(_data["customValue"]) : undefined;
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["deliveryScheduleShippingTypes"])) {
                this.deliveryScheduleShippingTypes = [];
                try {
                    for (var _b = __values(_data["deliveryScheduleShippingTypes"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.deliveryScheduleShippingTypes.push(DeliveryScheduleShippingType.fromJS(item));
                    }
                }
                catch (e_676_1) { e_676 = { error: e_676_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_676) throw e_676.error; }
                }
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    DeliverySchedule.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliverySchedule();
        result.init(data);
        return result;
    };
    DeliverySchedule.prototype.toJSON = function (data) {
        var e_677, _a;
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["hourFrom"] = this.hourFrom;
        data["offset"] = this.offset;
        data["customValueId"] = this.customValueId;
        data["customValue"] = this.customValue ? this.customValue.toJSON() : undefined;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.deliveryScheduleShippingTypes)) {
            data["deliveryScheduleShippingTypes"] = [];
            try {
                for (var _b = __values(this.deliveryScheduleShippingTypes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["deliveryScheduleShippingTypes"].push(item.toJSON());
                }
            }
            catch (e_677_1) { e_677 = { error: e_677_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_677) throw e_677.error; }
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    DeliverySchedule.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DeliverySchedule();
        result.init(json);
        return result;
    };
    return DeliverySchedule;
}());
export { DeliverySchedule };
var DeliveryScheduleShippingType = /** @class */ (function () {
    function DeliveryScheduleShippingType(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryScheduleShippingType.prototype.init = function (_data) {
        if (_data) {
            this.deliveryScheduleId = _data["deliveryScheduleId"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.deliverySchedule = _data["deliverySchedule"] ? DeliverySchedule.fromJS(_data["deliverySchedule"]) : undefined;
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : undefined;
            this.id = _data["id"];
        }
    };
    DeliveryScheduleShippingType.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryScheduleShippingType();
        result.init(data);
        return result;
    };
    DeliveryScheduleShippingType.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["deliveryScheduleId"] = this.deliveryScheduleId;
        data["shippingTypeId"] = this.shippingTypeId;
        data["deliverySchedule"] = this.deliverySchedule ? this.deliverySchedule.toJSON() : undefined;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    DeliveryScheduleShippingType.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DeliveryScheduleShippingType();
        result.init(json);
        return result;
    };
    return DeliveryScheduleShippingType;
}());
export { DeliveryScheduleShippingType };
var ShippingType = /** @class */ (function () {
    function ShippingType(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingType.prototype.init = function (_data) {
        var e_678, _a;
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroup = _data["shippingTypeGroup"] ? ShippingTypeGroup.fromJS(_data["shippingTypeGroup"]) : undefined;
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["deliveryScheduleShippingTypes"])) {
                this.deliveryScheduleShippingTypes = [];
                try {
                    for (var _b = __values(_data["deliveryScheduleShippingTypes"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.deliveryScheduleShippingTypes.push(DeliveryScheduleShippingType.fromJS(item));
                    }
                }
                catch (e_678_1) { e_678 = { error: e_678_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_678) throw e_678.error; }
                }
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    ShippingType.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingType();
        result.init(data);
        return result;
    };
    ShippingType.prototype.toJSON = function (data) {
        var e_679, _a;
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroup"] = this.shippingTypeGroup ? this.shippingTypeGroup.toJSON() : undefined;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.deliveryScheduleShippingTypes)) {
            data["deliveryScheduleShippingTypes"] = [];
            try {
                for (var _b = __values(this.deliveryScheduleShippingTypes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["deliveryScheduleShippingTypes"].push(item.toJSON());
                }
            }
            catch (e_679_1) { e_679 = { error: e_679_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_679) throw e_679.error; }
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    ShippingType.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingType();
        result.init(json);
        return result;
    };
    return ShippingType;
}());
export { ShippingType };
var ShippingTypeGroup = /** @class */ (function () {
    function ShippingTypeGroup(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingTypeGroup.prototype.init = function (_data) {
        var e_680, _a;
        if (_data) {
            this.code = _data["code"];
            this.name = _data["name"];
            this.color = _data["color"];
            this.icon = _data["icon"];
            if (Array.isArray(_data["shippingTypes"])) {
                this.shippingTypes = [];
                try {
                    for (var _b = __values(_data["shippingTypes"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.shippingTypes.push(ShippingType.fromJS(item));
                    }
                }
                catch (e_680_1) { e_680 = { error: e_680_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_680) throw e_680.error; }
                }
            }
            this.countryCode = _data["countryCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    ShippingTypeGroup.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingTypeGroup();
        result.init(data);
        return result;
    };
    ShippingTypeGroup.prototype.toJSON = function (data) {
        var e_681, _a;
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["name"] = this.name;
        data["color"] = this.color;
        data["icon"] = this.icon;
        if (Array.isArray(this.shippingTypes)) {
            data["shippingTypes"] = [];
            try {
                for (var _b = __values(this.shippingTypes), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["shippingTypes"].push(item.toJSON());
                }
            }
            catch (e_681_1) { e_681 = { error: e_681_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_681) throw e_681.error; }
            }
        }
        data["countryCode"] = this.countryCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    ShippingTypeGroup.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingTypeGroup();
        result.init(json);
        return result;
    };
    return ShippingTypeGroup;
}());
export { ShippingTypeGroup };
var StoreCarrier = /** @class */ (function () {
    function StoreCarrier(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StoreCarrier.prototype.init = function (_data) {
        if (_data) {
            this.carrierId = _data["carrierId"];
            this.storeCode = _data["storeCode"];
            this.carrier = _data["carrier"] ? Carrier.fromJS(_data["carrier"]) : undefined;
            this.id = _data["id"];
        }
    };
    StoreCarrier.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StoreCarrier();
        result.init(data);
        return result;
    };
    StoreCarrier.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["carrierId"] = this.carrierId;
        data["storeCode"] = this.storeCode;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    StoreCarrier.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StoreCarrier();
        result.init(json);
        return result;
    };
    return StoreCarrier;
}());
export { StoreCarrier };
var Carrier = /** @class */ (function () {
    function Carrier(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Carrier.prototype.init = function (_data) {
        var e_682, _a, e_683, _b;
        if (_data) {
            if (Array.isArray(_data["domainEvents"])) {
                this.domainEvents = [];
                try {
                    for (var _c = __values(_data["domainEvents"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.domainEvents.push(IEventData.fromJS(item));
                    }
                }
                catch (e_682_1) { e_682 = { error: e_682_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_682) throw e_682.error; }
                }
            }
            this.shippingTypeGroupId = _data["shippingTypeGroupId"];
            this.shippingTypeGroup = _data["shippingTypeGroup"] ? ShippingTypeGroup.fromJS(_data["shippingTypeGroup"]) : undefined;
            this.countryCode = _data["countryCode"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [];
                try {
                    for (var _e = __values(_data["stores"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.stores.push(StoreCarrier.fromJS(item));
                    }
                }
                catch (e_683_1) { e_683 = { error: e_683_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_683) throw e_683.error; }
                }
            }
            this.apiToken = _data["apiToken"];
            this.carrierGroup = _data["carrierGroup"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Carrier.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Carrier();
        result.init(data);
        return result;
    };
    Carrier.prototype.toJSON = function (data) {
        var e_684, _a, e_685, _b;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.domainEvents)) {
            data["domainEvents"] = [];
            try {
                for (var _c = __values(this.domainEvents), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["domainEvents"].push(item.toJSON());
                }
            }
            catch (e_684_1) { e_684 = { error: e_684_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_684) throw e_684.error; }
            }
        }
        data["shippingTypeGroupId"] = this.shippingTypeGroupId;
        data["shippingTypeGroup"] = this.shippingTypeGroup ? this.shippingTypeGroup.toJSON() : undefined;
        data["countryCode"] = this.countryCode;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            try {
                for (var _e = __values(this.stores), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["stores"].push(item.toJSON());
                }
            }
            catch (e_685_1) { e_685 = { error: e_685_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_685) throw e_685.error; }
            }
        }
        data["apiToken"] = this.apiToken;
        data["carrierGroup"] = this.carrierGroup;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Carrier.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Carrier();
        result.init(json);
        return result;
    };
    return Carrier;
}());
export { Carrier };
var SourceOrderItem = /** @class */ (function () {
    function SourceOrderItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SourceOrderItem.prototype.init = function (_data) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.sourceProductCode = _data["sourceProductCode"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.length = _data["length"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.isPromotion = _data["isPromotion"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? SourceOrderItem.fromJS(_data["promotion"]) : undefined;
            this.barCode = _data["barCode"];
            this.notInventory = _data["notInventory"];
            this.id = _data["id"];
        }
    };
    SourceOrderItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SourceOrderItem();
        result.init(data);
        return result;
    };
    SourceOrderItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["sourceProductCode"] = this.sourceProductCode;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["length"] = this.length;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["width"] = this.width;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["isPromotion"] = this.isPromotion;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : undefined;
        data["barCode"] = this.barCode;
        data["notInventory"] = this.notInventory;
        data["id"] = this.id;
        return data;
    };
    SourceOrderItem.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SourceOrderItem();
        result.init(json);
        return result;
    };
    return SourceOrderItem;
}());
export { SourceOrderItem };
export var StockStatus;
(function (StockStatus) {
    StockStatus[StockStatus["_0"] = 0] = "_0";
    StockStatus[StockStatus["_1"] = 1] = "_1";
    StockStatus[StockStatus["_2"] = 2] = "_2";
})(StockStatus || (StockStatus = {}));
var OrderItem = /** @class */ (function () {
    function OrderItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderItem.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.deliveryIssue = _data["deliveryIssue"];
            this.quantity = _data["quantity"];
            this.quantityDelivered = _data["quantityDelivered"];
            this.quantityInConflict = _data["quantityInConflict"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.cancelled = _data["cancelled"];
            this.length = _data["length"];
            this.weight = _data["weight"];
            this.height = _data["height"];
            this.width = _data["width"];
            this.sourceOrderItemId = _data["sourceOrderItemId"];
            this.selfPurchaseFrequency = _data["selfPurchaseFrequency"];
            this.isExclusiveOnline = _data["isExclusiveOnline"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.sourceOrderItem = _data["sourceOrderItem"] ? SourceOrderItem.fromJS(_data["sourceOrderItem"]) : undefined;
            this.isPromotion = _data["isPromotion"];
            this.promotionId = _data["promotionId"];
            this.promotion = _data["promotion"] ? OrderItem.fromJS(_data["promotion"]) : undefined;
            this.barCode = _data["barCode"];
            this.supplierCatalogNumber = _data["supplierCatalogNumber"];
            this.stock = _data["stock"];
            this.stockStatus = _data["stockStatus"];
            this.logisticAuditStockInWarehouse = _data["logisticAuditStockInWarehouse"];
            this.notInventory = _data["notInventory"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderItem();
        result.init(data);
        return result;
    };
    OrderItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["deliveryIssue"] = this.deliveryIssue;
        data["quantity"] = this.quantity;
        data["quantityDelivered"] = this.quantityDelivered;
        data["quantityInConflict"] = this.quantityInConflict;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["cancelled"] = this.cancelled;
        data["length"] = this.length;
        data["weight"] = this.weight;
        data["height"] = this.height;
        data["width"] = this.width;
        data["sourceOrderItemId"] = this.sourceOrderItemId;
        data["selfPurchaseFrequency"] = this.selfPurchaseFrequency;
        data["isExclusiveOnline"] = this.isExclusiveOnline;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["sourceOrderItem"] = this.sourceOrderItem ? this.sourceOrderItem.toJSON() : undefined;
        data["isPromotion"] = this.isPromotion;
        data["promotionId"] = this.promotionId;
        data["promotion"] = this.promotion ? this.promotion.toJSON() : undefined;
        data["barCode"] = this.barCode;
        data["supplierCatalogNumber"] = this.supplierCatalogNumber;
        data["stock"] = this.stock;
        data["stockStatus"] = this.stockStatus;
        data["logisticAuditStockInWarehouse"] = this.logisticAuditStockInWarehouse;
        data["notInventory"] = this.notInventory;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderItem.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderItem();
        result.init(json);
        return result;
    };
    return OrderItem;
}());
export { OrderItem };
var Payment = /** @class */ (function () {
    function Payment(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Payment.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.paymentSystemName = _data["paymentSystemName"];
            this.installments = _data["installments"];
            this.value = _data["value"];
            this.binCode = _data["binCode"];
            this.status = _data["status"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Payment.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Payment();
        result.init(data);
        return result;
    };
    Payment.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["paymentSystemName"] = this.paymentSystemName;
        data["installments"] = this.installments;
        data["value"] = this.value;
        data["binCode"] = this.binCode;
        data["status"] = this.status;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Payment.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Payment();
        result.init(json);
        return result;
    };
    return Payment;
}());
export { Payment };
export var DeliveryType;
(function (DeliveryType) {
    DeliveryType[DeliveryType["_0"] = 0] = "_0";
    DeliveryType[DeliveryType["_1"] = 1] = "_1";
    DeliveryType[DeliveryType["_2"] = 2] = "_2";
})(DeliveryType || (DeliveryType = {}));
var DeliveryData = /** @class */ (function () {
    function DeliveryData(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DeliveryData.prototype.init = function (_data) {
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceCode = _data["sourceCode"];
            this.sourceOrderCode = _data["sourceOrderCode"];
            this.sourceStatus = _data["sourceStatus"];
            this.shippingCost = _data["shippingCost"];
            this.estimatedDeliveryDateFrom = _data["estimatedDeliveryDateFrom"] ? moment(_data["estimatedDeliveryDateFrom"].toString()) : undefined;
            this.estimatedDeliveryDateTo = _data["estimatedDeliveryDateTo"] ? moment(_data["estimatedDeliveryDateTo"].toString()) : undefined;
            this.deliveryType = _data["deliveryType"];
            this.pointOfDelivery = _data["pointOfDelivery"];
            this.addressTypeCode = _data["addressTypeCode"];
            this.street = _data["street"];
            this.number = _data["number"];
            this.complement = _data["complement"];
            this.postalCode = _data["postalCode"];
            this.neighborhood = _data["neighborhood"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.country = _data["country"];
            this.geoLat = _data["geoLat"];
            this.geoLong = _data["geoLong"];
            this.trackingMethod = _data["trackingMethod"];
            this.trackingNumber = _data["trackingNumber"];
            this.deliveryCompany = _data["deliveryCompany"];
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : undefined;
            this.shippingTypeSourceCode = _data["shippingTypeSourceCode"];
            this.receiverName = _data["receiverName"];
            this.carrierEsimatedDeliveryDate = _data["carrierEsimatedDeliveryDate"] ? moment(_data["carrierEsimatedDeliveryDate"].toString()) : undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    DeliveryData.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DeliveryData();
        result.init(data);
        return result;
    };
    DeliveryData.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceCode"] = this.sourceCode;
        data["sourceOrderCode"] = this.sourceOrderCode;
        data["sourceStatus"] = this.sourceStatus;
        data["shippingCost"] = this.shippingCost;
        data["estimatedDeliveryDateFrom"] = this.estimatedDeliveryDateFrom ? this.estimatedDeliveryDateFrom.toISOString() : undefined;
        data["estimatedDeliveryDateTo"] = this.estimatedDeliveryDateTo ? this.estimatedDeliveryDateTo.toISOString() : undefined;
        data["deliveryType"] = this.deliveryType;
        data["pointOfDelivery"] = this.pointOfDelivery;
        data["addressTypeCode"] = this.addressTypeCode;
        data["street"] = this.street;
        data["number"] = this.number;
        data["complement"] = this.complement;
        data["postalCode"] = this.postalCode;
        data["neighborhood"] = this.neighborhood;
        data["city"] = this.city;
        data["state"] = this.state;
        data["country"] = this.country;
        data["geoLat"] = this.geoLat;
        data["geoLong"] = this.geoLong;
        data["trackingMethod"] = this.trackingMethod;
        data["trackingNumber"] = this.trackingNumber;
        data["deliveryCompany"] = this.deliveryCompany;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : undefined;
        data["shippingTypeSourceCode"] = this.shippingTypeSourceCode;
        data["receiverName"] = this.receiverName;
        data["carrierEsimatedDeliveryDate"] = this.carrierEsimatedDeliveryDate ? this.carrierEsimatedDeliveryDate.toISOString() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    DeliveryData.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DeliveryData();
        result.init(json);
        return result;
    };
    return DeliveryData;
}());
export { DeliveryData };
var OrderNote = /** @class */ (function () {
    function OrderNote(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderNote.prototype.init = function (_data) {
        if (_data) {
            this.readed = _data["readed"];
            this.notify = _data["notify"];
            this.description = _data["description"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.creatorName = _data["creatorName"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderNote.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderNote();
        result.init(data);
        return result;
    };
    OrderNote.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["readed"] = this.readed;
        data["notify"] = this.notify;
        data["description"] = this.description;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["creatorName"] = this.creatorName;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderNote.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderNote();
        result.init(json);
        return result;
    };
    return OrderNote;
}());
export { OrderNote };
var AssignedToStore = /** @class */ (function () {
    function AssignedToStore(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    AssignedToStore.prototype.init = function (_data) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    AssignedToStore.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new AssignedToStore();
        result.init(data);
        return result;
    };
    AssignedToStore.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    AssignedToStore.prototype.clone = function () {
        var json = this.toJSON();
        var result = new AssignedToStore();
        result.init(json);
        return result;
    };
    return AssignedToStore;
}());
export { AssignedToStore };
export var OverallStatusValue;
(function (OverallStatusValue) {
    OverallStatusValue[OverallStatusValue["_0"] = 0] = "_0";
    OverallStatusValue[OverallStatusValue["_1"] = 1] = "_1";
    OverallStatusValue[OverallStatusValue["_2"] = 2] = "_2";
})(OverallStatusValue || (OverallStatusValue = {}));
var OverallStatus = /** @class */ (function () {
    function OverallStatus(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OverallStatus.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OverallStatus.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OverallStatus();
        result.init(data);
        return result;
    };
    OverallStatus.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OverallStatus.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OverallStatus();
        result.init(json);
        return result;
    };
    return OverallStatus;
}());
export { OverallStatus };
export var CommercialStatusValue;
(function (CommercialStatusValue) {
    CommercialStatusValue[CommercialStatusValue["_0"] = 0] = "_0";
    CommercialStatusValue[CommercialStatusValue["_1"] = 1] = "_1";
    CommercialStatusValue[CommercialStatusValue["_2"] = 2] = "_2";
    CommercialStatusValue[CommercialStatusValue["_3"] = 3] = "_3";
    CommercialStatusValue[CommercialStatusValue["_4"] = 4] = "_4";
    CommercialStatusValue[CommercialStatusValue["_5"] = 5] = "_5";
    CommercialStatusValue[CommercialStatusValue["_6"] = 6] = "_6";
    CommercialStatusValue[CommercialStatusValue["_7"] = 7] = "_7";
})(CommercialStatusValue || (CommercialStatusValue = {}));
var CommercialStatus = /** @class */ (function () {
    function CommercialStatus(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CommercialStatus.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    CommercialStatus.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CommercialStatus();
        result.init(data);
        return result;
    };
    CommercialStatus.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    CommercialStatus.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CommercialStatus();
        result.init(json);
        return result;
    };
    return CommercialStatus;
}());
export { CommercialStatus };
export var FinancialStatusValue;
(function (FinancialStatusValue) {
    FinancialStatusValue[FinancialStatusValue["_0"] = 0] = "_0";
    FinancialStatusValue[FinancialStatusValue["_1"] = 1] = "_1";
    FinancialStatusValue[FinancialStatusValue["_2"] = 2] = "_2";
    FinancialStatusValue[FinancialStatusValue["_3"] = 3] = "_3";
    FinancialStatusValue[FinancialStatusValue["_4"] = 4] = "_4";
    FinancialStatusValue[FinancialStatusValue["_5"] = 5] = "_5";
    FinancialStatusValue[FinancialStatusValue["_6"] = 6] = "_6";
})(FinancialStatusValue || (FinancialStatusValue = {}));
var FinancialStatus = /** @class */ (function () {
    function FinancialStatus(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    FinancialStatus.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    FinancialStatus.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new FinancialStatus();
        result.init(data);
        return result;
    };
    FinancialStatus.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    FinancialStatus.prototype.clone = function () {
        var json = this.toJSON();
        var result = new FinancialStatus();
        result.init(json);
        return result;
    };
    return FinancialStatus;
}());
export { FinancialStatus };
export var LogisticStatusValue;
(function (LogisticStatusValue) {
    LogisticStatusValue[LogisticStatusValue["_0"] = 0] = "_0";
    LogisticStatusValue[LogisticStatusValue["_1"] = 1] = "_1";
    LogisticStatusValue[LogisticStatusValue["_2"] = 2] = "_2";
    LogisticStatusValue[LogisticStatusValue["_3"] = 3] = "_3";
    LogisticStatusValue[LogisticStatusValue["_4"] = 4] = "_4";
    LogisticStatusValue[LogisticStatusValue["_5"] = 5] = "_5";
    LogisticStatusValue[LogisticStatusValue["_6"] = 6] = "_6";
    LogisticStatusValue[LogisticStatusValue["_7"] = 7] = "_7";
    LogisticStatusValue[LogisticStatusValue["_8"] = 8] = "_8";
    LogisticStatusValue[LogisticStatusValue["_9"] = 9] = "_9";
    LogisticStatusValue[LogisticStatusValue["_10"] = 10] = "_10";
    LogisticStatusValue[LogisticStatusValue["_11"] = 11] = "_11";
    LogisticStatusValue[LogisticStatusValue["_12"] = 12] = "_12";
    LogisticStatusValue[LogisticStatusValue["_13"] = 13] = "_13";
    LogisticStatusValue[LogisticStatusValue["_14"] = 14] = "_14";
    LogisticStatusValue[LogisticStatusValue["_15"] = 15] = "_15";
    LogisticStatusValue[LogisticStatusValue["_16"] = 16] = "_16";
    LogisticStatusValue[LogisticStatusValue["_17"] = 17] = "_17";
    LogisticStatusValue[LogisticStatusValue["_18"] = 18] = "_18";
})(LogisticStatusValue || (LogisticStatusValue = {}));
var LogisticStatus = /** @class */ (function () {
    function LogisticStatus(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogisticStatus.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    LogisticStatus.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogisticStatus();
        result.init(data);
        return result;
    };
    LogisticStatus.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    LogisticStatus.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LogisticStatus();
        result.init(json);
        return result;
    };
    return LogisticStatus;
}());
export { LogisticStatus };
export var LogisticAuditStatusValue;
(function (LogisticAuditStatusValue) {
    LogisticAuditStatusValue[LogisticAuditStatusValue["_0"] = 0] = "_0";
    LogisticAuditStatusValue[LogisticAuditStatusValue["_1"] = 1] = "_1";
    LogisticAuditStatusValue[LogisticAuditStatusValue["_2"] = 2] = "_2";
    LogisticAuditStatusValue[LogisticAuditStatusValue["_3"] = 3] = "_3";
    LogisticAuditStatusValue[LogisticAuditStatusValue["_4"] = 4] = "_4";
})(LogisticAuditStatusValue || (LogisticAuditStatusValue = {}));
var LogisticAuditStatus = /** @class */ (function () {
    function LogisticAuditStatus(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    LogisticAuditStatus.prototype.init = function (_data) {
        if (_data) {
            this.value = _data["value"];
            this.reason = _data["reason"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    LogisticAuditStatus.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new LogisticAuditStatus();
        result.init(data);
        return result;
    };
    LogisticAuditStatus.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["reason"] = this.reason;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    LogisticAuditStatus.prototype.clone = function () {
        var json = this.toJSON();
        var result = new LogisticAuditStatus();
        result.init(json);
        return result;
    };
    return LogisticAuditStatus;
}());
export { LogisticAuditStatus };
var EventLog = /** @class */ (function () {
    function EventLog(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    EventLog.prototype.init = function (_data) {
        if (_data) {
            this.creatorUserId = _data["creatorUserId"];
            this.creatorName = _data["creatorName"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.description = _data["description"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.id = _data["id"];
        }
    };
    EventLog.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new EventLog();
        result.init(data);
        return result;
    };
    EventLog.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["creatorUserId"] = this.creatorUserId;
        data["creatorName"] = this.creatorName;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["description"] = this.description;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    EventLog.prototype.clone = function () {
        var json = this.toJSON();
        var result = new EventLog();
        result.init(json);
        return result;
    };
    return EventLog;
}());
export { EventLog };
export var PreparationStatus;
(function (PreparationStatus) {
    PreparationStatus[PreparationStatus["_0"] = 0] = "_0";
    PreparationStatus[PreparationStatus["_1"] = 1] = "_1";
    PreparationStatus[PreparationStatus["_2"] = 2] = "_2";
})(PreparationStatus || (PreparationStatus = {}));
var Package = /** @class */ (function () {
    function Package(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Package.prototype.init = function (_data) {
        var e_686, _a;
        if (_data) {
            this.code = _data["code"];
            this.preparationId = _data["preparationId"];
            this.preparation = _data["preparation"] ? Preparation.fromJS(_data["preparation"]) : undefined;
            if (Array.isArray(_data["preparedItems"])) {
                this.preparedItems = [];
                try {
                    for (var _b = __values(_data["preparedItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.preparedItems.push(PreparedItem.fromJS(item));
                    }
                }
                catch (e_686_1) { e_686 = { error: e_686_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_686) throw e_686.error; }
                }
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Package.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Package();
        result.init(data);
        return result;
    };
    Package.prototype.toJSON = function (data) {
        var e_687, _a;
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["preparationId"] = this.preparationId;
        data["preparation"] = this.preparation ? this.preparation.toJSON() : undefined;
        if (Array.isArray(this.preparedItems)) {
            data["preparedItems"] = [];
            try {
                for (var _b = __values(this.preparedItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["preparedItems"].push(item.toJSON());
                }
            }
            catch (e_687_1) { e_687 = { error: e_687_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_687) throw e_687.error; }
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Package.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Package();
        result.init(json);
        return result;
    };
    return Package;
}());
export { Package };
var PreparedItem = /** @class */ (function () {
    function PreparedItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PreparedItem.prototype.init = function (_data) {
        if (_data) {
            this.discount = _data["discount"];
            this.grossAmount = _data["grossAmount"];
            this.imageUrl = _data["imageUrl"];
            this.netAmount = _data["netAmount"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.orderItemId = _data["orderItemId"];
            this.orderItem = _data["orderItem"] ? OrderItem.fromJS(_data["orderItem"]) : undefined;
            this.quantity = _data["quantity"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.taxes = _data["taxes"];
            this.packageId = _data["packageId"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined;
            this.preparationId = _data["preparationId"];
            this.preparation = _data["preparation"] ? Preparation.fromJS(_data["preparation"]) : undefined;
            this.barCode = _data["barCode"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    PreparedItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PreparedItem();
        result.init(data);
        return result;
    };
    PreparedItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["discount"] = this.discount;
        data["grossAmount"] = this.grossAmount;
        data["imageUrl"] = this.imageUrl;
        data["netAmount"] = this.netAmount;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["orderItemId"] = this.orderItemId;
        data["orderItem"] = this.orderItem ? this.orderItem.toJSON() : undefined;
        data["quantity"] = this.quantity;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["taxes"] = this.taxes;
        data["packageId"] = this.packageId;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["preparationId"] = this.preparationId;
        data["preparation"] = this.preparation ? this.preparation.toJSON() : undefined;
        data["barCode"] = this.barCode;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    PreparedItem.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PreparedItem();
        result.init(json);
        return result;
    };
    return PreparedItem;
}());
export { PreparedItem };
var Preparation = /** @class */ (function () {
    function Preparation(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Preparation.prototype.init = function (_data) {
        var e_688, _a, e_689, _b;
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.countryCode = _data["countryCode"];
            this.status = _data["status"];
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            if (Array.isArray(_data["preparedItems"])) {
                this.preparedItems = [];
                try {
                    for (var _c = __values(_data["preparedItems"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.preparedItems.push(PreparedItem.fromJS(item));
                    }
                }
                catch (e_688_1) { e_688 = { error: e_688_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_688) throw e_688.error; }
                }
            }
            if (Array.isArray(_data["packages"])) {
                this.packages = [];
                try {
                    for (var _e = __values(_data["packages"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.packages.push(Package.fromJS(item));
                    }
                }
                catch (e_689_1) { e_689 = { error: e_689_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_689) throw e_689.error; }
                }
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Preparation.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Preparation();
        result.init(data);
        return result;
    };
    Preparation.prototype.toJSON = function (data) {
        var e_690, _a, e_691, _b;
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["countryCode"] = this.countryCode;
        data["status"] = this.status;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        if (Array.isArray(this.preparedItems)) {
            data["preparedItems"] = [];
            try {
                for (var _c = __values(this.preparedItems), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["preparedItems"].push(item.toJSON());
                }
            }
            catch (e_690_1) { e_690 = { error: e_690_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_690) throw e_690.error; }
            }
        }
        if (Array.isArray(this.packages)) {
            data["packages"] = [];
            try {
                for (var _e = __values(this.packages), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["packages"].push(item.toJSON());
                }
            }
            catch (e_691_1) { e_691 = { error: e_691_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_691) throw e_691.error; }
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Preparation.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Preparation();
        result.init(json);
        return result;
    };
    return Preparation;
}());
export { Preparation };
var OrderBillingInfo = /** @class */ (function () {
    function OrderBillingInfo(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderBillingInfo.prototype.init = function (_data) {
        if (_data) {
            this.documentType = _data["documentType"];
            this.documentNumber = _data["documentNumber"];
            this.taxPayerType = _data["taxPayerType"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.orderId = _data["orderId"];
            this.billedTo = _data["billedTo"];
            this.id = _data["id"];
        }
    };
    OrderBillingInfo.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderBillingInfo();
        result.init(data);
        return result;
    };
    OrderBillingInfo.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["documentType"] = this.documentType;
        data["documentNumber"] = this.documentNumber;
        data["taxPayerType"] = this.taxPayerType;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["orderId"] = this.orderId;
        data["billedTo"] = this.billedTo;
        data["id"] = this.id;
        return data;
    };
    OrderBillingInfo.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderBillingInfo();
        result.init(json);
        return result;
    };
    return OrderBillingInfo;
}());
export { OrderBillingInfo };
export var PickingGroupStatusValue;
(function (PickingGroupStatusValue) {
    PickingGroupStatusValue[PickingGroupStatusValue["_0"] = 0] = "_0";
    PickingGroupStatusValue[PickingGroupStatusValue["_1"] = 1] = "_1";
    PickingGroupStatusValue[PickingGroupStatusValue["_2"] = 2] = "_2";
    PickingGroupStatusValue[PickingGroupStatusValue["_3"] = 3] = "_3";
    PickingGroupStatusValue[PickingGroupStatusValue["_4"] = 4] = "_4";
})(PickingGroupStatusValue || (PickingGroupStatusValue = {}));
var PickingGroupShippingType = /** @class */ (function () {
    function PickingGroupShippingType(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupShippingType.prototype.init = function (_data) {
        if (_data) {
            this.pickingGroupId = _data["pickingGroupId"];
            this.pickingGroup = _data["pickingGroup"] ? PickingGroup.fromJS(_data["pickingGroup"]) : undefined;
            this.shippingTypeId = _data["shippingTypeId"];
            this.shippingType = _data["shippingType"] ? ShippingType.fromJS(_data["shippingType"]) : undefined;
            this.isDeleted = _data["isDeleted"];
            this.id = _data["id"];
        }
    };
    PickingGroupShippingType.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupShippingType();
        result.init(data);
        return result;
    };
    PickingGroupShippingType.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["pickingGroupId"] = this.pickingGroupId;
        data["pickingGroup"] = this.pickingGroup ? this.pickingGroup.toJSON() : undefined;
        data["shippingTypeId"] = this.shippingTypeId;
        data["shippingType"] = this.shippingType ? this.shippingType.toJSON() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["id"] = this.id;
        return data;
    };
    PickingGroupShippingType.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupShippingType();
        result.init(json);
        return result;
    };
    return PickingGroupShippingType;
}());
export { PickingGroupShippingType };
var PickingGroupItem = /** @class */ (function () {
    function PickingGroupItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroupItem.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.quantityPicked = _data["quantityPicked"];
            this.barCode = _data["barCode"];
            this.orderNumber = _data["orderNumber"];
            this.aisle = _data["aisle"];
            this.location = _data["location"];
            this.locationId = _data["locationId"];
            this.weight = _data["weight"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    PickingGroupItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroupItem();
        result.init(data);
        return result;
    };
    PickingGroupItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["quantityPicked"] = this.quantityPicked;
        data["barCode"] = this.barCode;
        data["orderNumber"] = this.orderNumber;
        data["aisle"] = this.aisle;
        data["location"] = this.location;
        data["locationId"] = this.locationId;
        data["weight"] = this.weight;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    PickingGroupItem.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroupItem();
        result.init(json);
        return result;
    };
    return PickingGroupItem;
}());
export { PickingGroupItem };
var PickingGroup = /** @class */ (function () {
    function PickingGroup(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    PickingGroup.prototype.init = function (_data) {
        var e_692, _a, e_693, _b, e_694, _c;
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.responsible = _data["responsible"];
            this.pickingGroupStatus = _data["pickingGroupStatus"];
            this.alias = _data["alias"];
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            this.dispatchTag = _data["dispatchTag"];
            if (Array.isArray(_data["pickingGroupShippingTypes"])) {
                this.pickingGroupShippingTypes = [];
                try {
                    for (var _d = __values(_data["pickingGroupShippingTypes"]), _e = _d.next(); !_e.done; _e = _d.next()) {
                        var item = _e.value;
                        this.pickingGroupShippingTypes.push(PickingGroupShippingType.fromJS(item));
                    }
                }
                catch (e_692_1) { e_692 = { error: e_692_1 }; }
                finally {
                    try {
                        if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                    }
                    finally { if (e_692) throw e_692.error; }
                }
            }
            if (Array.isArray(_data["pickingGroupItems"])) {
                this.pickingGroupItems = [];
                try {
                    for (var _f = __values(_data["pickingGroupItems"]), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var item = _g.value;
                        this.pickingGroupItems.push(PickingGroupItem.fromJS(item));
                    }
                }
                catch (e_693_1) { e_693 = { error: e_693_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_693) throw e_693.error; }
                }
            }
            if (Array.isArray(_data["ordersToPick"])) {
                this.ordersToPick = [];
                try {
                    for (var _h = __values(_data["ordersToPick"]), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var item = _j.value;
                        this.ordersToPick.push(OrderPickingGroup.fromJS(item));
                    }
                }
                catch (e_694_1) { e_694 = { error: e_694_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_694) throw e_694.error; }
                }
            }
            this.countryCode = _data["countryCode"];
            this.weight = _data["weight"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    PickingGroup.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new PickingGroup();
        result.init(data);
        return result;
    };
    PickingGroup.prototype.toJSON = function (data) {
        var e_695, _a, e_696, _b, e_697, _c;
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["responsible"] = this.responsible;
        data["pickingGroupStatus"] = this.pickingGroupStatus;
        data["alias"] = this.alias;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        data["dispatchTag"] = this.dispatchTag;
        if (Array.isArray(this.pickingGroupShippingTypes)) {
            data["pickingGroupShippingTypes"] = [];
            try {
                for (var _d = __values(this.pickingGroupShippingTypes), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var item = _e.value;
                    data["pickingGroupShippingTypes"].push(item.toJSON());
                }
            }
            catch (e_695_1) { e_695 = { error: e_695_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_695) throw e_695.error; }
            }
        }
        if (Array.isArray(this.pickingGroupItems)) {
            data["pickingGroupItems"] = [];
            try {
                for (var _f = __values(this.pickingGroupItems), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var item = _g.value;
                    data["pickingGroupItems"].push(item.toJSON());
                }
            }
            catch (e_696_1) { e_696 = { error: e_696_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_696) throw e_696.error; }
            }
        }
        if (Array.isArray(this.ordersToPick)) {
            data["ordersToPick"] = [];
            try {
                for (var _h = __values(this.ordersToPick), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var item = _j.value;
                    data["ordersToPick"].push(item.toJSON());
                }
            }
            catch (e_697_1) { e_697 = { error: e_697_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                }
                finally { if (e_697) throw e_697.error; }
            }
        }
        data["countryCode"] = this.countryCode;
        data["weight"] = this.weight;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    PickingGroup.prototype.clone = function () {
        var json = this.toJSON();
        var result = new PickingGroup();
        result.init(json);
        return result;
    };
    return PickingGroup;
}());
export { PickingGroup };
var OrderPickingGroup = /** @class */ (function () {
    function OrderPickingGroup(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderPickingGroup.prototype.init = function (_data) {
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.pickingGroup = _data["pickingGroup"] ? PickingGroup.fromJS(_data["pickingGroup"]) : undefined;
            this.orderId = _data["orderId"];
            this.pickingGroupId = _data["pickingGroupId"];
            this.id = _data["id"];
        }
    };
    OrderPickingGroup.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderPickingGroup();
        result.init(data);
        return result;
    };
    OrderPickingGroup.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["pickingGroup"] = this.pickingGroup ? this.pickingGroup.toJSON() : undefined;
        data["orderId"] = this.orderId;
        data["pickingGroupId"] = this.pickingGroupId;
        data["id"] = this.id;
        return data;
    };
    OrderPickingGroup.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderPickingGroup();
        result.init(json);
        return result;
    };
    return OrderPickingGroup;
}());
export { OrderPickingGroup };
export var DocType;
(function (DocType) {
    DocType[DocType["_0"] = 0] = "_0";
    DocType[DocType["_1"] = 1] = "_1";
    DocType[DocType["_2"] = 2] = "_2";
})(DocType || (DocType = {}));
export var DocumentStatus;
(function (DocumentStatus) {
    DocumentStatus[DocumentStatus["_0"] = 0] = "_0";
    DocumentStatus[DocumentStatus["_1"] = 1] = "_1";
    DocumentStatus[DocumentStatus["_2"] = 2] = "_2";
})(DocumentStatus || (DocumentStatus = {}));
var DocumentNotification = /** @class */ (function () {
    function DocumentNotification(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    DocumentNotification.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.documentType = _data["documentType"];
            this.amount = _data["amount"];
            this.documentRequest = _data["documentRequest"];
            this.relatedDocument = _data["relatedDocument"];
            this.processed = _data["processed"];
            this.processTime = _data["processTime"] ? moment(_data["processTime"].toString()) : undefined;
            this.failed = _data["failed"];
            this.processMessage = _data["processMessage"];
            this.processAttempts = _data["processAttempts"];
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    };
    DocumentNotification.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new DocumentNotification();
        result.init(data);
        return result;
    };
    DocumentNotification.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["documentType"] = this.documentType;
        data["amount"] = this.amount;
        data["documentRequest"] = this.documentRequest;
        data["relatedDocument"] = this.relatedDocument;
        data["processed"] = this.processed;
        data["processTime"] = this.processTime ? this.processTime.toISOString() : undefined;
        data["failed"] = this.failed;
        data["processMessage"] = this.processMessage;
        data["processAttempts"] = this.processAttempts;
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    };
    DocumentNotification.prototype.clone = function () {
        var json = this.toJSON();
        var result = new DocumentNotification();
        result.init(json);
        return result;
    };
    return DocumentNotification;
}());
export { DocumentNotification };
var Document = /** @class */ (function () {
    function Document(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Document.prototype.init = function (_data) {
        if (_data) {
            this.draftNumber = _data["draftNumber"];
            this.number = _data["number"];
            this.folioNumber = _data["folioNumber"];
            this.amount = _data["amount"];
            this.type = _data["type"];
            this.additionalInfo = _data["additionalInfo"];
            this.orderId = _data["orderId"];
            this.documentUrl = _data["documentUrl"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.status = _data["status"];
            this.processAttemp = _data["processAttemp"];
            this.nextAttemp = _data["nextAttemp"] ? moment(_data["nextAttemp"].toString()) : undefined;
            this.documentNotificationId = _data["documentNotificationId"];
            this.documentNotification = _data["documentNotification"] ? DocumentNotification.fromJS(_data["documentNotification"]) : undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Document.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Document();
        result.init(data);
        return result;
    };
    Document.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["draftNumber"] = this.draftNumber;
        data["number"] = this.number;
        data["folioNumber"] = this.folioNumber;
        data["amount"] = this.amount;
        data["type"] = this.type;
        data["additionalInfo"] = this.additionalInfo;
        data["orderId"] = this.orderId;
        data["documentUrl"] = this.documentUrl;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["status"] = this.status;
        data["processAttemp"] = this.processAttemp;
        data["nextAttemp"] = this.nextAttemp ? this.nextAttemp.toISOString() : undefined;
        data["documentNotificationId"] = this.documentNotificationId;
        data["documentNotification"] = this.documentNotification ? this.documentNotification.toJSON() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Document.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Document();
        result.init(json);
        return result;
    };
    return Document;
}());
export { Document };
export var ClaimType;
(function (ClaimType) {
    ClaimType[ClaimType["_0"] = 0] = "_0";
    ClaimType[ClaimType["_1"] = 1] = "_1";
    ClaimType[ClaimType["_2"] = 2] = "_2";
    ClaimType[ClaimType["_3"] = 3] = "_3";
    ClaimType[ClaimType["_4"] = 4] = "_4";
    ClaimType[ClaimType["_5"] = 5] = "_5";
})(ClaimType || (ClaimType = {}));
export var ReturnStatus;
(function (ReturnStatus) {
    ReturnStatus[ReturnStatus["_0"] = 0] = "_0";
    ReturnStatus[ReturnStatus["_1"] = 1] = "_1";
})(ReturnStatus || (ReturnStatus = {}));
var ReturnItem = /** @class */ (function () {
    function ReturnItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ReturnItem.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.returnId = _data["returnId"];
            this.return = _data["return"] ? Return.fromJS(_data["return"]) : undefined;
            this.id = _data["id"];
        }
    };
    ReturnItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ReturnItem();
        result.init(data);
        return result;
    };
    ReturnItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["returnId"] = this.returnId;
        data["return"] = this.return ? this.return.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    ReturnItem.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ReturnItem();
        result.init(json);
        return result;
    };
    return ReturnItem;
}());
export { ReturnItem };
var Return = /** @class */ (function () {
    function Return(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Return.prototype.init = function (_data) {
        var e_698, _a;
        if (_data) {
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.deliveryDataId = _data["deliveryDataId"];
            this.deliveryData = _data["deliveryData"] ? DeliveryData.fromJS(_data["deliveryData"]) : undefined;
            this.status = _data["status"];
            this.claimId = _data["claimId"];
            this.claim = _data["claim"] ? Claim.fromJS(_data["claim"]) : undefined;
            if (Array.isArray(_data["returnItems"])) {
                this.returnItems = [];
                try {
                    for (var _b = __values(_data["returnItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.returnItems.push(ReturnItem.fromJS(item));
                    }
                }
                catch (e_698_1) { e_698 = { error: e_698_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_698) throw e_698.error; }
                }
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Return.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Return();
        result.init(data);
        return result;
    };
    Return.prototype.toJSON = function (data) {
        var e_699, _a;
        data = typeof data === 'object' ? data : {};
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["deliveryDataId"] = this.deliveryDataId;
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        data["status"] = this.status;
        data["claimId"] = this.claimId;
        data["claim"] = this.claim ? this.claim.toJSON() : undefined;
        if (Array.isArray(this.returnItems)) {
            data["returnItems"] = [];
            try {
                for (var _b = __values(this.returnItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["returnItems"].push(item.toJSON());
                }
            }
            catch (e_699_1) { e_699 = { error: e_699_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_699) throw e_699.error; }
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Return.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Return();
        result.init(json);
        return result;
    };
    return Return;
}());
export { Return };
var ClaimItem = /** @class */ (function () {
    function ClaimItem(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ClaimItem.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.claimedQuantity = _data["claimedQuantity"];
            this.netAmount = _data["netAmount"];
            this.deliveryIssue = _data["deliveryIssue"];
            this.observation = _data["observation"];
            this.action = _data["action"];
            this.claim = _data["claim"] ? Claim.fromJS(_data["claim"]) : undefined;
            this.id = _data["id"];
        }
    };
    ClaimItem.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ClaimItem();
        result.init(data);
        return result;
    };
    ClaimItem.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["claimedQuantity"] = this.claimedQuantity;
        data["netAmount"] = this.netAmount;
        data["deliveryIssue"] = this.deliveryIssue;
        data["observation"] = this.observation;
        data["action"] = this.action;
        data["claim"] = this.claim ? this.claim.toJSON() : undefined;
        data["id"] = this.id;
        return data;
    };
    ClaimItem.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ClaimItem();
        result.init(json);
        return result;
    };
    return ClaimItem;
}());
export { ClaimItem };
var Claim = /** @class */ (function () {
    function Claim(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Claim.prototype.init = function (_data) {
        var e_700, _a;
        if (_data) {
            this.description = _data["description"];
            this.type = _data["type"];
            this.withdrawTime = _data["withdrawTime"] ? moment(_data["withdrawTime"].toString()) : undefined;
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.returnId = _data["returnId"];
            this.return = _data["return"] ? Return.fromJS(_data["return"]) : undefined;
            if (Array.isArray(_data["claimItems"])) {
                this.claimItems = [];
                try {
                    for (var _b = __values(_data["claimItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.claimItems.push(ClaimItem.fromJS(item));
                    }
                }
                catch (e_700_1) { e_700 = { error: e_700_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_700) throw e_700.error; }
                }
            }
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Claim.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Claim();
        result.init(data);
        return result;
    };
    Claim.prototype.toJSON = function (data) {
        var e_701, _a;
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["type"] = this.type;
        data["withdrawTime"] = this.withdrawTime ? this.withdrawTime.toISOString() : undefined;
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["returnId"] = this.returnId;
        data["return"] = this.return ? this.return.toJSON() : undefined;
        if (Array.isArray(this.claimItems)) {
            data["claimItems"] = [];
            try {
                for (var _b = __values(this.claimItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["claimItems"].push(item.toJSON());
                }
            }
            catch (e_701_1) { e_701 = { error: e_701_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_701) throw e_701.error; }
            }
        }
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Claim.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Claim();
        result.init(json);
        return result;
    };
    return Claim;
}());
export { Claim };
export var ShipmentStatus;
(function (ShipmentStatus) {
    ShipmentStatus[ShipmentStatus["_0"] = 0] = "_0";
    ShipmentStatus[ShipmentStatus["_1"] = 1] = "_1";
})(ShipmentStatus || (ShipmentStatus = {}));
var CarrierDriver = /** @class */ (function () {
    function CarrierDriver(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CarrierDriver.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? Carrier.fromJS(_data["carrier"]) : undefined;
            this.countryCode = _data["countryCode"];
            this.userId = _data["userId"];
            this.id = _data["id"];
        }
    };
    CarrierDriver.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CarrierDriver();
        result.init(data);
        return result;
    };
    CarrierDriver.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["countryCode"] = this.countryCode;
        data["userId"] = this.userId;
        data["id"] = this.id;
        return data;
    };
    CarrierDriver.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CarrierDriver();
        result.init(json);
        return result;
    };
    return CarrierDriver;
}());
export { CarrierDriver };
export var ShippingStatus;
(function (ShippingStatus) {
    ShippingStatus[ShippingStatus["_0"] = 0] = "_0";
    ShippingStatus[ShippingStatus["_1"] = 1] = "_1";
    ShippingStatus[ShippingStatus["_2"] = 2] = "_2";
    ShippingStatus[ShippingStatus["_3"] = 3] = "_3";
})(ShippingStatus || (ShippingStatus = {}));
var ShippingPackage = /** @class */ (function () {
    function ShippingPackage(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShippingPackage.prototype.init = function (_data) {
        if (_data) {
            this.address = _data["address"];
            this.status = _data["status"];
            this.package = _data["package"] ? Package.fromJS(_data["package"]) : undefined;
            this.shipmentId = _data["shipmentId"];
            this.id = _data["id"];
        }
    };
    ShippingPackage.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShippingPackage();
        result.init(data);
        return result;
    };
    ShippingPackage.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["address"] = this.address;
        data["status"] = this.status;
        data["package"] = this.package ? this.package.toJSON() : undefined;
        data["shipmentId"] = this.shipmentId;
        data["id"] = this.id;
        return data;
    };
    ShippingPackage.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShippingPackage();
        result.init(json);
        return result;
    };
    return ShippingPackage;
}());
export { ShippingPackage };
var OrderNotDeliveredPartialSaved = /** @class */ (function () {
    function OrderNotDeliveredPartialSaved(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderNotDeliveredPartialSaved.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.shipmentIssue = _data["shipmentIssue"];
        }
    };
    OrderNotDeliveredPartialSaved.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderNotDeliveredPartialSaved();
        result.init(data);
        return result;
    };
    OrderNotDeliveredPartialSaved.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["shipmentIssue"] = this.shipmentIssue;
        return data;
    };
    OrderNotDeliveredPartialSaved.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderNotDeliveredPartialSaved();
        result.init(json);
        return result;
    };
    return OrderNotDeliveredPartialSaved;
}());
export { OrderNotDeliveredPartialSaved };
var ShipmentRegisterPartialSaved = /** @class */ (function () {
    function ShipmentRegisterPartialSaved(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShipmentRegisterPartialSaved.prototype.init = function (_data) {
        var e_702, _a, e_703, _b;
        if (_data) {
            if (Array.isArray(_data["orderDeliveredIds"])) {
                this.orderDeliveredIds = [];
                try {
                    for (var _c = __values(_data["orderDeliveredIds"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.orderDeliveredIds.push(item);
                    }
                }
                catch (e_702_1) { e_702 = { error: e_702_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_702) throw e_702.error; }
                }
            }
            if (Array.isArray(_data["ordersNotDelivered"])) {
                this.ordersNotDelivered = [];
                try {
                    for (var _e = __values(_data["ordersNotDelivered"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.ordersNotDelivered.push(OrderNotDeliveredPartialSaved.fromJS(item));
                    }
                }
                catch (e_703_1) { e_703 = { error: e_703_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_703) throw e_703.error; }
                }
            }
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    ShipmentRegisterPartialSaved.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShipmentRegisterPartialSaved();
        result.init(data);
        return result;
    };
    ShipmentRegisterPartialSaved.prototype.toJSON = function (data) {
        var e_704, _a, e_705, _b;
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderDeliveredIds)) {
            data["orderDeliveredIds"] = [];
            try {
                for (var _c = __values(this.orderDeliveredIds), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["orderDeliveredIds"].push(item);
                }
            }
            catch (e_704_1) { e_704 = { error: e_704_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_704) throw e_704.error; }
            }
        }
        if (Array.isArray(this.ordersNotDelivered)) {
            data["ordersNotDelivered"] = [];
            try {
                for (var _e = __values(this.ordersNotDelivered), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["ordersNotDelivered"].push(item.toJSON());
                }
            }
            catch (e_705_1) { e_705 = { error: e_705_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_705) throw e_705.error; }
            }
        }
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    ShipmentRegisterPartialSaved.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShipmentRegisterPartialSaved();
        result.init(json);
        return result;
    };
    return ShipmentRegisterPartialSaved;
}());
export { ShipmentRegisterPartialSaved };
var Shipment = /** @class */ (function () {
    function Shipment(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Shipment.prototype.init = function (_data) {
        var e_706, _a, e_707, _b;
        if (_data) {
            this.shipmentDate = _data["shipmentDate"] ? moment(_data["shipmentDate"].toString()) : undefined;
            this.status = _data["status"];
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? Carrier.fromJS(_data["carrier"]) : undefined;
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriver.fromJS(_data["carrierDriver"]) : undefined;
            if (Array.isArray(_data["shippingPackages"])) {
                this.shippingPackages = [];
                try {
                    for (var _c = __values(_data["shippingPackages"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.shippingPackages.push(ShippingPackage.fromJS(item));
                    }
                }
                catch (e_706_1) { e_706 = { error: e_706_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_706) throw e_706.error; }
                }
            }
            if (Array.isArray(_data["shipmentOrders"])) {
                this.shipmentOrders = [];
                try {
                    for (var _e = __values(_data["shipmentOrders"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.shipmentOrders.push(ShipmentOrder.fromJS(item));
                    }
                }
                catch (e_707_1) { e_707 = { error: e_707_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_707) throw e_707.error; }
                }
            }
            this.countryCode = _data["countryCode"];
            this.storeCode = _data["storeCode"];
            this.carrierSourceCode = _data["carrierSourceCode"];
            this.carrierRequestData = _data["carrierRequestData"];
            this.isIntegrated = _data["isIntegrated"];
            this.shipmentRegisterPartialSavedId = _data["shipmentRegisterPartialSavedId"];
            this.shipmentRegisterPartialSaved = _data["shipmentRegisterPartialSaved"] ? ShipmentRegisterPartialSaved.fromJS(_data["shipmentRegisterPartialSaved"]) : undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Shipment.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Shipment();
        result.init(data);
        return result;
    };
    Shipment.prototype.toJSON = function (data) {
        var e_708, _a, e_709, _b;
        data = typeof data === 'object' ? data : {};
        data["shipmentDate"] = this.shipmentDate ? this.shipmentDate.toISOString() : undefined;
        data["status"] = this.status;
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : undefined;
        if (Array.isArray(this.shippingPackages)) {
            data["shippingPackages"] = [];
            try {
                for (var _c = __values(this.shippingPackages), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["shippingPackages"].push(item.toJSON());
                }
            }
            catch (e_708_1) { e_708 = { error: e_708_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_708) throw e_708.error; }
            }
        }
        if (Array.isArray(this.shipmentOrders)) {
            data["shipmentOrders"] = [];
            try {
                for (var _e = __values(this.shipmentOrders), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["shipmentOrders"].push(item.toJSON());
                }
            }
            catch (e_709_1) { e_709 = { error: e_709_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_709) throw e_709.error; }
            }
        }
        data["countryCode"] = this.countryCode;
        data["storeCode"] = this.storeCode;
        data["carrierSourceCode"] = this.carrierSourceCode;
        data["carrierRequestData"] = this.carrierRequestData;
        data["isIntegrated"] = this.isIntegrated;
        data["shipmentRegisterPartialSavedId"] = this.shipmentRegisterPartialSavedId;
        data["shipmentRegisterPartialSaved"] = this.shipmentRegisterPartialSaved ? this.shipmentRegisterPartialSaved.toJSON() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Shipment.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Shipment();
        result.init(json);
        return result;
    };
    return Shipment;
}());
export { Shipment };
var ShipmentOrder = /** @class */ (function () {
    function ShipmentOrder(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ShipmentOrder.prototype.init = function (_data) {
        var e_710, _a;
        if (_data) {
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.shipment = _data["shipment"] ? Shipment.fromJS(_data["shipment"]) : undefined;
            this.orderId = _data["orderId"];
            this.shipmentId = _data["shipmentId"];
            this.shippingStatus = _data["shippingStatus"];
            this.shipmentIssue = _data["shipmentIssue"];
            this.carrierTrackingLink = _data["carrierTrackingLink"];
            this.shippingFinishDate = _data["shippingFinishDate"] ? moment(_data["shippingFinishDate"].toString()) : undefined;
            this.deliveredOn = _data["deliveredOn"] ? moment(_data["deliveredOn"].toString()) : undefined;
            this.notDeliveredOn = _data["notDeliveredOn"] ? moment(_data["notDeliveredOn"].toString()) : undefined;
            if (Array.isArray(_data["proofFiles"])) {
                this.proofFiles = [];
                try {
                    for (var _b = __values(_data["proofFiles"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.proofFiles.push(item);
                    }
                }
                catch (e_710_1) { e_710 = { error: e_710_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_710) throw e_710.error; }
                }
            }
            this.proofNote = _data["proofNote"];
            this.id = _data["id"];
        }
    };
    ShipmentOrder.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ShipmentOrder();
        result.init(data);
        return result;
    };
    ShipmentOrder.prototype.toJSON = function (data) {
        var e_711, _a;
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["shipment"] = this.shipment ? this.shipment.toJSON() : undefined;
        data["orderId"] = this.orderId;
        data["shipmentId"] = this.shipmentId;
        data["shippingStatus"] = this.shippingStatus;
        data["shipmentIssue"] = this.shipmentIssue;
        data["carrierTrackingLink"] = this.carrierTrackingLink;
        data["shippingFinishDate"] = this.shippingFinishDate ? this.shippingFinishDate.toISOString() : undefined;
        data["deliveredOn"] = this.deliveredOn ? this.deliveredOn.toISOString() : undefined;
        data["notDeliveredOn"] = this.notDeliveredOn ? this.notDeliveredOn.toISOString() : undefined;
        if (Array.isArray(this.proofFiles)) {
            data["proofFiles"] = [];
            try {
                for (var _b = __values(this.proofFiles), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["proofFiles"].push(item);
                }
            }
            catch (e_711_1) { e_711 = { error: e_711_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_711) throw e_711.error; }
            }
        }
        data["proofNote"] = this.proofNote;
        data["id"] = this.id;
        return data;
    };
    ShipmentOrder.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ShipmentOrder();
        result.init(json);
        return result;
    };
    return ShipmentOrder;
}());
export { ShipmentOrder };
var OrderBalance = /** @class */ (function () {
    function OrderBalance(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    OrderBalance.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.order = _data["order"] ? Order.fromJS(_data["order"]) : undefined;
            this.amount = _data["amount"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.quantity = _data["quantity"];
            this.movementType = _data["movementType"];
            this.documentId = _data["documentId"];
            this.document = _data["document"] ? Document.fromJS(_data["document"]) : undefined;
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    OrderBalance.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new OrderBalance();
        result.init(data);
        return result;
    };
    OrderBalance.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["order"] = this.order ? this.order.toJSON() : undefined;
        data["amount"] = this.amount;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["quantity"] = this.quantity;
        data["movementType"] = this.movementType;
        data["documentId"] = this.documentId;
        data["document"] = this.document ? this.document.toJSON() : undefined;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    OrderBalance.prototype.clone = function () {
        var json = this.toJSON();
        var result = new OrderBalance();
        result.init(json);
        return result;
    };
    return OrderBalance;
}());
export { OrderBalance };
export var ReplacementCriteria;
(function (ReplacementCriteria) {
    ReplacementCriteria[ReplacementCriteria["_0"] = 0] = "_0";
    ReplacementCriteria[ReplacementCriteria["_1"] = 1] = "_1";
    ReplacementCriteria[ReplacementCriteria["_2"] = 2] = "_2";
})(ReplacementCriteria || (ReplacementCriteria = {}));
export var IncludedGiftCard;
(function (IncludedGiftCard) {
    IncludedGiftCard[IncludedGiftCard["_0"] = 0] = "_0";
    IncludedGiftCard[IncludedGiftCard["_1"] = 1] = "_1";
})(IncludedGiftCard || (IncludedGiftCard = {}));
var Order = /** @class */ (function () {
    function Order(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    Order.prototype.init = function (_data) {
        var e_712, _a, e_713, _b, e_714, _c, e_715, _d, e_716, _e, e_717, _f, e_718, _g, e_719, _h, e_720, _j, e_721, _k, e_722, _l, e_723, _m, e_724, _o, e_725, _p, e_726, _q, e_727, _r, e_728, _s;
        if (_data) {
            this.sourceName = _data["sourceName"];
            this.sourceCode = _data["sourceCode"];
            this.sourceCreationTime = _data["sourceCreationTime"] ? moment(_data["sourceCreationTime"].toString()) : undefined;
            this.sourceGrossAmount = _data["sourceGrossAmount"];
            this.sourceNetAmount = _data["sourceNetAmount"];
            this.grossAmount = _data["grossAmount"];
            this.netAmount = _data["netAmount"];
            this.discount = _data["discount"];
            this.taxes = _data["taxes"];
            this.countryCode = _data["countryCode"];
            this.highlighted = _data["highlighted"];
            this.sourceStoreCode = _data["sourceStoreCode"];
            this.customer = _data["customer"] ? Customer.fromJS(_data["customer"]) : undefined;
            if (Array.isArray(_data["relatedDocuments"])) {
                this.relatedDocuments = [];
                try {
                    for (var _t = __values(_data["relatedDocuments"]), _u = _t.next(); !_u.done; _u = _t.next()) {
                        var item = _u.value;
                        this.relatedDocuments.push(OrderDocument.fromJS(item));
                    }
                }
                catch (e_712_1) { e_712 = { error: e_712_1 }; }
                finally {
                    try {
                        if (_u && !_u.done && (_a = _t.return)) _a.call(_t);
                    }
                    finally { if (e_712) throw e_712.error; }
                }
            }
            this.carrierId = _data["carrierId"];
            this.carrier = _data["carrier"] ? Carrier.fromJS(_data["carrier"]) : undefined;
            if (Array.isArray(_data["sourceOrderItems"])) {
                this.sourceOrderItems = [];
                try {
                    for (var _v = __values(_data["sourceOrderItems"]), _w = _v.next(); !_w.done; _w = _v.next()) {
                        var item = _w.value;
                        this.sourceOrderItems.push(SourceOrderItem.fromJS(item));
                    }
                }
                catch (e_713_1) { e_713 = { error: e_713_1 }; }
                finally {
                    try {
                        if (_w && !_w.done && (_b = _v.return)) _b.call(_v);
                    }
                    finally { if (e_713) throw e_713.error; }
                }
            }
            if (Array.isArray(_data["orderItems"])) {
                this.orderItems = [];
                try {
                    for (var _x = __values(_data["orderItems"]), _y = _x.next(); !_y.done; _y = _x.next()) {
                        var item = _y.value;
                        this.orderItems.push(OrderItem.fromJS(item));
                    }
                }
                catch (e_714_1) { e_714 = { error: e_714_1 }; }
                finally {
                    try {
                        if (_y && !_y.done && (_c = _x.return)) _c.call(_x);
                    }
                    finally { if (e_714) throw e_714.error; }
                }
            }
            if (Array.isArray(_data["payments"])) {
                this.payments = [];
                try {
                    for (var _z = __values(_data["payments"]), _19 = _z.next(); !_19.done; _19 = _z.next()) {
                        var item = _19.value;
                        this.payments.push(Payment.fromJS(item));
                    }
                }
                catch (e_715_1) { e_715 = { error: e_715_1 }; }
                finally {
                    try {
                        if (_19 && !_19.done && (_d = _z.return)) _d.call(_z);
                    }
                    finally { if (e_715) throw e_715.error; }
                }
            }
            this.deliveryData = _data["deliveryData"] ? DeliveryData.fromJS(_data["deliveryData"]) : undefined;
            if (Array.isArray(_data["notes"])) {
                this.notes = [];
                try {
                    for (var _20 = __values(_data["notes"]), _21 = _20.next(); !_21.done; _21 = _20.next()) {
                        var item = _21.value;
                        this.notes.push(OrderNote.fromJS(item));
                    }
                }
                catch (e_716_1) { e_716 = { error: e_716_1 }; }
                finally {
                    try {
                        if (_21 && !_21.done && (_e = _20.return)) _e.call(_20);
                    }
                    finally { if (e_716) throw e_716.error; }
                }
            }
            this.currentAssignedToStore = _data["currentAssignedToStore"] ? AssignedToStore.fromJS(_data["currentAssignedToStore"]) : undefined;
            if (Array.isArray(_data["historicAssignedToStore"])) {
                this.historicAssignedToStore = [];
                try {
                    for (var _22 = __values(_data["historicAssignedToStore"]), _23 = _22.next(); !_23.done; _23 = _22.next()) {
                        var item = _23.value;
                        this.historicAssignedToStore.push(AssignedToStore.fromJS(item));
                    }
                }
                catch (e_717_1) { e_717 = { error: e_717_1 }; }
                finally {
                    try {
                        if (_23 && !_23.done && (_f = _22.return)) _f.call(_22);
                    }
                    finally { if (e_717) throw e_717.error; }
                }
            }
            this.currentOverallStatus = _data["currentOverallStatus"] ? OverallStatus.fromJS(_data["currentOverallStatus"]) : undefined;
            if (Array.isArray(_data["historicOverallStatus"])) {
                this.historicOverallStatus = [];
                try {
                    for (var _24 = __values(_data["historicOverallStatus"]), _25 = _24.next(); !_25.done; _25 = _24.next()) {
                        var item = _25.value;
                        this.historicOverallStatus.push(OverallStatus.fromJS(item));
                    }
                }
                catch (e_718_1) { e_718 = { error: e_718_1 }; }
                finally {
                    try {
                        if (_25 && !_25.done && (_g = _24.return)) _g.call(_24);
                    }
                    finally { if (e_718) throw e_718.error; }
                }
            }
            this.currentCommercialStatus = _data["currentCommercialStatus"] ? CommercialStatus.fromJS(_data["currentCommercialStatus"]) : undefined;
            if (Array.isArray(_data["historicCommercialStatus"])) {
                this.historicCommercialStatus = [];
                try {
                    for (var _26 = __values(_data["historicCommercialStatus"]), _27 = _26.next(); !_27.done; _27 = _26.next()) {
                        var item = _27.value;
                        this.historicCommercialStatus.push(CommercialStatus.fromJS(item));
                    }
                }
                catch (e_719_1) { e_719 = { error: e_719_1 }; }
                finally {
                    try {
                        if (_27 && !_27.done && (_h = _26.return)) _h.call(_26);
                    }
                    finally { if (e_719) throw e_719.error; }
                }
            }
            this.currentFinancialStatus = _data["currentFinancialStatus"] ? FinancialStatus.fromJS(_data["currentFinancialStatus"]) : undefined;
            if (Array.isArray(_data["historicFinancialStatus"])) {
                this.historicFinancialStatus = [];
                try {
                    for (var _28 = __values(_data["historicFinancialStatus"]), _29 = _28.next(); !_29.done; _29 = _28.next()) {
                        var item = _29.value;
                        this.historicFinancialStatus.push(FinancialStatus.fromJS(item));
                    }
                }
                catch (e_720_1) { e_720 = { error: e_720_1 }; }
                finally {
                    try {
                        if (_29 && !_29.done && (_j = _28.return)) _j.call(_28);
                    }
                    finally { if (e_720) throw e_720.error; }
                }
            }
            this.currentLogisticStatus = _data["currentLogisticStatus"] ? LogisticStatus.fromJS(_data["currentLogisticStatus"]) : undefined;
            if (Array.isArray(_data["historicLogisticStatus"])) {
                this.historicLogisticStatus = [];
                try {
                    for (var _30 = __values(_data["historicLogisticStatus"]), _31 = _30.next(); !_31.done; _31 = _30.next()) {
                        var item = _31.value;
                        this.historicLogisticStatus.push(LogisticStatus.fromJS(item));
                    }
                }
                catch (e_721_1) { e_721 = { error: e_721_1 }; }
                finally {
                    try {
                        if (_31 && !_31.done && (_k = _30.return)) _k.call(_30);
                    }
                    finally { if (e_721) throw e_721.error; }
                }
            }
            this.currentLogisticAuditStatus = _data["currentLogisticAuditStatus"] ? LogisticAuditStatus.fromJS(_data["currentLogisticAuditStatus"]) : undefined;
            if (Array.isArray(_data["historicLogisticAuditStatus"])) {
                this.historicLogisticAuditStatus = [];
                try {
                    for (var _32 = __values(_data["historicLogisticAuditStatus"]), _33 = _32.next(); !_33.done; _33 = _32.next()) {
                        var item = _33.value;
                        this.historicLogisticAuditStatus.push(LogisticAuditStatus.fromJS(item));
                    }
                }
                catch (e_722_1) { e_722 = { error: e_722_1 }; }
                finally {
                    try {
                        if (_33 && !_33.done && (_l = _32.return)) _l.call(_32);
                    }
                    finally { if (e_722) throw e_722.error; }
                }
            }
            this.invoiceNumber = _data["invoiceNumber"];
            this.sourceStatus = _data["sourceStatus"];
            this.sourceStatusDetail = _data["sourceStatusDetail"];
            this.dispatchDate = _data["dispatchDate"] ? moment(_data["dispatchDate"].toString()) : undefined;
            if (Array.isArray(_data["eventLogs"])) {
                this.eventLogs = [];
                try {
                    for (var _34 = __values(_data["eventLogs"]), _35 = _34.next(); !_35.done; _35 = _34.next()) {
                        var item = _35.value;
                        this.eventLogs.push(EventLog.fromJS(item));
                    }
                }
                catch (e_723_1) { e_723 = { error: e_723_1 }; }
                finally {
                    try {
                        if (_35 && !_35.done && (_m = _34.return)) _m.call(_34);
                    }
                    finally { if (e_723) throw e_723.error; }
                }
            }
            this.isPackOrder = _data["isPackOrder"];
            this.isPackItemOrder = _data["isPackItemOrder"];
            this.packOrder = _data["packOrder"] ? Order.fromJS(_data["packOrder"]) : undefined;
            this.packOrderId = _data["packOrderId"];
            this.sourcePackCode = _data["sourcePackCode"];
            if (Array.isArray(_data["preparations"])) {
                this.preparations = [];
                try {
                    for (var _36 = __values(_data["preparations"]), _37 = _36.next(); !_37.done; _37 = _36.next()) {
                        var item = _37.value;
                        this.preparations.push(Preparation.fromJS(item));
                    }
                }
                catch (e_724_1) { e_724 = { error: e_724_1 }; }
                finally {
                    try {
                        if (_37 && !_37.done && (_o = _36.return)) _o.call(_36);
                    }
                    finally { if (e_724) throw e_724.error; }
                }
            }
            this.orderBillingInfo = _data["orderBillingInfo"] ? OrderBillingInfo.fromJS(_data["orderBillingInfo"]) : undefined;
            if (Array.isArray(_data["orderPickingGroups"])) {
                this.orderPickingGroups = [];
                try {
                    for (var _38 = __values(_data["orderPickingGroups"]), _39 = _38.next(); !_39.done; _39 = _38.next()) {
                        var item = _39.value;
                        this.orderPickingGroups.push(OrderPickingGroup.fromJS(item));
                    }
                }
                catch (e_725_1) { e_725 = { error: e_725_1 }; }
                finally {
                    try {
                        if (_39 && !_39.done && (_p = _38.return)) _p.call(_38);
                    }
                    finally { if (e_725) throw e_725.error; }
                }
            }
            if (Array.isArray(_data["documents"])) {
                this.documents = [];
                try {
                    for (var _40 = __values(_data["documents"]), _41 = _40.next(); !_41.done; _41 = _40.next()) {
                        var item = _41.value;
                        this.documents.push(Document.fromJS(item));
                    }
                }
                catch (e_726_1) { e_726 = { error: e_726_1 }; }
                finally {
                    try {
                        if (_41 && !_41.done && (_q = _40.return)) _q.call(_40);
                    }
                    finally { if (e_726) throw e_726.error; }
                }
            }
            if (Array.isArray(_data["claims"])) {
                this.claims = [];
                try {
                    for (var _42 = __values(_data["claims"]), _43 = _42.next(); !_43.done; _43 = _42.next()) {
                        var item = _43.value;
                        this.claims.push(Claim.fromJS(item));
                    }
                }
                catch (e_727_1) { e_727 = { error: e_727_1 }; }
                finally {
                    try {
                        if (_43 && !_43.done && (_r = _42.return)) _r.call(_42);
                    }
                    finally { if (e_727) throw e_727.error; }
                }
            }
            this.shipmentOrder = _data["shipmentOrder"] ? ShipmentOrder.fromJS(_data["shipmentOrder"]) : undefined;
            if (Array.isArray(_data["orderBalances"])) {
                this.orderBalances = [];
                try {
                    for (var _44 = __values(_data["orderBalances"]), _45 = _44.next(); !_45.done; _45 = _44.next()) {
                        var item = _45.value;
                        this.orderBalances.push(OrderBalance.fromJS(item));
                    }
                }
                catch (e_728_1) { e_728 = { error: e_728_1 }; }
                finally {
                    try {
                        if (_45 && !_45.done && (_s = _44.return)) _s.call(_44);
                    }
                    finally { if (e_728) throw e_728.error; }
                }
            }
            this.balance = _data["balance"];
            this.routeOrder = _data["routeOrder"];
            this.dispatchTag = _data["dispatchTag"];
            this.pickupStoreCode = _data["pickupStoreCode"];
            this.modified = _data["modified"];
            this.stockStatus = _data["stockStatus"];
            this.carrierDriverId = _data["carrierDriverId"];
            this.carrierDriver = _data["carrierDriver"] ? CarrierDriver.fromJS(_data["carrierDriver"]) : undefined;
            this.delayAlertSent = _data["delayAlertSent"];
            this.secureId = _data["secureId"];
            this.interest = _data["interest"];
            this.notificationSended = _data["notificationSended"];
            this.openTextField = _data["openTextField"];
            this.replacementCriteria = _data["replacementCriteria"];
            this.carrierInfo = _data["carrierInfo"];
            this.includedGiftCard = _data["includedGiftCard"];
            this.giftCard = _data["giftCard"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    Order.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new Order();
        result.init(data);
        return result;
    };
    Order.prototype.toJSON = function (data) {
        var e_729, _a, e_730, _b, e_731, _c, e_732, _d, e_733, _e, e_734, _f, e_735, _g, e_736, _h, e_737, _j, e_738, _k, e_739, _l, e_740, _m, e_741, _o, e_742, _p, e_743, _q, e_744, _r, e_745, _s;
        data = typeof data === 'object' ? data : {};
        data["sourceName"] = this.sourceName;
        data["sourceCode"] = this.sourceCode;
        data["sourceCreationTime"] = this.sourceCreationTime ? this.sourceCreationTime.toISOString() : undefined;
        data["sourceGrossAmount"] = this.sourceGrossAmount;
        data["sourceNetAmount"] = this.sourceNetAmount;
        data["grossAmount"] = this.grossAmount;
        data["netAmount"] = this.netAmount;
        data["discount"] = this.discount;
        data["taxes"] = this.taxes;
        data["countryCode"] = this.countryCode;
        data["highlighted"] = this.highlighted;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["customer"] = this.customer ? this.customer.toJSON() : undefined;
        if (Array.isArray(this.relatedDocuments)) {
            data["relatedDocuments"] = [];
            try {
                for (var _t = __values(this.relatedDocuments), _u = _t.next(); !_u.done; _u = _t.next()) {
                    var item = _u.value;
                    data["relatedDocuments"].push(item.toJSON());
                }
            }
            catch (e_729_1) { e_729 = { error: e_729_1 }; }
            finally {
                try {
                    if (_u && !_u.done && (_a = _t.return)) _a.call(_t);
                }
                finally { if (e_729) throw e_729.error; }
            }
        }
        data["carrierId"] = this.carrierId;
        data["carrier"] = this.carrier ? this.carrier.toJSON() : undefined;
        if (Array.isArray(this.sourceOrderItems)) {
            data["sourceOrderItems"] = [];
            try {
                for (var _v = __values(this.sourceOrderItems), _w = _v.next(); !_w.done; _w = _v.next()) {
                    var item = _w.value;
                    data["sourceOrderItems"].push(item.toJSON());
                }
            }
            catch (e_730_1) { e_730 = { error: e_730_1 }; }
            finally {
                try {
                    if (_w && !_w.done && (_b = _v.return)) _b.call(_v);
                }
                finally { if (e_730) throw e_730.error; }
            }
        }
        if (Array.isArray(this.orderItems)) {
            data["orderItems"] = [];
            try {
                for (var _x = __values(this.orderItems), _y = _x.next(); !_y.done; _y = _x.next()) {
                    var item = _y.value;
                    data["orderItems"].push(item.toJSON());
                }
            }
            catch (e_731_1) { e_731 = { error: e_731_1 }; }
            finally {
                try {
                    if (_y && !_y.done && (_c = _x.return)) _c.call(_x);
                }
                finally { if (e_731) throw e_731.error; }
            }
        }
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            try {
                for (var _z = __values(this.payments), _19 = _z.next(); !_19.done; _19 = _z.next()) {
                    var item = _19.value;
                    data["payments"].push(item.toJSON());
                }
            }
            catch (e_732_1) { e_732 = { error: e_732_1 }; }
            finally {
                try {
                    if (_19 && !_19.done && (_d = _z.return)) _d.call(_z);
                }
                finally { if (e_732) throw e_732.error; }
            }
        }
        data["deliveryData"] = this.deliveryData ? this.deliveryData.toJSON() : undefined;
        if (Array.isArray(this.notes)) {
            data["notes"] = [];
            try {
                for (var _20 = __values(this.notes), _21 = _20.next(); !_21.done; _21 = _20.next()) {
                    var item = _21.value;
                    data["notes"].push(item.toJSON());
                }
            }
            catch (e_733_1) { e_733 = { error: e_733_1 }; }
            finally {
                try {
                    if (_21 && !_21.done && (_e = _20.return)) _e.call(_20);
                }
                finally { if (e_733) throw e_733.error; }
            }
        }
        data["currentAssignedToStore"] = this.currentAssignedToStore ? this.currentAssignedToStore.toJSON() : undefined;
        if (Array.isArray(this.historicAssignedToStore)) {
            data["historicAssignedToStore"] = [];
            try {
                for (var _22 = __values(this.historicAssignedToStore), _23 = _22.next(); !_23.done; _23 = _22.next()) {
                    var item = _23.value;
                    data["historicAssignedToStore"].push(item.toJSON());
                }
            }
            catch (e_734_1) { e_734 = { error: e_734_1 }; }
            finally {
                try {
                    if (_23 && !_23.done && (_f = _22.return)) _f.call(_22);
                }
                finally { if (e_734) throw e_734.error; }
            }
        }
        data["currentOverallStatus"] = this.currentOverallStatus ? this.currentOverallStatus.toJSON() : undefined;
        if (Array.isArray(this.historicOverallStatus)) {
            data["historicOverallStatus"] = [];
            try {
                for (var _24 = __values(this.historicOverallStatus), _25 = _24.next(); !_25.done; _25 = _24.next()) {
                    var item = _25.value;
                    data["historicOverallStatus"].push(item.toJSON());
                }
            }
            catch (e_735_1) { e_735 = { error: e_735_1 }; }
            finally {
                try {
                    if (_25 && !_25.done && (_g = _24.return)) _g.call(_24);
                }
                finally { if (e_735) throw e_735.error; }
            }
        }
        data["currentCommercialStatus"] = this.currentCommercialStatus ? this.currentCommercialStatus.toJSON() : undefined;
        if (Array.isArray(this.historicCommercialStatus)) {
            data["historicCommercialStatus"] = [];
            try {
                for (var _26 = __values(this.historicCommercialStatus), _27 = _26.next(); !_27.done; _27 = _26.next()) {
                    var item = _27.value;
                    data["historicCommercialStatus"].push(item.toJSON());
                }
            }
            catch (e_736_1) { e_736 = { error: e_736_1 }; }
            finally {
                try {
                    if (_27 && !_27.done && (_h = _26.return)) _h.call(_26);
                }
                finally { if (e_736) throw e_736.error; }
            }
        }
        data["currentFinancialStatus"] = this.currentFinancialStatus ? this.currentFinancialStatus.toJSON() : undefined;
        if (Array.isArray(this.historicFinancialStatus)) {
            data["historicFinancialStatus"] = [];
            try {
                for (var _28 = __values(this.historicFinancialStatus), _29 = _28.next(); !_29.done; _29 = _28.next()) {
                    var item = _29.value;
                    data["historicFinancialStatus"].push(item.toJSON());
                }
            }
            catch (e_737_1) { e_737 = { error: e_737_1 }; }
            finally {
                try {
                    if (_29 && !_29.done && (_j = _28.return)) _j.call(_28);
                }
                finally { if (e_737) throw e_737.error; }
            }
        }
        data["currentLogisticStatus"] = this.currentLogisticStatus ? this.currentLogisticStatus.toJSON() : undefined;
        if (Array.isArray(this.historicLogisticStatus)) {
            data["historicLogisticStatus"] = [];
            try {
                for (var _30 = __values(this.historicLogisticStatus), _31 = _30.next(); !_31.done; _31 = _30.next()) {
                    var item = _31.value;
                    data["historicLogisticStatus"].push(item.toJSON());
                }
            }
            catch (e_738_1) { e_738 = { error: e_738_1 }; }
            finally {
                try {
                    if (_31 && !_31.done && (_k = _30.return)) _k.call(_30);
                }
                finally { if (e_738) throw e_738.error; }
            }
        }
        data["currentLogisticAuditStatus"] = this.currentLogisticAuditStatus ? this.currentLogisticAuditStatus.toJSON() : undefined;
        if (Array.isArray(this.historicLogisticAuditStatus)) {
            data["historicLogisticAuditStatus"] = [];
            try {
                for (var _32 = __values(this.historicLogisticAuditStatus), _33 = _32.next(); !_33.done; _33 = _32.next()) {
                    var item = _33.value;
                    data["historicLogisticAuditStatus"].push(item.toJSON());
                }
            }
            catch (e_739_1) { e_739 = { error: e_739_1 }; }
            finally {
                try {
                    if (_33 && !_33.done && (_l = _32.return)) _l.call(_32);
                }
                finally { if (e_739) throw e_739.error; }
            }
        }
        data["invoiceNumber"] = this.invoiceNumber;
        data["sourceStatus"] = this.sourceStatus;
        data["sourceStatusDetail"] = this.sourceStatusDetail;
        data["dispatchDate"] = this.dispatchDate ? this.dispatchDate.toISOString() : undefined;
        if (Array.isArray(this.eventLogs)) {
            data["eventLogs"] = [];
            try {
                for (var _34 = __values(this.eventLogs), _35 = _34.next(); !_35.done; _35 = _34.next()) {
                    var item = _35.value;
                    data["eventLogs"].push(item.toJSON());
                }
            }
            catch (e_740_1) { e_740 = { error: e_740_1 }; }
            finally {
                try {
                    if (_35 && !_35.done && (_m = _34.return)) _m.call(_34);
                }
                finally { if (e_740) throw e_740.error; }
            }
        }
        data["isPackOrder"] = this.isPackOrder;
        data["isPackItemOrder"] = this.isPackItemOrder;
        data["packOrder"] = this.packOrder ? this.packOrder.toJSON() : undefined;
        data["packOrderId"] = this.packOrderId;
        data["sourcePackCode"] = this.sourcePackCode;
        if (Array.isArray(this.preparations)) {
            data["preparations"] = [];
            try {
                for (var _36 = __values(this.preparations), _37 = _36.next(); !_37.done; _37 = _36.next()) {
                    var item = _37.value;
                    data["preparations"].push(item.toJSON());
                }
            }
            catch (e_741_1) { e_741 = { error: e_741_1 }; }
            finally {
                try {
                    if (_37 && !_37.done && (_o = _36.return)) _o.call(_36);
                }
                finally { if (e_741) throw e_741.error; }
            }
        }
        data["orderBillingInfo"] = this.orderBillingInfo ? this.orderBillingInfo.toJSON() : undefined;
        if (Array.isArray(this.orderPickingGroups)) {
            data["orderPickingGroups"] = [];
            try {
                for (var _38 = __values(this.orderPickingGroups), _39 = _38.next(); !_39.done; _39 = _38.next()) {
                    var item = _39.value;
                    data["orderPickingGroups"].push(item.toJSON());
                }
            }
            catch (e_742_1) { e_742 = { error: e_742_1 }; }
            finally {
                try {
                    if (_39 && !_39.done && (_p = _38.return)) _p.call(_38);
                }
                finally { if (e_742) throw e_742.error; }
            }
        }
        if (Array.isArray(this.documents)) {
            data["documents"] = [];
            try {
                for (var _40 = __values(this.documents), _41 = _40.next(); !_41.done; _41 = _40.next()) {
                    var item = _41.value;
                    data["documents"].push(item.toJSON());
                }
            }
            catch (e_743_1) { e_743 = { error: e_743_1 }; }
            finally {
                try {
                    if (_41 && !_41.done && (_q = _40.return)) _q.call(_40);
                }
                finally { if (e_743) throw e_743.error; }
            }
        }
        if (Array.isArray(this.claims)) {
            data["claims"] = [];
            try {
                for (var _42 = __values(this.claims), _43 = _42.next(); !_43.done; _43 = _42.next()) {
                    var item = _43.value;
                    data["claims"].push(item.toJSON());
                }
            }
            catch (e_744_1) { e_744 = { error: e_744_1 }; }
            finally {
                try {
                    if (_43 && !_43.done && (_r = _42.return)) _r.call(_42);
                }
                finally { if (e_744) throw e_744.error; }
            }
        }
        data["shipmentOrder"] = this.shipmentOrder ? this.shipmentOrder.toJSON() : undefined;
        if (Array.isArray(this.orderBalances)) {
            data["orderBalances"] = [];
            try {
                for (var _44 = __values(this.orderBalances), _45 = _44.next(); !_45.done; _45 = _44.next()) {
                    var item = _45.value;
                    data["orderBalances"].push(item.toJSON());
                }
            }
            catch (e_745_1) { e_745 = { error: e_745_1 }; }
            finally {
                try {
                    if (_45 && !_45.done && (_s = _44.return)) _s.call(_44);
                }
                finally { if (e_745) throw e_745.error; }
            }
        }
        data["balance"] = this.balance;
        data["routeOrder"] = this.routeOrder;
        data["dispatchTag"] = this.dispatchTag;
        data["pickupStoreCode"] = this.pickupStoreCode;
        data["modified"] = this.modified;
        data["stockStatus"] = this.stockStatus;
        data["carrierDriverId"] = this.carrierDriverId;
        data["carrierDriver"] = this.carrierDriver ? this.carrierDriver.toJSON() : undefined;
        data["delayAlertSent"] = this.delayAlertSent;
        data["secureId"] = this.secureId;
        data["interest"] = this.interest;
        data["notificationSended"] = this.notificationSended;
        data["openTextField"] = this.openTextField;
        data["replacementCriteria"] = this.replacementCriteria;
        data["carrierInfo"] = this.carrierInfo;
        data["includedGiftCard"] = this.includedGiftCard;
        data["giftCard"] = this.giftCard;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    Order.prototype.clone = function () {
        var json = this.toJSON();
        var result = new Order();
        result.init(json);
        return result;
    };
    return Order;
}());
export { Order };
var StateDto = /** @class */ (function () {
    function StateDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StateDto.prototype.init = function (_data) {
        var e_746, _a;
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["cities"])) {
                this.cities = [];
                try {
                    for (var _b = __values(_data["cities"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.cities.push(CityDto.fromJS(item));
                    }
                }
                catch (e_746_1) { e_746 = { error: e_746_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_746) throw e_746.error; }
                }
            }
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    };
    StateDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StateDto();
        result.init(data);
        return result;
    };
    StateDto.prototype.toJSON = function (data) {
        var e_747, _a;
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.cities)) {
            data["cities"] = [];
            try {
                for (var _b = __values(this.cities), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["cities"].push(item.toJSON());
                }
            }
            catch (e_747_1) { e_747 = { error: e_747_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_747) throw e_747.error; }
            }
        }
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    };
    StateDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StateDto();
        result.init(json);
        return result;
    };
    return StateDto;
}());
export { StateDto };
var StateDtoPagedResultDto = /** @class */ (function () {
    function StateDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StateDtoPagedResultDto.prototype.init = function (_data) {
        var e_748, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(StateDto.fromJS(item));
                    }
                }
                catch (e_748_1) { e_748 = { error: e_748_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_748) throw e_748.error; }
                }
            }
        }
    };
    StateDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StateDtoPagedResultDto();
        result.init(data);
        return result;
    };
    StateDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_749, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_749_1) { e_749 = { error: e_749_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_749) throw e_749.error; }
            }
        }
        return data;
    };
    StateDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StateDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return StateDtoPagedResultDto;
}());
export { StateDtoPagedResultDto };
var ProductStock = /** @class */ (function () {
    function ProductStock(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ProductStock.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.sku = _data["sku"];
            this.stock = _data["stock"];
            this.quantity = _data["quantity"];
            this.storeCode = _data["storeCode"];
            this.isDanger = _data["isDanger"];
            this.isWarning = _data["isWarning"];
            this.isSafe = _data["isSafe"];
            this.id = _data["id"];
        }
    };
    ProductStock.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ProductStock();
        result.init(data);
        return result;
    };
    ProductStock.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["sku"] = this.sku;
        data["stock"] = this.stock;
        data["quantity"] = this.quantity;
        data["storeCode"] = this.storeCode;
        data["isDanger"] = this.isDanger;
        data["isWarning"] = this.isWarning;
        data["isSafe"] = this.isSafe;
        data["id"] = this.id;
        return data;
    };
    ProductStock.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ProductStock();
        result.init(json);
        return result;
    };
    return ProductStock;
}());
export { ProductStock };
var StoreDistanceAndStockDto = /** @class */ (function () {
    function StoreDistanceAndStockDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StoreDistanceAndStockDto.prototype.init = function (_data) {
        var e_750, _a;
        if (_data) {
            this.storeName = _data["storeName"];
            this.distance = _data["distance"];
            if (Array.isArray(_data["stock"])) {
                this.stock = [];
                try {
                    for (var _b = __values(_data["stock"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.stock.push(ProductStock.fromJS(item));
                    }
                }
                catch (e_750_1) { e_750 = { error: e_750_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_750) throw e_750.error; }
                }
            }
            this.isDanger = _data["isDanger"];
            this.isWarning = _data["isWarning"];
            this.isSafe = _data["isSafe"];
            this.storeId = _data["storeId"];
            this.storeCode = _data["storeCode"];
            this.storeIsHub = _data["storeIsHub"];
            this.clusterId = _data["clusterId"];
            this.assignations = _data["assignations"];
        }
    };
    StoreDistanceAndStockDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StoreDistanceAndStockDto();
        result.init(data);
        return result;
    };
    StoreDistanceAndStockDto.prototype.toJSON = function (data) {
        var e_751, _a;
        data = typeof data === 'object' ? data : {};
        data["storeName"] = this.storeName;
        data["distance"] = this.distance;
        if (Array.isArray(this.stock)) {
            data["stock"] = [];
            try {
                for (var _b = __values(this.stock), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["stock"].push(item.toJSON());
                }
            }
            catch (e_751_1) { e_751 = { error: e_751_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_751) throw e_751.error; }
            }
        }
        data["isDanger"] = this.isDanger;
        data["isWarning"] = this.isWarning;
        data["isSafe"] = this.isSafe;
        data["storeId"] = this.storeId;
        data["storeCode"] = this.storeCode;
        data["storeIsHub"] = this.storeIsHub;
        data["clusterId"] = this.clusterId;
        data["assignations"] = this.assignations;
        return data;
    };
    StoreDistanceAndStockDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StoreDistanceAndStockDto();
        result.init(json);
        return result;
    };
    return StoreDistanceAndStockDto;
}());
export { StoreDistanceAndStockDto };
var StoreNameAndCodeDto = /** @class */ (function () {
    function StoreNameAndCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StoreNameAndCodeDto.prototype.init = function (_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    };
    StoreNameAndCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StoreNameAndCodeDto();
        result.init(data);
        return result;
    };
    StoreNameAndCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    };
    StoreNameAndCodeDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StoreNameAndCodeDto();
        result.init(json);
        return result;
    };
    return StoreNameAndCodeDto;
}());
export { StoreNameAndCodeDto };
var UploadStorePostalCodesRequestDto = /** @class */ (function () {
    function UploadStorePostalCodesRequestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    UploadStorePostalCodesRequestDto.prototype.init = function (_data) {
        var e_752, _a;
        if (_data) {
            this.url = _data["url"];
            if (Array.isArray(_data["stores"])) {
                this.stores = [];
                try {
                    for (var _b = __values(_data["stores"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.stores.push(StoreNameAndCodeDto.fromJS(item));
                    }
                }
                catch (e_752_1) { e_752 = { error: e_752_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_752) throw e_752.error; }
                }
            }
        }
    };
    UploadStorePostalCodesRequestDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new UploadStorePostalCodesRequestDto();
        result.init(data);
        return result;
    };
    UploadStorePostalCodesRequestDto.prototype.toJSON = function (data) {
        var e_753, _a;
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        if (Array.isArray(this.stores)) {
            data["stores"] = [];
            try {
                for (var _b = __values(this.stores), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["stores"].push(item.toJSON());
                }
            }
            catch (e_753_1) { e_753 = { error: e_753_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_753) throw e_753.error; }
            }
        }
        return data;
    };
    UploadStorePostalCodesRequestDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new UploadStorePostalCodesRequestDto();
        result.init(json);
        return result;
    };
    return UploadStorePostalCodesRequestDto;
}());
export { UploadStorePostalCodesRequestDto };
var StorePostalCodeDto = /** @class */ (function () {
    function StorePostalCodeDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StorePostalCodeDto.prototype.init = function (_data) {
        if (_data) {
            this.storeCode = _data["storeCode"];
            this.postalCode = _data["postalCode"];
            this.id = _data["id"];
        }
    };
    StorePostalCodeDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StorePostalCodeDto();
        result.init(data);
        return result;
    };
    StorePostalCodeDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        data["postalCode"] = this.postalCode;
        data["id"] = this.id;
        return data;
    };
    StorePostalCodeDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StorePostalCodeDto();
        result.init(json);
        return result;
    };
    return StorePostalCodeDto;
}());
export { StorePostalCodeDto };
var StorePostalCodeDtoPagedResultDto = /** @class */ (function () {
    function StorePostalCodeDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    StorePostalCodeDtoPagedResultDto.prototype.init = function (_data) {
        var e_754, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(StorePostalCodeDto.fromJS(item));
                    }
                }
                catch (e_754_1) { e_754 = { error: e_754_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_754) throw e_754.error; }
                }
            }
        }
    };
    StorePostalCodeDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new StorePostalCodeDtoPagedResultDto();
        result.init(data);
        return result;
    };
    StorePostalCodeDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_755, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_755_1) { e_755 = { error: e_755_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_755) throw e_755.error; }
            }
        }
        return data;
    };
    StorePostalCodeDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new StorePostalCodeDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return StorePostalCodeDtoPagedResultDto;
}());
export { StorePostalCodeDtoPagedResultDto };
var SapTransfersDto = /** @class */ (function () {
    function SapTransfersDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SapTransfersDto.prototype.init = function (_data) {
        var e_756, _a;
        if (_data) {
            this.countryCode = _data["countryCode"];
            this.separationId = _data["separationId"];
            this.alias = _data["alias"];
            if (Array.isArray(_data["orders"])) {
                this.orders = [];
                try {
                    for (var _b = __values(_data["orders"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.orders.push(OrderDto.fromJS(item));
                    }
                }
                catch (e_756_1) { e_756 = { error: e_756_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_756) throw e_756.error; }
                }
            }
        }
    };
    SapTransfersDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SapTransfersDto();
        result.init(data);
        return result;
    };
    SapTransfersDto.prototype.toJSON = function (data) {
        var e_757, _a;
        data = typeof data === 'object' ? data : {};
        data["countryCode"] = this.countryCode;
        data["separationId"] = this.separationId;
        data["alias"] = this.alias;
        if (Array.isArray(this.orders)) {
            data["orders"] = [];
            try {
                for (var _b = __values(this.orders), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["orders"].push(item.toJSON());
                }
            }
            catch (e_757_1) { e_757 = { error: e_757_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_757) throw e_757.error; }
            }
        }
        return data;
    };
    SapTransfersDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SapTransfersDto();
        result.init(json);
        return result;
    };
    return SapTransfersDto;
}());
export { SapTransfersDto };
var TransferRequestDto = /** @class */ (function () {
    function TransferRequestDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TransferRequestDto.prototype.init = function (_data) {
        var e_758, _a, e_759, _b;
        if (_data) {
            this.orderId = _data["orderId"];
            this.transferId = _data["transferId"];
            if (Array.isArray(_data["codes"])) {
                this.codes = [];
                try {
                    for (var _c = __values(_data["codes"]), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var item = _d.value;
                        this.codes.push(item);
                    }
                }
                catch (e_758_1) { e_758 = { error: e_758_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                    }
                    finally { if (e_758) throw e_758.error; }
                }
            }
            if (Array.isArray(_data["shipments"])) {
                this.shipments = [];
                try {
                    for (var _e = __values(_data["shipments"]), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var item = _f.value;
                        this.shipments.push(item);
                    }
                }
                catch (e_759_1) { e_759 = { error: e_759_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_759) throw e_759.error; }
                }
            }
            this.hasFailure = _data["hasFailure"];
            this.notReceived = _data["notReceived"];
            this.notAccepted = _data["notAccepted"];
            this.note = _data["note"];
            this.id = _data["id"];
        }
    };
    TransferRequestDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TransferRequestDto();
        result.init(data);
        return result;
    };
    TransferRequestDto.prototype.toJSON = function (data) {
        var e_760, _a, e_761, _b;
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["transferId"] = this.transferId;
        if (Array.isArray(this.codes)) {
            data["codes"] = [];
            try {
                for (var _c = __values(this.codes), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var item = _d.value;
                    data["codes"].push(item);
                }
            }
            catch (e_760_1) { e_760 = { error: e_760_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_760) throw e_760.error; }
            }
        }
        if (Array.isArray(this.shipments)) {
            data["shipments"] = [];
            try {
                for (var _e = __values(this.shipments), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var item = _f.value;
                    data["shipments"].push(item);
                }
            }
            catch (e_761_1) { e_761 = { error: e_761_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_761) throw e_761.error; }
            }
        }
        data["hasFailure"] = this.hasFailure;
        data["notReceived"] = this.notReceived;
        data["notAccepted"] = this.notAccepted;
        data["note"] = this.note;
        data["id"] = this.id;
        return data;
    };
    TransferRequestDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new TransferRequestDto();
        result.init(json);
        return result;
    };
    return TransferRequestDto;
}());
export { TransferRequestDto };
var SupplyingOrderStoreDto = /** @class */ (function () {
    function SupplyingOrderStoreDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SupplyingOrderStoreDto.prototype.init = function (_data) {
        if (_data) {
            this.addressCity = _data["addressCity"];
            this.addressGeoLat = _data["addressGeoLat"];
            this.addressGeoLong = _data["addressGeoLong"];
            this.addressPostalCode = _data["addressPostalCode"];
            this.addressState = _data["addressState"];
            this.addressStreetName = _data["addressStreetName"];
            this.addressStreetNumber = _data["addressStreetNumber"];
            this.email = _data["email"];
            this.erpCode = _data["erpCode"];
            this.isHub = _data["isHub"];
            this.name = _data["name"];
            this.phoneNumber = _data["phoneNumber"];
            this.storeCode = _data["storeCode"];
            this.id = _data["id"];
        }
    };
    SupplyingOrderStoreDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SupplyingOrderStoreDto();
        result.init(data);
        return result;
    };
    SupplyingOrderStoreDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["addressCity"] = this.addressCity;
        data["addressGeoLat"] = this.addressGeoLat;
        data["addressGeoLong"] = this.addressGeoLong;
        data["addressPostalCode"] = this.addressPostalCode;
        data["addressState"] = this.addressState;
        data["addressStreetName"] = this.addressStreetName;
        data["addressStreetNumber"] = this.addressStreetNumber;
        data["email"] = this.email;
        data["erpCode"] = this.erpCode;
        data["isHub"] = this.isHub;
        data["name"] = this.name;
        data["phoneNumber"] = this.phoneNumber;
        data["storeCode"] = this.storeCode;
        data["id"] = this.id;
        return data;
    };
    SupplyingOrderStoreDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SupplyingOrderStoreDto();
        result.init(json);
        return result;
    };
    return SupplyingOrderStoreDto;
}());
export { SupplyingOrderStoreDto };
var SupplyingOrderItemDto = /** @class */ (function () {
    function SupplyingOrderItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SupplyingOrderItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sourceCode = _data["sourceCode"];
            this.sku = _data["sku"];
            this.description = _data["description"];
            this.imageUrl = _data["imageUrl"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    };
    SupplyingOrderItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SupplyingOrderItemDto();
        result.init(data);
        return result;
    };
    SupplyingOrderItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sourceCode"] = this.sourceCode;
        data["sku"] = this.sku;
        data["description"] = this.description;
        data["imageUrl"] = this.imageUrl;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    };
    SupplyingOrderItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SupplyingOrderItemDto();
        result.init(json);
        return result;
    };
    return SupplyingOrderItemDto;
}());
export { SupplyingOrderItemDto };
var SupplyingOrderDto = /** @class */ (function () {
    function SupplyingOrderDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    SupplyingOrderDto.prototype.init = function (_data) {
        var e_762, _a;
        if (_data) {
            this.orderId = _data["orderId"];
            this.sourceCode = _data["sourceCode"];
            this.store = _data["store"] ? SupplyingOrderStoreDto.fromJS(_data["store"]) : undefined;
            this.customerId = _data["customerId"];
            this.receiverName = _data["receiverName"];
            this.isFlashShipping = _data["isFlashShipping"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(SupplyingOrderItemDto.fromJS(item));
                    }
                }
                catch (e_762_1) { e_762 = { error: e_762_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_762) throw e_762.error; }
                }
            }
            this.countryCode = _data["countryCode"];
            this.id = _data["id"];
        }
    };
    SupplyingOrderDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new SupplyingOrderDto();
        result.init(data);
        return result;
    };
    SupplyingOrderDto.prototype.toJSON = function (data) {
        var e_763, _a;
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["sourceCode"] = this.sourceCode;
        data["store"] = this.store ? this.store.toJSON() : undefined;
        data["customerId"] = this.customerId;
        data["receiverName"] = this.receiverName;
        data["isFlashShipping"] = this.isFlashShipping;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_763_1) { e_763 = { error: e_763_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_763) throw e_763.error; }
            }
        }
        data["countryCode"] = this.countryCode;
        data["id"] = this.id;
        return data;
    };
    SupplyingOrderDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new SupplyingOrderDto();
        result.init(json);
        return result;
    };
    return SupplyingOrderDto;
}());
export { SupplyingOrderDto };
var TransferItemDto = /** @class */ (function () {
    function TransferItemDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TransferItemDto.prototype.init = function (_data) {
        if (_data) {
            this.sku = _data["sku"];
            this.name = _data["name"];
            this.unitPrice = _data["unitPrice"];
            this.quantity = _data["quantity"];
            this.id = _data["id"];
        }
    };
    TransferItemDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TransferItemDto();
        result.init(data);
        return result;
    };
    TransferItemDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["sku"] = this.sku;
        data["name"] = this.name;
        data["unitPrice"] = this.unitPrice;
        data["quantity"] = this.quantity;
        data["id"] = this.id;
        return data;
    };
    TransferItemDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new TransferItemDto();
        result.init(json);
        return result;
    };
    return TransferItemDto;
}());
export { TransferItemDto };
var TransferDto = /** @class */ (function () {
    function TransferDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TransferDto.prototype.init = function (_data) {
        var e_764, _a;
        if (_data) {
            this.orderId = _data["orderId"];
            this.trxSrcCode = _data["trxSrcCode"];
            this.sourceStoreCode = _data["sourceStoreCode"];
            this.destinationStoreCode = _data["destinationStoreCode"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : undefined;
            if (Array.isArray(_data["transferItems"])) {
                this.transferItems = [];
                try {
                    for (var _b = __values(_data["transferItems"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.transferItems.push(TransferItemDto.fromJS(item));
                    }
                }
                catch (e_764_1) { e_764 = { error: e_764_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_764) throw e_764.error; }
                }
            }
            this.id = _data["id"];
        }
    };
    TransferDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TransferDto();
        result.init(data);
        return result;
    };
    TransferDto.prototype.toJSON = function (data) {
        var e_765, _a;
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["trxSrcCode"] = this.trxSrcCode;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["destinationStoreCode"] = this.destinationStoreCode;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        if (Array.isArray(this.transferItems)) {
            data["transferItems"] = [];
            try {
                for (var _b = __values(this.transferItems), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["transferItems"].push(item.toJSON());
                }
            }
            catch (e_765_1) { e_765 = { error: e_765_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_765) throw e_765.error; }
            }
        }
        data["id"] = this.id;
        return data;
    };
    TransferDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new TransferDto();
        result.init(json);
        return result;
    };
    return TransferDto;
}());
export { TransferDto };
var CreateTransfersDto = /** @class */ (function () {
    function CreateTransfersDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateTransfersDto.prototype.init = function (_data) {
        var e_766, _a;
        if (_data) {
            this.supplyingOrder = _data["supplyingOrder"] ? SupplyingOrderDto.fromJS(_data["supplyingOrder"]) : undefined;
            if (Array.isArray(_data["transfers"])) {
                this.transfers = [];
                try {
                    for (var _b = __values(_data["transfers"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.transfers.push(TransferDto.fromJS(item));
                    }
                }
                catch (e_766_1) { e_766 = { error: e_766_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_766) throw e_766.error; }
                }
            }
            this.countryCode = _data["countryCode"];
            this.storeCode = _data["storeCode"];
            this.erpStoreCode = _data["erpStoreCode"];
        }
    };
    CreateTransfersDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateTransfersDto();
        result.init(data);
        return result;
    };
    CreateTransfersDto.prototype.toJSON = function (data) {
        var e_767, _a;
        data = typeof data === 'object' ? data : {};
        data["supplyingOrder"] = this.supplyingOrder ? this.supplyingOrder.toJSON() : undefined;
        if (Array.isArray(this.transfers)) {
            data["transfers"] = [];
            try {
                for (var _b = __values(this.transfers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["transfers"].push(item.toJSON());
                }
            }
            catch (e_767_1) { e_767 = { error: e_767_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_767) throw e_767.error; }
            }
        }
        data["countryCode"] = this.countryCode;
        data["storeCode"] = this.storeCode;
        data["erpStoreCode"] = this.erpStoreCode;
        return data;
    };
    CreateTransfersDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CreateTransfersDto();
        result.init(json);
        return result;
    };
    return CreateTransfersDto;
}());
export { CreateTransfersDto };
var TransferOrderInfoDto = /** @class */ (function () {
    function TransferOrderInfoDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TransferOrderInfoDto.prototype.init = function (_data) {
        var e_768, _a;
        if (_data) {
            this.trxSrcCode = _data["trxSrcCode"];
            this.sourceStoreCode = _data["sourceStoreCode"];
            this.destinationStoreCode = _data["destinationStoreCode"];
            this.deliveryDate = _data["deliveryDate"] ? moment(_data["deliveryDate"].toString()) : undefined;
            if (Array.isArray(_data["transferItemsSkus"])) {
                this.transferItemsSkus = [];
                try {
                    for (var _b = __values(_data["transferItemsSkus"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.transferItemsSkus.push(item);
                    }
                }
                catch (e_768_1) { e_768 = { error: e_768_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_768) throw e_768.error; }
                }
            }
            this.orderCompleteAdress = _data["orderCompleteAdress"];
            this.orderShippingType = _data["orderShippingType"];
        }
    };
    TransferOrderInfoDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TransferOrderInfoDto();
        result.init(data);
        return result;
    };
    TransferOrderInfoDto.prototype.toJSON = function (data) {
        var e_769, _a;
        data = typeof data === 'object' ? data : {};
        data["trxSrcCode"] = this.trxSrcCode;
        data["sourceStoreCode"] = this.sourceStoreCode;
        data["destinationStoreCode"] = this.destinationStoreCode;
        data["deliveryDate"] = this.deliveryDate ? this.deliveryDate.toISOString() : undefined;
        if (Array.isArray(this.transferItemsSkus)) {
            data["transferItemsSkus"] = [];
            try {
                for (var _b = __values(this.transferItemsSkus), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["transferItemsSkus"].push(item);
                }
            }
            catch (e_769_1) { e_769 = { error: e_769_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_769) throw e_769.error; }
            }
        }
        data["orderCompleteAdress"] = this.orderCompleteAdress;
        data["orderShippingType"] = this.orderShippingType;
        return data;
    };
    TransferOrderInfoDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new TransferOrderInfoDto();
        result.init(json);
        return result;
    };
    return TransferOrderInfoDto;
}());
export { TransferOrderInfoDto };
var TransferRequestDtoPagedResultDto = /** @class */ (function () {
    function TransferRequestDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    TransferRequestDtoPagedResultDto.prototype.init = function (_data) {
        var e_770, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(TransferRequestDto.fromJS(item));
                    }
                }
                catch (e_770_1) { e_770 = { error: e_770_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_770) throw e_770.error; }
                }
            }
        }
    };
    TransferRequestDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new TransferRequestDtoPagedResultDto();
        result.init(data);
        return result;
    };
    TransferRequestDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_771, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_771_1) { e_771 = { error: e_771_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_771) throw e_771.error; }
            }
        }
        return data;
    };
    TransferRequestDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new TransferRequestDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return TransferRequestDtoPagedResultDto;
}());
export { TransferRequestDtoPagedResultDto };
var VtexAccountDto = /** @class */ (function () {
    function VtexAccountDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VtexAccountDto.prototype.init = function (_data) {
        if (_data) {
            this.name = _data["name"];
            this.baseUrl = _data["baseUrl"];
            this.appKey = _data["appKey"];
            this.appToken = _data["appToken"];
            this.isListening = _data["isListening"];
            this.storeCode = _data["storeCode"];
            this.isMaster = _data["isMaster"];
            this.id = _data["id"];
        }
    };
    VtexAccountDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VtexAccountDto();
        result.init(data);
        return result;
    };
    VtexAccountDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["baseUrl"] = this.baseUrl;
        data["appKey"] = this.appKey;
        data["appToken"] = this.appToken;
        data["isListening"] = this.isListening;
        data["storeCode"] = this.storeCode;
        data["isMaster"] = this.isMaster;
        data["id"] = this.id;
        return data;
    };
    VtexAccountDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new VtexAccountDto();
        result.init(json);
        return result;
    };
    return VtexAccountDto;
}());
export { VtexAccountDto };
var VtexAccountDtoPagedResultDto = /** @class */ (function () {
    function VtexAccountDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    VtexAccountDtoPagedResultDto.prototype.init = function (_data) {
        var e_772, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(VtexAccountDto.fromJS(item));
                    }
                }
                catch (e_772_1) { e_772 = { error: e_772_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_772) throw e_772.error; }
                }
            }
        }
    };
    VtexAccountDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new VtexAccountDtoPagedResultDto();
        result.init(data);
        return result;
    };
    VtexAccountDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_773, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_773_1) { e_773 = { error: e_773_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_773) throw e_773.error; }
            }
        }
        return data;
    };
    VtexAccountDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new VtexAccountDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return VtexAccountDtoPagedResultDto;
}());
export { VtexAccountDtoPagedResultDto };
var ZohoStadisticUrlDto = /** @class */ (function () {
    function ZohoStadisticUrlDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZohoStadisticUrlDto.prototype.init = function (_data) {
        if (_data) {
            this.title = _data["title"];
            this.url = _data["url"];
            this.isPublic = _data["isPublic"];
            this.countryCode = _data["countryCode"];
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    ZohoStadisticUrlDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZohoStadisticUrlDto();
        result.init(data);
        return result;
    };
    ZohoStadisticUrlDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title;
        data["url"] = this.url;
        data["isPublic"] = this.isPublic;
        data["countryCode"] = this.countryCode;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    ZohoStadisticUrlDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ZohoStadisticUrlDto();
        result.init(json);
        return result;
    };
    return ZohoStadisticUrlDto;
}());
export { ZohoStadisticUrlDto };
var ZohoStadisticUrlDtoPagedResultDto = /** @class */ (function () {
    function ZohoStadisticUrlDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZohoStadisticUrlDtoPagedResultDto.prototype.init = function (_data) {
        var e_774, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ZohoStadisticUrlDto.fromJS(item));
                    }
                }
                catch (e_774_1) { e_774 = { error: e_774_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_774) throw e_774.error; }
                }
            }
        }
    };
    ZohoStadisticUrlDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZohoStadisticUrlDtoPagedResultDto();
        result.init(data);
        return result;
    };
    ZohoStadisticUrlDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_775, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_775_1) { e_775 = { error: e_775_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_775) throw e_775.error; }
            }
        }
        return data;
    };
    ZohoStadisticUrlDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ZohoStadisticUrlDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return ZohoStadisticUrlDtoPagedResultDto;
}());
export { ZohoStadisticUrlDtoPagedResultDto };
var ZubaleNotificationDto = /** @class */ (function () {
    function ZubaleNotificationDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZubaleNotificationDto.prototype.init = function (_data) {
        if (_data) {
            this.orderId = _data["orderId"];
            this.oldStatus = _data["oldStatus"];
            this.newStatus = _data["newStatus"];
            this.trackingUrl = _data["trackingUrl"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.isDeleted = _data["isDeleted"];
            this.deleterUserId = _data["deleterUserId"];
            this.deletionTime = _data["deletionTime"] ? moment(_data["deletionTime"].toString()) : undefined;
            this.lastModificationTime = _data["lastModificationTime"] ? moment(_data["lastModificationTime"].toString()) : undefined;
            this.lastModifierUserId = _data["lastModifierUserId"];
            this.creationTime = _data["creationTime"] ? moment(_data["creationTime"].toString()) : undefined;
            this.creatorUserId = _data["creatorUserId"];
            this.id = _data["id"];
        }
    };
    ZubaleNotificationDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZubaleNotificationDto();
        result.init(data);
        return result;
    };
    ZubaleNotificationDto.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["orderId"] = this.orderId;
        data["oldStatus"] = this.oldStatus;
        data["newStatus"] = this.newStatus;
        data["trackingUrl"] = this.trackingUrl;
        data["name"] = this.name;
        data["description"] = this.description;
        data["isDeleted"] = this.isDeleted;
        data["deleterUserId"] = this.deleterUserId;
        data["deletionTime"] = this.deletionTime ? this.deletionTime.toISOString() : undefined;
        data["lastModificationTime"] = this.lastModificationTime ? this.lastModificationTime.toISOString() : undefined;
        data["lastModifierUserId"] = this.lastModifierUserId;
        data["creationTime"] = this.creationTime ? this.creationTime.toISOString() : undefined;
        data["creatorUserId"] = this.creatorUserId;
        data["id"] = this.id;
        return data;
    };
    ZubaleNotificationDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ZubaleNotificationDto();
        result.init(json);
        return result;
    };
    return ZubaleNotificationDto;
}());
export { ZubaleNotificationDto };
var CreateDeliveryOrdersDto = /** @class */ (function () {
    function CreateDeliveryOrdersDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateDeliveryOrdersDto.prototype.init = function (_data) {
        var e_776, _a;
        if (_data) {
            this.storeCode = _data["storeCode"];
            if (Array.isArray(_data["deliveryOrders"])) {
                this.deliveryOrders = [];
                try {
                    for (var _b = __values(_data["deliveryOrders"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.deliveryOrders.push(item);
                    }
                }
                catch (e_776_1) { e_776 = { error: e_776_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_776) throw e_776.error; }
                }
            }
        }
    };
    CreateDeliveryOrdersDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateDeliveryOrdersDto();
        result.init(data);
        return result;
    };
    CreateDeliveryOrdersDto.prototype.toJSON = function (data) {
        var e_777, _a;
        data = typeof data === 'object' ? data : {};
        data["storeCode"] = this.storeCode;
        if (Array.isArray(this.deliveryOrders)) {
            data["deliveryOrders"] = [];
            try {
                for (var _b = __values(this.deliveryOrders), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["deliveryOrders"].push(item);
                }
            }
            catch (e_777_1) { e_777 = { error: e_777_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_777) throw e_777.error; }
            }
        }
        return data;
    };
    CreateDeliveryOrdersDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CreateDeliveryOrdersDto();
        result.init(json);
        return result;
    };
    return CreateDeliveryOrdersDto;
}());
export { CreateDeliveryOrdersDto };
var CreateDeliveryOrderResponseModel = /** @class */ (function () {
    function CreateDeliveryOrderResponseModel(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    CreateDeliveryOrderResponseModel.prototype.init = function (_data) {
        if (_data) {
            this.message = _data["message"];
            this.success = _data["success"];
            this.externalDeliveryId = _data["externalDeliveryId"];
            this.externalOrderId = _data["externalOrderId"];
            this.internalId = _data["internalId"];
            this.status = _data["status"];
            this.jsonRequest = _data["jsonRequest"];
        }
    };
    CreateDeliveryOrderResponseModel.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new CreateDeliveryOrderResponseModel();
        result.init(data);
        return result;
    };
    CreateDeliveryOrderResponseModel.prototype.toJSON = function (data) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message;
        data["success"] = this.success;
        data["externalDeliveryId"] = this.externalDeliveryId;
        data["externalOrderId"] = this.externalOrderId;
        data["internalId"] = this.internalId;
        data["status"] = this.status;
        data["jsonRequest"] = this.jsonRequest;
        return data;
    };
    CreateDeliveryOrderResponseModel.prototype.clone = function () {
        var json = this.toJSON();
        var result = new CreateDeliveryOrderResponseModel();
        result.init(json);
        return result;
    };
    return CreateDeliveryOrderResponseModel;
}());
export { CreateDeliveryOrderResponseModel };
var ZubaleNotificationDtoPagedResultDto = /** @class */ (function () {
    function ZubaleNotificationDtoPagedResultDto(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    ZubaleNotificationDtoPagedResultDto.prototype.init = function (_data) {
        var e_778, _a;
        if (_data) {
            this.totalCount = _data["totalCount"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                try {
                    for (var _b = __values(_data["items"]), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var item = _c.value;
                        this.items.push(ZubaleNotificationDto.fromJS(item));
                    }
                }
                catch (e_778_1) { e_778 = { error: e_778_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_778) throw e_778.error; }
                }
            }
        }
    };
    ZubaleNotificationDtoPagedResultDto.fromJS = function (data) {
        data = typeof data === 'object' ? data : {};
        var result = new ZubaleNotificationDtoPagedResultDto();
        result.init(data);
        return result;
    };
    ZubaleNotificationDtoPagedResultDto.prototype.toJSON = function (data) {
        var e_779, _a;
        data = typeof data === 'object' ? data : {};
        data["totalCount"] = this.totalCount;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            try {
                for (var _b = __values(this.items), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var item = _c.value;
                    data["items"].push(item.toJSON());
                }
            }
            catch (e_779_1) { e_779 = { error: e_779_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_779) throw e_779.error; }
            }
        }
        return data;
    };
    ZubaleNotificationDtoPagedResultDto.prototype.clone = function () {
        var json = this.toJSON();
        var result = new ZubaleNotificationDtoPagedResultDto();
        result.init(json);
        return result;
    };
    return ZubaleNotificationDtoPagedResultDto;
}());
export { ZubaleNotificationDtoPagedResultDto };
var ApiException = /** @class */ (function (_super) {
    __extends(ApiException, _super);
    function ApiException(message, status, response, headers, result) {
        var _this = _super.call(this) || this;
        _this.isApiException = true;
        _this.message = message;
        _this.status = status;
        _this.response = response;
        _this.headers = headers;
        _this.result = result;
        return _this;
    }
    ApiException.isApiException = function (obj) {
        return obj.isApiException === true;
    };
    return ApiException;
}(Error));
export { ApiException };
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}
function blobToText(blob) {
    return new Observable(function (observer) {
        if (!blob) {
            observer.next("");
            observer.complete();
        }
        else {
            var reader = new FileReader();
            reader.onload = function (event) {
                observer.next(event.target.result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}
